import * as $d from "react/jsx-runtime";
import { jsx as y, jsxs as J, Fragment as La } from "react/jsx-runtime";
import * as fn from "react";
import N, { createElement as SC, forwardRef as CC, useContext as sg } from "react";
import { Alert as Tc } from "@instructure/ui-alerts";
import { Pagination as Sc } from "@instructure/ui-pagination";
import b from "@instructure/ui-themes";
import { IconButton as _n, CloseButton as xC, Button as Er } from "@instructure/ui-buttons";
import { IconTagLine as ag, IconUserLine as _C, IconAddLine as Cc, IconAddSolid as bC, IconMoreSolid as xc, IconUnarchiveLine as EC, IconUserSolid as og, IconWarningLine as IC, IconDragHandleSolid as AC, IconCheckMarkSolid as OC, IconArrowOpenDownLine as kC, IconArrowOpenEndLine as $C, IconPlusLine as NC, IconSearchLine as ug, IconArrowUpLine as RC, IconArrowDownLine as MC, IconXLine as PC, IconEditLine as DC } from "@instructure/ui-icons";
import { Pill as xr } from "@instructure/ui-pill";
import { Text as Je } from "@instructure/ui-text";
import { Heading as Ji } from "@instructure/ui-heading";
import { Menu as ji } from "@instructure/ui-menu";
import { Tooltip as ba } from "@instructure/ui-tooltip";
import { TruncateText as Ea } from "@instructure/ui-truncate-text";
import { usePlatformUi as cg } from "@instructure/platform-provider";
import { useQuery as Nr, useQueryClient as bn, useMutation as En } from "@tanstack/react-query";
import { gql as At } from "graphql-tag";
import { FormFieldGroup as _c } from "@instructure/ui-form-field";
import { TextInput as Ar } from "@instructure/ui-text-input";
import { SimpleSelect as Nd } from "@instructure/ui-simple-select";
import { Select as Cn } from "@instructure/ui-select";
import { Badge as LC } from "@instructure/ui-badge";
import { Avatar as lg } from "@instructure/ui-avatar";
import { Tag as FC } from "@instructure/ui-tag";
import { Checkbox as WC } from "@instructure/ui-checkbox";
import { createPortal as UC } from "react-dom";
import { Modal as ta } from "@instructure/ui-modal";
import { TextDirectionContext as Rd } from "@instructure/ui-i18n";
import { DeterministicIdContextProvider as qC } from "@instructure/ui-react-utils";
import { isBaseTheme as fg, mergeDeep as dg } from "@instructure/ui-utils";
import { Popover as zC } from "@instructure/ui-popover";
import { TextArea as BC } from "@instructure/ui-text-area";
import { Table as Et } from "@instructure/ui-table";
const hg = {
  categoryAutocomplete: !1
}, gg = N.createContext(hg), yk = ({
  featureFlags: t,
  children: n
}) => {
  const i = N.useMemo(() => ({ ...hg, ...t }), [t]);
  return /* @__PURE__ */ y(gg.Provider, { value: i, children: n });
}, Fa = () => N.useContext(gg), Xi = (t) => Array.from({ length: t }, (n, i) => ({ id: i })), bc = (t) => N.useMemo(() => Xi(t).map((n) => n.id), [t]);
var Rt = function() {
  return Rt = Object.assign || function(n) {
    for (var i, s = 1, o = arguments.length; s < o; s++) {
      i = arguments[s];
      for (var u in i) Object.prototype.hasOwnProperty.call(i, u) && (n[u] = i[u]);
    }
    return n;
  }, Rt.apply(this, arguments);
};
function Or(t, n, i) {
  if (i || arguments.length === 2) for (var s = 0, o = n.length, u; s < o; s++)
    (u || !(s in n)) && (u || (u = Array.prototype.slice.call(n, 0, s)), u[s] = n[s]);
  return t.concat(u || Array.prototype.slice.call(n));
}
function pg(t) {
  var n = /* @__PURE__ */ Object.create(null);
  return function(i) {
    return n[i] === void 0 && (n[i] = t(i)), n[i];
  };
}
var VC = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, HC = /* @__PURE__ */ pg(
  function(t) {
    return VC.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), mg = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Ye = "-ms-", Gi = "-moz-", Me = "-webkit-", yg = "comm", Wa = "rule", Ec = "decl", GC = "@import", YC = "@namespace", vg = "@keyframes", ZC = "@layer", wg = Math.abs, Ic = String.fromCharCode, Gu = Object.assign;
function KC(t, n) {
  return ft(t, 0) ^ 45 ? (((n << 2 ^ ft(t, 0)) << 2 ^ ft(t, 1)) << 2 ^ ft(t, 2)) << 2 ^ ft(t, 3) : 0;
}
function Tg(t) {
  return t.trim();
}
function Fn(t, n) {
  return (t = n.exec(t)) ? t[0] : t;
}
function Se(t, n, i) {
  return t.replace(n, i);
}
function ga(t, n, i) {
  return t.indexOf(n, i);
}
function ft(t, n) {
  return t.charCodeAt(n) | 0;
}
function kr(t, n, i) {
  return t.slice(n, i);
}
function ln(t) {
  return t.length;
}
function Sg(t) {
  return t.length;
}
function Ui(t, n) {
  return n.push(t), t;
}
function QC(t, n) {
  return t.map(n).join("");
}
function Md(t, n) {
  return t.filter(function(i) {
    return !Fn(i, n);
  });
}
var Ua = 1, ii = 1, Cg = 0, en = 0, ot = 0, li = "";
function qa(t, n, i, s, o, u, l, d) {
  return { value: t, root: n, parent: i, type: s, props: o, children: u, line: Ua, column: ii, length: l, return: "", siblings: d };
}
function nr(t, n) {
  return Gu(qa("", null, null, "", null, null, 0, t.siblings), t, { length: -t.length }, n);
}
function Kr(t) {
  for (; t.root; )
    t = nr(t.root, { children: [t] });
  Ui(t, t.siblings);
}
function JC() {
  return ot;
}
function jC() {
  return ot = en > 0 ? ft(li, --en) : 0, ii--, ot === 10 && (ii = 1, Ua--), ot;
}
function hn() {
  return ot = en < Cg ? ft(li, en++) : 0, ii++, ot === 10 && (ii = 1, Ua++), ot;
}
function or() {
  return ft(li, en);
}
function pa() {
  return en;
}
function za(t, n) {
  return kr(li, t, n);
}
function es(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function XC(t) {
  return Ua = ii = 1, Cg = ln(li = t), en = 0, [];
}
function ex(t) {
  return li = "", t;
}
function xu(t) {
  return Tg(za(en - 1, Yu(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function tx(t) {
  for (; (ot = or()) && ot < 33; )
    hn();
  return es(t) > 2 || es(ot) > 3 ? "" : " ";
}
function nx(t, n) {
  for (; --n && hn() && !(ot < 48 || ot > 102 || ot > 57 && ot < 65 || ot > 70 && ot < 97); )
    ;
  return za(t, pa() + (n < 6 && or() == 32 && hn() == 32));
}
function Yu(t) {
  for (; hn(); )
    switch (ot) {
      case t:
        return en;
      case 34:
      case 39:
        t !== 34 && t !== 39 && Yu(ot);
        break;
      case 40:
        t === 41 && Yu(t);
        break;
      case 92:
        hn();
        break;
    }
  return en;
}
function rx(t, n) {
  for (; hn() && t + ot !== 57; )
    if (t + ot === 84 && or() === 47)
      break;
  return "/*" + za(n, en - 1) + "*" + Ic(t === 47 ? t : hn());
}
function ix(t) {
  for (; !es(or()); )
    hn();
  return za(t, en);
}
function sx(t) {
  return ex(ma("", null, null, null, [""], t = XC(t), 0, [0], t));
}
function ma(t, n, i, s, o, u, l, d, f) {
  for (var m = 0, T = 0, v = l, x = 0, C = 0, A = 0, _ = 1, R = 1, L = 1, U = 0, q = "", P = o, O = u, M = s, $ = q; R; )
    switch (A = U, U = hn()) {
      case 40:
        if (A != 108 && ft($, v - 1) == 58) {
          ga($ += Se(xu(U), "&", "&\f"), "&\f", wg(m ? d[m - 1] : 0)) != -1 && (L = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        $ += xu(U);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        $ += tx(A);
        break;
      case 92:
        $ += nx(pa() - 1, 7);
        continue;
      case 47:
        switch (or()) {
          case 42:
          case 47:
            Ui(ax(rx(hn(), pa()), n, i, f), f), (es(A || 1) == 5 || es(or() || 1) == 5) && ln($) && kr($, -1, void 0) !== " " && ($ += " ");
            break;
          default:
            $ += "/";
        }
        break;
      case 123 * _:
        d[m++] = ln($) * L;
      case 125 * _:
      case 59:
      case 0:
        switch (U) {
          case 0:
          case 125:
            R = 0;
          case 59 + T:
            L == -1 && ($ = Se($, /\f/g, "")), C > 0 && (ln($) - v || _ === 0 && A === 47) && Ui(C > 32 ? Dd($ + ";", s, i, v - 1, f) : Dd(Se($, " ", "") + ";", s, i, v - 2, f), f);
            break;
          case 59:
            $ += ";";
          default:
            if (Ui(M = Pd($, n, i, m, T, o, d, q, P = [], O = [], v, u), u), U === 123)
              if (T === 0)
                ma($, n, M, M, P, u, v, d, O);
              else {
                switch (x) {
                  case 99:
                    if (ft($, 3) === 110) break;
                  case 108:
                    if (ft($, 2) === 97) break;
                  default:
                    T = 0;
                  case 100:
                  case 109:
                  case 115:
                }
                T ? ma(t, M, M, s && Ui(Pd(t, M, M, 0, 0, o, d, q, o, P = [], v, O), O), o, O, v, d, s ? P : O) : ma($, M, M, M, [""], O, 0, d, O);
              }
        }
        m = T = C = 0, _ = L = 1, q = $ = "", v = l;
        break;
      case 58:
        v = 1 + ln($), C = A;
      default:
        if (_ < 1) {
          if (U == 123)
            --_;
          else if (U == 125 && _++ == 0 && jC() == 125)
            continue;
        }
        switch ($ += Ic(U), U * _) {
          case 38:
            L = T > 0 ? 1 : ($ += "\f", -1);
            break;
          case 44:
            d[m++] = (ln($) - 1) * L, L = 1;
            break;
          case 64:
            or() === 45 && ($ += xu(hn())), x = or(), T = v = ln(q = $ += ix(pa())), U++;
            break;
          case 45:
            A === 45 && ln($) == 2 && (_ = 0);
        }
    }
  return u;
}
function Pd(t, n, i, s, o, u, l, d, f, m, T, v) {
  for (var x = o - 1, C = o === 0 ? u : [""], A = Sg(C), _ = 0, R = 0, L = 0; _ < s; ++_)
    for (var U = 0, q = kr(t, x + 1, x = wg(R = l[_])), P = t; U < A; ++U)
      (P = Tg(R > 0 ? C[U] + " " + q : Se(q, /&\f/g, C[U]))) && (f[L++] = P);
  return qa(t, n, i, o === 0 ? Wa : d, f, m, T, v);
}
function ax(t, n, i, s) {
  return qa(t, n, i, yg, Ic(JC()), kr(t, 2, -2), 0, s);
}
function Dd(t, n, i, s, o) {
  return qa(t, n, i, Ec, kr(t, 0, s), kr(t, s + 1, -1), s, o);
}
function xg(t, n, i) {
  switch (KC(t, n)) {
    case 5103:
      return Me + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
      return Me + t + t;
    case 4855:
      return Me + t.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + t;
    case 4789:
      return Gi + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Me + t + Gi + t + Ye + t + t;
    case 5936:
      switch (ft(t, n + 11)) {
        case 114:
          return Me + t + Ye + Se(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return Me + t + Ye + Se(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return Me + t + Ye + Se(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
    case 6828:
    case 4268:
    case 2903:
      return Me + t + Ye + t + t;
    case 6165:
      return Me + t + Ye + "flex-" + t + t;
    case 5187:
      return Me + t + Se(t, /(\w+).+(:[^]+)/, Me + "box-$1$2" + Ye + "flex-$1$2") + t;
    case 5443:
      return Me + t + Ye + "flex-item-" + Se(t, /flex-|-self/g, "") + (Fn(t, /flex-|baseline/) ? "" : Ye + "grid-row-" + Se(t, /flex-|-self/g, "")) + t;
    case 4675:
      return Me + t + Ye + "flex-line-pack" + Se(t, /align-content|flex-|-self/g, "") + t;
    case 5548:
      return Me + t + Ye + Se(t, "shrink", "negative") + t;
    case 5292:
      return Me + t + Ye + Se(t, "basis", "preferred-size") + t;
    case 6060:
      return Me + "box-" + Se(t, "-grow", "") + Me + t + Ye + Se(t, "grow", "positive") + t;
    case 4554:
      return Me + Se(t, /([^-])(transform)/g, "$1" + Me + "$2") + t;
    case 6187:
      return Se(Se(Se(t, /(zoom-|grab)/, Me + "$1"), /(image-set)/, Me + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return Se(t, /(image-set\([^]*)/, Me + "$1$`$1");
    case 4968:
      return Se(Se(t, /(.+:)(flex-)?(.*)/, Me + "box-pack:$3" + Ye + "flex-pack:$3"), /space-between/, "justify") + Me + t + t;
    case 4200:
      if (!Fn(t, /flex-|baseline/)) return Ye + "grid-column-align" + kr(t, n) + t;
      break;
    case 2592:
    case 3360:
      return Ye + Se(t, "template-", "") + t;
    case 4384:
    case 3616:
      return i && i.some(function(s, o) {
        return n = o, Fn(s.props, /grid-\w+-end/);
      }) ? ~ga(t + (i = i[n].value), "span", 0) ? t : Ye + Se(t, "-start", "") + t + Ye + "grid-row-span:" + (~ga(i, "span", 0) ? Fn(i, /\d+/) : +Fn(i, /\d+/) - +Fn(t, /\d+/)) + ";" : Ye + Se(t, "-start", "") + t;
    case 4896:
    case 4128:
      return i && i.some(function(s) {
        return Fn(s.props, /grid-\w+-start/);
      }) ? t : Ye + Se(Se(t, "-end", "-span"), "span ", "") + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Se(t, /(.+)-inline(.+)/, Me + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ln(t) - 1 - n > 6)
        switch (ft(t, n + 1)) {
          case 109:
            if (ft(t, n + 4) !== 45)
              break;
          case 102:
            return Se(t, /(.+:)(.+)-([^]+)/, "$1" + Me + "$2-$3$1" + Gi + (ft(t, n + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~ga(t, "stretch", 0) ? xg(Se(t, "stretch", "fill-available"), n, i) + t : t;
        }
      break;
    case 5152:
    case 5920:
      return Se(t, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(s, o, u, l, d, f, m) {
        return Ye + o + ":" + u + m + (l ? Ye + o + "-span:" + (d ? f : +f - +u) + m : "") + t;
      });
    case 4949:
      if (ft(t, n + 6) === 121)
        return Se(t, ":", ":" + Me) + t;
      break;
    case 6444:
      switch (ft(t, ft(t, 14) === 45 ? 18 : 11)) {
        case 120:
          return Se(t, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + Me + (ft(t, 14) === 45 ? "inline-" : "") + "box$3$1" + Me + "$2$3$1" + Ye + "$2box$3") + t;
        case 100:
          return Se(t, ":", ":" + Ye) + t;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return Se(t, "scroll-", "scroll-snap-") + t;
  }
  return t;
}
function Ia(t, n) {
  for (var i = "", s = 0; s < t.length; s++)
    i += n(t[s], s, t, n) || "";
  return i;
}
function ox(t, n, i, s) {
  switch (t.type) {
    case ZC:
      if (t.children.length) break;
    case GC:
    case YC:
    case Ec:
      return t.return = t.return || t.value;
    case yg:
      return "";
    case vg:
      return t.return = t.value + "{" + Ia(t.children, s) + "}";
    case Wa:
      if (!ln(t.value = t.props.join(","))) return "";
  }
  return ln(i = Ia(t.children, s)) ? t.return = t.value + "{" + i + "}" : "";
}
function ux(t) {
  var n = Sg(t);
  return function(i, s, o, u) {
    for (var l = "", d = 0; d < n; d++)
      l += t[d](i, s, o, u) || "";
    return l;
  };
}
function cx(t) {
  return function(n) {
    n.root || (n = n.return) && t(n);
  };
}
function lx(t, n, i, s) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case Ec:
        t.return = xg(t.value, t.length, i);
        return;
      case vg:
        return Ia([nr(t, { value: Se(t.value, "@", "@" + Me) })], s);
      case Wa:
        if (t.length)
          return QC(i = t.props, function(o) {
            switch (Fn(o, s = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                Kr(nr(t, { props: [Se(o, /:(read-\w+)/, ":" + Gi + "$1")] })), Kr(nr(t, { props: [o] })), Gu(t, { props: Md(i, s) });
                break;
              case "::placeholder":
                Kr(nr(t, { props: [Se(o, /:(plac\w+)/, ":" + Me + "input-$1")] })), Kr(nr(t, { props: [Se(o, /:(plac\w+)/, ":" + Gi + "$1")] })), Kr(nr(t, { props: [Se(o, /:(plac\w+)/, Ye + "input-$1")] })), Kr(nr(t, { props: [o] })), Gu(t, { props: Md(i, s) });
                break;
            }
            return "";
          });
    }
}
var $r = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", _g = "active", bg = "data-styled-version", Ba = "6.3.12", Ac = `/*!sc*/
`, Yi = typeof window < "u" && typeof document < "u", fx = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), dx = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function hx() {
  for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
  for (var i = t[0], s = [], o = 1, u = t.length; o < u; o += 1) s.push(t[o]);
  return s.forEach(function(l) {
    i = i.replace(/%[a-z]/, l);
  }), i;
}
function fi(t) {
  for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : "")) : new Error(hx.apply(void 0, Or([dx[t]], n, !1)).trim());
}
var gx = 1 << 30, ya = /* @__PURE__ */ new Map(), Aa = /* @__PURE__ */ new Map(), va = 1, qi = function(t) {
  if (ya.has(t)) return ya.get(t);
  for (; Aa.has(va); ) va++;
  var n = va++;
  if (process.env.NODE_ENV !== "production" && ((0 | n) < 0 || n > gx)) throw fi(16, "".concat(n));
  return ya.set(t, n), Aa.set(n, t), n;
}, px = function(t, n) {
  va = n + 1, ya.set(t, n), Aa.set(n, t);
}, Ld = /invalid hook call/i, na = /* @__PURE__ */ new Set(), mx = function(t, n) {
  if (process.env.NODE_ENV !== "production") {
    var i = n ? ' with the id of "'.concat(n, '"') : "", s = "The component ".concat(t).concat(i, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, o = console.error;
    try {
      var u = !0;
      console.error = function(l) {
        for (var d = [], f = 1; f < arguments.length; f++) d[f - 1] = arguments[f];
        Ld.test(l) ? (u = !1, na.delete(s)) : o.apply(void 0, Or([l], d, !1));
      }, typeof N.useState == "function" && N.useState(null), u && !na.has(s) && (console.warn(s), na.add(s));
    } catch (l) {
      Ld.test(l.message) && na.delete(s);
    } finally {
      console.error = o;
    }
  }
}, Oc = Object.freeze([]), si = Object.freeze({});
function yx(t, n, i) {
  return i === void 0 && (i = si), t.theme !== i.theme && t.theme || n || i.theme;
}
var Zu = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "body", "button", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "menu", "meter", "nav", "object", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "slot", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use"]), vx = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, wx = /(^-|-$)/g;
function Fd(t) {
  return t.replace(vx, "-").replace(wx, "");
}
var Tx = /(a)(d)/gi, Wd = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function Ku(t) {
  var n, i = "";
  for (n = Math.abs(t); n > 52; n = n / 52 | 0) i = Wd(n % 52) + i;
  return (Wd(n % 52) + i).replace(Tx, "$1-$2");
}
var _u, rr = function(t, n) {
  for (var i = n.length; i; ) t = 33 * t ^ n.charCodeAt(--i);
  return t;
}, Eg = function(t) {
  return rr(5381, t);
};
function Ig(t) {
  return Ku(Eg(t) >>> 0);
}
function Ag(t) {
  return process.env.NODE_ENV !== "production" && typeof t == "string" && t || t.displayName || t.name || "Component";
}
function bu(t) {
  return typeof t == "string" && (process.env.NODE_ENV === "production" || t.charAt(0) === t.charAt(0).toLowerCase());
}
var Og = typeof Symbol == "function" && Symbol.for, kg = Og ? Symbol.for("react.memo") : 60115, Sx = Og ? Symbol.for("react.forward_ref") : 60112, Cx = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, xx = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, $g = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, _x = ((_u = {})[Sx] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, _u[kg] = $g, _u);
function Ud(t) {
  return ("type" in (n = t) && n.type.$$typeof) === kg ? $g : "$$typeof" in t ? _x[t.$$typeof] : Cx;
  var n;
}
var bx = Object.defineProperty, Ex = Object.getOwnPropertyNames, qd = Object.getOwnPropertySymbols, Ix = Object.getOwnPropertyDescriptor, Ax = Object.getPrototypeOf, zd = Object.prototype;
function Ng(t, n, i) {
  if (typeof n != "string") {
    if (zd) {
      var s = Ax(n);
      s && s !== zd && Ng(t, s, i);
    }
    var o = Ex(n);
    qd && (o = o.concat(qd(n)));
    for (var u = Ud(t), l = Ud(n), d = 0; d < o.length; ++d) {
      var f = o[d];
      if (!(f in xx || i && i[f] || l && f in l || u && f in u)) {
        var m = Ix(n, f);
        try {
          bx(t, f, m);
        } catch {
        }
      }
    }
  }
  return t;
}
function ai(t) {
  return typeof t == "function";
}
function kc(t) {
  return typeof t == "object" && "styledComponentId" in t;
}
function _r(t, n) {
  return t && n ? "".concat(t, " ").concat(n) : t || n || "";
}
function Qu(t, n) {
  return t.join("");
}
function oi(t) {
  return t !== null && typeof t == "object" && t.constructor.name === Object.name && !("props" in t && t.$$typeof);
}
function Ju(t, n, i) {
  if (i === void 0 && (i = !1), !i && !oi(t) && !Array.isArray(t)) return n;
  if (Array.isArray(n)) for (var s = 0; s < n.length; s++) t[s] = Ju(t[s], n[s]);
  else if (oi(n)) for (var s in n) t[s] = Ju(t[s], n[s]);
  return t;
}
function $c(t, n) {
  Object.defineProperty(t, "toString", { value: n });
}
var Ox = function() {
  function t(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n, this._cGroup = 0, this._cIndex = 0;
  }
  return t.prototype.indexOfGroup = function(n) {
    if (n === this._cGroup) return this._cIndex;
    var i = this._cIndex;
    if (n > this._cGroup) for (var s = this._cGroup; s < n; s++) i += this.groupSizes[s];
    else for (s = this._cGroup - 1; s >= n; s--) i -= this.groupSizes[s];
    return this._cGroup = n, this._cIndex = i, i;
  }, t.prototype.insertRules = function(n, i) {
    if (n >= this.groupSizes.length) {
      for (var s = this.groupSizes, o = s.length, u = o; n >= u; ) if ((u <<= 1) < 0) throw fi(16, "".concat(n));
      this.groupSizes = new Uint32Array(u), this.groupSizes.set(s), this.length = u;
      for (var l = o; l < u; l++) this.groupSizes[l] = 0;
    }
    for (var d = this.indexOfGroup(n + 1), f = 0, m = (l = 0, i.length); l < m; l++) this.tag.insertRule(d, i[l]) && (this.groupSizes[n]++, d++, f++);
    f > 0 && this._cGroup > n && (this._cIndex += f);
  }, t.prototype.clearGroup = function(n) {
    if (n < this.length) {
      var i = this.groupSizes[n], s = this.indexOfGroup(n), o = s + i;
      this.groupSizes[n] = 0;
      for (var u = s; u < o; u++) this.tag.deleteRule(s);
      i > 0 && this._cGroup > n && (this._cIndex -= i);
    }
  }, t.prototype.getGroup = function(n) {
    var i = "";
    if (n >= this.length || this.groupSizes[n] === 0) return i;
    for (var s = this.groupSizes[n], o = this.indexOfGroup(n), u = o + s, l = o; l < u; l++) i += this.tag.getRule(l) + Ac;
    return i;
  }, t;
}(), kx = "style[".concat($r, "][").concat(bg, '="').concat(Ba, '"]'), $x = new RegExp("^".concat($r, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Bd = function(t) {
  return typeof ShadowRoot < "u" && t instanceof ShadowRoot || "host" in t && t.nodeType === 11;
}, ju = function(t) {
  if (!t) return document;
  if (Bd(t)) return t;
  if ("getRootNode" in t) {
    var n = t.getRootNode();
    if (Bd(n)) return n;
  }
  return document;
}, Nx = function(t, n, i) {
  for (var s, o = i.split(","), u = 0, l = o.length; u < l; u++) (s = o[u]) && t.registerName(n, s);
}, Rx = function(t, n) {
  for (var i, s = ((i = n.textContent) !== null && i !== void 0 ? i : "").split(Ac), o = [], u = 0, l = s.length; u < l; u++) {
    var d = s[u].trim();
    if (d) {
      var f = d.match($x);
      if (f) {
        var m = 0 | parseInt(f[1], 10), T = f[2];
        m !== 0 && (px(T, m), Nx(t, T, f[3]), t.getTag().insertRules(m, o)), o.length = 0;
      } else o.push(d);
    }
  }
}, Eu = function(t) {
  for (var n = ju(t.options.target).querySelectorAll(kx), i = 0, s = n.length; i < s; i++) {
    var o = n[i];
    o && o.getAttribute($r) !== _g && (Rx(t, o), o.parentNode && o.parentNode.removeChild(o));
  }
};
function Mx() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var Rg = function(t) {
  var n = document.head, i = t || n, s = document.createElement("style"), o = function(d) {
    var f = Array.from(d.querySelectorAll("style[".concat($r, "]")));
    return f[f.length - 1];
  }(i), u = o !== void 0 ? o.nextSibling : null;
  s.setAttribute($r, _g), s.setAttribute(bg, Ba);
  var l = Mx();
  return l && s.setAttribute("nonce", l), i.insertBefore(s, u), s;
}, Px = function() {
  function t(n) {
    this.element = Rg(n), this.element.appendChild(document.createTextNode("")), this.sheet = function(i) {
      var s;
      if (i.sheet) return i.sheet;
      for (var o = (s = i.getRootNode().styleSheets) !== null && s !== void 0 ? s : document.styleSheets, u = 0, l = o.length; u < l; u++) {
        var d = o[u];
        if (d.ownerNode === i) return d;
      }
      throw fi(17);
    }(this.element), this.length = 0;
  }
  return t.prototype.insertRule = function(n, i) {
    try {
      return this.sheet.insertRule(i, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.prototype.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, t.prototype.getRule = function(n) {
    var i = this.sheet.cssRules[n];
    return i && i.cssText ? i.cssText : "";
  }, t;
}(), Dx = function() {
  function t(n) {
    this.element = Rg(n), this.nodes = this.element.childNodes, this.length = 0;
  }
  return t.prototype.insertRule = function(n, i) {
    if (n <= this.length && n >= 0) {
      var s = document.createTextNode(i);
      return this.element.insertBefore(s, this.nodes[n] || null), this.length++, !0;
    }
    return !1;
  }, t.prototype.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, t.prototype.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, t;
}(), Lx = function() {
  function t(n) {
    this.rules = [], this.length = 0;
  }
  return t.prototype.insertRule = function(n, i) {
    return n <= this.length && (n === this.length ? this.rules.push(i) : this.rules.splice(n, 0, i), this.length++, !0);
  }, t.prototype.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, t.prototype.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, t;
}(), Vd = Yi, Fx = { isServer: !Yi, useCSSOMInjection: !fx }, Mg = function() {
  function t(n, i, s) {
    n === void 0 && (n = si), i === void 0 && (i = {});
    var o = this;
    this.options = Rt(Rt({}, Fx), n), this.gs = i, this.names = new Map(s), this.server = !!n.isServer, !this.server && Yi && Vd && (Vd = !1, Eu(this)), $c(this, function() {
      return function(u) {
        for (var l = u.getTag(), d = l.length, f = "", m = function(v) {
          var x = function(L) {
            return Aa.get(L);
          }(v);
          if (x === void 0) return "continue";
          var C = u.names.get(x);
          if (C === void 0 || !C.size) return "continue";
          var A = l.getGroup(v);
          if (A.length === 0) return "continue";
          var _ = $r + ".g" + v + '[id="' + x + '"]', R = "";
          C.forEach(function(L) {
            L.length > 0 && (R += L + ",");
          }), f += A + _ + '{content:"' + R + '"}' + Ac;
        }, T = 0; T < d; T++) m(T);
        return f;
      }(o);
    });
  }
  return t.registerId = function(n) {
    return qi(n);
  }, t.prototype.rehydrate = function() {
    !this.server && Yi && Eu(this);
  }, t.prototype.reconstructWithOptions = function(n, i) {
    i === void 0 && (i = !0);
    var s = new t(Rt(Rt({}, this.options), n), this.gs, i && this.names || void 0);
    return !this.server && Yi && n.target !== this.options.target && ju(this.options.target) !== ju(n.target) && Eu(s), s;
  }, t.prototype.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, t.prototype.getTag = function() {
    return this.tag || (this.tag = (n = function(i) {
      var s = i.useCSSOMInjection, o = i.target;
      return i.isServer ? new Lx(o) : s ? new Px(o) : new Dx(o);
    }(this.options), new Ox(n)));
    var n;
  }, t.prototype.hasNameForId = function(n, i) {
    var s, o;
    return (o = (s = this.names.get(n)) === null || s === void 0 ? void 0 : s.has(i)) !== null && o !== void 0 && o;
  }, t.prototype.registerName = function(n, i) {
    qi(n);
    var s = this.names.get(n);
    s ? s.add(i) : this.names.set(n, /* @__PURE__ */ new Set([i]));
  }, t.prototype.insertRules = function(n, i, s) {
    this.registerName(n, i), this.getTag().insertRules(qi(n), s);
  }, t.prototype.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, t.prototype.clearRules = function(n) {
    this.getTag().clearGroup(qi(n)), this.clearNames(n);
  }, t.prototype.clearTag = function() {
    this.tag = void 0;
  }, t;
}();
function Wx(t, n) {
  return n == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || t in mg || t.startsWith("--") ? String(n).trim() : "".concat(n, "px");
}
var Ux = function(t) {
  return t >= "A" && t <= "Z";
};
function Hd(t) {
  for (var n = "", i = 0; i < t.length; i++) {
    var s = t[i];
    if (i === 1 && s === "-" && t[0] === "-") return t;
    Ux(s) ? n += "-" + s.toLowerCase() : n += s;
  }
  return n.startsWith("ms-") ? "-" + n : n;
}
var Pg = Symbol.for("sc-keyframes");
function Gd(t) {
  return typeof t == "object" && t !== null && Pg in t;
}
var Dg = function(t) {
  return t == null || t === !1 || t === "";
}, Lg = function(t) {
  var n = [];
  for (var i in t) {
    var s = t[i];
    t.hasOwnProperty(i) && !Dg(s) && (Array.isArray(s) && s.isCss || ai(s) ? n.push("".concat(Hd(i), ":"), s, ";") : oi(s) ? n.push.apply(n, Or(Or(["".concat(i, " {")], Lg(s), !1), ["}"], !1)) : n.push("".concat(Hd(i), ": ").concat(Wx(i, s), ";")));
  }
  return n;
};
function Ir(t, n, i, s, o) {
  if (o === void 0 && (o = []), typeof t == "string") return t && o.push(t), o;
  if (Dg(t)) return o;
  if (kc(t)) return o.push(".".concat(t.styledComponentId)), o;
  if (ai(t)) {
    if (!ai(l = t) || l.prototype && l.prototype.isReactComponent || !n) return o.push(t), o;
    var u = t(n);
    return process.env.NODE_ENV === "production" || typeof u != "object" || Array.isArray(u) || Gd(u) || oi(u) || u === null || console.error("".concat(Ag(t), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Ir(u, n, i, s, o);
  }
  var l;
  if (Gd(t)) return i ? (t.inject(i, s), o.push(t.getName(s))) : o.push(t), o;
  if (oi(t)) {
    for (var d = Lg(t), f = 0; f < d.length; f++) o.push(d[f]);
    return o;
  }
  if (!Array.isArray(t)) return o.push(t.toString()), o;
  for (f = 0; f < t.length; f++) Ir(t[f], n, i, s, o);
  return o;
}
function qx(t) {
  for (var n = 0; n < t.length; n += 1) {
    var i = t[n];
    if (ai(i) && !kc(i)) return !1;
  }
  return !0;
}
var zx = Eg(Ba), Bx = function() {
  function t(n, i, s) {
    this.rules = n, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (s === void 0 || s.isStatic) && qx(n), this.componentId = i, this.baseHash = rr(zx, i), this.baseStyle = s, Mg.registerId(i);
  }
  return t.prototype.generateAndInjectStyles = function(n, i, s) {
    var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(n, i, s).className : "";
    if (this.isStatic && !s.hash) if (this.staticRulesId && i.hasNameForId(this.componentId, this.staticRulesId)) o = _r(o, this.staticRulesId);
    else {
      var u = Qu(Ir(this.rules, n, i, s)), l = Ku(rr(this.baseHash, u) >>> 0);
      if (!i.hasNameForId(this.componentId, l)) {
        var d = s(u, ".".concat(l), void 0, this.componentId);
        i.insertRules(this.componentId, l, d);
      }
      o = _r(o, l), this.staticRulesId = l;
    }
    else {
      for (var f = rr(this.baseHash, s.hash), m = "", T = 0; T < this.rules.length; T++) {
        var v = this.rules[T];
        if (typeof v == "string") m += v, process.env.NODE_ENV !== "production" && (f = rr(f, v));
        else if (v) {
          var x = Qu(Ir(v, n, i, s));
          f = rr(rr(f, String(T)), x), m += x;
        }
      }
      if (m) {
        var C = Ku(f >>> 0);
        if (!i.hasNameForId(this.componentId, C)) {
          var A = s(m, ".".concat(C), void 0, this.componentId);
          i.insertRules(this.componentId, C, A);
        }
        o = _r(o, C);
      }
    }
    return { className: o, css: typeof window > "u" ? i.getTag().getGroup(qi(this.componentId)) : "" };
  }, t;
}(), Vx = /&/g, Wn = 47, Cr = 42;
function Yd(t) {
  if (t.indexOf("}") === -1) return !1;
  for (var n = t.length, i = 0, s = 0, o = !1, u = 0; u < n; u++) {
    var l = t.charCodeAt(u);
    if (s !== 0 || o || l !== Wn || t.charCodeAt(u + 1) !== Cr) if (o) l === Cr && t.charCodeAt(u + 1) === Wn && (o = !1, u++);
    else if (l !== 34 && l !== 39 || u !== 0 && t.charCodeAt(u - 1) === 92) {
      if (s === 0) {
        if (l === 123) i++;
        else if (l === 125 && --i < 0) return !0;
      }
    } else s === 0 ? s = l : s === l && (s = 0);
    else o = !0, u++;
  }
  return i !== 0 || s !== 0;
}
function Fg(t, n) {
  return t.map(function(i) {
    return i.type === "rule" && (i.value = "".concat(n, " ").concat(i.value), i.value = i.value.replaceAll(",", ",".concat(n, " ")), i.props = i.props.map(function(s) {
      return "".concat(n, " ").concat(s);
    })), Array.isArray(i.children) && i.type !== "@keyframes" && (i.children = Fg(i.children, n)), i;
  });
}
function Hx(t) {
  var n, i, s, o = si, u = o.options, l = u === void 0 ? si : u, d = o.plugins, f = d === void 0 ? Oc : d, m = function(A, _, R) {
    return R.startsWith(i) && R.endsWith(i) && R.replaceAll(i, "").length > 0 ? ".".concat(n) : A;
  }, T = f.slice();
  T.push(function(A) {
    A.type === Wa && A.value.includes("&") && (s || (s = new RegExp("\\".concat(i, "\\b"), "g")), A.props[0] = A.props[0].replace(Vx, i).replace(s, m));
  }), l.prefix && T.push(lx), T.push(ox);
  var v = [], x = ux(T.concat(cx(function(A) {
    return v.push(A);
  }))), C = function(A, _, R, L) {
    _ === void 0 && (_ = ""), R === void 0 && (R = ""), L === void 0 && (L = "&"), n = L, i = _, s = void 0;
    var U = function(P) {
      if (!Yd(P)) return P;
      for (var O = P.length, M = "", $ = 0, H = 0, re = 0, ke = !1, oe = 0; oe < O; oe++) {
        var ue = P.charCodeAt(oe);
        if (re !== 0 || ke || ue !== Wn || P.charCodeAt(oe + 1) !== Cr) if (ke) ue === Cr && P.charCodeAt(oe + 1) === Wn && (ke = !1, oe++);
        else if (ue !== 34 && ue !== 39 || oe !== 0 && P.charCodeAt(oe - 1) === 92) {
          if (re === 0) if (ue === 123) H++;
          else if (ue === 125) {
            if (--H < 0) {
              for (var xe = oe + 1; xe < O; ) {
                var He = P.charCodeAt(xe);
                if (He === 59 || He === 10) break;
                xe++;
              }
              xe < O && P.charCodeAt(xe) === 59 && xe++, H = 0, oe = xe - 1, $ = xe;
              continue;
            }
            H === 0 && (M += P.substring($, oe + 1), $ = oe + 1);
          } else ue === 59 && H === 0 && (M += P.substring($, oe + 1), $ = oe + 1);
        } else re === 0 ? re = ue : re === ue && (re = 0);
        else ke = !0, oe++;
      }
      if ($ < O) {
        var $e = P.substring($);
        Yd($e) || (M += $e);
      }
      return M;
    }(function(P) {
      if (P.indexOf("//") === -1) return P;
      for (var O = P.length, M = [], $ = 0, H = 0, re = 0, ke = 0; H < O; ) {
        var oe = P.charCodeAt(H);
        if (oe !== 34 && oe !== 39 || H !== 0 && P.charCodeAt(H - 1) === 92) if (re === 0) if (oe === Wn && H + 1 < O && P.charCodeAt(H + 1) === Cr) {
          for (H += 2; H + 1 < O && (P.charCodeAt(H) !== Cr || P.charCodeAt(H + 1) !== Wn); ) H++;
          H += 2;
        } else if (oe === 40 && H >= 3 && (32 | P.charCodeAt(H - 1)) == 108 && (32 | P.charCodeAt(H - 2)) == 114 && (32 | P.charCodeAt(H - 3)) == 117) ke = 1, H++;
        else if (ke > 0) oe === 41 ? ke-- : oe === 40 && ke++, H++;
        else if (oe === Cr && H + 1 < O && P.charCodeAt(H + 1) === Wn) H > $ && M.push(P.substring($, H)), $ = H += 2;
        else if (oe === Wn && H + 1 < O && P.charCodeAt(H + 1) === Wn) {
          for (H > $ && M.push(P.substring($, H)); H < O && P.charCodeAt(H) !== 10; ) H++;
          $ = H;
        } else H++;
        else H++;
        else re === 0 ? re = oe : re === oe && (re = 0), H++;
      }
      return $ === 0 ? P : ($ < O && M.push(P.substring($)), M.join(""));
    }(A)), q = sx(R || _ ? "".concat(R, " ").concat(_, " { ").concat(U, " }") : U);
    return l.namespace && (q = Fg(q, l.namespace)), v = [], Ia(q, x), v;
  };
  return C.hash = f.length ? f.reduce(function(A, _) {
    return _.name || fi(15), rr(A, _.name);
  }, 5381).toString() : "", C;
}
var Gx = new Mg(), Xu = Hx(), Wg = N.createContext({ shouldForwardProp: void 0, styleSheet: Gx, stylis: Xu });
Wg.Consumer;
N.createContext(void 0);
function Zd() {
  return N.useContext(Wg);
}
var Ug = N.createContext(void 0);
Ug.Consumer;
var Iu = {}, Kd = /* @__PURE__ */ new Set();
function Yx(t, n, i) {
  var s = kc(t), o = t, u = !bu(t), l = n.attrs, d = l === void 0 ? Oc : l, f = n.componentId, m = f === void 0 ? function(P, O) {
    var M = typeof P != "string" ? "sc" : Fd(P);
    Iu[M] = (Iu[M] || 0) + 1;
    var $ = "".concat(M, "-").concat(Ig(Ba + M + Iu[M]));
    return O ? "".concat(O, "-").concat($) : $;
  }(n.displayName, n.parentComponentId) : f, T = n.displayName, v = T === void 0 ? function(P) {
    return bu(P) ? "styled.".concat(P) : "Styled(".concat(Ag(P), ")");
  }(t) : T, x = n.displayName && n.componentId ? "".concat(Fd(n.displayName), "-").concat(n.componentId) : n.componentId || m, C = s && o.attrs ? o.attrs.concat(d).filter(Boolean) : d, A = n.shouldForwardProp;
  if (s && o.shouldForwardProp) {
    var _ = o.shouldForwardProp;
    if (n.shouldForwardProp) {
      var R = n.shouldForwardProp;
      A = function(P, O) {
        return _(P, O) && R(P, O);
      };
    } else A = _;
  }
  var L = new Bx(i, x, s ? o.componentStyle : void 0);
  function U(P, O) {
    return function(M, $, H) {
      var re = M.attrs, ke = M.componentStyle, oe = M.defaultProps, ue = M.foldedComponentIds, xe = M.styledComponentId, He = M.target, $e = N.useContext(Ug), st = Zd(), X = M.shouldForwardProp || st.shouldForwardProp;
      process.env.NODE_ENV !== "production" && N.useDebugValue && N.useDebugValue(xe);
      var ze = yx($, $e, oe) || si, je = function(ce, le, me) {
        for (var ve, he = Rt(Rt({}, le), { className: void 0, theme: me }), Ke = 0; Ke < ce.length; Ke += 1) {
          var G = ai(ve = ce[Ke]) ? ve(he) : ve;
          for (var Xe in G) Xe === "className" ? he.className = _r(he.className, G[Xe]) : Xe === "style" ? he.style = Rt(Rt({}, he.style), G[Xe]) : Xe in le && le[Xe] === void 0 || (he[Xe] = G[Xe]);
        }
        return "className" in le && typeof le.className == "string" && (he.className = _r(he.className, le.className)), he;
      }(re, $, ze), B = je.as || He, V = {};
      for (var Y in je) je[Y] === void 0 || Y[0] === "$" || Y === "as" || Y === "theme" && je.theme === ze || (Y === "forwardedAs" ? V.as = je.forwardedAs : X && !X(Y, B) || (V[Y] = je[Y], X || process.env.NODE_ENV !== "development" || HC(Y) || Kd.has(Y) || !Zu.has(B) || (Kd.add(Y), console.warn('styled-components: it looks like an unknown prop "'.concat(Y, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var ne = function(ce, le) {
        var me = Zd(), ve = ce.generateAndInjectStyles(le, me.styleSheet, me.stylis);
        return process.env.NODE_ENV !== "production" && N.useDebugValue && N.useDebugValue(ve.className), ve;
      }(ke, je), te = ne.className;
      process.env.NODE_ENV !== "production" && M.warnTooManyClasses && M.warnTooManyClasses(te);
      var pe = _r(ue, xe);
      return te && (pe += " " + te), je.className && (pe += " " + je.className), V[bu(B) && !Zu.has(B) ? "class" : "className"] = pe, H && (V.ref = H), SC(B, V);
    }(q, P, O);
  }
  U.displayName = v;
  var q = N.forwardRef(U);
  return q.attrs = C, q.componentStyle = L, q.displayName = v, q.shouldForwardProp = A, q.foldedComponentIds = s ? _r(o.foldedComponentIds, o.styledComponentId) : "", q.styledComponentId = x, q.target = s ? o.target : t, Object.defineProperty(q, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(P) {
    this._foldedDefaultProps = s ? function(O) {
      for (var M = [], $ = 1; $ < arguments.length; $++) M[$ - 1] = arguments[$];
      for (var H = 0, re = M; H < re.length; H++) Ju(O, re[H], !0);
      return O;
    }({}, o.defaultProps, P) : P;
  } }), process.env.NODE_ENV !== "production" && (mx(v, x), q.warnTooManyClasses = /* @__PURE__ */ function(P, O) {
    var M = {}, $ = !1;
    return function(H) {
      if (!$ && (M[H] = !0, Object.keys(M).length >= 200)) {
        var re = O ? ' with the id of "'.concat(O, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(P).concat(re, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), $ = !0, M = {};
      }
    };
  }(v, x)), $c(q, function() {
    return ".".concat(q.styledComponentId);
  }), u && Ng(q, t, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), q;
}
function Qd(t, n) {
  for (var i = [t[0]], s = 0, o = n.length; s < o; s += 1) i.push(n[s], t[s + 1]);
  return i;
}
var Jd = function(t) {
  return Object.assign(t, { isCss: !0 });
};
function qg(t) {
  for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
  if (ai(t) || oi(t)) return Jd(Ir(Qd(Oc, Or([t], n, !0))));
  var s = t;
  return n.length === 0 && s.length === 1 && typeof s[0] == "string" ? Ir(s) : Jd(Ir(Qd(s, n)));
}
function ec(t, n, i) {
  if (i === void 0 && (i = si), !n) throw fi(1, n);
  var s = function(o) {
    for (var u = [], l = 1; l < arguments.length; l++) u[l - 1] = arguments[l];
    return t(n, i, qg.apply(void 0, Or([o], u, !1)));
  };
  return s.attrs = function(o) {
    return ec(t, n, Rt(Rt({}, i), { attrs: Array.prototype.concat(i.attrs, o).filter(Boolean) }));
  }, s.withConfig = function(o) {
    return ec(t, n, Rt(Rt({}, i), o));
  }, s;
}
var zg = function(t) {
  return ec(Yx, t);
}, Q = zg;
Zu.forEach(function(t) {
  Q[t] = zg(t);
});
var Bg, Zx = function() {
  function t(n, i) {
    var s = this;
    this[Bg] = !0, this.inject = function(o, u) {
      u === void 0 && (u = Xu);
      var l = s.name + u.hash;
      o.hasNameForId(s.id, l) || o.insertRules(s.id, l, u(s.rules, l, "@keyframes"));
    }, this.name = n, this.id = "sc-keyframes-".concat(n), this.rules = i, $c(this, function() {
      throw fi(12, String(s.name));
    });
  }
  return t.prototype.getName = function(n) {
    return n === void 0 && (n = Xu), this.name + n.hash;
  }, t;
}();
function Kx(t) {
  for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
  process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  var s = Qu(qg.apply(void 0, Or([t], n, !1))), o = Ig(s);
  return new Zx(o, s);
}
Bg = Pg;
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var ra = "__sc-".concat($r, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[ra] || (window[ra] = 0), window[ra] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page for more info.`), window[ra] += 1);
const Qx = Q.li`
  list-style: none;
  margin: 0;
  padding: 0;
  border: ${b.borders.widthSmall} solid ${b.colors.contrasts.grey1214};
  border-radius: ${b.borders.radiusLarge};
  box-shadow: ${b.shadows.resting};
  width: 100%;
`, Jx = Q.div`
  background: ${b.colors.contrasts.grey100100};
  border-radius: ${b.borders.radiusLarge} ${b.borders.radiusLarge} 0 0;
  padding: ${b.spacing.small} ${b.spacing.medium};
  display: flex;
  flex-direction: row;
  gap: ${b.spacing.small};
  align-items: flex-start;
`, jx = Q.div`
  display: flex;
  flex-direction: column;
  gap: ${b.spacing.small};
  flex: 1;
  min-width: 0;
`, Xx = Q.div`
  display: flex;
  flex-direction: row;
  gap: ${b.spacing.small};
`, e_ = Q.div`
  padding: ${b.spacing.medium} ${b.spacing.small};
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: ${b.spacing.medium};
`, t_ = Q.div`
  padding: ${b.spacing.small};
  border: ${b.borders.widthSmall} solid ${b.colors.contrasts.grey1214};
  border-radius: ${b.borders.radiusLarge};
  display: flex;
  flex-direction: column;
  gap: ${b.spacing.xxSmall};
`, n_ = Q.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${b.spacing.small};
  padding: ${b.spacing.small};
  border: ${b.borders.widthSmall} solid ${b.colors.contrasts.grey1214};
  border-radius: ${b.borders.radiusLarge};
  background: ${b.colors.contrasts.white1010};
  box-shadow: ${b.shadows.resting};
`, r_ = Q.div`
  display: flex;
  flex-direction: column;
  gap: ${b.spacing.xxSmall};
  flex: 1;
  min-width: 0;
`, i_ = Q.div`
  border: ${b.borders.widthSmall} solid ${b.colors.contrasts.grey1214};
  border-radius: ${b.borders.radiusLarge};
  padding: ${b.spacing.small} ${b.spacing.medium};
  display: flex;
  flex-direction: column;
  gap: ${b.spacing.small};
`, s_ = Q.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${b.spacing.small};
  justify-content: space-between;
`, a_ = Q.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${b.spacing.small};
`, o_ = Q.div`
  display: flex;
  flex-direction: row;
  gap: ${b.spacing.xSmall};
`, u_ = Q.div`
  display: flex;
  flex-direction: row;
  gap: ${b.spacing.small};
  align-items: flex-end;
`, c_ = Q.div`
  display: flex;
  flex-direction: column;
  gap: ${b.spacing.small};
`, jd = Q.div`
  display: grid;
  grid-template-columns: 1fr 2fr 40px;
  gap: ${b.spacing.medium};
  align-items: center;
  padding: ${b.spacing.xSmall} 0;
`, l_ = Q.span`
	display: flex;
	align-items: center;
	gap: ${b.spacing.small};
`, f_ = Q.span`
	display: flex;
	flex-direction: column;
	gap: ${b.spacing.xxxSmall};
`, d_ = Kx`
  0%   { background-position: -200% 0; }
  100% { background-position:  200% 0; }
`, Ie = Q.div`
  width:         ${({ $width: t }) => t ?? "100%"};
  height:        ${({ $height: t }) => t ?? "1rem"};
  border-radius: ${({ $radius: t }) => t ?? b.borders.radiusMedium};
  flex-shrink: 0;

  background: ${({ $dark: t }) => t ? "linear-gradient(90deg, rgb(255 255 255 / 8%) 25%, rgb(255 255 255 / 18%) 50%, rgb(255 255 255 / 8%) 75%)" : `linear-gradient(90deg, ${b.colors.contrasts.grey1214} 25%, ${b.colors.contrasts.grey1111} 50%, ${b.colors.contrasts.grey1214} 75%)`};
  background-size: 200% 100%;
  animation: ${d_} 1.5s infinite linear;
`, Xd = () => /* @__PURE__ */ J(Qx, { "aria-hidden": !0, children: [
  /* @__PURE__ */ J(Jx, { children: [
    /* @__PURE__ */ y(
      Ie,
      {
        $dark: !0,
        $width: b.typography.fontSizeXLarge,
        $height: b.typography.fontSizeXLarge,
        $radius: b.borders.radiusMedium
      }
    ),
    /* @__PURE__ */ J(jx, { children: [
      /* @__PURE__ */ y(Ie, { $dark: !0, $width: "35%", $height: b.typography.fontSizeMedium }),
      /* @__PURE__ */ y(Ie, { $dark: !0, $width: "65%", $height: b.typography.fontSizeSmall }),
      /* @__PURE__ */ J(Xx, { children: [
        /* @__PURE__ */ y(
          Ie,
          {
            $dark: !0,
            $width: b.breakpoints.xxSmall,
            $height: b.spacing.medium,
            $radius: "999px"
          }
        ),
        /* @__PURE__ */ y(
          Ie,
          {
            $dark: !0,
            $width: b.spacing.space48,
            $height: b.spacing.medium,
            $radius: "999px"
          }
        ),
        /* @__PURE__ */ y(
          Ie,
          {
            $dark: !0,
            $width: b.spacing.space48,
            $height: b.spacing.medium,
            $radius: "999px"
          }
        )
      ] })
    ] })
  ] }),
  /* @__PURE__ */ y(e_, { children: Xi(4).map((t) => /* @__PURE__ */ J(t_, { children: [
    /* @__PURE__ */ y(Ie, { $width: "50%", $height: b.typography.fontSizeSmall }),
    /* @__PURE__ */ y(Ie, { $width: "75%", $height: b.typography.fontSizeXSmall })
  ] }, t.id)) })
] }), h_ = {
  accountTags: "Account tags",
  active: "Active",
  add: "Add",
  archive: "Archive",
  cancel: "Cancel",
  close: "Close",
  createdAt: "Created: %{date}",
  edit: "Edit",
  id: "ID",
  loadingData: "Loading data",
  moreOptions: "More options",
  move: "Move",
  name: "Name",
  nextPage: "Next page",
  people: "People",
  peopleManagement: "People management",
  permissions: "Permissions",
  previousPage: "Previous page",
  restoreAssociations: "Restore previous account associations",
  restoreTagDescription: "Once you restore this tag, it will become active immediately. Do you also want to restore previous account associations? This will affect %{count} people.",
  save: "Save",
  search: "Search",
  searchAndFilter: "Search and filter",
  searchPeople: "Search or select people",
  selectedPeople: { one: "%{count} person selected", other: "%{count} people selected" },
  sisId: "SIS ID",
  title: "Institutional Tagging",
  view: "View"
}, g_ = {
  addPeopleFailed: "Failed to add people to tag.",
  addPeopleRequired: "Select at least one person.",
  archiveCategoryAlreadyArchived: "This category has already been archived.",
  archiveCategoryFailed: "Failed to archive category.",
  archiveTagFailed: "Failed to archive tag.",
  archiveTagNotFound: "Tag not found or already archived.",
  archiveTagUnprocessable: "This tag cannot be archived in its current state.",
  categoryNameAlreadyExists: "A category with this name already exists.",
  categoryNameRequired: "Category name is required.",
  categoryRequired: "Category is required.",
  loadCategories: "Failed to load categories: %{errorMessage}",
  removeUserFromTagFailed: "Failed to remove user from tag.",
  restoreTagCategoryRequired: "Select a category to restore the tag.",
  restoreTagFailed: "Failed to restore tag.",
  saveCategoryFailed: "Failed to save category. Please try again.",
  tagAlreadyExists: "This tag name already exists.",
  tagDescriptionRequired: "Tag description is required.",
  tagMoveConflict: "A tag with this name already exists in the selected category.",
  tagMoveFailed: "Failed to move the tag. Please try again.",
  tagMoveInvalidState: "This tag cannot be moved.",
  tagMoveNotFound: "Tag not found.",
  tagNameRequired: "Tag name is required."
}, p_ = {
  addPeopleSuccess: {
    one: "%{count} person added to %{tagName}",
    other: "%{count} people added to %{tagName}"
  },
  categoryArchiveSuccess: "Category archived",
  categoryCreated: "Category created",
  categoryUpdated: "Category changes saved",
  tagArchived: "Tag archived",
  tagDeleted: "Tag deleted",
  tagMoved: "Tag moved to %{categoryName}",
  tagRestored: "Tag restored",
  tagSaved: "Tag saved",
  tagUpdated: "Tag changes saved",
  userRemovedFromTag: "User removed from tag"
}, m_ = {
  addPeople: "Add people",
  addPeopleToTag: "Add people to tag",
  addTag: "Add tag",
  addTags: "Add tags",
  archiveTag: "Archive tag",
  archiveTagConfirmation: "Archiving this tag means it will no longer be active or available for use. You can restore it later if needed.",
  assignTag: "Assign people to tag",
  editTag: "Edit tag",
  moveTags: "Move tags",
  moveTo: "Move to",
  newTag: "New tag",
  noResultsFound: "No results found",
  removeSelectedUser: "Remove %{userName}",
  removeUserFromTag: "Remove user from tag",
  restoreTag: "Restore tag",
  sortPeople: "Sort people",
  tagActions: "Actions for %{tagName} tag",
  tagAssociationCount: {
    one: "%{count} associated user with tag: %{tagName}",
    other: "%{count} associated users with tag: %{tagName}"
  },
  tagDescriptionLabel: "Tag description",
  tagDescriptionPlaceholder: "Briefly describe this tag",
  tagFieldGroupLabel: "Tag details",
  tagNameLabel: "Tag name",
  tagNameNoMatches: "No matching tags",
  tagNamePlaceholder: "Name this tag",
  tagsSelected: { one: "%{count} tag selected", other: "%{count} tags selected" },
  viewTagDetails: "View tag details"
}, y_ = {
  addTagToCategory: "Add tag to %{categoryName} category",
  archiveCategoryConfirmation: "Tags in this category will remain active but become uncategorized.",
  category: "Category",
  categoryArchived: "Archived",
  categoryAssociationCount: {
    one: "%{count} associated user with category: %{categoryName}",
    other: "%{count} associated users with category: %{categoryName}"
  },
  categoryDescriptionLabel: "Category description",
  categoryDescriptionPlaceholder: "Briefly describe this category",
  categoryMenuLabel: "Actions for %{category}",
  categoryMoreOptions: "More options for %{categoryName} category",
  categoryNameLabel: "Category name",
  categoryNameNoMatches: "No matching categories",
  categoryNamePlaceholder: "Enter a new category name",
  categoryPlaceholder: "Select a category",
  categoryTagCount: {
    one: "%{count} tag in %{categoryName} category",
    other: "%{count} tags in %{categoryName} category"
  },
  collapseAll: "Collapse all",
  collapseCategory: "Collapse %{categoryName} category",
  createNewCategoryOption: "Create new category",
  editCategory: "Edit category",
  expandCategory: "Expand %{categoryName} category",
  expendAll: "Expand all",
  newCategory: "New category",
  newCategoryDescriptionLabel: "Description",
  searchResults: "%{resultCount} results found",
  selectCategoryToMove: "Select a new category to move",
  sortCategories: "Sort categories",
  sortCategoriesAscending: "Sort categories: ascending",
  sortCategoriesDescending: "Sort categories: descending"
}, Vg = {
  ...h_,
  ...g_,
  ...p_,
  ...m_,
  ...y_
}, Hg = N.createContext(void 0);
function v_({
  translations: t,
  translate: n,
  children: i
}) {
  const s = { translations: t, translate: n };
  return /* @__PURE__ */ y(Hg.Provider, { value: s, children: i });
}
function Ae() {
  const t = N.useContext(Hg);
  if (!t)
    throw new Error("useTranslations must be used within TranslationsProvider");
  const n = N.useCallback(
    (i) => w_(i, t.translate),
    [t.translate]
  );
  return { ...t, resolveToken: n };
}
const w_ = (t, n) => {
  if (typeof t == "string") return n(t);
  if ("count" in t) {
    const i = "vars" in t ? t.vars : {};
    return n(t.key, { count: t.count, ...i });
  }
  return n(t.key, t.vars);
}, T_ = (t, n) => {
  const i = Vg[t];
  let s;
  if (typeof i == "object" && "one" in i && "other" in i) {
    const o = Number((n == null ? void 0 : n.count) ?? 0);
    s = new Intl.PluralRules("en").select(o) === "one" ? i.one : i.other;
  } else
    s = i || t;
  return n ? s.replace(/%\{([^}]+)}/g, (o, u) => u in n ? String(n[u]) : o) : s;
}, Gg = N.createContext({
  isMultiSelectEnabled: !1,
  setIsMultiSelectEnabled: () => {
  },
  selectedTags: [],
  setSelectedTags: () => {
  },
  categoryMoreButtonRef: { current: null }
}), S_ = ({
  children: t,
  editHandler: n,
  archiveHandler: i
}) => {
  const [s, o] = N.useState(!1), [u, l] = N.useState([]), d = N.useRef(null);
  return /* @__PURE__ */ y(
    Gg.Provider,
    {
      value: {
        isMultiSelectEnabled: s,
        setIsMultiSelectEnabled: o,
        selectedTags: u,
        setSelectedTags: l,
        categoryMoreButtonRef: d,
        editHandler: n,
        archiveHandler: i
      },
      children: t
    }
  );
}, Yg = () => N.useContext(Gg), Zg = N.createContext({
  allExpanded: !0,
  handleExpandAllToggle: () => {
  }
}), C_ = ({ children: t }) => {
  const [n, i] = N.useState(!0), s = () => i((o) => !o);
  return /* @__PURE__ */ y(Zg.Provider, { value: { allExpanded: n, handleExpandAllToggle: s }, children: t });
}, Kg = () => N.useContext(Zg);
var Sn = /* @__PURE__ */ ((t) => (t.Large = "large", t.Medium = "medium", t.Small = "small", t))(Sn || {}), Zi = /* @__PURE__ */ ((t) => (t[t.Large = 992] = "Large", t[t.Medium = 768] = "Medium", t[t.Small = 480] = "Small", t))(Zi || {});
const Xr = {
  [Sn.Large]: Zi.Large,
  [Sn.Medium]: Zi.Medium,
  [Sn.Small]: Zi.Small
}, Qg = {
  width: Xr[Sn.Large],
  isMobile: !1,
  isTablet: !1,
  isTabletOrMobile: !1,
  isLargeScreen: !0
}, Jg = N.createContext(Qg), Va = () => N.useContext(Jg);
var Oa = /* @__PURE__ */ ((t) => (t.Active = "active", t.Archive = "archive", t))(Oa || {}), zn = /* @__PURE__ */ ((t) => (t.Active = "active", t.Deleted = "deleted", t))(zn || {}), sr = /* @__PURE__ */ ((t) => (t.Asc = "asc", t.Desc = "desc", t))(sr || {});
class Rr extends Error {
}
class x_ extends Rr {
  constructor(n) {
    super(`Invalid DateTime: ${n.toMessage()}`);
  }
}
class __ extends Rr {
  constructor(n) {
    super(`Invalid Interval: ${n.toMessage()}`);
  }
}
class b_ extends Rr {
  constructor(n) {
    super(`Invalid Duration: ${n.toMessage()}`);
  }
}
class ei extends Rr {
}
class jg extends Rr {
  constructor(n) {
    super(`Invalid unit ${n}`);
  }
}
class St extends Rr {
}
class tr extends Rr {
  constructor() {
    super("Zone is an abstract class");
  }
}
const K = "numeric", gn = "short", qt = "long", ka = {
  year: K,
  month: K,
  day: K
}, Xg = {
  year: K,
  month: gn,
  day: K
}, E_ = {
  year: K,
  month: gn,
  day: K,
  weekday: gn
}, ep = {
  year: K,
  month: qt,
  day: K
}, tp = {
  year: K,
  month: qt,
  day: K,
  weekday: qt
}, np = {
  hour: K,
  minute: K
}, rp = {
  hour: K,
  minute: K,
  second: K
}, ip = {
  hour: K,
  minute: K,
  second: K,
  timeZoneName: gn
}, sp = {
  hour: K,
  minute: K,
  second: K,
  timeZoneName: qt
}, ap = {
  hour: K,
  minute: K,
  hourCycle: "h23"
}, op = {
  hour: K,
  minute: K,
  second: K,
  hourCycle: "h23"
}, up = {
  hour: K,
  minute: K,
  second: K,
  hourCycle: "h23",
  timeZoneName: gn
}, cp = {
  hour: K,
  minute: K,
  second: K,
  hourCycle: "h23",
  timeZoneName: qt
}, lp = {
  year: K,
  month: K,
  day: K,
  hour: K,
  minute: K
}, fp = {
  year: K,
  month: K,
  day: K,
  hour: K,
  minute: K,
  second: K
}, dp = {
  year: K,
  month: gn,
  day: K,
  hour: K,
  minute: K
}, hp = {
  year: K,
  month: gn,
  day: K,
  hour: K,
  minute: K,
  second: K
}, I_ = {
  year: K,
  month: gn,
  day: K,
  weekday: gn,
  hour: K,
  minute: K
}, gp = {
  year: K,
  month: qt,
  day: K,
  hour: K,
  minute: K,
  timeZoneName: gn
}, pp = {
  year: K,
  month: qt,
  day: K,
  hour: K,
  minute: K,
  second: K,
  timeZoneName: gn
}, mp = {
  year: K,
  month: qt,
  day: K,
  weekday: qt,
  hour: K,
  minute: K,
  timeZoneName: qt
}, yp = {
  year: K,
  month: qt,
  day: K,
  weekday: qt,
  hour: K,
  minute: K,
  second: K,
  timeZoneName: qt
};
class ss {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new tr();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new tr();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new tr();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, i) {
    throw new tr();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, i) {
    throw new tr();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    throw new tr();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    throw new tr();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new tr();
  }
}
let Au = null;
class Ha extends ss {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return Au === null && (Au = new Ha()), Au;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(n, { format: i, locale: s }) {
    return Ap(n, i, s);
  }
  /** @override **/
  formatOffset(n, i) {
    return Ki(this.offset(n), i);
  }
  /** @override **/
  offset(n) {
    return -new Date(n).getTimezoneOffset();
  }
  /** @override **/
  equals(n) {
    return n.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const tc = /* @__PURE__ */ new Map();
function A_(t) {
  let n = tc.get(t);
  return n === void 0 && (n = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), tc.set(t, n)), n;
}
const O_ = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function k_(t, n) {
  const i = t.format(n).replace(/\u200E/g, ""), s = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(i), [, o, u, l, d, f, m, T] = s;
  return [l, o, u, d, f, m, T];
}
function $_(t, n) {
  const i = t.formatToParts(n), s = [];
  for (let o = 0; o < i.length; o++) {
    const { type: u, value: l } = i[o], d = O_[u];
    u === "era" ? s[d] = l : fe(d) || (s[d] = parseInt(l, 10));
  }
  return s;
}
const Ou = /* @__PURE__ */ new Map();
class Bn extends ss {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(n) {
    let i = Ou.get(n);
    return i === void 0 && Ou.set(n, i = new Bn(n)), i;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    Ou.clear(), tc.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(n) {
    return this.isValidZone(n);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(n) {
    if (!n)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: n }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(n) {
    super(), this.zoneName = n, this.valid = Bn.isValidZone(n);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, { format: i, locale: s }) {
    return Ap(n, i, s, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, i) {
    return Ki(this.offset(n), i);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    if (!this.valid) return NaN;
    const i = new Date(n);
    if (isNaN(i)) return NaN;
    const s = A_(this.name);
    let [o, u, l, d, f, m, T] = s.formatToParts ? $_(s, i) : k_(s, i);
    d === "BC" && (o = -Math.abs(o) + 1);
    const x = Ya({
      year: o,
      month: u,
      day: l,
      hour: f === 24 ? 0 : f,
      minute: m,
      second: T,
      millisecond: 0
    });
    let C = +i;
    const A = C % 1e3;
    return C -= A >= 0 ? A : 1e3 + A, (x - C) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "iana" && n.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let eh = {};
function N_(t, n = {}) {
  const i = JSON.stringify([t, n]);
  let s = eh[i];
  return s || (s = new Intl.ListFormat(t, n), eh[i] = s), s;
}
const nc = /* @__PURE__ */ new Map();
function rc(t, n = {}) {
  const i = JSON.stringify([t, n]);
  let s = nc.get(i);
  return s === void 0 && (s = new Intl.DateTimeFormat(t, n), nc.set(i, s)), s;
}
const ic = /* @__PURE__ */ new Map();
function R_(t, n = {}) {
  const i = JSON.stringify([t, n]);
  let s = ic.get(i);
  return s === void 0 && (s = new Intl.NumberFormat(t, n), ic.set(i, s)), s;
}
const sc = /* @__PURE__ */ new Map();
function M_(t, n = {}) {
  const { base: i, ...s } = n, o = JSON.stringify([t, s]);
  let u = sc.get(o);
  return u === void 0 && (u = new Intl.RelativeTimeFormat(t, n), sc.set(o, u)), u;
}
let zi = null;
function P_() {
  return zi || (zi = new Intl.DateTimeFormat().resolvedOptions().locale, zi);
}
const ac = /* @__PURE__ */ new Map();
function vp(t) {
  let n = ac.get(t);
  return n === void 0 && (n = new Intl.DateTimeFormat(t).resolvedOptions(), ac.set(t, n)), n;
}
const oc = /* @__PURE__ */ new Map();
function D_(t) {
  let n = oc.get(t);
  if (!n) {
    const i = new Intl.Locale(t);
    n = "getWeekInfo" in i ? i.getWeekInfo() : i.weekInfo, "minimalDays" in n || (n = { ...wp, ...n }), oc.set(t, n);
  }
  return n;
}
function L_(t) {
  const n = t.indexOf("-x-");
  n !== -1 && (t = t.substring(0, n));
  const i = t.indexOf("-u-");
  if (i === -1)
    return [t];
  {
    let s, o;
    try {
      s = rc(t).resolvedOptions(), o = t;
    } catch {
      const f = t.substring(0, i);
      s = rc(f).resolvedOptions(), o = f;
    }
    const { numberingSystem: u, calendar: l } = s;
    return [o, u, l];
  }
}
function F_(t, n, i) {
  return (i || n) && (t.includes("-u-") || (t += "-u"), i && (t += `-ca-${i}`), n && (t += `-nu-${n}`)), t;
}
function W_(t) {
  const n = [];
  for (let i = 1; i <= 12; i++) {
    const s = de.utc(2009, i, 1);
    n.push(t(s));
  }
  return n;
}
function U_(t) {
  const n = [];
  for (let i = 1; i <= 7; i++) {
    const s = de.utc(2016, 11, 13 + i);
    n.push(t(s));
  }
  return n;
}
function ia(t, n, i, s) {
  const o = t.listingMode();
  return o === "error" ? null : o === "en" ? i(n) : s(n);
}
function q_(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || vp(t.locale).numberingSystem === "latn";
}
class z_ {
  constructor(n, i, s) {
    this.padTo = s.padTo || 0, this.floor = s.floor || !1;
    const { padTo: o, floor: u, ...l } = s;
    if (!i || Object.keys(l).length > 0) {
      const d = { useGrouping: !1, ...s };
      s.padTo > 0 && (d.minimumIntegerDigits = s.padTo), this.inf = R_(n, d);
    }
  }
  format(n) {
    if (this.inf) {
      const i = this.floor ? Math.floor(n) : n;
      return this.inf.format(i);
    } else {
      const i = this.floor ? Math.floor(n) : Dc(n, 3);
      return at(i, this.padTo);
    }
  }
}
class B_ {
  constructor(n, i, s) {
    this.opts = s, this.originalZone = void 0;
    let o;
    if (this.opts.timeZone)
      this.dt = n;
    else if (n.zone.type === "fixed") {
      const l = -1 * (n.offset / 60), d = l >= 0 ? `Etc/GMT+${l}` : `Etc/GMT${l}`;
      n.offset !== 0 && Bn.create(d).valid ? (o = d, this.dt = n) : (o = "UTC", this.dt = n.offset === 0 ? n : n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    } else n.zone.type === "system" ? this.dt = n : n.zone.type === "iana" ? (this.dt = n, o = n.zone.name) : (o = "UTC", this.dt = n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    const u = { ...this.opts };
    u.timeZone = u.timeZone || o, this.dtf = rc(i, u);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: n }) => n).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const n = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? n.map((i) => {
      if (i.type === "timeZoneName") {
        const s = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...i,
          value: s
        };
      } else
        return i;
    }) : n;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class V_ {
  constructor(n, i, s) {
    this.opts = { style: "long", ...s }, !i && Ep() && (this.rtf = M_(n, s));
  }
  format(n, i) {
    return this.rtf ? this.rtf.format(n, i) : db(i, n, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(n, i) {
    return this.rtf ? this.rtf.formatToParts(n, i) : [];
  }
}
const wp = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class qe {
  static fromOpts(n) {
    return qe.create(
      n.locale,
      n.numberingSystem,
      n.outputCalendar,
      n.weekSettings,
      n.defaultToEN
    );
  }
  static create(n, i, s, o, u = !1) {
    const l = n || nt.defaultLocale, d = l || (u ? "en-US" : P_()), f = i || nt.defaultNumberingSystem, m = s || nt.defaultOutputCalendar, T = cc(o) || nt.defaultWeekSettings;
    return new qe(d, f, m, T, l);
  }
  static resetCache() {
    zi = null, nc.clear(), ic.clear(), sc.clear(), ac.clear(), oc.clear();
  }
  static fromObject({ locale: n, numberingSystem: i, outputCalendar: s, weekSettings: o } = {}) {
    return qe.create(n, i, s, o);
  }
  constructor(n, i, s, o, u) {
    const [l, d, f] = L_(n);
    this.locale = l, this.numberingSystem = i || d || null, this.outputCalendar = s || f || null, this.weekSettings = o, this.intl = F_(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = u, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = q_(this)), this.fastNumbersCached;
  }
  listingMode() {
    const n = this.isEnglish(), i = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return n && i ? "en" : "intl";
  }
  clone(n) {
    return !n || Object.getOwnPropertyNames(n).length === 0 ? this : qe.create(
      n.locale || this.specifiedLocale,
      n.numberingSystem || this.numberingSystem,
      n.outputCalendar || this.outputCalendar,
      cc(n.weekSettings) || this.weekSettings,
      n.defaultToEN || !1
    );
  }
  redefaultToEN(n = {}) {
    return this.clone({ ...n, defaultToEN: !0 });
  }
  redefaultToSystem(n = {}) {
    return this.clone({ ...n, defaultToEN: !1 });
  }
  months(n, i = !1) {
    return ia(this, n, $p, () => {
      const s = this.intl === "ja" || this.intl.startsWith("ja-");
      i &= !s;
      const o = i ? { month: n, day: "numeric" } : { month: n }, u = i ? "format" : "standalone";
      if (!this.monthsCache[u][n]) {
        const l = s ? (d) => this.dtFormatter(d, o).format() : (d) => this.extract(d, o, "month");
        this.monthsCache[u][n] = W_(l);
      }
      return this.monthsCache[u][n];
    });
  }
  weekdays(n, i = !1) {
    return ia(this, n, Mp, () => {
      const s = i ? { weekday: n, year: "numeric", month: "long", day: "numeric" } : { weekday: n }, o = i ? "format" : "standalone";
      return this.weekdaysCache[o][n] || (this.weekdaysCache[o][n] = U_(
        (u) => this.extract(u, s, "weekday")
      )), this.weekdaysCache[o][n];
    });
  }
  meridiems() {
    return ia(
      this,
      void 0,
      () => Pp,
      () => {
        if (!this.meridiemCache) {
          const n = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [de.utc(2016, 11, 13, 9), de.utc(2016, 11, 13, 19)].map(
            (i) => this.extract(i, n, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(n) {
    return ia(this, n, Dp, () => {
      const i = { era: n };
      return this.eraCache[n] || (this.eraCache[n] = [de.utc(-40, 1, 1), de.utc(2017, 1, 1)].map(
        (s) => this.extract(s, i, "era")
      )), this.eraCache[n];
    });
  }
  extract(n, i, s) {
    const o = this.dtFormatter(n, i), u = o.formatToParts(), l = u.find((d) => d.type.toLowerCase() === s);
    return l ? l.value : null;
  }
  numberFormatter(n = {}) {
    return new z_(this.intl, n.forceSimple || this.fastNumbers, n);
  }
  dtFormatter(n, i = {}) {
    return new B_(n, this.intl, i);
  }
  relFormatter(n = {}) {
    return new V_(this.intl, this.isEnglish(), n);
  }
  listFormatter(n = {}) {
    return N_(this.intl, n);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || vp(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : Ip() ? D_(this.locale) : wp;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(n) {
    return this.locale === n.locale && this.numberingSystem === n.numberingSystem && this.outputCalendar === n.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let ku = null;
class It extends ss {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return ku === null && (ku = new It(0)), ku;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(n) {
    return n === 0 ? It.utcInstance : new It(n);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(n) {
    if (n) {
      const i = n.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (i)
        return new It(Za(i[1], i[2]));
    }
    return null;
  }
  constructor(n) {
    super(), this.fixed = n;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Ki(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Ki(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, i) {
    return Ki(this.fixed, i);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "fixed" && n.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class H_ extends ss {
  constructor(n) {
    super(), this.zoneName = n;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function ar(t, n) {
  if (fe(t) || t === null)
    return n;
  if (t instanceof ss)
    return t;
  if (J_(t)) {
    const i = t.toLowerCase();
    return i === "default" ? n : i === "local" || i === "system" ? Ha.instance : i === "utc" || i === "gmt" ? It.utcInstance : It.parseSpecifier(i) || Bn.create(t);
  } else return ur(t) ? It.instance(t) : typeof t == "object" && "offset" in t && typeof t.offset == "function" ? t : new H_(t);
}
const Nc = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, th = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, G_ = Nc.hanidec.replace(/[\[|\]]/g, "").split("");
function Y_(t) {
  let n = parseInt(t, 10);
  if (isNaN(n)) {
    n = "";
    for (let i = 0; i < t.length; i++) {
      const s = t.charCodeAt(i);
      if (t[i].search(Nc.hanidec) !== -1)
        n += G_.indexOf(t[i]);
      else
        for (const o in th) {
          const [u, l] = th[o];
          s >= u && s <= l && (n += s - u);
        }
    }
    return parseInt(n, 10);
  } else
    return n;
}
const uc = /* @__PURE__ */ new Map();
function Z_() {
  uc.clear();
}
function un({ numberingSystem: t }, n = "") {
  const i = t || "latn";
  let s = uc.get(i);
  s === void 0 && (s = /* @__PURE__ */ new Map(), uc.set(i, s));
  let o = s.get(n);
  return o === void 0 && (o = new RegExp(`${Nc[i]}${n}`), s.set(n, o)), o;
}
let nh = () => Date.now(), rh = "system", ih = null, sh = null, ah = null, oh = 60, uh, ch = null;
class nt {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return nh;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    nh = n;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(n) {
    rh = n;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return ar(rh, Ha.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return ih;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(n) {
    ih = n;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return sh;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(n) {
    sh = n;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return ah;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(n) {
    ah = n;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return ch;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(n) {
    ch = cc(n);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return oh;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(n) {
    oh = n % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return uh;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(n) {
    uh = n;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    qe.resetCache(), Bn.resetCache(), de.resetCache(), Z_();
  }
}
class dn {
  constructor(n, i) {
    this.reason = n, this.explanation = i;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const Tp = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], Sp = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function jt(t, n) {
  return new dn(
    "unit out of range",
    `you specified ${n} (of type ${typeof n}) as a ${t}, which is invalid`
  );
}
function Rc(t, n, i) {
  const s = new Date(Date.UTC(t, n - 1, i));
  t < 100 && t >= 0 && s.setUTCFullYear(s.getUTCFullYear() - 1900);
  const o = s.getUTCDay();
  return o === 0 ? 7 : o;
}
function Cp(t, n, i) {
  return i + (as(t) ? Sp : Tp)[n - 1];
}
function xp(t, n) {
  const i = as(t) ? Sp : Tp, s = i.findIndex((u) => u < n), o = n - i[s];
  return { month: s + 1, day: o };
}
function Mc(t, n) {
  return (t - n + 7) % 7 + 1;
}
function $a(t, n = 4, i = 1) {
  const { year: s, month: o, day: u } = t, l = Cp(s, o, u), d = Mc(Rc(s, o, u), i);
  let f = Math.floor((l - d + 14 - n) / 7), m;
  return f < 1 ? (m = s - 1, f = ts(m, n, i)) : f > ts(s, n, i) ? (m = s + 1, f = 1) : m = s, { weekYear: m, weekNumber: f, weekday: d, ...Ka(t) };
}
function lh(t, n = 4, i = 1) {
  const { weekYear: s, weekNumber: o, weekday: u } = t, l = Mc(Rc(s, 1, n), i), d = ti(s);
  let f = o * 7 + u - l - 7 + n, m;
  f < 1 ? (m = s - 1, f += ti(m)) : f > d ? (m = s + 1, f -= ti(s)) : m = s;
  const { month: T, day: v } = xp(m, f);
  return { year: m, month: T, day: v, ...Ka(t) };
}
function $u(t) {
  const { year: n, month: i, day: s } = t, o = Cp(n, i, s);
  return { year: n, ordinal: o, ...Ka(t) };
}
function fh(t) {
  const { year: n, ordinal: i } = t, { month: s, day: o } = xp(n, i);
  return { year: n, month: s, day: o, ...Ka(t) };
}
function dh(t, n) {
  if (!fe(t.localWeekday) || !fe(t.localWeekNumber) || !fe(t.localWeekYear)) {
    if (!fe(t.weekday) || !fe(t.weekNumber) || !fe(t.weekYear))
      throw new ei(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return fe(t.localWeekday) || (t.weekday = t.localWeekday), fe(t.localWeekNumber) || (t.weekNumber = t.localWeekNumber), fe(t.localWeekYear) || (t.weekYear = t.localWeekYear), delete t.localWeekday, delete t.localWeekNumber, delete t.localWeekYear, {
      minDaysInFirstWeek: n.getMinDaysInFirstWeek(),
      startOfWeek: n.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function K_(t, n = 4, i = 1) {
  const s = Ga(t.weekYear), o = Xt(
    t.weekNumber,
    1,
    ts(t.weekYear, n, i)
  ), u = Xt(t.weekday, 1, 7);
  return s ? o ? u ? !1 : jt("weekday", t.weekday) : jt("week", t.weekNumber) : jt("weekYear", t.weekYear);
}
function Q_(t) {
  const n = Ga(t.year), i = Xt(t.ordinal, 1, ti(t.year));
  return n ? i ? !1 : jt("ordinal", t.ordinal) : jt("year", t.year);
}
function _p(t) {
  const n = Ga(t.year), i = Xt(t.month, 1, 12), s = Xt(t.day, 1, Na(t.year, t.month));
  return n ? i ? s ? !1 : jt("day", t.day) : jt("month", t.month) : jt("year", t.year);
}
function bp(t) {
  const { hour: n, minute: i, second: s, millisecond: o } = t, u = Xt(n, 0, 23) || n === 24 && i === 0 && s === 0 && o === 0, l = Xt(i, 0, 59), d = Xt(s, 0, 59), f = Xt(o, 0, 999);
  return u ? l ? d ? f ? !1 : jt("millisecond", o) : jt("second", s) : jt("minute", i) : jt("hour", n);
}
function fe(t) {
  return typeof t > "u";
}
function ur(t) {
  return typeof t == "number";
}
function Ga(t) {
  return typeof t == "number" && t % 1 === 0;
}
function J_(t) {
  return typeof t == "string";
}
function j_(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function Ep() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function Ip() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function X_(t) {
  return Array.isArray(t) ? t : [t];
}
function hh(t, n, i) {
  if (t.length !== 0)
    return t.reduce((s, o) => {
      const u = [n(o), o];
      return s && i(s[0], u[0]) === s[0] ? s : u;
    }, null)[1];
}
function eb(t, n) {
  return n.reduce((i, s) => (i[s] = t[s], i), {});
}
function ui(t, n) {
  return Object.prototype.hasOwnProperty.call(t, n);
}
function cc(t) {
  if (t == null)
    return null;
  if (typeof t != "object")
    throw new St("Week settings must be an object");
  if (!Xt(t.firstDay, 1, 7) || !Xt(t.minimalDays, 1, 7) || !Array.isArray(t.weekend) || t.weekend.some((n) => !Xt(n, 1, 7)))
    throw new St("Invalid week settings");
  return {
    firstDay: t.firstDay,
    minimalDays: t.minimalDays,
    weekend: Array.from(t.weekend)
  };
}
function Xt(t, n, i) {
  return Ga(t) && t >= n && t <= i;
}
function tb(t, n) {
  return t - n * Math.floor(t / n);
}
function at(t, n = 2) {
  const i = t < 0;
  let s;
  return i ? s = "-" + ("" + -t).padStart(n, "0") : s = ("" + t).padStart(n, "0"), s;
}
function ir(t) {
  if (!(fe(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function wr(t) {
  if (!(fe(t) || t === null || t === ""))
    return parseFloat(t);
}
function Pc(t) {
  if (!(fe(t) || t === null || t === "")) {
    const n = parseFloat("0." + t) * 1e3;
    return Math.floor(n);
  }
}
function Dc(t, n, i = "round") {
  const s = 10 ** n;
  switch (i) {
    case "expand":
      return t > 0 ? Math.ceil(t * s) / s : Math.floor(t * s) / s;
    case "trunc":
      return Math.trunc(t * s) / s;
    case "round":
      return Math.round(t * s) / s;
    case "floor":
      return Math.floor(t * s) / s;
    case "ceil":
      return Math.ceil(t * s) / s;
    default:
      throw new RangeError(`Value rounding ${i} is out of range`);
  }
}
function as(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function ti(t) {
  return as(t) ? 366 : 365;
}
function Na(t, n) {
  const i = tb(n - 1, 12) + 1, s = t + (n - i) / 12;
  return i === 2 ? as(s) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][i - 1];
}
function Ya(t) {
  let n = Date.UTC(
    t.year,
    t.month - 1,
    t.day,
    t.hour,
    t.minute,
    t.second,
    t.millisecond
  );
  return t.year < 100 && t.year >= 0 && (n = new Date(n), n.setUTCFullYear(t.year, t.month - 1, t.day)), +n;
}
function gh(t, n, i) {
  return -Mc(Rc(t, 1, n), i) + n - 1;
}
function ts(t, n = 4, i = 1) {
  const s = gh(t, n, i), o = gh(t + 1, n, i);
  return (ti(t) - s + o) / 7;
}
function lc(t) {
  return t > 99 ? t : t > nt.twoDigitCutoffYear ? 1900 + t : 2e3 + t;
}
function Ap(t, n, i, s = null) {
  const o = new Date(t), u = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  s && (u.timeZone = s);
  const l = { timeZoneName: n, ...u }, d = new Intl.DateTimeFormat(i, l).formatToParts(o).find((f) => f.type.toLowerCase() === "timezonename");
  return d ? d.value : null;
}
function Za(t, n) {
  let i = parseInt(t, 10);
  Number.isNaN(i) && (i = 0);
  const s = parseInt(n, 10) || 0, o = i < 0 || Object.is(i, -0) ? -s : s;
  return i * 60 + o;
}
function Op(t) {
  const n = Number(t);
  if (typeof t == "boolean" || t === "" || !Number.isFinite(n))
    throw new St(`Invalid unit value ${t}`);
  return n;
}
function Ra(t, n) {
  const i = {};
  for (const s in t)
    if (ui(t, s)) {
      const o = t[s];
      if (o == null) continue;
      i[n(s)] = Op(o);
    }
  return i;
}
function Ki(t, n) {
  const i = Math.trunc(Math.abs(t / 60)), s = Math.trunc(Math.abs(t % 60)), o = t >= 0 ? "+" : "-";
  switch (n) {
    case "short":
      return `${o}${at(i, 2)}:${at(s, 2)}`;
    case "narrow":
      return `${o}${i}${s > 0 ? `:${s}` : ""}`;
    case "techie":
      return `${o}${at(i, 2)}${at(s, 2)}`;
    default:
      throw new RangeError(`Value format ${n} is out of range for property format`);
  }
}
function Ka(t) {
  return eb(t, ["hour", "minute", "second", "millisecond"]);
}
const nb = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], kp = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], rb = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function $p(t) {
  switch (t) {
    case "narrow":
      return [...rb];
    case "short":
      return [...kp];
    case "long":
      return [...nb];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const Np = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], Rp = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], ib = ["M", "T", "W", "T", "F", "S", "S"];
function Mp(t) {
  switch (t) {
    case "narrow":
      return [...ib];
    case "short":
      return [...Rp];
    case "long":
      return [...Np];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Pp = ["AM", "PM"], sb = ["Before Christ", "Anno Domini"], ab = ["BC", "AD"], ob = ["B", "A"];
function Dp(t) {
  switch (t) {
    case "narrow":
      return [...ob];
    case "short":
      return [...ab];
    case "long":
      return [...sb];
    default:
      return null;
  }
}
function ub(t) {
  return Pp[t.hour < 12 ? 0 : 1];
}
function cb(t, n) {
  return Mp(n)[t.weekday - 1];
}
function lb(t, n) {
  return $p(n)[t.month - 1];
}
function fb(t, n) {
  return Dp(n)[t.year < 0 ? 0 : 1];
}
function db(t, n, i = "always", s = !1) {
  const o = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, u = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (i === "auto" && u) {
    const v = t === "days";
    switch (n) {
      case 1:
        return v ? "tomorrow" : `next ${o[t][0]}`;
      case -1:
        return v ? "yesterday" : `last ${o[t][0]}`;
      case 0:
        return v ? "today" : `this ${o[t][0]}`;
    }
  }
  const l = Object.is(n, -0) || n < 0, d = Math.abs(n), f = d === 1, m = o[t], T = s ? f ? m[1] : m[2] || m[1] : f ? o[t][0] : t;
  return l ? `${d} ${T} ago` : `in ${d} ${T}`;
}
function ph(t, n) {
  let i = "";
  for (const s of t)
    s.literal ? i += s.val : i += n(s.val);
  return i;
}
const hb = {
  D: ka,
  DD: Xg,
  DDD: ep,
  DDDD: tp,
  t: np,
  tt: rp,
  ttt: ip,
  tttt: sp,
  T: ap,
  TT: op,
  TTT: up,
  TTTT: cp,
  f: lp,
  ff: dp,
  fff: gp,
  ffff: mp,
  F: fp,
  FF: hp,
  FFF: pp,
  FFFF: yp
};
class Ct {
  static create(n, i = {}) {
    return new Ct(n, i);
  }
  static parseFormat(n) {
    let i = null, s = "", o = !1;
    const u = [];
    for (let l = 0; l < n.length; l++) {
      const d = n.charAt(l);
      d === "'" ? ((s.length > 0 || o) && u.push({
        literal: o || /^\s+$/.test(s),
        val: s === "" ? "'" : s
      }), i = null, s = "", o = !o) : o || d === i ? s += d : (s.length > 0 && u.push({ literal: /^\s+$/.test(s), val: s }), s = d, i = d);
    }
    return s.length > 0 && u.push({ literal: o || /^\s+$/.test(s), val: s }), u;
  }
  static macroTokenToFormatOpts(n) {
    return hb[n];
  }
  constructor(n, i) {
    this.opts = i, this.loc = n, this.systemLoc = null;
  }
  formatWithSystemDefault(n, i) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(n, { ...this.opts, ...i }).format();
  }
  dtFormatter(n, i = {}) {
    return this.loc.dtFormatter(n, { ...this.opts, ...i });
  }
  formatDateTime(n, i) {
    return this.dtFormatter(n, i).format();
  }
  formatDateTimeParts(n, i) {
    return this.dtFormatter(n, i).formatToParts();
  }
  formatInterval(n, i) {
    return this.dtFormatter(n.start, i).dtf.formatRange(n.start.toJSDate(), n.end.toJSDate());
  }
  resolvedOptions(n, i) {
    return this.dtFormatter(n, i).resolvedOptions();
  }
  num(n, i = 0, s = void 0) {
    if (this.opts.forceSimple)
      return at(n, i);
    const o = { ...this.opts };
    return i > 0 && (o.padTo = i), s && (o.signDisplay = s), this.loc.numberFormatter(o).format(n);
  }
  formatDateTimeFromString(n, i) {
    const s = this.loc.listingMode() === "en", o = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", u = (C, A) => this.loc.extract(n, C, A), l = (C) => n.isOffsetFixed && n.offset === 0 && C.allowZ ? "Z" : n.isValid ? n.zone.formatOffset(n.ts, C.format) : "", d = () => s ? ub(n) : u({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), f = (C, A) => s ? lb(n, C) : u(A ? { month: C } : { month: C, day: "numeric" }, "month"), m = (C, A) => s ? cb(n, C) : u(
      A ? { weekday: C } : { weekday: C, month: "long", day: "numeric" },
      "weekday"
    ), T = (C) => {
      const A = Ct.macroTokenToFormatOpts(C);
      return A ? this.formatWithSystemDefault(n, A) : C;
    }, v = (C) => s ? fb(n, C) : u({ era: C }, "era"), x = (C) => {
      switch (C) {
        case "S":
          return this.num(n.millisecond);
        case "u":
        case "SSS":
          return this.num(n.millisecond, 3);
        case "s":
          return this.num(n.second);
        case "ss":
          return this.num(n.second, 2);
        case "uu":
          return this.num(Math.floor(n.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(n.millisecond / 100));
        case "m":
          return this.num(n.minute);
        case "mm":
          return this.num(n.minute, 2);
        case "h":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12);
        case "hh":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12, 2);
        case "H":
          return this.num(n.hour);
        case "HH":
          return this.num(n.hour, 2);
        case "Z":
          return l({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return l({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return l({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return n.zone.offsetName(n.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return n.zone.offsetName(n.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return n.zoneName;
        case "a":
          return d();
        case "d":
          return o ? u({ day: "numeric" }, "day") : this.num(n.day);
        case "dd":
          return o ? u({ day: "2-digit" }, "day") : this.num(n.day, 2);
        case "c":
          return this.num(n.weekday);
        case "ccc":
          return m("short", !0);
        case "cccc":
          return m("long", !0);
        case "ccccc":
          return m("narrow", !0);
        case "E":
          return this.num(n.weekday);
        case "EEE":
          return m("short", !1);
        case "EEEE":
          return m("long", !1);
        case "EEEEE":
          return m("narrow", !1);
        case "L":
          return o ? u({ month: "numeric", day: "numeric" }, "month") : this.num(n.month);
        case "LL":
          return o ? u({ month: "2-digit", day: "numeric" }, "month") : this.num(n.month, 2);
        case "LLL":
          return f("short", !0);
        case "LLLL":
          return f("long", !0);
        case "LLLLL":
          return f("narrow", !0);
        case "M":
          return o ? u({ month: "numeric" }, "month") : this.num(n.month);
        case "MM":
          return o ? u({ month: "2-digit" }, "month") : this.num(n.month, 2);
        case "MMM":
          return f("short", !1);
        case "MMMM":
          return f("long", !1);
        case "MMMMM":
          return f("narrow", !1);
        case "y":
          return o ? u({ year: "numeric" }, "year") : this.num(n.year);
        case "yy":
          return o ? u({ year: "2-digit" }, "year") : this.num(n.year.toString().slice(-2), 2);
        case "yyyy":
          return o ? u({ year: "numeric" }, "year") : this.num(n.year, 4);
        case "yyyyyy":
          return o ? u({ year: "numeric" }, "year") : this.num(n.year, 6);
        case "G":
          return v("short");
        case "GG":
          return v("long");
        case "GGGGG":
          return v("narrow");
        case "kk":
          return this.num(n.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(n.weekYear, 4);
        case "W":
          return this.num(n.weekNumber);
        case "WW":
          return this.num(n.weekNumber, 2);
        case "n":
          return this.num(n.localWeekNumber);
        case "nn":
          return this.num(n.localWeekNumber, 2);
        case "ii":
          return this.num(n.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(n.localWeekYear, 4);
        case "o":
          return this.num(n.ordinal);
        case "ooo":
          return this.num(n.ordinal, 3);
        case "q":
          return this.num(n.quarter);
        case "qq":
          return this.num(n.quarter, 2);
        case "X":
          return this.num(Math.floor(n.ts / 1e3));
        case "x":
          return this.num(n.ts);
        default:
          return T(C);
      }
    };
    return ph(Ct.parseFormat(i), x);
  }
  formatDurationFromString(n, i) {
    const s = this.opts.signMode === "negativeLargestOnly" ? -1 : 1, o = (T) => {
      switch (T[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, u = (T, v) => (x) => {
      const C = o(x);
      if (C) {
        const A = v.isNegativeDuration && C !== v.largestUnit ? s : 1;
        let _;
        return this.opts.signMode === "negativeLargestOnly" && C !== v.largestUnit ? _ = "never" : this.opts.signMode === "all" ? _ = "always" : _ = "auto", this.num(T.get(C) * A, x.length, _);
      } else
        return x;
    }, l = Ct.parseFormat(i), d = l.reduce(
      (T, { literal: v, val: x }) => v ? T : T.concat(x),
      []
    ), f = n.shiftTo(...d.map(o).filter((T) => T)), m = {
      isNegativeDuration: f < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(f.values)[0]
    };
    return ph(l, u(f, m));
  }
}
const Lp = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function di(...t) {
  const n = t.reduce((i, s) => i + s.source, "");
  return RegExp(`^${n}$`);
}
function hi(...t) {
  return (n) => t.reduce(
    ([i, s, o], u) => {
      const [l, d, f] = u(n, o);
      return [{ ...i, ...l }, d || s, f];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function gi(t, ...n) {
  if (t == null)
    return [null, null];
  for (const [i, s] of n) {
    const o = i.exec(t);
    if (o)
      return s(o);
  }
  return [null, null];
}
function Fp(...t) {
  return (n, i) => {
    const s = {};
    let o;
    for (o = 0; o < t.length; o++)
      s[t[o]] = ir(n[i + o]);
    return [s, null, i + o];
  };
}
const Wp = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/, gb = `(?:${Wp.source}?(?:\\[(${Lp.source})\\])?)?`, Lc = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Up = RegExp(`${Lc.source}${gb}`), Fc = RegExp(`(?:[Tt]${Up.source})?`), pb = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, mb = /(\d{4})-?W(\d\d)(?:-?(\d))?/, yb = /(\d{4})-?(\d{3})/, vb = Fp("weekYear", "weekNumber", "weekDay"), wb = Fp("year", "ordinal"), Tb = /(\d{4})-(\d\d)-(\d\d)/, qp = RegExp(
  `${Lc.source} ?(?:${Wp.source}|(${Lp.source}))?`
), Sb = RegExp(`(?: ${qp.source})?`);
function ni(t, n, i) {
  const s = t[n];
  return fe(s) ? i : ir(s);
}
function Cb(t, n) {
  return [{
    year: ni(t, n),
    month: ni(t, n + 1, 1),
    day: ni(t, n + 2, 1)
  }, null, n + 3];
}
function pi(t, n) {
  return [{
    hours: ni(t, n, 0),
    minutes: ni(t, n + 1, 0),
    seconds: ni(t, n + 2, 0),
    milliseconds: Pc(t[n + 3])
  }, null, n + 4];
}
function os(t, n) {
  const i = !t[n] && !t[n + 1], s = Za(t[n + 1], t[n + 2]), o = i ? null : It.instance(s);
  return [{}, o, n + 3];
}
function us(t, n) {
  const i = t[n] ? Bn.create(t[n]) : null;
  return [{}, i, n + 1];
}
const xb = RegExp(`^T?${Lc.source}$`), _b = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function bb(t) {
  const [n, i, s, o, u, l, d, f, m] = t, T = n[0] === "-", v = f && f[0] === "-", x = (C, A = !1) => C !== void 0 && (A || C && T) ? -C : C;
  return [
    {
      years: x(wr(i)),
      months: x(wr(s)),
      weeks: x(wr(o)),
      days: x(wr(u)),
      hours: x(wr(l)),
      minutes: x(wr(d)),
      seconds: x(wr(f), f === "-0"),
      milliseconds: x(Pc(m), v)
    }
  ];
}
const Eb = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Wc(t, n, i, s, o, u, l) {
  const d = {
    year: n.length === 2 ? lc(ir(n)) : ir(n),
    month: kp.indexOf(i) + 1,
    day: ir(s),
    hour: ir(o),
    minute: ir(u)
  };
  return l && (d.second = ir(l)), t && (d.weekday = t.length > 3 ? Np.indexOf(t) + 1 : Rp.indexOf(t) + 1), d;
}
const Ib = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function Ab(t) {
  const [
    ,
    n,
    i,
    s,
    o,
    u,
    l,
    d,
    f,
    m,
    T,
    v
  ] = t, x = Wc(n, o, s, i, u, l, d);
  let C;
  return f ? C = Eb[f] : m ? C = 0 : C = Za(T, v), [x, new It(C)];
}
function Ob(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const kb = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $b = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Nb = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function mh(t) {
  const [, n, i, s, o, u, l, d] = t;
  return [Wc(n, o, s, i, u, l, d), It.utcInstance];
}
function Rb(t) {
  const [, n, i, s, o, u, l, d] = t;
  return [Wc(n, d, i, s, o, u, l), It.utcInstance];
}
const Mb = di(pb, Fc), Pb = di(mb, Fc), Db = di(yb, Fc), Lb = di(Up), zp = hi(
  Cb,
  pi,
  os,
  us
), Fb = hi(
  vb,
  pi,
  os,
  us
), Wb = hi(
  wb,
  pi,
  os,
  us
), Ub = hi(
  pi,
  os,
  us
);
function qb(t) {
  return gi(
    t,
    [Mb, zp],
    [Pb, Fb],
    [Db, Wb],
    [Lb, Ub]
  );
}
function zb(t) {
  return gi(Ob(t), [Ib, Ab]);
}
function Bb(t) {
  return gi(
    t,
    [kb, mh],
    [$b, mh],
    [Nb, Rb]
  );
}
function Vb(t) {
  return gi(t, [_b, bb]);
}
const Hb = hi(pi);
function Gb(t) {
  return gi(t, [xb, Hb]);
}
const Yb = di(Tb, Sb), Zb = di(qp), Kb = hi(
  pi,
  os,
  us
);
function Qb(t) {
  return gi(
    t,
    [Yb, zp],
    [Zb, Kb]
  );
}
const yh = "Invalid Duration", Bp = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, Jb = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...Bp
}, Jt = 146097 / 400, Qr = 146097 / 4800, jb = {
  years: {
    quarters: 4,
    months: 12,
    weeks: Jt / 7,
    days: Jt,
    hours: Jt * 24,
    minutes: Jt * 24 * 60,
    seconds: Jt * 24 * 60 * 60,
    milliseconds: Jt * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: Jt / 28,
    days: Jt / 4,
    hours: Jt * 24 / 4,
    minutes: Jt * 24 * 60 / 4,
    seconds: Jt * 24 * 60 * 60 / 4,
    milliseconds: Jt * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Qr / 7,
    days: Qr,
    hours: Qr * 24,
    minutes: Qr * 24 * 60,
    seconds: Qr * 24 * 60 * 60,
    milliseconds: Qr * 24 * 60 * 60 * 1e3
  },
  ...Bp
}, br = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Xb = br.slice(0).reverse();
function Ln(t, n, i = !1) {
  const s = {
    values: i ? n.values : { ...t.values, ...n.values || {} },
    loc: t.loc.clone(n.loc),
    conversionAccuracy: n.conversionAccuracy || t.conversionAccuracy,
    matrix: n.matrix || t.matrix
  };
  return new Oe(s);
}
function Vp(t, n) {
  let i = n.milliseconds ?? 0;
  for (const s of Xb.slice(1))
    n[s] && (i += n[s] * t[s].milliseconds);
  return i;
}
function vh(t, n) {
  const i = Vp(t, n) < 0 ? -1 : 1;
  br.reduceRight((s, o) => {
    if (fe(n[o]))
      return s;
    if (s) {
      const u = n[s] * i, l = t[o][s], d = Math.floor(u / l);
      n[o] += d * i, n[s] -= d * l * i;
    }
    return o;
  }, null), br.reduce((s, o) => {
    if (fe(n[o]))
      return s;
    if (s) {
      const u = n[s] % 1;
      n[s] -= u, n[o] += u * t[s][o];
    }
    return o;
  }, null);
}
function wh(t) {
  const n = {};
  for (const [i, s] of Object.entries(t))
    s !== 0 && (n[i] = s);
  return n;
}
class Oe {
  /**
   * @private
   */
  constructor(n) {
    const i = n.conversionAccuracy === "longterm" || !1;
    let s = i ? jb : Jb;
    n.matrix && (s = n.matrix), this.values = n.values, this.loc = n.loc || qe.create(), this.conversionAccuracy = i ? "longterm" : "casual", this.invalid = n.invalid || null, this.matrix = s, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(n, i) {
    return Oe.fromObject({ milliseconds: n }, i);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(n, i = {}) {
    if (n == null || typeof n != "object")
      throw new St(
        `Duration.fromObject: argument expected to be an object, got ${n === null ? "null" : typeof n}`
      );
    return new Oe({
      values: Ra(n, Oe.normalizeUnit),
      loc: qe.fromObject(i),
      conversionAccuracy: i.conversionAccuracy,
      matrix: i.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(n) {
    if (ur(n))
      return Oe.fromMillis(n);
    if (Oe.isDuration(n))
      return n;
    if (typeof n == "object")
      return Oe.fromObject(n);
    throw new St(
      `Unknown duration argument ${n} of type ${typeof n}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(n, i) {
    const [s] = Vb(n);
    return s ? Oe.fromObject(s, i) : Oe.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(n, i) {
    const [s] = Gb(n);
    return s ? Oe.fromObject(s, i) : Oe.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(n, i = null) {
    if (!n)
      throw new St("need to specify a reason the Duration is invalid");
    const s = n instanceof dn ? n : new dn(n, i);
    if (nt.throwOnInvalid)
      throw new b_(s);
    return new Oe({ invalid: s });
  }
  /**
   * @private
   */
  static normalizeUnit(n) {
    const i = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[n && n.toLowerCase()];
    if (!i) throw new jg(n);
    return i;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(n) {
    return n && n.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(n, i = {}) {
    const s = {
      ...i,
      floor: i.round !== !1 && i.floor !== !1
    };
    return this.isValid ? Ct.create(this.loc, s).formatDurationFromString(this, n) : yh;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(n = {}) {
    if (!this.isValid) return yh;
    const i = n.showZeros !== !1, s = br.map((o) => {
      const u = this.values[o];
      return fe(u) || u === 0 && !i ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...n, unit: o.slice(0, -1) }).format(u);
    }).filter((o) => o);
    return this.loc.listFormatter({ type: "conjunction", style: n.listStyle || "narrow", ...n }).format(s);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let n = "P";
    return this.years !== 0 && (n += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (n += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (n += this.weeks + "W"), this.days !== 0 && (n += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (n += "T"), this.hours !== 0 && (n += this.hours + "H"), this.minutes !== 0 && (n += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (n += Dc(this.seconds + this.milliseconds / 1e3, 3) + "S"), n === "P" && (n += "T0S"), n;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(n = {}) {
    if (!this.isValid) return null;
    const i = this.toMillis();
    return i < 0 || i >= 864e5 ? null : (n = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...n,
      includeOffset: !1
    }, de.fromMillis(i, { zone: "UTC" }).toISOTime(n));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? Vp(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(n) {
    if (!this.isValid) return this;
    const i = Oe.fromDurationLike(n), s = {};
    for (const o of br)
      (ui(i.values, o) || ui(this.values, o)) && (s[o] = i.get(o) + this.get(o));
    return Ln(this, { values: s }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(n) {
    if (!this.isValid) return this;
    const i = Oe.fromDurationLike(n);
    return this.plus(i.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(n) {
    if (!this.isValid) return this;
    const i = {};
    for (const s of Object.keys(this.values))
      i[s] = Op(n(this.values[s], s));
    return Ln(this, { values: i }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(n) {
    return this[Oe.normalizeUnit(n)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(n) {
    if (!this.isValid) return this;
    const i = { ...this.values, ...Ra(n, Oe.normalizeUnit) };
    return Ln(this, { values: i });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: n, numberingSystem: i, conversionAccuracy: s, matrix: o } = {}) {
    const l = { loc: this.loc.clone({ locale: n, numberingSystem: i }), matrix: o, conversionAccuracy: s };
    return Ln(this, l);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(n) {
    return this.isValid ? this.shiftTo(n).get(n) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const n = this.toObject();
    return vh(this.matrix, n), Ln(this, { values: n }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const n = wh(this.normalize().shiftToAll().toObject());
    return Ln(this, { values: n }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...n) {
    if (!this.isValid) return this;
    if (n.length === 0)
      return this;
    n = n.map((l) => Oe.normalizeUnit(l));
    const i = {}, s = {}, o = this.toObject();
    let u;
    for (const l of br)
      if (n.indexOf(l) >= 0) {
        u = l;
        let d = 0;
        for (const m in s)
          d += this.matrix[m][l] * s[m], s[m] = 0;
        ur(o[l]) && (d += o[l]);
        const f = Math.trunc(d);
        i[l] = f, s[l] = (d * 1e3 - f * 1e3) / 1e3;
      } else ur(o[l]) && (s[l] = o[l]);
    for (const l in s)
      s[l] !== 0 && (i[u] += l === u ? s[l] : s[l] / this.matrix[u][l]);
    return vh(this.matrix, i), Ln(this, { values: i }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const n = {};
    for (const i of Object.keys(this.values))
      n[i] = this.values[i] === 0 ? 0 : -this.values[i];
    return Ln(this, { values: n }, !0);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const n = wh(this.values);
    return Ln(this, { values: n }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(n) {
    if (!this.isValid || !n.isValid || !this.loc.equals(n.loc))
      return !1;
    function i(s, o) {
      return s === void 0 || s === 0 ? o === void 0 || o === 0 : s === o;
    }
    for (const s of br)
      if (!i(this.values[s], n.values[s]))
        return !1;
    return !0;
  }
}
const Jr = "Invalid Interval";
function eE(t, n) {
  return !t || !t.isValid ? tt.invalid("missing or invalid start") : !n || !n.isValid ? tt.invalid("missing or invalid end") : n < t ? tt.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${t.toISO()} and end=${n.toISO()}`
  ) : null;
}
class tt {
  /**
   * @private
   */
  constructor(n) {
    this.s = n.start, this.e = n.end, this.invalid = n.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(n, i = null) {
    if (!n)
      throw new St("need to specify a reason the Interval is invalid");
    const s = n instanceof dn ? n : new dn(n, i);
    if (nt.throwOnInvalid)
      throw new __(s);
    return new tt({ invalid: s });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(n, i) {
    const s = Fi(n), o = Fi(i), u = eE(s, o);
    return u ?? new tt({
      start: s,
      end: o
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(n, i) {
    const s = Oe.fromDurationLike(i), o = Fi(n);
    return tt.fromDateTimes(o, o.plus(s));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(n, i) {
    const s = Oe.fromDurationLike(i), o = Fi(n);
    return tt.fromDateTimes(o.minus(s), o);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(n, i) {
    const [s, o] = (n || "").split("/", 2);
    if (s && o) {
      let u, l;
      try {
        u = de.fromISO(s, i), l = u.isValid;
      } catch {
        l = !1;
      }
      let d, f;
      try {
        d = de.fromISO(o, i), f = d.isValid;
      } catch {
        f = !1;
      }
      if (l && f)
        return tt.fromDateTimes(u, d);
      if (l) {
        const m = Oe.fromISO(o, i);
        if (m.isValid)
          return tt.after(u, m);
      } else if (f) {
        const m = Oe.fromISO(s, i);
        if (m.isValid)
          return tt.before(d, m);
      }
    }
    return tt.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(n) {
    return n && n.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(n = "milliseconds") {
    return this.isValid ? this.toDuration(n).get(n) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(n = "milliseconds", i) {
    if (!this.isValid) return NaN;
    const s = this.start.startOf(n, i);
    let o;
    return i != null && i.useLocaleWeeks ? o = this.end.reconfigure({ locale: s.locale }) : o = this.end, o = o.startOf(n, i), Math.floor(o.diff(s, n).get(n)) + (o.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(n) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, n) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(n) {
    return this.isValid ? this.s > n : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(n) {
    return this.isValid ? this.e <= n : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(n) {
    return this.isValid ? this.s <= n && this.e > n : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: n, end: i } = {}) {
    return this.isValid ? tt.fromDateTimes(n || this.s, i || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...n) {
    if (!this.isValid) return [];
    const i = n.map(Fi).filter((l) => this.contains(l)).sort((l, d) => l.toMillis() - d.toMillis()), s = [];
    let { s: o } = this, u = 0;
    for (; o < this.e; ) {
      const l = i[u] || this.e, d = +l > +this.e ? this.e : l;
      s.push(tt.fromDateTimes(o, d)), o = d, u += 1;
    }
    return s;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(n) {
    const i = Oe.fromDurationLike(n);
    if (!this.isValid || !i.isValid || i.as("milliseconds") === 0)
      return [];
    let { s } = this, o = 1, u;
    const l = [];
    for (; s < this.e; ) {
      const d = this.start.plus(i.mapUnits((f) => f * o));
      u = +d > +this.e ? this.e : d, l.push(tt.fromDateTimes(s, u)), s = u, o += 1;
    }
    return l;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(n) {
    return this.isValid ? this.splitBy(this.length() / n).slice(0, n) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(n) {
    return this.e > n.s && this.s < n.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(n) {
    return this.isValid ? +this.e == +n.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(n) {
    return this.isValid ? +n.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(n) {
    return this.isValid ? this.s <= n.s && this.e >= n.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(n) {
    return !this.isValid || !n.isValid ? !1 : this.s.equals(n.s) && this.e.equals(n.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(n) {
    if (!this.isValid) return this;
    const i = this.s > n.s ? this.s : n.s, s = this.e < n.e ? this.e : n.e;
    return i >= s ? null : tt.fromDateTimes(i, s);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(n) {
    if (!this.isValid) return this;
    const i = this.s < n.s ? this.s : n.s, s = this.e > n.e ? this.e : n.e;
    return tt.fromDateTimes(i, s);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(n) {
    const [i, s] = n.sort((o, u) => o.s - u.s).reduce(
      ([o, u], l) => u ? u.overlaps(l) || u.abutsStart(l) ? [o, u.union(l)] : [o.concat([u]), l] : [o, l],
      [[], null]
    );
    return s && i.push(s), i;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(n) {
    let i = null, s = 0;
    const o = [], u = n.map((f) => [
      { time: f.s, type: "s" },
      { time: f.e, type: "e" }
    ]), l = Array.prototype.concat(...u), d = l.sort((f, m) => f.time - m.time);
    for (const f of d)
      s += f.type === "s" ? 1 : -1, s === 1 ? i = f.time : (i && +i != +f.time && o.push(tt.fromDateTimes(i, f.time)), i = null);
    return tt.merge(o);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...n) {
    return tt.xor([this].concat(n)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Jr;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(n = ka, i = {}) {
    return this.isValid ? Ct.create(this.s.loc.clone(i), n).formatInterval(this) : Jr;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(n) {
    return this.isValid ? `${this.s.toISO(n)}/${this.e.toISO(n)}` : Jr;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Jr;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(n) {
    return this.isValid ? `${this.s.toISOTime(n)}/${this.e.toISOTime(n)}` : Jr;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(n, { separator: i = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(n)}${i}${this.e.toFormat(n)}` : Jr;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(n, i) {
    return this.isValid ? this.e.diff(this.s, n, i) : Oe.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(n) {
    return tt.fromDateTimes(n(this.s), n(this.e));
  }
}
class sa {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(n = nt.defaultZone) {
    const i = de.now().setZone(n).set({ month: 12 });
    return !n.isUniversal && i.offset !== i.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(n) {
    return Bn.isValidZone(n);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(n) {
    return ar(n, nt.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: n = null, locObj: i = null } = {}) {
    return (i || qe.create(n)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: n = null, locObj: i = null } = {}) {
    return (i || qe.create(n)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: n = null, locObj: i = null } = {}) {
    return (i || qe.create(n)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(n = "long", { locale: i = null, numberingSystem: s = null, locObj: o = null, outputCalendar: u = "gregory" } = {}) {
    return (o || qe.create(i, s, u)).months(n);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(n = "long", { locale: i = null, numberingSystem: s = null, locObj: o = null, outputCalendar: u = "gregory" } = {}) {
    return (o || qe.create(i, s, u)).months(n, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(n = "long", { locale: i = null, numberingSystem: s = null, locObj: o = null } = {}) {
    return (o || qe.create(i, s, null)).weekdays(n);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(n = "long", { locale: i = null, numberingSystem: s = null, locObj: o = null } = {}) {
    return (o || qe.create(i, s, null)).weekdays(n, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: n = null } = {}) {
    return qe.create(n).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(n = "short", { locale: i = null } = {}) {
    return qe.create(i, null, "gregory").eras(n);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: Ep(), localeWeek: Ip() };
  }
}
function Th(t, n) {
  const i = (o) => o.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), s = i(n) - i(t);
  return Math.floor(Oe.fromMillis(s).as("days"));
}
function tE(t, n, i) {
  const s = [
    ["years", (f, m) => m.year - f.year],
    ["quarters", (f, m) => m.quarter - f.quarter + (m.year - f.year) * 4],
    ["months", (f, m) => m.month - f.month + (m.year - f.year) * 12],
    [
      "weeks",
      (f, m) => {
        const T = Th(f, m);
        return (T - T % 7) / 7;
      }
    ],
    ["days", Th]
  ], o = {}, u = t;
  let l, d;
  for (const [f, m] of s)
    i.indexOf(f) >= 0 && (l = f, o[f] = m(t, n), d = u.plus(o), d > n ? (o[f]--, t = u.plus(o), t > n && (d = t, o[f]--, t = u.plus(o))) : t = d);
  return [t, o, d, l];
}
function nE(t, n, i, s) {
  let [o, u, l, d] = tE(t, n, i);
  const f = n - o, m = i.filter(
    (v) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(v) >= 0
  );
  m.length === 0 && (l < n && (l = o.plus({ [d]: 1 })), l !== o && (u[d] = (u[d] || 0) + f / (l - o)));
  const T = Oe.fromObject(u, s);
  return m.length > 0 ? Oe.fromMillis(f, s).shiftTo(...m).plus(T) : T;
}
const rE = "missing Intl.DateTimeFormat.formatToParts support";
function Re(t, n = (i) => i) {
  return { regex: t, deser: ([i]) => n(Y_(i)) };
}
const iE = " ", Hp = `[ ${iE}]`, Gp = new RegExp(Hp, "g");
function sE(t) {
  return t.replace(/\./g, "\\.?").replace(Gp, Hp);
}
function Sh(t) {
  return t.replace(/\./g, "").replace(Gp, " ").toLowerCase();
}
function cn(t, n) {
  return t === null ? null : {
    regex: RegExp(t.map(sE).join("|")),
    deser: ([i]) => t.findIndex((s) => Sh(i) === Sh(s)) + n
  };
}
function Ch(t, n) {
  return { regex: t, deser: ([, i, s]) => Za(i, s), groups: n };
}
function aa(t) {
  return { regex: t, deser: ([n]) => n };
}
function aE(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function oE(t, n) {
  const i = un(n), s = un(n, "{2}"), o = un(n, "{3}"), u = un(n, "{4}"), l = un(n, "{6}"), d = un(n, "{1,2}"), f = un(n, "{1,3}"), m = un(n, "{1,6}"), T = un(n, "{1,9}"), v = un(n, "{2,4}"), x = un(n, "{4,6}"), C = (R) => ({ regex: RegExp(aE(R.val)), deser: ([L]) => L, literal: !0 }), _ = ((R) => {
    if (t.literal)
      return C(R);
    switch (R.val) {
      case "G":
        return cn(n.eras("short"), 0);
      case "GG":
        return cn(n.eras("long"), 0);
      case "y":
        return Re(m);
      case "yy":
        return Re(v, lc);
      case "yyyy":
        return Re(u);
      case "yyyyy":
        return Re(x);
      case "yyyyyy":
        return Re(l);
      case "M":
        return Re(d);
      case "MM":
        return Re(s);
      case "MMM":
        return cn(n.months("short", !0), 1);
      case "MMMM":
        return cn(n.months("long", !0), 1);
      case "L":
        return Re(d);
      case "LL":
        return Re(s);
      case "LLL":
        return cn(n.months("short", !1), 1);
      case "LLLL":
        return cn(n.months("long", !1), 1);
      case "d":
        return Re(d);
      case "dd":
        return Re(s);
      case "o":
        return Re(f);
      case "ooo":
        return Re(o);
      case "HH":
        return Re(s);
      case "H":
        return Re(d);
      case "hh":
        return Re(s);
      case "h":
        return Re(d);
      case "mm":
        return Re(s);
      case "m":
        return Re(d);
      case "q":
        return Re(d);
      case "qq":
        return Re(s);
      case "s":
        return Re(d);
      case "ss":
        return Re(s);
      case "S":
        return Re(f);
      case "SSS":
        return Re(o);
      case "u":
        return aa(T);
      case "uu":
        return aa(d);
      case "uuu":
        return Re(i);
      case "a":
        return cn(n.meridiems(), 0);
      case "kkkk":
        return Re(u);
      case "kk":
        return Re(v, lc);
      case "W":
        return Re(d);
      case "WW":
        return Re(s);
      case "E":
      case "c":
        return Re(i);
      case "EEE":
        return cn(n.weekdays("short", !1), 1);
      case "EEEE":
        return cn(n.weekdays("long", !1), 1);
      case "ccc":
        return cn(n.weekdays("short", !0), 1);
      case "cccc":
        return cn(n.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return Ch(new RegExp(`([+-]${d.source})(?::(${s.source}))?`), 2);
      case "ZZZ":
        return Ch(new RegExp(`([+-]${d.source})(${s.source})?`), 2);
      case "z":
        return aa(/[a-z_+-/]{1,256}?/i);
      case " ":
        return aa(/[^\S\n\r]/);
      default:
        return C(R);
    }
  })(t) || {
    invalidReason: rE
  };
  return _.token = t, _;
}
const uE = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function cE(t, n, i) {
  const { type: s, value: o } = t;
  if (s === "literal") {
    const f = /^\s+$/.test(o);
    return {
      literal: !f,
      val: f ? " " : o
    };
  }
  const u = n[s];
  let l = s;
  s === "hour" && (n.hour12 != null ? l = n.hour12 ? "hour12" : "hour24" : n.hourCycle != null ? n.hourCycle === "h11" || n.hourCycle === "h12" ? l = "hour12" : l = "hour24" : l = i.hour12 ? "hour12" : "hour24");
  let d = uE[l];
  if (typeof d == "object" && (d = d[u]), d)
    return {
      literal: !1,
      val: d
    };
}
function lE(t) {
  return [`^${t.map((i) => i.regex).reduce((i, s) => `${i}(${s.source})`, "")}$`, t];
}
function fE(t, n, i) {
  const s = t.match(n);
  if (s) {
    const o = {};
    let u = 1;
    for (const l in i)
      if (ui(i, l)) {
        const d = i[l], f = d.groups ? d.groups + 1 : 1;
        !d.literal && d.token && (o[d.token.val[0]] = d.deser(s.slice(u, u + f))), u += f;
      }
    return [s, o];
  } else
    return [s, {}];
}
function dE(t) {
  const n = (u) => {
    switch (u) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let i = null, s;
  return fe(t.z) || (i = Bn.create(t.z)), fe(t.Z) || (i || (i = new It(t.Z)), s = t.Z), fe(t.q) || (t.M = (t.q - 1) * 3 + 1), fe(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), fe(t.u) || (t.S = Pc(t.u)), [Object.keys(t).reduce((u, l) => {
    const d = n(l);
    return d && (u[d] = t[l]), u;
  }, {}), i, s];
}
let Nu = null;
function hE() {
  return Nu || (Nu = de.fromMillis(1555555555555)), Nu;
}
function gE(t, n) {
  if (t.literal)
    return t;
  const i = Ct.macroTokenToFormatOpts(t.val), s = Qp(i, n);
  return s == null || s.includes(void 0) ? t : s;
}
function Yp(t, n) {
  return Array.prototype.concat(...t.map((i) => gE(i, n)));
}
class Zp {
  constructor(n, i) {
    if (this.locale = n, this.format = i, this.tokens = Yp(Ct.parseFormat(i), n), this.units = this.tokens.map((s) => oE(s, n)), this.disqualifyingUnit = this.units.find((s) => s.invalidReason), !this.disqualifyingUnit) {
      const [s, o] = lE(this.units);
      this.regex = RegExp(s, "i"), this.handlers = o;
    }
  }
  explainFromTokens(n) {
    if (this.isValid) {
      const [i, s] = fE(n, this.regex, this.handlers), [o, u, l] = s ? dE(s) : [null, null, void 0];
      if (ui(s, "a") && ui(s, "H"))
        throw new ei(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: n,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: i,
        matches: s,
        result: o,
        zone: u,
        specificOffset: l
      };
    } else
      return { input: n, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function Kp(t, n, i) {
  return new Zp(t, i).explainFromTokens(n);
}
function pE(t, n, i) {
  const { result: s, zone: o, specificOffset: u, invalidReason: l } = Kp(t, n, i);
  return [s, o, u, l];
}
function Qp(t, n) {
  if (!t)
    return null;
  const s = Ct.create(n, t).dtFormatter(hE()), o = s.formatToParts(), u = s.resolvedOptions();
  return o.map((l) => cE(l, t, u));
}
const Ru = "Invalid DateTime", xh = 864e13;
function Bi(t) {
  return new dn("unsupported zone", `the zone "${t.name}" is not supported`);
}
function Mu(t) {
  return t.weekData === null && (t.weekData = $a(t.c)), t.weekData;
}
function Pu(t) {
  return t.localWeekData === null && (t.localWeekData = $a(
    t.c,
    t.loc.getMinDaysInFirstWeek(),
    t.loc.getStartOfWeek()
  )), t.localWeekData;
}
function Tr(t, n) {
  const i = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new de({ ...i, ...n, old: i });
}
function Jp(t, n, i) {
  let s = t - n * 60 * 1e3;
  const o = i.offset(s);
  if (n === o)
    return [s, n];
  s -= (o - n) * 60 * 1e3;
  const u = i.offset(s);
  return o === u ? [s, o] : [t - Math.min(o, u) * 60 * 1e3, Math.max(o, u)];
}
function oa(t, n) {
  t += n * 60 * 1e3;
  const i = new Date(t);
  return {
    year: i.getUTCFullYear(),
    month: i.getUTCMonth() + 1,
    day: i.getUTCDate(),
    hour: i.getUTCHours(),
    minute: i.getUTCMinutes(),
    second: i.getUTCSeconds(),
    millisecond: i.getUTCMilliseconds()
  };
}
function wa(t, n, i) {
  return Jp(Ya(t), n, i);
}
function _h(t, n) {
  const i = t.o, s = t.c.year + Math.trunc(n.years), o = t.c.month + Math.trunc(n.months) + Math.trunc(n.quarters) * 3, u = {
    ...t.c,
    year: s,
    month: o,
    day: Math.min(t.c.day, Na(s, o)) + Math.trunc(n.days) + Math.trunc(n.weeks) * 7
  }, l = Oe.fromObject({
    years: n.years - Math.trunc(n.years),
    quarters: n.quarters - Math.trunc(n.quarters),
    months: n.months - Math.trunc(n.months),
    weeks: n.weeks - Math.trunc(n.weeks),
    days: n.days - Math.trunc(n.days),
    hours: n.hours,
    minutes: n.minutes,
    seconds: n.seconds,
    milliseconds: n.milliseconds
  }).as("milliseconds"), d = Ya(u);
  let [f, m] = Jp(d, i, t.zone);
  return l !== 0 && (f += l, m = t.zone.offset(f)), { ts: f, o: m };
}
function jr(t, n, i, s, o, u) {
  const { setZone: l, zone: d } = i;
  if (t && Object.keys(t).length !== 0 || n) {
    const f = n || d, m = de.fromObject(t, {
      ...i,
      zone: f,
      specificOffset: u
    });
    return l ? m : m.setZone(d);
  } else
    return de.invalid(
      new dn("unparsable", `the input "${o}" can't be parsed as ${s}`)
    );
}
function ua(t, n, i = !0) {
  return t.isValid ? Ct.create(qe.create("en-US"), {
    allowZ: i,
    forceSimple: !0
  }).formatDateTimeFromString(t, n) : null;
}
function Du(t, n, i) {
  const s = t.c.year > 9999 || t.c.year < 0;
  let o = "";
  if (s && t.c.year >= 0 && (o += "+"), o += at(t.c.year, s ? 6 : 4), i === "year") return o;
  if (n) {
    if (o += "-", o += at(t.c.month), i === "month") return o;
    o += "-";
  } else if (o += at(t.c.month), i === "month") return o;
  return o += at(t.c.day), o;
}
function bh(t, n, i, s, o, u, l) {
  let d = !i || t.c.millisecond !== 0 || t.c.second !== 0, f = "";
  switch (l) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      if (f += at(t.c.hour), l === "hour") break;
      if (n) {
        if (f += ":", f += at(t.c.minute), l === "minute") break;
        d && (f += ":", f += at(t.c.second));
      } else {
        if (f += at(t.c.minute), l === "minute") break;
        d && (f += at(t.c.second));
      }
      if (l === "second") break;
      d && (!s || t.c.millisecond !== 0) && (f += ".", f += at(t.c.millisecond, 3));
  }
  return o && (t.isOffsetFixed && t.offset === 0 && !u ? f += "Z" : t.o < 0 ? (f += "-", f += at(Math.trunc(-t.o / 60)), f += ":", f += at(Math.trunc(-t.o % 60))) : (f += "+", f += at(Math.trunc(t.o / 60)), f += ":", f += at(Math.trunc(t.o % 60)))), u && (f += "[" + t.zone.ianaName + "]"), f;
}
const jp = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, mE = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, yE = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Ta = ["year", "month", "day", "hour", "minute", "second", "millisecond"], vE = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], wE = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function Sa(t) {
  const n = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!n) throw new jg(t);
  return n;
}
function Eh(t) {
  switch (t.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return Sa(t);
  }
}
function TE(t) {
  if (Vi === void 0 && (Vi = nt.now()), t.type !== "iana")
    return t.offset(Vi);
  const n = t.name;
  let i = fc.get(n);
  return i === void 0 && (i = t.offset(Vi), fc.set(n, i)), i;
}
function Ih(t, n) {
  const i = ar(n.zone, nt.defaultZone);
  if (!i.isValid)
    return de.invalid(Bi(i));
  const s = qe.fromObject(n);
  let o, u;
  if (fe(t.year))
    o = nt.now();
  else {
    for (const f of Ta)
      fe(t[f]) && (t[f] = jp[f]);
    const l = _p(t) || bp(t);
    if (l)
      return de.invalid(l);
    const d = TE(i);
    [o, u] = wa(t, d, i);
  }
  return new de({ ts: o, zone: i, loc: s, o: u });
}
function Ah(t, n, i) {
  const s = fe(i.round) ? !0 : i.round, o = fe(i.rounding) ? "trunc" : i.rounding, u = (d, f) => (d = Dc(d, s || i.calendary ? 0 : 2, i.calendary ? "round" : o), n.loc.clone(i).relFormatter(i).format(d, f)), l = (d) => i.calendary ? n.hasSame(t, d) ? 0 : n.startOf(d).diff(t.startOf(d), d).get(d) : n.diff(t, d).get(d);
  if (i.unit)
    return u(l(i.unit), i.unit);
  for (const d of i.units) {
    const f = l(d);
    if (Math.abs(f) >= 1)
      return u(f, d);
  }
  return u(t > n ? -0 : 0, i.units[i.units.length - 1]);
}
function Oh(t) {
  let n = {}, i;
  return t.length > 0 && typeof t[t.length - 1] == "object" ? (n = t[t.length - 1], i = Array.from(t).slice(0, t.length - 1)) : i = Array.from(t), [n, i];
}
let Vi;
const fc = /* @__PURE__ */ new Map();
class de {
  /**
   * @access private
   */
  constructor(n) {
    const i = n.zone || nt.defaultZone;
    let s = n.invalid || (Number.isNaN(n.ts) ? new dn("invalid input") : null) || (i.isValid ? null : Bi(i));
    this.ts = fe(n.ts) ? nt.now() : n.ts;
    let o = null, u = null;
    if (!s)
      if (n.old && n.old.ts === this.ts && n.old.zone.equals(i))
        [o, u] = [n.old.c, n.old.o];
      else {
        const d = ur(n.o) && !n.old ? n.o : i.offset(this.ts);
        o = oa(this.ts, d), s = Number.isNaN(o.year) ? new dn("invalid input") : null, o = s ? null : o, u = s ? null : d;
      }
    this._zone = i, this.loc = n.loc || qe.create(), this.invalid = s, this.weekData = null, this.localWeekData = null, this.c = o, this.o = u, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new de({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [n, i] = Oh(arguments), [s, o, u, l, d, f, m] = i;
    return Ih({ year: s, month: o, day: u, hour: l, minute: d, second: f, millisecond: m }, n);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [n, i] = Oh(arguments), [s, o, u, l, d, f, m] = i;
    return n.zone = It.utcInstance, Ih({ year: s, month: o, day: u, hour: l, minute: d, second: f, millisecond: m }, n);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(n, i = {}) {
    const s = j_(n) ? n.valueOf() : NaN;
    if (Number.isNaN(s))
      return de.invalid("invalid input");
    const o = ar(i.zone, nt.defaultZone);
    return o.isValid ? new de({
      ts: s,
      zone: o,
      loc: qe.fromObject(i)
    }) : de.invalid(Bi(o));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(n, i = {}) {
    if (ur(n))
      return n < -xh || n > xh ? de.invalid("Timestamp out of range") : new de({
        ts: n,
        zone: ar(i.zone, nt.defaultZone),
        loc: qe.fromObject(i)
      });
    throw new St(
      `fromMillis requires a numerical input, but received a ${typeof n} with value ${n}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(n, i = {}) {
    if (ur(n))
      return new de({
        ts: n * 1e3,
        zone: ar(i.zone, nt.defaultZone),
        loc: qe.fromObject(i)
      });
    throw new St("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(n, i = {}) {
    n = n || {};
    const s = ar(i.zone, nt.defaultZone);
    if (!s.isValid)
      return de.invalid(Bi(s));
    const o = qe.fromObject(i), u = Ra(n, Eh), { minDaysInFirstWeek: l, startOfWeek: d } = dh(u, o), f = nt.now(), m = fe(i.specificOffset) ? s.offset(f) : i.specificOffset, T = !fe(u.ordinal), v = !fe(u.year), x = !fe(u.month) || !fe(u.day), C = v || x, A = u.weekYear || u.weekNumber;
    if ((C || T) && A)
      throw new ei(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (x && T)
      throw new ei("Can't mix ordinal dates with month/day");
    const _ = A || u.weekday && !C;
    let R, L, U = oa(f, m);
    _ ? (R = vE, L = mE, U = $a(U, l, d)) : T ? (R = wE, L = yE, U = $u(U)) : (R = Ta, L = jp);
    let q = !1;
    for (const ke of R) {
      const oe = u[ke];
      fe(oe) ? q ? u[ke] = L[ke] : u[ke] = U[ke] : q = !0;
    }
    const P = _ ? K_(u, l, d) : T ? Q_(u) : _p(u), O = P || bp(u);
    if (O)
      return de.invalid(O);
    const M = _ ? lh(u, l, d) : T ? fh(u) : u, [$, H] = wa(M, m, s), re = new de({
      ts: $,
      zone: s,
      o: H,
      loc: o
    });
    return u.weekday && C && n.weekday !== re.weekday ? de.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${u.weekday} and a date of ${re.toISO()}`
    ) : re.isValid ? re : de.invalid(re.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(n, i = {}) {
    const [s, o] = qb(n);
    return jr(s, o, i, "ISO 8601", n);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(n, i = {}) {
    const [s, o] = zb(n);
    return jr(s, o, i, "RFC 2822", n);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(n, i = {}) {
    const [s, o] = Bb(n);
    return jr(s, o, i, "HTTP", i);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(n, i, s = {}) {
    if (fe(n) || fe(i))
      throw new St("fromFormat requires an input string and a format");
    const { locale: o = null, numberingSystem: u = null } = s, l = qe.fromOpts({
      locale: o,
      numberingSystem: u,
      defaultToEN: !0
    }), [d, f, m, T] = pE(l, n, i);
    return T ? de.invalid(T) : jr(d, f, s, `format ${i}`, n, m);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(n, i, s = {}) {
    return de.fromFormat(n, i, s);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(n, i = {}) {
    const [s, o] = Qb(n);
    return jr(s, o, i, "SQL", n);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(n, i = null) {
    if (!n)
      throw new St("need to specify a reason the DateTime is invalid");
    const s = n instanceof dn ? n : new dn(n, i);
    if (nt.throwOnInvalid)
      throw new x_(s);
    return new de({ invalid: s });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(n) {
    return n && n.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(n, i = {}) {
    const s = Qp(n, qe.fromObject(i));
    return s ? s.map((o) => o ? o.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(n, i = {}) {
    return Yp(Ct.parseFormat(n), qe.fromObject(i)).map((o) => o.val).join("");
  }
  static resetCache() {
    Vi = void 0, fc.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(n) {
    return this[n];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? Mu(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? Mu(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? Mu(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? Pu(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? Pu(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? Pu(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? $u(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? sa.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? sa.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? sa.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? sa.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const n = 864e5, i = 6e4, s = Ya(this.c), o = this.zone.offset(s - n), u = this.zone.offset(s + n), l = this.zone.offset(s - o * i), d = this.zone.offset(s - u * i);
    if (l === d)
      return [this];
    const f = s - l * i, m = s - d * i, T = oa(f, l), v = oa(m, d);
    return T.hour === v.hour && T.minute === v.minute && T.second === v.second && T.millisecond === v.millisecond ? [Tr(this, { ts: f }), Tr(this, { ts: m })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return as(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return Na(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? ti(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? ts(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? ts(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(n = {}) {
    const { locale: i, numberingSystem: s, calendar: o } = Ct.create(
      this.loc.clone(n),
      n
    ).resolvedOptions(this);
    return { locale: i, numberingSystem: s, outputCalendar: o };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(n = 0, i = {}) {
    return this.setZone(It.instance(n), i);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(nt.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(n, { keepLocalTime: i = !1, keepCalendarTime: s = !1 } = {}) {
    if (n = ar(n, nt.defaultZone), n.equals(this.zone))
      return this;
    if (n.isValid) {
      let o = this.ts;
      if (i || s) {
        const u = n.offset(this.ts), l = this.toObject();
        [o] = wa(l, u, n);
      }
      return Tr(this, { ts: o, zone: n });
    } else
      return de.invalid(Bi(n));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: n, numberingSystem: i, outputCalendar: s } = {}) {
    const o = this.loc.clone({ locale: n, numberingSystem: i, outputCalendar: s });
    return Tr(this, { loc: o });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(n) {
    return this.reconfigure({ locale: n });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(n) {
    if (!this.isValid) return this;
    const i = Ra(n, Eh), { minDaysInFirstWeek: s, startOfWeek: o } = dh(i, this.loc), u = !fe(i.weekYear) || !fe(i.weekNumber) || !fe(i.weekday), l = !fe(i.ordinal), d = !fe(i.year), f = !fe(i.month) || !fe(i.day), m = d || f, T = i.weekYear || i.weekNumber;
    if ((m || l) && T)
      throw new ei(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (f && l)
      throw new ei("Can't mix ordinal dates with month/day");
    let v;
    u ? v = lh(
      { ...$a(this.c, s, o), ...i },
      s,
      o
    ) : fe(i.ordinal) ? (v = { ...this.toObject(), ...i }, fe(i.day) && (v.day = Math.min(Na(v.year, v.month), v.day))) : v = fh({ ...$u(this.c), ...i });
    const [x, C] = wa(v, this.o, this.zone);
    return Tr(this, { ts: x, o: C });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(n) {
    if (!this.isValid) return this;
    const i = Oe.fromDurationLike(n);
    return Tr(this, _h(this, i));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(n) {
    if (!this.isValid) return this;
    const i = Oe.fromDurationLike(n).negate();
    return Tr(this, _h(this, i));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(n, { useLocaleWeeks: i = !1 } = {}) {
    if (!this.isValid) return this;
    const s = {}, o = Oe.normalizeUnit(n);
    switch (o) {
      case "years":
        s.month = 1;
      case "quarters":
      case "months":
        s.day = 1;
      case "weeks":
      case "days":
        s.hour = 0;
      case "hours":
        s.minute = 0;
      case "minutes":
        s.second = 0;
      case "seconds":
        s.millisecond = 0;
        break;
    }
    if (o === "weeks")
      if (i) {
        const u = this.loc.getStartOfWeek(), { weekday: l } = this;
        l < u && (s.weekNumber = this.weekNumber - 1), s.weekday = u;
      } else
        s.weekday = 1;
    if (o === "quarters") {
      const u = Math.ceil(this.month / 3);
      s.month = (u - 1) * 3 + 1;
    }
    return this.set(s);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(n, i) {
    return this.isValid ? this.plus({ [n]: 1 }).startOf(n, i).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(n, i = {}) {
    return this.isValid ? Ct.create(this.loc.redefaultToEN(i)).formatDateTimeFromString(this, n) : Ru;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(n = ka, i = {}) {
    return this.isValid ? Ct.create(this.loc.clone(i), n).formatDateTime(this) : Ru;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(n = {}) {
    return this.isValid ? Ct.create(this.loc.clone(n), n).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format: n = "extended",
    suppressSeconds: i = !1,
    suppressMilliseconds: s = !1,
    includeOffset: o = !0,
    extendedZone: u = !1,
    precision: l = "milliseconds"
  } = {}) {
    if (!this.isValid)
      return null;
    l = Sa(l);
    const d = n === "extended";
    let f = Du(this, d, l);
    return Ta.indexOf(l) >= 3 && (f += "T"), f += bh(
      this,
      d,
      i,
      s,
      o,
      u,
      l
    ), f;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format: n = "extended", precision: i = "day" } = {}) {
    return this.isValid ? Du(this, n === "extended", Sa(i)) : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return ua(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: n = !1,
    suppressSeconds: i = !1,
    includeOffset: s = !0,
    includePrefix: o = !1,
    extendedZone: u = !1,
    format: l = "extended",
    precision: d = "milliseconds"
  } = {}) {
    return this.isValid ? (d = Sa(d), (o && Ta.indexOf(d) >= 3 ? "T" : "") + bh(
      this,
      l === "extended",
      i,
      n,
      s,
      u,
      d
    )) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return ua(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return ua(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    return this.isValid ? Du(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: n = !0, includeZone: i = !1, includeOffsetSpace: s = !0 } = {}) {
    let o = "HH:mm:ss.SSS";
    return (i || n) && (s && (o += " "), i ? o += "z" : n && (o += "ZZ")), ua(this, o, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(n = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(n)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : Ru;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(n = {}) {
    if (!this.isValid) return {};
    const i = { ...this.c };
    return n.includeConfig && (i.outputCalendar = this.outputCalendar, i.numberingSystem = this.loc.numberingSystem, i.locale = this.loc.locale), i;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(n, i = "milliseconds", s = {}) {
    if (!this.isValid || !n.isValid)
      return Oe.invalid("created by diffing an invalid DateTime");
    const o = { locale: this.locale, numberingSystem: this.numberingSystem, ...s }, u = X_(i).map(Oe.normalizeUnit), l = n.valueOf() > this.valueOf(), d = l ? this : n, f = l ? n : this, m = nE(d, f, u, o);
    return l ? m.negate() : m;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(n = "milliseconds", i = {}) {
    return this.diff(de.now(), n, i);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(n) {
    return this.isValid ? tt.fromDateTimes(this, n) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(n, i, s) {
    if (!this.isValid) return !1;
    const o = n.valueOf(), u = this.setZone(n.zone, { keepLocalTime: !0 });
    return u.startOf(i, s) <= o && o <= u.endOf(i, s);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(n) {
    return this.isValid && n.isValid && this.valueOf() === n.valueOf() && this.zone.equals(n.zone) && this.loc.equals(n.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(n = {}) {
    if (!this.isValid) return null;
    const i = n.base || de.fromObject({}, { zone: this.zone }), s = n.padding ? this < i ? -n.padding : n.padding : 0;
    let o = ["years", "months", "days", "hours", "minutes", "seconds"], u = n.unit;
    return Array.isArray(n.unit) && (o = n.unit, u = void 0), Ah(i, this.plus(s), {
      ...n,
      numeric: "always",
      units: o,
      unit: u
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(n = {}) {
    return this.isValid ? Ah(n.base || de.fromObject({}, { zone: this.zone }), this, {
      ...n,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...n) {
    if (!n.every(de.isDateTime))
      throw new St("min requires all arguments be DateTimes");
    return hh(n, (i) => i.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...n) {
    if (!n.every(de.isDateTime))
      throw new St("max requires all arguments be DateTimes");
    return hh(n, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(n, i, s = {}) {
    const { locale: o = null, numberingSystem: u = null } = s, l = qe.fromOpts({
      locale: o,
      numberingSystem: u,
      defaultToEN: !0
    });
    return Kp(l, n, i);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(n, i, s = {}) {
    return de.fromFormatExplain(n, i, s);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(n, i = {}) {
    const { locale: s = null, numberingSystem: o = null } = i, u = qe.fromOpts({
      locale: s,
      numberingSystem: o,
      defaultToEN: !0
    });
    return new Zp(u, n);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(n, i, s = {}) {
    if (fe(n) || fe(i))
      throw new St(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: o = null, numberingSystem: u = null } = s, l = qe.fromOpts({
      locale: o,
      numberingSystem: u,
      defaultToEN: !0
    });
    if (!l.equals(i.locale))
      throw new St(
        `fromFormatParser called with a locale of ${l}, but the format parser was created for ${i.locale}`
      );
    const { result: d, zone: f, specificOffset: m, invalidReason: T } = i.explainFromTokens(n);
    return T ? de.invalid(T) : jr(
      d,
      f,
      s,
      `format ${i.format}`,
      n,
      m
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return ka;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return Xg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return E_;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return ep;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return tp;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return np;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return rp;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return ip;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return sp;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return ap;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return op;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return up;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return cp;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return lp;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return fp;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return dp;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return hp;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return I_;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return gp;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return pp;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return mp;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return yp;
  }
}
function Fi(t) {
  if (de.isDateTime(t))
    return t;
  if (t && t.valueOf && ur(t.valueOf()))
    return de.fromJSDate(t);
  if (t && typeof t == "object")
    return de.fromObject(t);
  throw new St(
    `Unknown datetime argument: ${t}, of type ${typeof t}`
  );
}
const Xp = (t) => de.fromISO(t).toFormat("MMM d"), kh = Q.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${b.spacing.mediumSmall};
`, SE = Q.li`
  list-style: none;
  margin: 0;
  padding: 0;
  border: ${b.borders.widthSmall} solid ${b.colors.contrasts.grey1214};
  border-radius: ${b.borders.radiusLarge};
  box-shadow: ${b.shadows.resting};
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`, CE = Q.div`
    background: ${b.colors.contrasts.grey100100};
	color: ${b.colors.contrasts.white1010};
    border-radius: ${b.borders.radiusLarge} ${b.borders.radiusLarge} 0 0;
    border: 0 solid transparent;
    padding: ${b.spacing.small} ${b.spacing.medium};
    gap: ${b.spacing.small};
    display: flex;
    flex-direction: row;
    align-items: flex-start;
`, xE = Q.div`
	gap: ${({ $isExpanded: t }) => t ? b.spacing.small : "0"};
	display: flex;
	flex-direction: column;
	flex: 1;
	min-width: 0;
`, $h = Q.div`
    display: flex;
	flex-direction: ${({ $isMobile: t }) => t ? "column" : "row"};
	justify-content: space-between;
	align-items: ${({ $isMobile: t }) => t ? "flex-start" : "center"};
	gap: ${({ $isMobile: t }) => t ? b.spacing.xSmall : "0"};
`, _E = Q.div`
    display: flex;
	flex-direction: row;
	overflow: hidden;
	flex-wrap: nowrap;
	gap: ${b.spacing.xSmall};
	align-items: center;
	flex: 1;
	min-width: 0;
`, Nh = Q.div`
	white-space: nowrap;
	flex-shrink: 0;
`, bE = Q.div`
	width: 100%;
	overflow: hidden;
	overflow-wrap: break-word;
	word-break: break-word;
`, EE = Q.div`
	display: flex;
	flex-direction: row;
	gap: ${b.spacing.small};
`, IE = Q.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`, AE = Q.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: ${b.spacing.small};
	align-items: center;
	${({ $withInlineSpacing: t }) => t && `margin: 0 ${b.spacing.medium};`}
`, OE = Q.div`
	padding: ${b.spacing.medium} ${b.spacing.small};
`, Rh = Q.div`
    display: flex;
	flex-direction: column;
	gap: ${b.spacing.medium};
	width: 100%;
`, Mh = Q.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(${({ $columns: t }) => t}, minmax(0, 1fr));
    gap: ${b.spacing.medium};
`, kE = Q.div`
	border: ${b.borders.widthSmall} dashed ${b.colors.contrasts.grey3045};
	border-radius: ${b.borders.radiusLarge};
	padding: ${b.spacing.medium} ${b.spacing.mediumSmall};
	background: ${b.colors.contrasts.grey1111};
`, dc = ({
  category: t,
  withInlineSpacing: n
}) => {
  const { resolveToken: i } = Ae(), s = t.workflowState === zn.Deleted;
  return /* @__PURE__ */ J(AE, { $withInlineSpacing: n, children: [
    s ? /* @__PURE__ */ y(xr, { color: "danger", children: /* @__PURE__ */ y(Je, { weight: "bold", children: i("categoryArchived") }) }) : t.createdAt ? /* @__PURE__ */ y(xr, { color: "info", children: /* @__PURE__ */ y(Je, { weight: "bold", children: i({
      key: "createdAt",
      vars: { date: Xp(t.createdAt) }
    }) }) }) : null,
    /* @__PURE__ */ y(
      xr,
      {
        renderIcon: /* @__PURE__ */ y(ag, {}),
        "aria-label": i({
          key: "categoryTagCount",
          count: t.tagsCount ?? 0,
          vars: { count: t.tagsCount ?? 0, categoryName: t.name }
        }),
        children: /* @__PURE__ */ y(Je, { weight: "bold", children: t.tagsCount ?? 0 })
      }
    ),
    !s && t.associationsCount != null && /* @__PURE__ */ y(
      xr,
      {
        renderIcon: /* @__PURE__ */ y(_C, {}),
        "aria-label": i({
          key: "categoryAssociationCount",
          count: t.associationsCount,
          vars: { count: t.associationsCount, categoryName: t.name }
        }),
        children: /* @__PURE__ */ y(Je, { weight: "bold", children: t.associationsCount })
      }
    )
  ] });
}, em = N.createContext({
  openModal: () => {
  },
  closeModal: () => {
  }
}), Vn = () => N.useContext(em), tm = N.createContext({
  canView: !1,
  canCreate: !1,
  canEdit: !1
}), $E = ({ children: t }) => {
  const { permissions: n } = cg(), i = n.canView ?? !1, s = (n.canCreate ?? !1) && i, o = (n.canEdit ?? !1) && i, u = N.useMemo(
    () => ({ canView: i, canCreate: s, canEdit: o }),
    [i, s, o]
  );
  return /* @__PURE__ */ y(tm.Provider, { value: u, children: t });
}, mi = () => N.useContext(tm), nm = At`
  query GetInstitutionalTagCategories(
    $accountId: ID!
    $first: Int
    $after: String
    $searchTerm: String
    $workflowState: String
    $tagsFirst: Int
  ) {
    account(id: $accountId) {
      _id
      institutionalTagCategoriesConnection(
        first: $first
        after: $after
        searchTerm: $searchTerm
        workflowState: $workflowState
      ) {
        nodes {
          _id
          name
          description
          workflowState
          associationsCount
          createdAt
          updatedAt
          tagsConnection(first: $tagsFirst) {
            nodes {
              _id
              name
              description
              workflowState
              associationsCount
              category {
                _id
                name
              }
              createdAt
              updatedAt
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              endCursor
              startCursor
              totalCount
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
          totalCount
        }
      }
    }
  }
`;
At`
  query GetAllInstitutionalTagCategories(
    $accountId: ID!
    $first: Int
    $after: String
    $workflowState: String
  ) {
    account(id: $accountId) {
      _id
      institutionalTagCategoriesConnection(
        first: $first
        after: $after
        workflowState: $workflowState
      ) {
        nodes {
          _id
          name
          description
          workflowState
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
const rm = At`
  query GetInstitutionalTagsForCategory(
    $accountId: ID!
    $categoryId: ID
    $first: Int
    $after: String
    $workflowState: String
  ) {
    account(id: $accountId) {
      _id
      institutionalTagsConnection(
        categoryId: $categoryId
        first: $first
        after: $after
        workflowState: $workflowState
      ) {
        nodes {
          _id
          name
          description
          workflowState
          associationsCount
          category {
            _id
            name
          }
          createdAt
          updatedAt
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
          totalCount
        }
      }
    }
  }
`, im = At`
  query GetInstitutionalTag($id: ID!, $first: Int, $after: String, $sort: InstitutionalTagUsersSortInput) {
    institutionalTag(id: $id) {
      _id
      name
      description
      workflowState
      associationsCount
      createdAt
      updatedAt
      category {
        _id
        name
      }
      usersConnection(first: $first, after: $after, sort: $sort) {
        nodes {
          _id
          name
          sortableName
          avatarUrl
          email
          sisId
        }
        pageInfo {
          hasNextPage
          endCursor
          totalCount
        }
      }
    }
  }
`;
At`
  query GetInstitutionalTagCategory($id: ID!) {
    institutionalTagCategory(id: $id) {
      _id
      name
      description
      workflowState
      associationsCount
    }
  }
`;
const NE = At`
  query GetAccountUsers(
    $accountId: ID!
    $first: Int
    $after: String
    $filter: AccountUsersFilter
  ) {
    account(id: $accountId) {
      _id
      usersConnection(first: $first, after: $after, filter: $filter) {
        nodes {
          _id
          name
          sortableName
          avatarUrl
          email
          sisId
        }
        pageInfo {
          hasNextPage
          endCursor
          totalCount
        }
      }
    }
  }
`;
At`
  query GetInstitutionalTagCategoryWithTags(
    $accountId: ID!
    $categoryId: ID!
    $first: Int
    $after: String
  ) {
    institutionalTagCategory(id: $categoryId) {
      _id
      name
      description
      workflowState
      associationsCount
    }
    account(id: $accountId) {
      _id
      institutionalTagsConnection(categoryId: $categoryId, first: $first, after: $after) {
        nodes {
          _id
          name
          description
          workflowState
          associationsCount
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
          totalCount
        }
      }
    }
  }
`;
function ht() {
  const { accounts: t, executeQuery: n } = cg();
  return { accountId: t[0].id, executeQuery: n };
}
const cr = (t) => t != null, sm = (t, n) => ({
  _id: t._id,
  name: t.name,
  description: t.description,
  workflowState: t.workflowState,
  associationsCount: t.associationsCount ?? void 0,
  category: t.category ?? n ?? { _id: "", name: "" },
  createdAt: t.createdAt ?? void 0,
  updatedAt: t.updatedAt ?? void 0
}), RE = (t) => ({
  _id: t._id,
  name: t.name,
  description: t.description,
  workflowState: t.workflowState,
  createdAt: t.createdAt ?? void 0,
  updatedAt: t.updatedAt ?? void 0
}), ME = (t) => ({
  _id: t._id,
  name: t.name,
  description: t.description,
  workflowState: t.workflowState,
  associationsCount: t.associationsCount,
  category: t.category ?? { _id: "", name: "" },
  createdAt: t.createdAt ?? void 0,
  updatedAt: t.updatedAt ?? void 0
}), am = (t) => ({
  _id: t._id,
  name: t.name ?? "",
  sortableName: t.sortableName ?? t.name ?? "",
  avatarUrl: t.avatarUrl ?? void 0,
  email: t.email ?? void 0,
  sisId: t.sisId ?? void 0
}), PE = (t) => {
  var n, i, s, o;
  return {
    tags: (((n = t.tagsConnection) == null ? void 0 : n.nodes) ?? []).filter(cr).map((u) => sm(u, { _id: t._id, name: t.name })),
    pageInfo: {
      hasNextPage: ((i = t.tagsConnection) == null ? void 0 : i.pageInfo.hasNextPage) ?? !1,
      endCursor: (s = t.tagsConnection) == null ? void 0 : s.pageInfo.endCursor,
      totalCount: (o = t.tagsConnection) == null ? void 0 : o.pageInfo.totalCount
    }
  };
}, DE = 500, LE = 5 * 60 * 1e3, yi = ({ enabled: t = !1 } = {}) => {
  const { accountId: n, executeQuery: i } = ht();
  return Nr({
    queryKey: ["allCategories", n],
    enabled: t,
    queryFn: async () => {
      var l;
      const s = [];
      let o, u = !0;
      for (; u; ) {
        const f = (l = (await i(nm, {
          accountId: n,
          first: DE,
          after: o,
          workflowState: "active",
          tagsFirst: 1
        })).account) == null ? void 0 : l.institutionalTagCategoriesConnection, m = ((f == null ? void 0 : f.nodes) ?? []).filter(cr).map(RE);
        s.push(...m), u = (f == null ? void 0 : f.pageInfo.hasNextPage) ?? !1, o = (f == null ? void 0 : f.pageInfo.endCursor) ?? void 0;
      }
      return s;
    },
    staleTime: LE
  });
}, FE = 500, WE = 5 * 60 * 1e3, Uc = ({ enabled: t = !1 } = {}) => {
  const { accountId: n, executeQuery: i } = ht();
  return Nr({
    queryKey: ["allTagNames", n],
    enabled: t,
    queryFn: async () => {
      var l;
      const s = /* @__PURE__ */ new Set();
      let o, u = !0;
      for (; u; ) {
        const f = (l = (await i(rm, {
          accountId: n,
          first: FE,
          after: o,
          workflowState: "active"
        })).account) == null ? void 0 : l.institutionalTagsConnection;
        for (const m of ((f == null ? void 0 : f.nodes) ?? []).filter(cr))
          s.add(m.name);
        u = (f == null ? void 0 : f.pageInfo.hasNextPage) ?? !1, o = (f == null ? void 0 : f.pageInfo.endCursor) ?? void 0;
      }
      return [...s];
    },
    staleTime: WE
  });
}, qc = Q.div`
	padding: ${b.spacing.mediumSmall};
	background: ${b.colors.contrasts.grey1111};
	border-radius: ${b.borders.radiusLarge};
	display: flex;
	flex-direction: column;
	gap: ${b.spacing.mediumSmall};
`, zc = ({
  options: t,
  onChange: n,
  label: i,
  placeholder: s,
  isRequired: o = !0,
  defaultValue: u,
  ...l
}) => {
  const { resolveToken: d } = Ae();
  return /* @__PURE__ */ y(
    Nd,
    {
      ...l,
      defaultValue: u != null ? String(u) : "",
      renderLabel: d(i),
      isRequired: o,
      placeholder: s ? d(s) : void 0,
      onChange: (f, m) => {
        var v;
        if (!m.id) return;
        const T = typeof ((v = t[0]) == null ? void 0 : v.id) == "number" ? Number(m.id) : m.id;
        n(T);
      },
      children: t.map((f) => /* @__PURE__ */ y(
        Nd.Option,
        {
          id: String(f.id),
          value: String(f.id),
          renderBeforeLabel: f.renderBeforeLabel,
          children: f.label
        },
        String(f.id)
      ))
    }
  );
}, Ma = "institutional-tagging-app-container", hc = "new";
Q.div`
    display: flex;
    flex-direction: column;
    gap: ${b.spacing.mediumSmall};
`;
const UE = Q.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${b.spacing.small};
`, Bc = ({
  inputValue: t,
  filteredSuggestions: n,
  messages: i,
  onInputChange: s
}) => {
  const { categoryAutocomplete: o } = Fa(), { translations: u } = Ae(), [l, d] = N.useState(!1), [f, m] = N.useState(null), T = (C) => {
    const A = C.target.value;
    s(A), d(!0), m(null);
  }, v = (C, { id: A }) => {
    var R;
    if (!A) return;
    const _ = (R = n.find((L) => L.id === A)) == null ? void 0 : R.label;
    _ && s(_), d(!1), m(null);
  }, x = (C, { id: A }) => {
    m(A ?? null);
  };
  return o ? /* @__PURE__ */ y(
    Cn,
    {
      renderLabel: u.categoryNameLabel,
      isRequired: !0,
      placeholder: u.categoryNamePlaceholder,
      inputValue: t,
      isShowingOptions: l,
      onRequestShowOptions: () => d(!0),
      onRequestHideOptions: () => d(!1),
      onBlur: () => m(null),
      onInputChange: T,
      onRequestHighlightOption: x,
      onRequestSelectOption: v,
      messages: i,
      children: n.length > 0 ? n.map((C) => /* @__PURE__ */ y(
        Cn.Option,
        {
          id: C.id,
          isHighlighted: C.id === f,
          children: C.label
        },
        C.id
      )) : /* @__PURE__ */ y(Cn.Option, { id: "empty-option", children: u.categoryNameNoMatches }, "empty-option")
    }
  ) : /* @__PURE__ */ y(
    Ar,
    {
      renderLabel: u.categoryNameLabel,
      isRequired: !0,
      placeholder: u.categoryNamePlaceholder,
      value: t,
      onChange: (C, A) => s(A),
      messages: i
    }
  );
}, om = ({
  categoryOptions: t,
  categoryError: n,
  newCategoryNameError: i,
  filteredSuggestions: s,
  newCategoryName: o,
  isCreatingCategory: u,
  defaultCategoryValue: l,
  categorySelectKey: d,
  onCategoryChange: f,
  onNewCategoryNameChange: m,
  onNewCategoryDescriptionChange: T
}) => {
  const { translations: v } = Ae();
  return /* @__PURE__ */ J(_c, { description: null, layout: "stacked", vAlign: "top", children: [
    /* @__PURE__ */ J(UE, { children: [
      /* @__PURE__ */ y(
        zc,
        {
          label: "category",
          placeholder: "categoryPlaceholder",
          defaultValue: l,
          messages: n,
          onChange: f,
          options: t.map((x) => ({
            ...x,
            renderBeforeLabel: x.id === hc ? /* @__PURE__ */ y(Cc, {}) : void 0
          }))
        },
        d
      ),
      u && /* @__PURE__ */ y(
        Bc,
        {
          inputValue: o,
          filteredSuggestions: s,
          messages: i,
          onInputChange: m
        }
      )
    ] }),
    u && /* @__PURE__ */ y(
      Ar,
      {
        renderLabel: v.categoryDescriptionLabel,
        onChange: (x, C) => T(C)
      }
    )
  ] });
}, um = ({
  tagNameError: t,
  tagDescriptionError: n,
  onTagNameChange: i,
  onTagDescriptionChange: s,
  defaultName: o,
  defaultDescription: u,
  existingTagNames: l = []
}) => {
  const { translations: d } = Ae(), [f, m] = N.useState(o ?? ""), [T, v] = N.useState(!1), [x, C] = N.useState(null), A = N.useMemo(() => {
    if (!f.trim()) return l;
    const L = f.trim().toLowerCase();
    return l.filter((U) => U.toLowerCase().includes(L));
  }, [l, f]), _ = (L) => {
    const U = L.target.value;
    m(U), i(U), v(!0), C(null);
  }, R = (L, { id: U }) => {
    if (!U) return;
    const q = A.find((P) => P === U);
    q && (m(q), i(q), v(!1), C(null));
  };
  return /* @__PURE__ */ J(
    _c,
    {
      description: /* @__PURE__ */ y(Je, { weight: "normal", size: "large", children: d.tagFieldGroupLabel }),
      colSpacing: "small",
      layout: "columns",
      vAlign: "top",
      children: [
        l.length > 0 ? /* @__PURE__ */ y(
          Cn,
          {
            renderLabel: d.tagNameLabel,
            isRequired: !0,
            placeholder: d.tagNamePlaceholder,
            inputValue: f,
            isShowingOptions: T,
            onRequestShowOptions: () => v(!0),
            onRequestHideOptions: () => v(!1),
            onBlur: () => C(null),
            onInputChange: _,
            onRequestHighlightOption: (L, { id: U }) => C(U ?? null),
            onRequestSelectOption: R,
            messages: t,
            children: A.length > 0 ? A.map((L) => /* @__PURE__ */ y(Cn.Option, { id: L, isHighlighted: L === x, children: L }, L)) : /* @__PURE__ */ y(Cn.Option, { id: "empty-option", children: d.tagNameNoMatches }, "empty-option")
          }
        ) : /* @__PURE__ */ y(
          Ar,
          {
            renderLabel: d.tagNameLabel,
            placeholder: d.tagNamePlaceholder,
            defaultValue: o,
            isRequired: !0,
            onChange: (L, U) => {
              m(U), i(U);
            },
            messages: t
          }
        ),
        /* @__PURE__ */ y(
          Ar,
          {
            renderLabel: d.tagDescriptionLabel,
            placeholder: d.tagDescriptionPlaceholder,
            defaultValue: u,
            isRequired: !0,
            messages: n,
            onChange: (L, U) => s(U)
          }
        )
      ]
    }
  );
}, cm = At`
  mutation CreateInstitutionalTagCategory($input: CreateInstitutionalTagCategoryInput!) {
    createInstitutionalTagCategory(input: $input) {
      institutionalTagCategory {
        _id
        name
        description
        workflowState
        createdAt
        updatedAt
      }
      errors {
        attribute
        message
      }
    }
  }
`, qE = At`
  mutation UpdateInstitutionalTagCategory($input: UpdateInstitutionalTagCategoryInput!) {
    updateInstitutionalTagCategory(input: $input) {
      institutionalTagCategory {
        _id
        name
        description
        workflowState
        createdAt
        updatedAt
      }
      errors {
        attribute
        message
      }
    }
  }
`, zE = At`
  mutation ArchiveInstitutionalTagCategory($input: UpdateInstitutionalTagCategoryArchivedStateInput!) {
    updateInstitutionalTagCategoryArchivedState(input: $input) {
      institutionalTagCategory {
        _id
        workflowState
      }
      errors {
        attribute
        message
      }
    }
  }
`, BE = At`
  mutation CreateInstitutionalTag($input: CreateInstitutionalTagInput!) {
    createInstitutionalTag(input: $input) {
      institutionalTag {
        _id
        name
        description
        workflowState
        associationsCount
        category {
          _id
          name
        }
        createdAt
        updatedAt
      }
      errors {
        attribute
        message
      }
    }
  }
`, Vc = At`
  mutation UpdateInstitutionalTag($input: UpdateInstitutionalTagInput!) {
    updateInstitutionalTag(input: $input) {
      institutionalTag {
        _id
        name
        description
        workflowState
        associationsCount
        category {
          _id
          name
        }
        createdAt
        updatedAt
      }
      errors {
        attribute
        message
      }
    }
  }
`, lm = At`
  mutation ArchiveInstitutionalTag($input: UpdateInstitutionalTagArchivedStateInput!) {
    updateInstitutionalTagArchivedState(input: $input) {
      institutionalTag {
        _id
        workflowState
      }
      errors {
        attribute
        message
      }
    }
  }
`, VE = At`
  mutation ApplyInstitutionalTag($input: ApplyInstitutionalTagInput!) {
    applyInstitutionalTag(input: $input) {
      institutionalTagAssociation {
        _id
        tag {
          _id
          name
        }
        user {
          _id
          name
        }
      }
      errors {
        attribute
        message
      }
    }
  }
`, HE = At`
  mutation RemoveInstitutionalTag($input: RemoveInstitutionalTagInput!) {
    removeInstitutionalTag(input: $input) {
      institutionalTagAssociation {
        _id
      }
      errors {
        attribute
        message
      }
    }
  }
`, fm = ({
  categories: t,
  initialCategoryId: n
}) => {
  const { categoryAutocomplete: i } = Fa(), [s, o] = N.useState(!1), [u, l] = N.useState([]), [d, f] = N.useState([]), [m, T] = N.useState(
    n ?? null
  ), [v, x] = N.useState(""), [C, A] = N.useState(""), [_, R] = N.useState(null), [L, U] = N.useState(0), [q, P] = N.useState(
    n
  ), { translations: O } = Ae(), { executeQuery: M } = ht(), $ = (X) => {
    X === hc ? o(!0) : (o(!1), T(X)), l([]);
  }, H = (X) => t.some((ze) => ze.label.trim().toLowerCase() === X.trim().toLowerCase()), re = (X) => {
    x(X), X.trim() && H(X) ? f([{ type: "error", text: O.categoryNameAlreadyExists }]) : f([]);
  }, ke = (X) => A(X), oe = () => {
    let X = !0;
    return s && (v.trim() ? H(v) ? (f([{ type: "error", text: O.categoryNameAlreadyExists }]), X = !1) : f([]) : (f([{ type: "error", text: O.categoryNameRequired }]), X = !1)), !s && !m ? (l([{ type: "error", text: O.categoryRequired }]), X = !1) : l([]), X;
  }, ue = async () => {
    var X;
    if (s) {
      const je = (X = (await M(cm, {
        input: {
          name: v.trim(),
          ...C.trim() ? { description: C.trim() } : {}
        }
      })).createInstitutionalTagCategory) == null ? void 0 : X.institutionalTagCategory;
      if (!je) throw new Error("Failed to create category");
      return je._id;
    }
    if (m === null)
      throw new Error("resolveCategoryId called without a selected category");
    return m;
  }, xe = (X) => {
    o(!1), T(X), R({ id: X, label: v }), P(X), U((ze) => ze + 1);
  }, He = _ && !t.find((X) => X.id === _.id) ? [_] : [], $e = [
    { id: hc, label: O.createNewCategoryOption },
    ...He,
    ...t
  ], st = N.useMemo(() => {
    if (!i) return [];
    const X = v.trim().toLowerCase();
    return X ? t.filter((ze) => ze.label.toLowerCase().includes(X)) : t;
  }, [i, t, v]);
  return {
    isCreatingCategory: s,
    categoryError: u,
    newCategoryName: v,
    newCategoryNameError: d,
    filteredSuggestions: st,
    categoryOptions: $e,
    categorySelectKey: L,
    defaultCategoryValue: q,
    onCategoryChange: $,
    onNewCategoryNameChange: re,
    onNewCategoryDescriptionChange: ke,
    validateCategory: oe,
    resolveCategoryId: ue,
    resolveToExistingCategory: xe
  };
};
function tn(t) {
  var n;
  return (((n = t == null ? void 0 : t.errors) == null ? void 0 : n.length) ?? 0) > 0;
}
function cs(t) {
  var n;
  return ((n = t == null ? void 0 : t.errors) == null ? void 0 : n.some((i) => {
    if (!i) return !1;
    const s = i.message.toLowerCase();
    return s.includes("taken") || s.includes("already exists") || s.includes("unique");
  })) ?? !1;
}
const dm = N.createContext({
  showAlert: () => {
  }
}), pn = () => N.useContext(dm), hm = (t) => {
  const [n, i] = N.useState((t == null ? void 0 : t.name) ?? ""), [s, o] = N.useState((t == null ? void 0 : t.description) ?? ""), [u, l] = N.useState([]), [d, f] = N.useState([]), { translations: m } = Ae();
  return {
    tagName: n,
    tagDescription: s,
    tagNameError: u,
    tagDescriptionError: d,
    onTagNameChange: (_) => {
      i(_), _.trim() && l([]);
    },
    onTagDescriptionChange: (_) => {
      o(_), _.trim() && f([]);
    },
    onTagNameRequired: () => l([{ type: "error", text: m.tagNameRequired }]),
    onTagDescriptionRequired: () => f([{ type: "error", text: m.tagDescriptionRequired }]),
    onConflictError: () => l([{ type: "error", text: m.tagAlreadyExists }])
  };
}, GE = ({
  categories: t,
  submitRef: n,
  initialCategoryId: i
}) => {
  const {
    tagName: s,
    tagDescription: o,
    tagNameError: u,
    tagDescriptionError: l,
    onTagNameChange: d,
    onTagDescriptionChange: f,
    onTagNameRequired: m,
    onTagDescriptionRequired: T,
    onConflictError: v
  } = hm(), {
    isCreatingCategory: x,
    categoryError: C,
    newCategoryName: A,
    newCategoryNameError: _,
    filteredSuggestions: R,
    categoryOptions: L,
    categorySelectKey: U,
    defaultCategoryValue: q,
    onCategoryChange: P,
    onNewCategoryNameChange: O,
    onNewCategoryDescriptionChange: M,
    validateCategory: $,
    resolveCategoryId: H,
    resolveToExistingCategory: re
  } = fm({ categories: t, initialCategoryId: i }), { closeModal: ke } = Vn(), { showAlert: oe } = pn(), { translations: ue } = Ae(), xe = bn(), { executeQuery: He } = ht(), $e = N.useRef(null), { mutate: st } = En({
    mutationFn: async () => {
      const X = await H();
      return x && ($e.current = X), He(
        BE,
        { input: { name: s, description: o, categoryId: X } }
      );
    },
    onSuccess: (X) => {
      if (tn(X.createInstitutionalTag)) {
        const ze = $e.current;
        $e.current = null, ze !== null && (xe.invalidateQueries({ queryKey: ["categories"] }), xe.invalidateQueries({ queryKey: ["allCategories"] }), re(ze)), cs(X.createInstitutionalTag) && v();
        return;
      }
      x && (xe.invalidateQueries({ queryKey: ["allCategories"] }), oe({ variant: "success", message: ue.categoryCreated })), $e.current = null, xe.invalidateQueries({ queryKey: ["categories"] }), xe.invalidateQueries({ queryKey: ["tags"] }), xe.invalidateQueries({ queryKey: ["allTagNames"] }), ke(), oe({ variant: "success", message: ue.tagSaved });
    },
    onError: () => {
      const X = $e.current;
      $e.current = null, X !== null && (xe.invalidateQueries({ queryKey: ["categories"] }), xe.invalidateQueries({ queryKey: ["allCategories"] }), re(X));
    }
  });
  return n.current = () => {
    let X = !1;
    s.trim() || (m(), X = !0), o.trim() || (T(), X = !0), $() || (X = !0), X || st();
  }, {
    tagNameError: u,
    tagDescriptionError: l,
    onTagNameChange: d,
    onTagDescriptionChange: f,
    isCreatingCategory: x,
    categoryError: C,
    newCategoryName: A,
    newCategoryNameError: _,
    filteredSuggestions: R,
    categoryOptions: L,
    categorySelectKey: U,
    defaultCategoryValue: q,
    onCategoryChange: P,
    onNewCategoryNameChange: O,
    onNewCategoryDescriptionChange: M
  };
}, YE = ({
  tag: t,
  categories: n,
  submitRef: i
}) => {
  const {
    tagName: s,
    tagDescription: o,
    tagNameError: u,
    tagDescriptionError: l,
    onTagNameChange: d,
    onTagDescriptionChange: f,
    onTagNameRequired: m,
    onTagDescriptionRequired: T,
    onConflictError: v
  } = hm({
    name: t.name,
    description: t.description
  }), {
    isCreatingCategory: x,
    categoryError: C,
    newCategoryName: A,
    newCategoryNameError: _,
    filteredSuggestions: R,
    categoryOptions: L,
    categorySelectKey: U,
    defaultCategoryValue: q,
    onCategoryChange: P,
    onNewCategoryNameChange: O,
    onNewCategoryDescriptionChange: M,
    validateCategory: $,
    resolveCategoryId: H
  } = fm({ categories: n, initialCategoryId: t.category._id }), { closeModal: re } = Vn(), { showAlert: ke } = pn(), { translations: oe } = Ae(), ue = bn(), { executeQuery: xe } = ht(), { mutate: He } = En({
    mutationFn: async () => {
      const $e = await H();
      return xe(
        Vc,
        { input: { id: t._id, name: s, description: o, categoryId: $e } }
      );
    },
    onSuccess: ($e) => {
      if (tn($e.updateInstitutionalTag)) {
        cs($e.updateInstitutionalTag) && v();
        return;
      }
      ue.invalidateQueries({ queryKey: ["categories"] }), ue.invalidateQueries({ queryKey: ["allCategories"] }), ue.invalidateQueries({ queryKey: ["tags"] }), ue.invalidateQueries({ queryKey: ["allTagNames"] }), ue.invalidateQueries({ queryKey: ["tagUsers", t._id] }), re(), ke({ variant: "success", message: oe.tagUpdated });
    },
    onError: () => {
    }
  });
  return i.current = () => {
    let $e = !1;
    s.trim() || (m(), $e = !0), o.trim() || (T(), $e = !0), $() || ($e = !0), $e || He();
  }, {
    tagNameError: u,
    tagDescriptionError: l,
    onTagNameChange: d,
    onTagDescriptionChange: f,
    isCreatingCategory: x,
    categoryError: C,
    newCategoryName: A,
    newCategoryNameError: _,
    filteredSuggestions: R,
    categoryOptions: L,
    categorySelectKey: U,
    defaultCategoryValue: q,
    onCategoryChange: P,
    onNewCategoryNameChange: O,
    onNewCategoryDescriptionChange: M
  };
}, gm = ({
  categories: t,
  submitRef: n,
  defaultCategory: i,
  existingTagNames: s
}) => {
  const {
    tagNameError: o,
    tagDescriptionError: u,
    onTagNameChange: l,
    onTagDescriptionChange: d,
    isCreatingCategory: f,
    categoryError: m,
    newCategoryName: T,
    newCategoryNameError: v,
    filteredSuggestions: x,
    categoryOptions: C,
    categorySelectKey: A,
    defaultCategoryValue: _,
    onCategoryChange: R,
    onNewCategoryNameChange: L,
    onNewCategoryDescriptionChange: U
  } = GE({
    categories: t,
    submitRef: n,
    initialCategoryId: i == null ? void 0 : i.id
  });
  return /* @__PURE__ */ J(qc, { children: [
    /* @__PURE__ */ y(
      um,
      {
        tagNameError: o,
        tagDescriptionError: u,
        onTagNameChange: l,
        onTagDescriptionChange: d,
        existingTagNames: s
      }
    ),
    /* @__PURE__ */ y(
      om,
      {
        categoryOptions: C,
        categoryError: m,
        newCategoryName: T,
        newCategoryNameError: v,
        filteredSuggestions: x,
        isCreatingCategory: f,
        onCategoryChange: R,
        onNewCategoryNameChange: L,
        onNewCategoryDescriptionChange: U,
        defaultCategoryValue: _,
        categorySelectKey: A
      }
    )
  ] });
}, Un = (t, n) => t.filter((i) => i._id !== n).map((i) => ({ id: i._id, label: i.name }));
var Qi = /* @__PURE__ */ ((t) => (t.Edit = "edit", t.Create = "create", t))(Qi || {});
const pm = (t, { canEdit: n, canCreate: i }) => t.filter(
  ({ requiredPermissions: s }) => (!s.includes(
    "edit"
    /* Edit */
  ) || n) && (!s.includes(
    "create"
    /* Create */
  ) || i)
).map(({ label: s, onClick: o }) => /* @__PURE__ */ y(ji.Item, { onClick: o, children: s }, s)), gc = {
  withBackground: !1,
  size: "small"
}, mm = ({ category: t }) => {
  const { translations: n, resolveToken: i } = Ae(), { data: s = [] } = yi({ enabled: !0 }), { data: o = [] } = Uc(), { openModal: u, closeModal: l } = Vn(), { editHandler: d, archiveHandler: f, categoryMoreButtonRef: m } = Yg(), { canCreate: T, canEdit: v } = mi(), x = N.useRef(void 0), C = (_) => _ == null ? void 0 : _(t._id), A = () => {
    const _ = [
      {
        label: n.edit,
        requiredPermissions: [Qi.Edit],
        onClick: () => C(d)
      }
      // TODO: archive menu item hidden — re-enable when archive feature is back in scope
      // {
      //   label: t.archive,
      //   requiredPermissions: [Permission.Edit],
      //   onClick: () => optionalFnCaller(archiveHandler),
      // },
    ];
    return pm(_, { canEdit: v, canCreate: T });
  };
  return /* @__PURE__ */ J(EE, { children: [
    T && t.workflowState === zn.Active && /* @__PURE__ */ y(ba, { renderTip: n.addTags, children: /* @__PURE__ */ y(
      _n,
      {
        ...gc,
        screenReaderLabel: i({
          key: "addTagToCategory",
          vars: { categoryName: t.name }
        }),
        renderIcon: /* @__PURE__ */ y(bC, {}),
        color: "primary-inverse",
        onClick: () => u({
          heading: "newTag",
          body: /* @__PURE__ */ y(
            gm,
            {
              categories: Un(s),
              submitRef: x,
              defaultCategory: Un(s).find(
                (_) => _.id === t._id
              ),
              existingTagNames: o
            }
          ),
          handleClose: l,
          onPrimaryClick: () => {
            var _;
            return (_ = x.current) == null ? void 0 : _.call(x);
          }
        })
      }
    ) }),
    v && t.workflowState === zn.Active && /* @__PURE__ */ y(
      ji,
      {
        label: i({ key: "categoryMenuLabel", vars: { category: t.name } }),
        trigger: /* @__PURE__ */ y(ba, { renderTip: n.moreOptions, children: /* @__PURE__ */ y(
          _n,
          {
            ...gc,
            elementRef: (_) => {
              m.current = _;
            },
            renderIcon: xc,
            screenReaderLabel: i({
              key: "categoryMoreOptions",
              vars: { categoryName: t.name }
            }),
            color: "primary-inverse"
          }
        ) }),
        children: A()
      }
    )
  ] });
}, ZE = ({ category: t, isExpanded: n }) => {
  const { isMobile: i } = Va();
  return i ? /* @__PURE__ */ J($h, { $isMobile: !0, children: [
    /* @__PURE__ */ y(Nh, { children: /* @__PURE__ */ y(Ji, { variant: "titleCardMini", children: t.name }) }),
    /* @__PURE__ */ y(bE, { children: /* @__PURE__ */ y(Je, { size: "medium", children: t.description }) }),
    /* @__PURE__ */ y(dc, { category: t })
  ] }) : /* @__PURE__ */ J($h, { children: [
    /* @__PURE__ */ J(_E, { children: [
      /* @__PURE__ */ y(Nh, { children: /* @__PURE__ */ y(Ji, { variant: "titleCardMini", children: n ? /* @__PURE__ */ y(Ea, { children: t.name }) : t.name }) }),
      n ? /* @__PURE__ */ y(Je, { size: "medium", children: t.description }) : /* @__PURE__ */ y(Je, { size: "medium", children: /* @__PURE__ */ y(Ea, { children: t.description }) })
    ] }),
    !n && /* @__PURE__ */ y(dc, { category: t, withInlineSpacing: !0 }),
    /* @__PURE__ */ y(mm, { category: t })
  ] });
}, KE = ({ category: t, isExpanded: n }) => {
  const { isMobile: i } = Va();
  return /* @__PURE__ */ J(IE, { children: [
    n && !i && /* @__PURE__ */ y(dc, { category: t }),
    i && /* @__PURE__ */ y(mm, { category: t })
  ] });
}, ls = `@container ${Ma} (max-width: ${b.breakpoints.small})`, ym = Q.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    span[class*="inlineBlock-badge__wrapper"] {
        display: flex;
        flex: 1;
        flex-direction: column;
    }
`, QE = Q.li`
	list-style: none;
	padding: ${b.spacing.small};
	border: ${b.borders.widthSmall} solid ${b.colors.contrasts.grey1214};
	border-radius: ${b.borders.radiusLarge};
	background: ${b.colors.contrasts.white1010};
	box-shadow: ${b.shadows.resting};
	display: flex;
	flex-direction: row;
	gap: ${b.spacing.small};
	justify-content: space-between;
	flex-wrap: nowrap;
	align-items: center;
	flex: 1;

	${ls} {
		display: grid;
		grid-template-columns: auto 1fr auto;
		grid-template-rows: auto auto;
		grid-template-areas: "drag text menu" "drag pill menu";
		column-gap: ${b.spacing.small};
		row-gap: ${b.spacing.xxSmall};
	}
`, JE = Q.div`
    display: flex;
	flex-direction: column;
	overflow: hidden;
	gap: ${b.spacing.xxSmall};
	flex: 5;
	text-align: start;

	${ls} { grid-area: text; }
`, jE = Q.div`
	overflow-wrap: normal;
	font-weight: ${b.typography.fontWeightBold};
`, XE = Q.div`
    flex: none;

	${ls} { grid-area: drag; align-self: center; }
`, eI = Q.div`
    flex: 1;

	${ls} { grid-area: pill; align-self: start; }
`, tI = Q.div`
    flex: none;

	${ls} { grid-area: menu; align-self: 
		${(t) => t.$isArchived ? "center" : "end"};
	}
`, vm = ({ tag: t, isArchived: n, pill: i, actions: s }) => /* @__PURE__ */ J(QE, { children: [
  /* @__PURE__ */ y(XE, { children: /* @__PURE__ */ y(AC, {}) }),
  /* @__PURE__ */ J(JE, { children: [
    /* @__PURE__ */ y(Ea, { children: /* @__PURE__ */ y(jE, { children: /* @__PURE__ */ y(Ji, { variant: "titleCardMini", children: t.name }) }) }),
    /* @__PURE__ */ y(Ea, { children: /* @__PURE__ */ y(Je, { size: "small", children: t.description }) })
  ] }),
  /* @__PURE__ */ y(eI, { children: i }),
  /* @__PURE__ */ y(tI, { $isArchived: n, children: s })
] }), nI = ({
  tag: t,
  editHandler: n,
  viewTagAssociationsHandler: i,
  addPeopleHandler: s,
  archiveHandler: o,
  moveToHandler: u,
  moreButtonRef: l
}) => {
  const { translations: d, resolveToken: f } = Ae(), { canCreate: m, canEdit: T } = mi(), v = t.associationsCount === 0, x = t.associationsCount ?? 0, C = () => {
    const A = [
      {
        label: d.viewTagDetails,
        requiredPermissions: [],
        onClick: () => i(t._id)
      },
      {
        label: d.assignTag,
        requiredPermissions: [Qi.Edit],
        onClick: () => s(t._id)
      },
      {
        label: d.edit,
        requiredPermissions: [Qi.Edit],
        onClick: () => n(t)
      },
      {
        label: d.moveTo,
        requiredPermissions: [Qi.Edit],
        onClick: () => u()
      }
      // TODO: archive menu item hidden — re-enable when archive feature is back in scope
      // {
      //   label: t.archive,
      //   requiredPermissions: [Permission.Edit],
      //   onClick: () => archiveHandler(tag._id),
      // },
    ];
    return pm(A, { canEdit: T, canCreate: m });
  };
  return /* @__PURE__ */ y(ym, { children: /* @__PURE__ */ y(
    LC,
    {
      variant: "inverse",
      placement: "start top",
      formatOutput: () => v ? /* @__PURE__ */ y(IC, { color: "error", size: "x-small" }) : /* @__PURE__ */ y("span", { "aria-hidden": !0 }),
      children: /* @__PURE__ */ y(
        vm,
        {
          tag: t,
          isArchived: !1,
          pill: /* @__PURE__ */ y(
            xr,
            {
              color: v ? "danger" : "primary",
              renderIcon: /* @__PURE__ */ y(og, {}),
              "aria-label": f({
                key: "tagAssociationCount",
                count: x,
                vars: { count: x, tagName: t.name }
              }),
              children: /* @__PURE__ */ y(Je, { children: t.associationsCount })
            }
          ),
          actions: /* @__PURE__ */ y(
            ji,
            {
              trigger: /* @__PURE__ */ y(
                _n,
                {
                  elementRef: (A) => l == null ? void 0 : l(A),
                  renderIcon: xc,
                  screenReaderLabel: f({
                    key: "tagActions",
                    vars: { tagName: t.name }
                  }),
                  withBorder: !1,
                  withBackground: !1,
                  size: "small"
                }
              ),
              withArrow: !0,
              children: C()
            }
          )
        }
      )
    }
  ) });
}, rI = ({
  tag: t,
  restoreHandler: n
}) => {
  const { translations: i } = Ae(), { canEdit: s } = mi();
  return /* @__PURE__ */ y(ym, { children: /* @__PURE__ */ y(
    vm,
    {
      tag: t,
      isArchived: !0,
      actions: s ? /* @__PURE__ */ y(
        _n,
        {
          screenReaderLabel: i.restoreTag,
          renderIcon: /* @__PURE__ */ y(EC, {}),
          withBackground: !1,
          withBorder: !1,
          onClick: () => n(t._id)
        }
      ) : null
    }
  ) });
}, iI = ({ tag: t, ...n }) => t.workflowState === zn.Deleted ? /* @__PURE__ */ y(rI, { tag: t, ...n }) : /* @__PURE__ */ y(nI, { tag: t, ...n }), sI = (t, n) => {
  const i = bn(), { showAlert: s } = pn(), { translations: o, resolveToken: u } = Ae(), { executeQuery: l } = ht(), { closeModal: d } = Vn(), { mutate: f, isPending: m } = En({
    mutationFn: async (T) => {
      const v = await Promise.all(
        T.map(
          (C) => l(
            VE,
            { input: { tagId: t, userId: C } }
          )
        )
      ), x = v.filter((C) => tn(C.applyInstitutionalTag));
      if (x.length > 0)
        throw new Error(`${x.length} of ${T.length} associations failed`);
      return v;
    },
    onSuccess: (T, v) => {
      i.invalidateQueries({ queryKey: ["tagUsers", t] }), i.invalidateQueries({ queryKey: ["categories"] }), i.invalidateQueries({ queryKey: ["tags"] }), d(), s({
        message: u({
          key: "addPeopleSuccess",
          count: v.length,
          vars: { count: v.length, tagName: n }
        }),
        variant: "success"
      });
    },
    onError: () => {
      i.invalidateQueries({ queryKey: ["tagUsers", t] }), s({ message: o.addPeopleFailed, variant: "error" });
    }
  });
  return { addPeople: f, isPending: m };
}, aI = 100, oI = (t) => {
  const { executeQuery: n } = ht(), { data: i } = Nr({
    queryKey: ["tagExistingUsers", t],
    queryFn: () => n(
      im,
      { id: t, first: aI }
    ).then((o) => o.institutionalTag)
  });
  return { existingUserIds: N.useMemo(
    () => {
      var o;
      return new Set((((o = i == null ? void 0 : i.usersConnection) == null ? void 0 : o.nodes) ?? []).filter(cr).map((u) => u._id));
    },
    [i]
  ), tagName: (i == null ? void 0 : i.name) ?? "" };
}, wm = 300, qn = 15, Qa = (t) => {
  const {
    items: n,
    currentPage: i,
    totalPages: s,
    onPageChange: o,
    endCursorRef: u,
    totalCount: l,
    resetKey: d
  } = t, f = "endCursorRef" in t || "totalCount" in t || "resetKey" in t, [m, T] = N.useState(1), [v, x] = N.useState([]);
  N.useEffect(() => {
    x([]);
  }, [d]);
  const C = !f && o !== void 0, A = v.at(-1) ?? null, _ = v.length + 1, R = (M) => Math.ceil((M ?? 0) / qn), U = f ? _ : C ? i ?? 1 : m, q = f ? R(l) : s ?? R(n == null ? void 0 : n.length), P = f ? (M) => {
    if (M > _) {
      const $ = u == null ? void 0 : u.current;
      $ && x((H) => [...H, $]);
    } else
      x(($) => $.slice(0, -1));
  } : C ? o : T, O = N.useMemo(() => {
    if (!n) return [];
    if (C || f) return n;
    const M = (U - 1) * qn;
    return n.slice(M, M + qn);
  }, [n, C, f, U]);
  return { cursor: A, currentPage: U, totalPages: q, shownItems: O, handlePageChange: P, getTotalPages: R };
}, uI = (t) => {
  var x, C, A;
  const { accountId: n, executeQuery: i } = ht(), s = N.useRef(void 0), { cursor: o, currentPage: u, handlePageChange: l, getTotalPages: d } = Qa({
    endCursorRef: s,
    resetKey: t
  }), { data: f, isPending: m, isFetching: T } = Nr({
    queryKey: ["accountUsers", n, t, o],
    queryFn: () => i(NE, {
      accountId: n,
      first: qn,
      after: o ?? void 0,
      filter: t ? { searchTerm: t } : void 0
    }).then((_) => _.account),
    enabled: t.length === 0 || t.length >= 2
  });
  return s.current = (x = f == null ? void 0 : f.usersConnection) == null ? void 0 : x.pageInfo.endCursor, {
    users: (((C = f == null ? void 0 : f.usersConnection) == null ? void 0 : C.nodes) ?? []).filter(cr).map(am),
    isPending: m,
    isFetching: T,
    currentPage: u,
    totalPages: d((A = f == null ? void 0 : f.usersConnection) == null ? void 0 : A.pageInfo.totalCount),
    handlePageChange: l
  };
}, cI = (t) => t.map((n) => /* @__PURE__ */ y(Cn.Option, { id: `skeleton-${n}`, isDisabled: !0, "aria-hidden": !0, children: /* @__PURE__ */ J(l_, { children: [
  /* @__PURE__ */ y(Ie, { $width: "2rem", $height: "2rem", $radius: "50%" }),
  /* @__PURE__ */ J(f_, { children: [
    /* @__PURE__ */ y(Ie, { $width: "140px", $height: "1rem" }),
    /* @__PURE__ */ y(Ie, { $width: "180px", $height: "0.75rem" })
  ] })
] }) }, n)), lI = Q.div`
	display: flex;
	flex-direction: column;
	gap: ${b.spacing.small};
`, fI = Q.span`
	display: inline-block;
	padding: ${b.spacing.xxSmall};
`, dI = Q.span`
	display: flex;
	align-items: center;
	gap: ${b.spacing.small};
`, hI = Q.span`
	display: flex;
	flex-direction: column;
	gap: ${b.spacing.xxxSmall};
`, gI = ({
  existingUserIds: t,
  selectedUsers: n,
  messages: i,
  onToggleUser: s,
  onRemoveUser: o
}) => {
  const { translations: u, resolveToken: l } = Ae(), d = bc(5), [f, m] = N.useState(""), [T, v] = N.useState(""), [x, C] = N.useState(!1), [A, _] = N.useState(null), { users: R, isPending: L } = uI(T), U = R.filter((M) => !t.has(M._id));
  N.useEffect(() => {
    const M = setTimeout(() => {
      (f.length === 0 || f.length >= 2) && v(f);
    }, wm);
    return () => clearTimeout(M);
  }, [f]);
  const q = (M) => n.some(($) => $._id === M), P = () => L ? cI(d) : U.length === 0 ? /* @__PURE__ */ y(Cn.Option, { id: "no-results", isDisabled: !0, children: u.noResultsFound }) : U.map((M) => /* @__PURE__ */ y(
    Cn.Option,
    {
      id: M._id,
      isHighlighted: A === M._id,
      isSelected: q(M._id),
      renderAfterLabel: ({ isSelected: $ }) => $ ? /* @__PURE__ */ y(OC, { size: "x-small" }) : null,
      children: /* @__PURE__ */ J(dI, { children: [
        /* @__PURE__ */ y(lg, { name: M.name, src: M.avatarUrl, size: "x-small" }),
        /* @__PURE__ */ J(hI, { children: [
          /* @__PURE__ */ y(Je, { weight: "bold", children: M.name }),
          M.email && /* @__PURE__ */ y(Je, { size: "small", children: M.email })
        ] })
      ] })
    },
    M._id
  )), O = n.length > 0 ? /* @__PURE__ */ y(fI, { children: n.map((M) => /* @__PURE__ */ y(
    FC,
    {
      text: M.name,
      dismissible: !0,
      size: "small",
      margin: "0 xx-small xx-small 0",
      onClick: ($) => {
        $.stopPropagation(), $.preventDefault(), o(M._id);
      },
      "aria-label": l({
        key: "removeSelectedUser",
        vars: { userName: M.name }
      })
    },
    M._id
  )) }) : null;
  return /* @__PURE__ */ J(lI, { children: [
    /* @__PURE__ */ y(
      Cn,
      {
        renderLabel: u.people,
        placeholder: u.searchPeople,
        inputValue: f,
        isShowingOptions: x,
        renderBeforeInput: O,
        assistiveText: u.searchPeople,
        messages: i,
        onInputChange: (M, $) => {
          m($), C(!0);
        },
        onRequestShowOptions: () => C(!0),
        onRequestHideOptions: () => {
          C(!1), _(null);
        },
        onRequestHighlightOption: (M, { id: $ }) => {
          _($ ?? null);
        },
        onRequestSelectOption: (M, { id: $ }) => {
          if (!$) return;
          const H = U.find((re) => re._id === $);
          H && s(H), m(""), _(null);
        },
        children: P()
      }
    ),
    n.length > 0 && /* @__PURE__ */ y(Je, { size: "small", weight: "bold", children: l({
      key: "selectedPeople",
      count: n.length,
      vars: { count: n.length }
    }) })
  ] });
}, pI = ({ tagId: t, submitRef: n }) => {
  const { translations: i } = Ae(), [s, o] = N.useState([]), [u, l] = N.useState([]), { existingUserIds: d, tagName: f } = oI(t), { addPeople: m } = sI(t, f);
  return n.current = () => {
    if (s.length === 0) {
      l([{ type: "error", text: i.addPeopleRequired }]);
      return;
    }
    m(s.map((x) => x._id));
  }, /* @__PURE__ */ y(
    gI,
    {
      existingUserIds: d,
      selectedUsers: s,
      messages: u,
      onToggleUser: (x) => {
        l([]), o((C) => C.some((_) => _._id === x._id) ? C.filter((_) => _._id !== x._id) : [...C, x]);
      },
      onRemoveUser: (x) => {
        o((C) => C.filter((A) => A._id !== x));
      }
    }
  );
}, Tm = (t) => {
  const { openModal: n, closeModal: i } = Vn();
  return { handleAddPeople: (o) => {
    n({
      heading: "addPeopleToTag",
      body: /* @__PURE__ */ y(pI, { tagId: o, submitRef: t }),
      handleClose: i,
      primaryButtonLabel: "add",
      onPrimaryClick: () => {
        var u;
        return (u = t.current) == null ? void 0 : u.call(t);
      }
    });
  } };
}, Sm = (t) => {
  const n = bn(), { showAlert: i } = pn(), { translations: s } = Ae(), { executeQuery: o } = ht(), { mutate: u } = En({
    mutationFn: (l) => o(
      lm,
      { input: { id: l, archived: !0 } }
    ),
    onSuccess: (l) => {
      if (tn(l.updateInstitutionalTagArchivedState)) {
        i({ message: s.archiveTagFailed, variant: "error" });
        return;
      }
      n.invalidateQueries({ queryKey: ["tags", t] }), i({ message: s.tagArchived, variant: "success", assertive: !0 }), n.invalidateQueries({ queryKey: ["allTagNames"] });
    },
    onError: () => {
      i({ message: s.archiveTagFailed, variant: "error" });
    }
  });
  return { archive: u };
}, mI = () => {
  const t = bn(), { showAlert: n } = pn(), { resolveToken: i } = Ae(), { executeQuery: s } = ht(), o = N.useRef(void 0), u = N.useRef(void 0), l = N.useRef(""), d = (v, x) => {
    t.invalidateQueries({ queryKey: ["tags", v] }), t.invalidateQueries({ queryKey: ["tags", x] }), t.invalidateQueries({ queryKey: ["allTagNames"] });
  }, f = (v) => {
    v && cs(v) ? n({ message: i("tagMoveConflict"), variant: "error" }) : v && tn(v) ? n({ message: i("tagMoveFailed"), variant: "error" }) : n({ message: i("tagMoveFailed"), variant: "error" });
  }, { mutate: m } = En({
    mutationFn: ({ tag: v, categoryId: x }) => s(
      Vc,
      { input: { id: v._id, name: v.name, description: v.description, categoryId: x } }
    ),
    onSuccess: (v, { sourceCategoryId: x, categoryId: C, categoryName: A }) => {
      if (tn(v.updateInstitutionalTag)) {
        f(v.updateInstitutionalTag);
        return;
      }
      d(x, C), n({
        message: i({ key: "tagMoved", vars: { categoryName: A } }),
        variant: "success"
      });
    },
    onError: () => f()
  });
  return {
    handleMoveTag: (v) => {
      const x = u.current;
      x !== void 0 && m({
        tag: v,
        sourceCategoryId: v.category._id,
        categoryId: x,
        categoryName: l.current
      });
    },
    validateRef: o,
    selectedCategoryRef: u,
    selectedCategoryNameRef: l
  };
}, yI = (t) => {
  const n = bn(), { showAlert: i } = pn(), { translations: s } = Ae(), { executeQuery: o } = ht(), u = N.useRef(void 0), l = N.useRef(void 0), d = N.useRef(!1), { mutate: f } = En({
    mutationFn: async (m) => {
      const T = await o(lm, { input: { id: m._id, archived: !1 } });
      if (tn(T.updateInstitutionalTagArchivedState))
        return T;
      const v = l.current;
      return v !== void 0 && v !== m.category._id && await o(
        Vc,
        { input: { id: m._id, categoryId: v } }
      ), T;
    },
    onSuccess: (m, T) => {
      if (tn(m.updateInstitutionalTagArchivedState)) {
        i({ message: s.restoreTagFailed, variant: "error" });
        return;
      }
      n.invalidateQueries({ queryKey: ["tags", t] }), n.invalidateQueries({ queryKey: ["allTagNames"] });
      const v = l.current;
      v !== void 0 && v !== T.category._id && n.invalidateQueries({ queryKey: ["tags", v] }), i({ message: s.tagRestored, variant: "success" });
    },
    onError: () => {
      i({ message: s.restoreTagFailed, variant: "error" });
    }
  });
  return { restore: f, validateRef: u, selectedCategoryRef: l, restoreAssociationsRef: d };
}, vI = Q.div`
	gap: ${b.spacing.small};
	display: flex;
	flex-direction: column;
`, wI = (t) => {
  const { translations: n, resolveToken: i } = Ae(), [s, o] = N.useState(void 0), [u, l] = N.useState([]), d = (f) => {
    var m;
    o(f), l([]), t.selectedCategoryRef.current = f, t.selectedCategoryNameRef.current = ((m = t.allCategories.find((T) => T.id === f)) == null ? void 0 : m.label) ?? "";
  };
  return t.validateRef.current = () => s == null ? (l([{ type: "error", text: n.categoryRequired }]), !1) : !0, /* @__PURE__ */ J(vI, { children: [
    /* @__PURE__ */ y(Je, { size: "small", color: "secondary", children: i({
      key: "tagsSelected",
      count: 1,
      vars: { count: 1 }
    }) }),
    /* @__PURE__ */ y(
      zc,
      {
        options: t.allCategories,
        onChange: d,
        placeholder: "categoryPlaceholder",
        label: "category",
        messages: u
      }
    )
  ] });
}, TI = Q.div`
	gap: ${b.spacing.small};
	display: flex;
	flex-direction: column;
`, SI = Q.div`
	background-color: ${b.colors.contrasts.grey1111};
	border-radius: ${b.borders.radiusMedium};
	padding: ${b.spacing.small};
`, CI = (t) => {
  const { translations: n, resolveToken: i } = Ae(), [s, o] = N.useState(void 0), [u, l] = N.useState([]), [d, f] = N.useState(!1), m = (x) => {
    o(x), l([]), t.selectedCategoryRef.current = x;
  }, T = (x) => {
    f(x.target.checked), t.restoreAssociationsRef.current = x.target.checked;
  }, v = N.useCallback(() => s == null ? (l([{ type: "error", text: n.restoreTagCategoryRequired }]), !1) : !0, [s, n.restoreTagCategoryRequired]);
  return t.validateRef.current = v, /* @__PURE__ */ J(TI, { children: [
    /* @__PURE__ */ y(Je, { children: i({ key: "restoreTagDescription", vars: { count: t.associationsCount } }) }),
    /* @__PURE__ */ y(SI, { children: /* @__PURE__ */ y(
      WC,
      {
        label: /* @__PURE__ */ y(Je, { weight: "bold", children: n.restoreAssociations }),
        variant: "toggle",
        checked: d,
        onChange: T
      }
    ) }),
    /* @__PURE__ */ y(
      zc,
      {
        options: t.allCategories,
        onChange: m,
        placeholder: "categoryPlaceholder",
        label: "category",
        messages: u
      }
    )
  ] });
}, Cm = ({
  tag: t,
  categories: n,
  submitRef: i,
  existingTagNames: s
}) => {
  const {
    tagNameError: o,
    tagDescriptionError: u,
    onTagNameChange: l,
    onTagDescriptionChange: d,
    isCreatingCategory: f,
    categoryError: m,
    newCategoryName: T,
    newCategoryNameError: v,
    filteredSuggestions: x,
    categoryOptions: C,
    categorySelectKey: A,
    defaultCategoryValue: _,
    onCategoryChange: R,
    onNewCategoryNameChange: L,
    onNewCategoryDescriptionChange: U
  } = YE({ tag: t, categories: n, submitRef: i });
  return /* @__PURE__ */ J(qc, { children: [
    /* @__PURE__ */ y(
      um,
      {
        tagNameError: o,
        tagDescriptionError: u,
        onTagNameChange: l,
        onTagDescriptionChange: d,
        defaultName: t.name,
        defaultDescription: t.description,
        existingTagNames: s
      }
    ),
    /* @__PURE__ */ y(
      om,
      {
        categoryOptions: C,
        categoryError: m,
        newCategoryName: T,
        newCategoryNameError: v,
        filteredSuggestions: x,
        isCreatingCategory: f,
        defaultCategoryValue: _,
        categorySelectKey: A,
        onCategoryChange: R,
        onNewCategoryNameChange: L,
        onNewCategoryDescriptionChange: U
      }
    )
  ] });
}, xI = () => /* @__PURE__ */ J(n_, { "aria-hidden": !0, children: [
  /* @__PURE__ */ y(
    Ie,
    {
      $width: b.typography.titleCardRegular,
      $height: b.typography.titleCardRegular,
      $radius: b.borders.radiusSmall
    }
  ),
  /* @__PURE__ */ J(r_, { children: [
    /* @__PURE__ */ y(Ie, { $width: "55%", $height: b.typography.fontSizeSmall }),
    /* @__PURE__ */ y(Ie, { $width: "80%", $height: b.typography.fontSizeXSmall })
  ] }),
  /* @__PURE__ */ y(
    Ie,
    {
      $width: b.spacing.xxLarge,
      $height: b.typography.titleCardLarge,
      $radius: "999px"
    }
  ),
  /* @__PURE__ */ y(
    Ie,
    {
      $width: b.typography.titleCardRegular,
      $height: b.typography.titleCardRegular,
      $radius: b.borders.radiusSmall
    }
  )
] }), _I = ({
  categoryId: t,
  categoryWorkflowState: n,
  tags: i,
  isLoadingTags: s,
  currentPage: o,
  totalPages: u,
  onPageChange: l,
  viewTagAssociationsHandler: d
}) => {
  const { translations: f } = Ae(), { data: m = [] } = yi({ enabled: !0 }), { data: T = [] } = Uc(), { isMobile: v, isTablet: x } = Va(), { categoryMoreButtonRef: C } = Yg(), { openModal: A, closeModal: _ } = Vn(), { handleMoveTag: R, validateRef: L, selectedCategoryRef: U, selectedCategoryNameRef: q } = mI(), { archive: P } = Sm(t), {
    restore: O,
    validateRef: M,
    selectedCategoryRef: $,
    restoreAssociationsRef: H
  } = yI(t), re = N.useRef(void 0), { handleAddPeople: ke } = Tm(re), oe = N.useRef(/* @__PURE__ */ new Map()), ue = (Y) => {
    var te;
    if (Y <= 0) return C.current;
    const ne = (te = i == null ? void 0 : i[Y - 1]) == null ? void 0 : te._id;
    return ne ? oe.current.get(ne) ?? null : null;
  }, xe = () => {
    A({
      heading: "newTag",
      body: /* @__PURE__ */ y(
        gm,
        {
          categories: Un(m),
          submitRef: re,
          defaultCategory: Un(m).find(
            (Y) => Y.id === t
          ),
          existingTagNames: T
        }
      ),
      handleClose: _,
      onPrimaryClick: () => {
        var Y;
        return (Y = re.current) == null ? void 0 : Y.call(re);
      }
    });
  }, He = (Y) => {
    const ne = (i ?? []).findIndex((te) => te._id === Y);
    A({
      heading: "archiveTag",
      simpleBodyText: "archiveTagConfirmation",
      handleClose: _,
      primaryButtonLabel: "archiveTag",
      size: "small",
      onPrimaryClick: () => {
        const te = ue(ne);
        P(Y), _(te);
      }
    });
  }, $e = (Y) => {
    const ne = i == null ? void 0 : i.find((te) => te._id === Y);
    ne && A({
      heading: "restoreTag",
      body: /* @__PURE__ */ y(
        CI,
        {
          associationsCount: ne.associationsCount ?? 0,
          allCategories: Un(m),
          validateRef: M,
          selectedCategoryRef: $,
          restoreAssociationsRef: H
        }
      ),
      handleClose: _,
      primaryButtonLabel: "restoreTag",
      secondaryButtonLabel: "cancel",
      size: "small",
      onPrimaryClick: () => {
        var te;
        (te = M.current) != null && te.call(M) && (O(ne), _());
      }
    });
  }, st = (Y) => {
    A({
      heading: "editTag",
      body: /* @__PURE__ */ y(
        Cm,
        {
          tag: Y,
          categories: Un(m),
          submitRef: re,
          existingTagNames: T
        }
      ),
      handleClose: _,
      onPrimaryClick: () => {
        var ne;
        return (ne = re.current) == null ? void 0 : ne.call(re);
      }
    });
  }, X = () => n !== zn.Active ? null : /* @__PURE__ */ y(kE, { children: /* @__PURE__ */ y(
    _n,
    {
      screenReaderLabel: f.addTag,
      renderIcon: /* @__PURE__ */ y(Cc, {}),
      withBorder: !1,
      color: "primary",
      onClick: xe
    }
  ) }), ze = () => !u || u <= 1 ? null : /* @__PURE__ */ y(
    Sc,
    {
      as: "nav",
      margin: "small",
      variant: "compact",
      labelNext: f.nextPage,
      labelPrev: f.previousPage,
      currentPage: o ?? 1,
      totalPageNumber: u,
      onPageChange: l
    }
  ), je = v ? 1 : x ? 2 : 3, B = bc(je * 2), V = (Y) => {
    A({
      heading: "moveTags",
      body: /* @__PURE__ */ y(
        wI,
        {
          allCategories: Un(m, Y.category._id),
          validateRef: L,
          selectedCategoryRef: U,
          selectedCategoryNameRef: q
        }
      ),
      handleClose: _,
      primaryButtonLabel: "move",
      secondaryButtonLabel: "cancel",
      size: "medium",
      onPrimaryClick: () => {
        var ne;
        (ne = L.current) != null && ne.call(L) && (R(Y), _());
      }
    });
  };
  return /* @__PURE__ */ y(OE, { children: s ? /* @__PURE__ */ y(Rh, { children: /* @__PURE__ */ y(Mh, { $columns: je, children: B.map((Y) => /* @__PURE__ */ y(xI, {}, Y)) }) }) : i && i.length > 0 ? /* @__PURE__ */ J(Rh, { children: [
    /* @__PURE__ */ y(Mh, { $columns: je, children: i.map((Y) => /* @__PURE__ */ y(
      iI,
      {
        tag: Y,
        editHandler: st,
        viewTagAssociationsHandler: d,
        addPeopleHandler: ke,
        archiveHandler: He,
        restoreHandler: $e,
        moveToHandler: () => V(Y),
        moreButtonRef: (ne) => oe.current.set(Y._id, ne)
      },
      Y._id
    )) }),
    ze()
  ] }) : X() });
}, bI = ({
  category: t,
  tags: n,
  isLoadingTags: i,
  currentPage: s,
  totalPages: o,
  onPageChange: u,
  editHandler: l,
  archiveHandler: d,
  viewTagAssociationsHandler: f
}) => {
  const [m, T] = N.useState(!0), { allExpanded: v } = Kg(), { resolveToken: x } = Ae();
  return N.useEffect(() => {
    T(v);
  }, [v]), /* @__PURE__ */ y(S_, { editHandler: l, archiveHandler: d, children: /* @__PURE__ */ J(SE, { children: [
    /* @__PURE__ */ J(CE, { children: [
      /* @__PURE__ */ y(
        _n,
        {
          ...gc,
          screenReaderLabel: x({
            key: m ? "collapseCategory" : "expandCategory",
            vars: { categoryName: t.name }
          }),
          renderIcon: m ? /* @__PURE__ */ y(kC, {}) : /* @__PURE__ */ y($C, {}),
          onClick: () => T(!m),
          withBorder: !1,
          color: "primary-inverse"
        }
      ),
      /* @__PURE__ */ J(xE, { $isExpanded: m, children: [
        /* @__PURE__ */ y(ZE, { category: t, isExpanded: m }),
        /* @__PURE__ */ y(KE, { category: t, isExpanded: m })
      ] })
    ] }),
    m && /* @__PURE__ */ y(
      _I,
      {
        categoryId: t._id,
        categoryWorkflowState: t.workflowState,
        tags: n,
        isLoadingTags: i,
        currentPage: s,
        totalPages: o,
        onPageChange: u,
        viewTagAssociationsHandler: f
      }
    )
  ] }) });
}, EI = () => {
  const t = bn(), { showAlert: n } = pn(), { translations: i } = Ae(), { executeQuery: s } = ht(), { mutate: o } = En({
    mutationFn: (u) => s(zE, { input: { id: u, archived: !0 } }),
    onSuccess: (u) => {
      if (tn(u.updateInstitutionalTagCategoryArchivedState)) {
        n({ message: i.archiveCategoryAlreadyArchived, variant: "error" });
        return;
      }
      t.invalidateQueries({ queryKey: ["categories"] }), n({ message: i.categoryArchiveSuccess, variant: "success" });
    },
    onError: () => {
      n({ message: i.archiveCategoryFailed, variant: "error" });
    }
  });
  return { archive: o };
}, II = (t, n, i) => {
  const { accountId: s, executeQuery: o } = ht(), u = N.useRef(i == null ? void 0 : i.pageInfo.endCursor), { cursor: l, currentPage: d, handlePageChange: f, getTotalPages: m } = Qa({
    endCursorRef: u,
    totalCount: i == null ? void 0 : i.pageInfo.totalCount
  }), T = i != null && i.tags.length === 0 && !i.pageInfo.hasNextPage, v = l === null && i != null && !T, { data: x, isPending: C } = Nr({
    queryKey: ["tags", t, l, n],
    queryFn: () => o(rm, {
      accountId: s,
      categoryId: t,
      first: qn,
      after: l ?? void 0,
      workflowState: n
    }).then((R) => {
      var L;
      return (L = R.account) == null ? void 0 : L.institutionalTagsConnection;
    }),
    enabled: !v
  });
  u.current = v ? i.pageInfo.endCursor : x == null ? void 0 : x.pageInfo.endCursor;
  const A = v ? i.pageInfo : x == null ? void 0 : x.pageInfo;
  return {
    tags: v ? i.tags : ((x == null ? void 0 : x.nodes) ?? []).filter(cr).map((R) => sm(R)),
    isPending: v ? !1 : C,
    currentPage: d,
    totalPages: m(A == null ? void 0 : A.totalCount),
    totalTagCount: (A == null ? void 0 : A.totalCount) ?? 0,
    handlePageChange: f
  };
}, AI = ({
  category: t,
  submitRef: n
}) => {
  const { categoryAutocomplete: i } = Fa(), [s, o] = N.useState(t.name), [u, l] = N.useState(t.description ?? ""), [d, f] = N.useState([]), { translations: m } = Ae(), { closeModal: T } = Vn(), { showAlert: v } = pn(), x = bn(), { executeQuery: C } = ht(), { data: A = [] } = yi({ enabled: i }), _ = N.useMemo(
    () => A.filter((O) => O._id !== t._id).map((O) => ({ id: O._id, label: O.name })),
    [A, t._id]
  ), R = N.useMemo(() => {
    if (!i) return [];
    const O = s.trim().toLowerCase();
    return O ? _.filter((M) => M.label.toLowerCase().includes(O)) : _;
  }, [i, _, s]), L = (O) => _.some((M) => M.label.toLowerCase() === O.trim().toLowerCase()), U = (O) => {
    o(O), O.trim() && L(O) ? f([{ type: "error", text: m.categoryNameAlreadyExists }]) : O.trim() ? f([]) : d.some((M) => M.text === m.categoryNameAlreadyExists) && f([]);
  }, q = (O) => {
    l(O);
  }, { mutate: P } = En({
    mutationFn: () => C(qE, {
      input: { id: t._id, name: s.trim(), description: u.trim() }
    }),
    onSuccess: (O) => {
      if (tn(O.updateInstitutionalTagCategory)) {
        cs(O.updateInstitutionalTagCategory) && f([{ type: "error", text: m.categoryNameAlreadyExists }]);
        return;
      }
      x.invalidateQueries({ queryKey: ["categories"] }), x.invalidateQueries({ queryKey: ["allCategories"] }), T(), v({ variant: "success", message: m.categoryUpdated });
    },
    onError: () => {
      v({ variant: "error", message: m.saveCategoryFailed });
    }
  });
  return n.current = () => {
    if (!s.trim()) {
      f([{ type: "error", text: m.categoryNameRequired }]);
      return;
    }
    P();
  }, { name: s, nameError: d, filteredSuggestions: R, onNameChange: U, onDescriptionChange: q };
}, OI = ({ category: t, submitRef: n }) => {
  const { translations: i } = Ae(), { name: s, nameError: o, filteredSuggestions: u, onNameChange: l, onDescriptionChange: d } = AI({
    category: t,
    submitRef: n
  });
  return /* @__PURE__ */ y(qc, { children: /* @__PURE__ */ J(
    _c,
    {
      description: /* @__PURE__ */ y(Je, { weight: "normal", size: "large", children: i.category }),
      colSpacing: "small",
      layout: "columns",
      vAlign: "top",
      children: [
        /* @__PURE__ */ y(
          Bc,
          {
            inputValue: s,
            filteredSuggestions: u,
            messages: o,
            onInputChange: l
          }
        ),
        /* @__PURE__ */ y(
          Ar,
          {
            renderLabel: i.categoryDescriptionLabel,
            placeholder: i.categoryDescriptionPlaceholder,
            defaultValue: t.description ?? "",
            onChange: (f, m) => d(m)
          }
        )
      ]
    }
  ) });
}, kI = ({
  category: t,
  initialTagsData: n,
  viewTagAssociationsHandler: i
}) => {
  const { tags: s, isPending: o, currentPage: u, totalPages: l, totalTagCount: d, handlePageChange: f } = II(t._id, t.workflowState, n), { data: m = [] } = yi({ enabled: !0 }), { openModal: T, closeModal: v } = Vn(), { archive: x } = EI(), C = N.useRef(void 0), A = (R) => {
    const L = m.find((U) => U._id === R) ?? t;
    T({
      heading: "editCategory",
      body: /* @__PURE__ */ y(OI, { category: L, submitRef: C }),
      handleClose: v,
      onPrimaryClick: () => {
        var U;
        return (U = C.current) == null ? void 0 : U.call(C);
      }
    });
  }, _ = (R) => {
    T({
      heading: "archive",
      simpleBodyText: "archiveCategoryConfirmation",
      handleClose: v,
      primaryButtonLabel: "archive",
      size: "small",
      onPrimaryClick: () => {
        x(R), v();
      }
    });
  };
  return /* @__PURE__ */ y(
    bI,
    {
      category: { ...t, tagsCount: d },
      tags: s,
      isLoadingTags: o,
      currentPage: u,
      totalPages: l,
      onPageChange: f,
      editHandler: A,
      archiveHandler: _,
      viewTagAssociationsHandler: i
    }
  );
}, $I = ({
  categories: t,
  categoryTagsMap: n,
  isPending: i,
  isFetching: s,
  isError: o,
  error: u,
  currentPage: l,
  totalPages: d,
  onPageChange: f,
  viewTagAssociationsHandler: m
}) => {
  const { translations: T, resolveToken: v } = Ae(), x = bc(4);
  return i ? /* @__PURE__ */ y(kh, { children: x.map((C) => /* @__PURE__ */ y(Xd, {}, C)) }) : o ? /* @__PURE__ */ y(Tc, { variant: "error", margin: "medium", children: v({
    key: "loadCategories",
    vars: { errorMessage: (u == null ? void 0 : u.message) ?? "Unknown error" }
  }) }) : /* @__PURE__ */ J(La, { children: [
    /* @__PURE__ */ J(kh, { children: [
      t.map((C) => /* @__PURE__ */ y(
        kI,
        {
          category: C,
          initialTagsData: n[C._id],
          viewTagAssociationsHandler: m
        },
        C._id
      )),
      s && /* @__PURE__ */ y(Xd, {})
    ] }),
    d > 1 && /* @__PURE__ */ y(
      Sc,
      {
        as: "nav",
        variant: "compact",
        labelNext: T.nextPage,
        labelPrev: T.previousPage,
        currentPage: l,
        totalPageNumber: d,
        onPageChange: f
      }
    )
  ] });
};
function NI(t) {
  if (t.sheet)
    return t.sheet;
  for (var n = 0; n < document.styleSheets.length; n++)
    if (document.styleSheets[n].ownerNode === t)
      return document.styleSheets[n];
}
function RI(t) {
  var n = document.createElement("style");
  return n.setAttribute("data-emotion", t.key), t.nonce !== void 0 && n.setAttribute("nonce", t.nonce), n.appendChild(document.createTextNode("")), n.setAttribute("data-s", ""), n;
}
var MI = /* @__PURE__ */ function() {
  function t(i) {
    var s = this;
    this._insertTag = function(o) {
      var u;
      s.tags.length === 0 ? s.insertionPoint ? u = s.insertionPoint.nextSibling : s.prepend ? u = s.container.firstChild : u = s.before : u = s.tags[s.tags.length - 1].nextSibling, s.container.insertBefore(o, u), s.tags.push(o);
    }, this.isSpeedy = i.speedy === void 0 ? !0 : i.speedy, this.tags = [], this.ctr = 0, this.nonce = i.nonce, this.key = i.key, this.container = i.container, this.prepend = i.prepend, this.insertionPoint = i.insertionPoint, this.before = null;
  }
  var n = t.prototype;
  return n.hydrate = function(s) {
    s.forEach(this._insertTag);
  }, n.insert = function(s) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(RI(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var u = NI(o);
      try {
        u.insertRule(s, u.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(s));
    this.ctr++;
  }, n.flush = function() {
    this.tags.forEach(function(s) {
      var o;
      return (o = s.parentNode) == null ? void 0 : o.removeChild(s);
    }), this.tags = [], this.ctr = 0;
  }, t;
}(), Tt = "-ms-", Pa = "-moz-", Pe = "-webkit-", xm = "comm", Hc = "rule", Gc = "decl", PI = "@import", _m = "@keyframes", DI = "@layer", LI = Math.abs, Ja = String.fromCharCode, FI = Object.assign;
function WI(t, n) {
  return mt(t, 0) ^ 45 ? (((n << 2 ^ mt(t, 0)) << 2 ^ mt(t, 1)) << 2 ^ mt(t, 2)) << 2 ^ mt(t, 3) : 0;
}
function bm(t) {
  return t.trim();
}
function UI(t, n) {
  return (t = n.exec(t)) ? t[0] : t;
}
function De(t, n, i) {
  return t.replace(n, i);
}
function pc(t, n) {
  return t.indexOf(n);
}
function mt(t, n) {
  return t.charCodeAt(n) | 0;
}
function ns(t, n, i) {
  return t.slice(n, i);
}
function wn(t) {
  return t.length;
}
function Yc(t) {
  return t.length;
}
function ca(t, n) {
  return n.push(t), t;
}
function qI(t, n) {
  return t.map(n).join("");
}
var ja = 1, ci = 1, Em = 0, Mt = 0, ut = 0, vi = "";
function Xa(t, n, i, s, o, u, l) {
  return { value: t, root: n, parent: i, type: s, props: o, children: u, line: ja, column: ci, length: l, return: "" };
}
function Wi(t, n) {
  return FI(Xa("", null, null, "", null, null, 0), t, { length: -t.length }, n);
}
function zI() {
  return ut;
}
function BI() {
  return ut = Mt > 0 ? mt(vi, --Mt) : 0, ci--, ut === 10 && (ci = 1, ja--), ut;
}
function zt() {
  return ut = Mt < Em ? mt(vi, Mt++) : 0, ci++, ut === 10 && (ci = 1, ja++), ut;
}
function xn() {
  return mt(vi, Mt);
}
function Ca() {
  return Mt;
}
function fs(t, n) {
  return ns(vi, t, n);
}
function rs(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Im(t) {
  return ja = ci = 1, Em = wn(vi = t), Mt = 0, [];
}
function Am(t) {
  return vi = "", t;
}
function xa(t) {
  return bm(fs(Mt - 1, mc(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function VI(t) {
  for (; (ut = xn()) && ut < 33; )
    zt();
  return rs(t) > 2 || rs(ut) > 3 ? "" : " ";
}
function HI(t, n) {
  for (; --n && zt() && !(ut < 48 || ut > 102 || ut > 57 && ut < 65 || ut > 70 && ut < 97); )
    ;
  return fs(t, Ca() + (n < 6 && xn() == 32 && zt() == 32));
}
function mc(t) {
  for (; zt(); )
    switch (ut) {
      case t:
        return Mt;
      case 34:
      case 39:
        t !== 34 && t !== 39 && mc(ut);
        break;
      case 40:
        t === 41 && mc(t);
        break;
      case 92:
        zt();
        break;
    }
  return Mt;
}
function GI(t, n) {
  for (; zt() && t + ut !== 57; )
    if (t + ut === 84 && xn() === 47)
      break;
  return "/*" + fs(n, Mt - 1) + "*" + Ja(t === 47 ? t : zt());
}
function YI(t) {
  for (; !rs(xn()); )
    zt();
  return fs(t, Mt);
}
function ZI(t) {
  return Am(_a("", null, null, null, [""], t = Im(t), 0, [0], t));
}
function _a(t, n, i, s, o, u, l, d, f) {
  for (var m = 0, T = 0, v = l, x = 0, C = 0, A = 0, _ = 1, R = 1, L = 1, U = 0, q = "", P = o, O = u, M = s, $ = q; R; )
    switch (A = U, U = zt()) {
      case 40:
        if (A != 108 && mt($, v - 1) == 58) {
          pc($ += De(xa(U), "&", "&\f"), "&\f") != -1 && (L = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        $ += xa(U);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        $ += VI(A);
        break;
      case 92:
        $ += HI(Ca() - 1, 7);
        continue;
      case 47:
        switch (xn()) {
          case 42:
          case 47:
            ca(KI(GI(zt(), Ca()), n, i), f);
            break;
          default:
            $ += "/";
        }
        break;
      case 123 * _:
        d[m++] = wn($) * L;
      case 125 * _:
      case 59:
      case 0:
        switch (U) {
          case 0:
          case 125:
            R = 0;
          case 59 + T:
            L == -1 && ($ = De($, /\f/g, "")), C > 0 && wn($) - v && ca(C > 32 ? Dh($ + ";", s, i, v - 1) : Dh(De($, " ", "") + ";", s, i, v - 2), f);
            break;
          case 59:
            $ += ";";
          default:
            if (ca(M = Ph($, n, i, m, T, o, d, q, P = [], O = [], v), u), U === 123)
              if (T === 0)
                _a($, n, M, M, P, u, v, d, O);
              else
                switch (x === 99 && mt($, 3) === 110 ? 100 : x) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    _a(t, M, M, s && ca(Ph(t, M, M, 0, 0, o, d, q, o, P = [], v), O), o, O, v, d, s ? P : O);
                    break;
                  default:
                    _a($, M, M, M, [""], O, 0, d, O);
                }
        }
        m = T = C = 0, _ = L = 1, q = $ = "", v = l;
        break;
      case 58:
        v = 1 + wn($), C = A;
      default:
        if (_ < 1) {
          if (U == 123)
            --_;
          else if (U == 125 && _++ == 0 && BI() == 125)
            continue;
        }
        switch ($ += Ja(U), U * _) {
          case 38:
            L = T > 0 ? 1 : ($ += "\f", -1);
            break;
          case 44:
            d[m++] = (wn($) - 1) * L, L = 1;
            break;
          case 64:
            xn() === 45 && ($ += xa(zt())), x = xn(), T = v = wn(q = $ += YI(Ca())), U++;
            break;
          case 45:
            A === 45 && wn($) == 2 && (_ = 0);
        }
    }
  return u;
}
function Ph(t, n, i, s, o, u, l, d, f, m, T) {
  for (var v = o - 1, x = o === 0 ? u : [""], C = Yc(x), A = 0, _ = 0, R = 0; A < s; ++A)
    for (var L = 0, U = ns(t, v + 1, v = LI(_ = l[A])), q = t; L < C; ++L)
      (q = bm(_ > 0 ? x[L] + " " + U : De(U, /&\f/g, x[L]))) && (f[R++] = q);
  return Xa(t, n, i, o === 0 ? Hc : d, f, m, T);
}
function KI(t, n, i) {
  return Xa(t, n, i, xm, Ja(zI()), ns(t, 2, -2), 0);
}
function Dh(t, n, i, s) {
  return Xa(t, n, i, Gc, ns(t, 0, s), ns(t, s + 1, -1), s);
}
function ri(t, n) {
  for (var i = "", s = Yc(t), o = 0; o < s; o++)
    i += n(t[o], o, t, n) || "";
  return i;
}
function QI(t, n, i, s) {
  switch (t.type) {
    case DI:
      if (t.children.length) break;
    case PI:
    case Gc:
      return t.return = t.return || t.value;
    case xm:
      return "";
    case _m:
      return t.return = t.value + "{" + ri(t.children, s) + "}";
    case Hc:
      t.value = t.props.join(",");
  }
  return wn(i = ri(t.children, s)) ? t.return = t.value + "{" + i + "}" : "";
}
function JI(t) {
  var n = Yc(t);
  return function(i, s, o, u) {
    for (var l = "", d = 0; d < n; d++)
      l += t[d](i, s, o, u) || "";
    return l;
  };
}
function jI(t) {
  return function(n) {
    n.root || (n = n.return) && t(n);
  };
}
var Lh = function(n) {
  var i = /* @__PURE__ */ new WeakMap();
  return function(s) {
    if (i.has(s))
      return i.get(s);
    var o = n(s);
    return i.set(s, o), o;
  };
}, XI = function(n, i, s) {
  for (var o = 0, u = 0; o = u, u = xn(), o === 38 && u === 12 && (i[s] = 1), !rs(u); )
    zt();
  return fs(n, Mt);
}, eA = function(n, i) {
  var s = -1, o = 44;
  do
    switch (rs(o)) {
      case 0:
        o === 38 && xn() === 12 && (i[s] = 1), n[s] += XI(Mt - 1, i, s);
        break;
      case 2:
        n[s] += xa(o);
        break;
      case 4:
        if (o === 44) {
          n[++s] = xn() === 58 ? "&\f" : "", i[s] = n[s].length;
          break;
        }
      default:
        n[s] += Ja(o);
    }
  while (o = zt());
  return n;
}, tA = function(n, i) {
  return Am(eA(Im(n), i));
}, Fh = /* @__PURE__ */ new WeakMap(), nA = function(n) {
  if (!(n.type !== "rule" || !n.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  n.length < 1)) {
    for (var i = n.value, s = n.parent, o = n.column === s.column && n.line === s.line; s.type !== "rule"; )
      if (s = s.parent, !s) return;
    if (!(n.props.length === 1 && i.charCodeAt(0) !== 58 && !Fh.get(s)) && !o) {
      Fh.set(n, !0);
      for (var u = [], l = tA(i, u), d = s.props, f = 0, m = 0; f < l.length; f++)
        for (var T = 0; T < d.length; T++, m++)
          n.props[m] = u[f] ? l[f].replace(/&\f/g, d[T]) : d[T] + " " + l[f];
    }
  }
}, rA = function(n) {
  if (n.type === "decl") {
    var i = n.value;
    // charcode for l
    i.charCodeAt(0) === 108 && // charcode for b
    i.charCodeAt(2) === 98 && (n.return = "", n.value = "");
  }
};
function Om(t, n) {
  switch (WI(t, n)) {
    case 5103:
      return Pe + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Pe + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Pe + t + Pa + t + Tt + t + t;
    case 6828:
    case 4268:
      return Pe + t + Tt + t + t;
    case 6165:
      return Pe + t + Tt + "flex-" + t + t;
    case 5187:
      return Pe + t + De(t, /(\w+).+(:[^]+)/, Pe + "box-$1$2" + Tt + "flex-$1$2") + t;
    case 5443:
      return Pe + t + Tt + "flex-item-" + De(t, /flex-|-self/, "") + t;
    case 4675:
      return Pe + t + Tt + "flex-line-pack" + De(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return Pe + t + Tt + De(t, "shrink", "negative") + t;
    case 5292:
      return Pe + t + Tt + De(t, "basis", "preferred-size") + t;
    case 6060:
      return Pe + "box-" + De(t, "-grow", "") + Pe + t + Tt + De(t, "grow", "positive") + t;
    case 4554:
      return Pe + De(t, /([^-])(transform)/g, "$1" + Pe + "$2") + t;
    case 6187:
      return De(De(De(t, /(zoom-|grab)/, Pe + "$1"), /(image-set)/, Pe + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return De(t, /(image-set\([^]*)/, Pe + "$1$`$1");
    case 4968:
      return De(De(t, /(.+:)(flex-)?(.*)/, Pe + "box-pack:$3" + Tt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Pe + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return De(t, /(.+)-inline(.+)/, Pe + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (wn(t) - 1 - n > 6) switch (mt(t, n + 1)) {
        case 109:
          if (mt(t, n + 4) !== 45) break;
        case 102:
          return De(t, /(.+:)(.+)-([^]+)/, "$1" + Pe + "$2-$3$1" + Pa + (mt(t, n + 3) == 108 ? "$3" : "$2-$3")) + t;
        case 115:
          return ~pc(t, "stretch") ? Om(De(t, "stretch", "fill-available"), n) + t : t;
      }
      break;
    case 4949:
      if (mt(t, n + 1) !== 115) break;
    case 6444:
      switch (mt(t, wn(t) - 3 - (~pc(t, "!important") && 10))) {
        case 107:
          return De(t, ":", ":" + Pe) + t;
        case 101:
          return De(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Pe + (mt(t, 14) === 45 ? "inline-" : "") + "box$3$1" + Pe + "$2$3$1" + Tt + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (mt(t, n + 11)) {
        case 114:
          return Pe + t + Tt + De(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return Pe + t + Tt + De(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return Pe + t + Tt + De(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return Pe + t + Tt + t + t;
  }
  return t;
}
var iA = function(n, i, s, o) {
  if (n.length > -1 && !n.return) switch (n.type) {
    case Gc:
      n.return = Om(n.value, n.length);
      break;
    case _m:
      return ri([Wi(n, {
        value: De(n.value, "@", "@" + Pe)
      })], o);
    case Hc:
      if (n.length) return qI(n.props, function(u) {
        switch (UI(u, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return ri([Wi(n, {
              props: [De(u, /:(read-\w+)/, ":" + Pa + "$1")]
            })], o);
          case "::placeholder":
            return ri([Wi(n, {
              props: [De(u, /:(plac\w+)/, ":" + Pe + "input-$1")]
            }), Wi(n, {
              props: [De(u, /:(plac\w+)/, ":" + Pa + "$1")]
            }), Wi(n, {
              props: [De(u, /:(plac\w+)/, Tt + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, sA = [iA], aA = function(n) {
  var i = n.key;
  if (i === "css") {
    var s = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(s, function(_) {
      var R = _.getAttribute("data-emotion");
      R.indexOf(" ") !== -1 && (document.head.appendChild(_), _.setAttribute("data-s", ""));
    });
  }
  var o = n.stylisPlugins || sA, u = {}, l, d = [];
  l = n.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + i + ' "]'),
    function(_) {
      for (var R = _.getAttribute("data-emotion").split(" "), L = 1; L < R.length; L++)
        u[R[L]] = !0;
      d.push(_);
    }
  );
  var f, m = [nA, rA];
  {
    var T, v = [QI, jI(function(_) {
      T.insert(_);
    })], x = JI(m.concat(o, v)), C = function(R) {
      return ri(ZI(R), x);
    };
    f = function(R, L, U, q) {
      T = U, C(R ? R + "{" + L.styles + "}" : L.styles), q && (A.inserted[L.name] = !0);
    };
  }
  var A = {
    key: i,
    sheet: new MI({
      key: i,
      container: l,
      nonce: n.nonce,
      speedy: n.speedy,
      prepend: n.prepend,
      insertionPoint: n.insertionPoint
    }),
    nonce: n.nonce,
    inserted: u,
    registered: {},
    insert: f
  };
  return A.sheet.hydrate(d), A;
};
function yc() {
  return yc = Object.assign ? Object.assign.bind() : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var i = arguments[n];
      for (var s in i) ({}).hasOwnProperty.call(i, s) && (t[s] = i[s]);
    }
    return t;
  }, yc.apply(null, arguments);
}
var la = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function oA(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var fa = { exports: {} }, We = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wh;
function uA() {
  if (Wh) return We;
  Wh = 1;
  var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, i = t ? Symbol.for("react.portal") : 60106, s = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, u = t ? Symbol.for("react.profiler") : 60114, l = t ? Symbol.for("react.provider") : 60109, d = t ? Symbol.for("react.context") : 60110, f = t ? Symbol.for("react.async_mode") : 60111, m = t ? Symbol.for("react.concurrent_mode") : 60111, T = t ? Symbol.for("react.forward_ref") : 60112, v = t ? Symbol.for("react.suspense") : 60113, x = t ? Symbol.for("react.suspense_list") : 60120, C = t ? Symbol.for("react.memo") : 60115, A = t ? Symbol.for("react.lazy") : 60116, _ = t ? Symbol.for("react.block") : 60121, R = t ? Symbol.for("react.fundamental") : 60117, L = t ? Symbol.for("react.responder") : 60118, U = t ? Symbol.for("react.scope") : 60119;
  function q(O) {
    if (typeof O == "object" && O !== null) {
      var M = O.$$typeof;
      switch (M) {
        case n:
          switch (O = O.type, O) {
            case f:
            case m:
            case s:
            case u:
            case o:
            case v:
              return O;
            default:
              switch (O = O && O.$$typeof, O) {
                case d:
                case T:
                case A:
                case C:
                case l:
                  return O;
                default:
                  return M;
              }
          }
        case i:
          return M;
      }
    }
  }
  function P(O) {
    return q(O) === m;
  }
  return We.AsyncMode = f, We.ConcurrentMode = m, We.ContextConsumer = d, We.ContextProvider = l, We.Element = n, We.ForwardRef = T, We.Fragment = s, We.Lazy = A, We.Memo = C, We.Portal = i, We.Profiler = u, We.StrictMode = o, We.Suspense = v, We.isAsyncMode = function(O) {
    return P(O) || q(O) === f;
  }, We.isConcurrentMode = P, We.isContextConsumer = function(O) {
    return q(O) === d;
  }, We.isContextProvider = function(O) {
    return q(O) === l;
  }, We.isElement = function(O) {
    return typeof O == "object" && O !== null && O.$$typeof === n;
  }, We.isForwardRef = function(O) {
    return q(O) === T;
  }, We.isFragment = function(O) {
    return q(O) === s;
  }, We.isLazy = function(O) {
    return q(O) === A;
  }, We.isMemo = function(O) {
    return q(O) === C;
  }, We.isPortal = function(O) {
    return q(O) === i;
  }, We.isProfiler = function(O) {
    return q(O) === u;
  }, We.isStrictMode = function(O) {
    return q(O) === o;
  }, We.isSuspense = function(O) {
    return q(O) === v;
  }, We.isValidElementType = function(O) {
    return typeof O == "string" || typeof O == "function" || O === s || O === m || O === u || O === o || O === v || O === x || typeof O == "object" && O !== null && (O.$$typeof === A || O.$$typeof === C || O.$$typeof === l || O.$$typeof === d || O.$$typeof === T || O.$$typeof === R || O.$$typeof === L || O.$$typeof === U || O.$$typeof === _);
  }, We.typeOf = q, We;
}
var Ue = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uh;
function cA() {
  return Uh || (Uh = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, i = t ? Symbol.for("react.portal") : 60106, s = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, u = t ? Symbol.for("react.profiler") : 60114, l = t ? Symbol.for("react.provider") : 60109, d = t ? Symbol.for("react.context") : 60110, f = t ? Symbol.for("react.async_mode") : 60111, m = t ? Symbol.for("react.concurrent_mode") : 60111, T = t ? Symbol.for("react.forward_ref") : 60112, v = t ? Symbol.for("react.suspense") : 60113, x = t ? Symbol.for("react.suspense_list") : 60120, C = t ? Symbol.for("react.memo") : 60115, A = t ? Symbol.for("react.lazy") : 60116, _ = t ? Symbol.for("react.block") : 60121, R = t ? Symbol.for("react.fundamental") : 60117, L = t ? Symbol.for("react.responder") : 60118, U = t ? Symbol.for("react.scope") : 60119;
    function q(G) {
      return typeof G == "string" || typeof G == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      G === s || G === m || G === u || G === o || G === v || G === x || typeof G == "object" && G !== null && (G.$$typeof === A || G.$$typeof === C || G.$$typeof === l || G.$$typeof === d || G.$$typeof === T || G.$$typeof === R || G.$$typeof === L || G.$$typeof === U || G.$$typeof === _);
    }
    function P(G) {
      if (typeof G == "object" && G !== null) {
        var Xe = G.$$typeof;
        switch (Xe) {
          case n:
            var yt = G.type;
            switch (yt) {
              case f:
              case m:
              case s:
              case u:
              case o:
              case v:
                return yt;
              default:
                var Hn = yt && yt.$$typeof;
                switch (Hn) {
                  case d:
                  case T:
                  case A:
                  case C:
                  case l:
                    return Hn;
                  default:
                    return Xe;
                }
            }
          case i:
            return Xe;
        }
      }
    }
    var O = f, M = m, $ = d, H = l, re = n, ke = T, oe = s, ue = A, xe = C, He = i, $e = u, st = o, X = v, ze = !1;
    function je(G) {
      return ze || (ze = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(G) || P(G) === f;
    }
    function B(G) {
      return P(G) === m;
    }
    function V(G) {
      return P(G) === d;
    }
    function Y(G) {
      return P(G) === l;
    }
    function ne(G) {
      return typeof G == "object" && G !== null && G.$$typeof === n;
    }
    function te(G) {
      return P(G) === T;
    }
    function pe(G) {
      return P(G) === s;
    }
    function ce(G) {
      return P(G) === A;
    }
    function le(G) {
      return P(G) === C;
    }
    function me(G) {
      return P(G) === i;
    }
    function ve(G) {
      return P(G) === u;
    }
    function he(G) {
      return P(G) === o;
    }
    function Ke(G) {
      return P(G) === v;
    }
    Ue.AsyncMode = O, Ue.ConcurrentMode = M, Ue.ContextConsumer = $, Ue.ContextProvider = H, Ue.Element = re, Ue.ForwardRef = ke, Ue.Fragment = oe, Ue.Lazy = ue, Ue.Memo = xe, Ue.Portal = He, Ue.Profiler = $e, Ue.StrictMode = st, Ue.Suspense = X, Ue.isAsyncMode = je, Ue.isConcurrentMode = B, Ue.isContextConsumer = V, Ue.isContextProvider = Y, Ue.isElement = ne, Ue.isForwardRef = te, Ue.isFragment = pe, Ue.isLazy = ce, Ue.isMemo = le, Ue.isPortal = me, Ue.isProfiler = ve, Ue.isStrictMode = he, Ue.isSuspense = Ke, Ue.isValidElementType = q, Ue.typeOf = P;
  }()), Ue;
}
var qh;
function Zc() {
  return qh || (qh = 1, process.env.NODE_ENV === "production" ? fa.exports = uA() : fa.exports = cA()), fa.exports;
}
var Lu, zh;
function lA() {
  if (zh) return Lu;
  zh = 1;
  var t = Zc(), n = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, i = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, s = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, u = {};
  u[t.ForwardRef] = s, u[t.Memo] = o;
  function l(A) {
    return t.isMemo(A) ? o : u[A.$$typeof] || n;
  }
  var d = Object.defineProperty, f = Object.getOwnPropertyNames, m = Object.getOwnPropertySymbols, T = Object.getOwnPropertyDescriptor, v = Object.getPrototypeOf, x = Object.prototype;
  function C(A, _, R) {
    if (typeof _ != "string") {
      if (x) {
        var L = v(_);
        L && L !== x && C(A, L, R);
      }
      var U = f(_);
      m && (U = U.concat(m(_)));
      for (var q = l(A), P = l(_), O = 0; O < U.length; ++O) {
        var M = U[O];
        if (!i[M] && !(R && R[M]) && !(P && P[M]) && !(q && q[M])) {
          var $ = T(_, M);
          try {
            d(A, M, $);
          } catch {
          }
        }
      }
    }
    return A;
  }
  return Lu = C, Lu;
}
lA();
var fA = !0;
function dA(t, n, i) {
  var s = "";
  return i.split(" ").forEach(function(o) {
    t[o] !== void 0 ? n.push(t[o] + ";") : o && (s += o + " ");
  }), s;
}
var km = function(n, i, s) {
  var o = n.key + "-" + i.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (s === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  fA === !1) && n.registered[o] === void 0 && (n.registered[o] = i.styles);
}, hA = function(n, i, s) {
  km(n, i, s);
  var o = n.key + "-" + i.name;
  if (n.inserted[i.name] === void 0) {
    var u = i;
    do
      n.insert(i === u ? "." + o : "", u, n.sheet, !0), u = u.next;
    while (u !== void 0);
  }
};
function gA(t) {
  for (var n = 0, i, s = 0, o = t.length; o >= 4; ++s, o -= 4)
    i = t.charCodeAt(s) & 255 | (t.charCodeAt(++s) & 255) << 8 | (t.charCodeAt(++s) & 255) << 16 | (t.charCodeAt(++s) & 255) << 24, i = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16), i ^= /* k >>> r: */
    i >>> 24, n = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      n ^= (t.charCodeAt(s + 2) & 255) << 16;
    case 2:
      n ^= (t.charCodeAt(s + 1) & 255) << 8;
    case 1:
      n ^= t.charCodeAt(s) & 255, n = /* Math.imul(h, m): */
      (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16);
  }
  return n ^= n >>> 13, n = /* Math.imul(h, m): */
  (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), ((n ^ n >>> 15) >>> 0).toString(36);
}
var pA = /[A-Z]|^ms/g, mA = /_EMO_([^_]+?)_([^]*?)_EMO_/g, $m = function(n) {
  return n.charCodeAt(1) === 45;
}, Bh = function(n) {
  return n != null && typeof n != "boolean";
}, Fu = /* @__PURE__ */ pg(function(t) {
  return $m(t) ? t : t.replace(pA, "-$&").toLowerCase();
}), Vh = function(n, i) {
  switch (n) {
    case "animation":
    case "animationName":
      if (typeof i == "string")
        return i.replace(mA, function(s, o, u) {
          return Tn = {
            name: o,
            styles: u,
            next: Tn
          }, o;
        });
  }
  return mg[n] !== 1 && !$m(n) && typeof i == "number" && i !== 0 ? i + "px" : i;
};
function is(t, n, i) {
  if (i == null)
    return "";
  var s = i;
  if (s.__emotion_styles !== void 0)
    return s;
  switch (typeof i) {
    case "boolean":
      return "";
    case "object": {
      var o = i;
      if (o.anim === 1)
        return Tn = {
          name: o.name,
          styles: o.styles,
          next: Tn
        }, o.name;
      var u = i;
      if (u.styles !== void 0) {
        var l = u.next;
        if (l !== void 0)
          for (; l !== void 0; )
            Tn = {
              name: l.name,
              styles: l.styles,
              next: Tn
            }, l = l.next;
        var d = u.styles + ";";
        return d;
      }
      return yA(t, n, i);
    }
    case "function": {
      if (t !== void 0) {
        var f = Tn, m = i(t);
        return Tn = f, is(t, n, m);
      }
      break;
    }
  }
  var T = i;
  return T;
}
function yA(t, n, i) {
  var s = "";
  if (Array.isArray(i))
    for (var o = 0; o < i.length; o++)
      s += is(t, n, i[o]) + ";";
  else
    for (var u in i) {
      var l = i[u];
      if (typeof l != "object") {
        var d = l;
        Bh(d) && (s += Fu(u) + ":" + Vh(u, d) + ";");
      } else if (Array.isArray(l) && typeof l[0] == "string" && n == null)
        for (var f = 0; f < l.length; f++)
          Bh(l[f]) && (s += Fu(u) + ":" + Vh(u, l[f]) + ";");
      else {
        var m = is(t, n, l);
        switch (u) {
          case "animation":
          case "animationName": {
            s += Fu(u) + ":" + m + ";";
            break;
          }
          default:
            s += u + "{" + m + "}";
        }
      }
    }
  return s;
}
var Hh = /label:\s*([^\s;{]+)\s*(;|$)/g, Tn;
function vA(t, n, i) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var s = !0, o = "";
  Tn = void 0;
  var u = t[0];
  if (u == null || u.raw === void 0)
    s = !1, o += is(i, n, u);
  else {
    var l = u;
    o += l[0];
  }
  for (var d = 1; d < t.length; d++)
    if (o += is(i, n, t[d]), s) {
      var f = u;
      o += f[d];
    }
  Hh.lastIndex = 0;
  for (var m = "", T; (T = Hh.exec(o)) !== null; )
    m += "-" + T[1];
  var v = gA(o) + m;
  return {
    name: v,
    styles: o,
    next: Tn
  };
}
var wA = function(n) {
  return n();
}, TA = fn.useInsertionEffect ? fn.useInsertionEffect : !1, SA = TA || wA, Nm = /* @__PURE__ */ fn.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ aA({
    key: "css"
  }) : null
);
Nm.Provider;
var CA = function(n) {
  return /* @__PURE__ */ CC(function(i, s) {
    var o = sg(Nm);
    return n(i, o, s);
  });
}, vc = /* @__PURE__ */ fn.createContext({}), xA = function(n, i) {
  if (typeof i == "function") {
    var s = i(n);
    return s;
  }
  return yc({}, n, i);
}, _A = /* @__PURE__ */ Lh(function(t) {
  return Lh(function(n) {
    return xA(t, n);
  });
}), bA = function(n) {
  var i = fn.useContext(vc);
  return n.theme !== i && (i = _A(i)(n.theme)), /* @__PURE__ */ fn.createElement(vc.Provider, {
    value: i
  }, n.children);
}, Kc = {}.hasOwnProperty, wc = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", EA = function(n, i) {
  var s = {};
  for (var o in i)
    Kc.call(i, o) && (s[o] = i[o]);
  return s[wc] = n, s;
}, IA = function(n) {
  var i = n.cache, s = n.serialized, o = n.isStringTag;
  return km(i, s, o), SA(function() {
    return hA(i, s, o);
  }), null;
}, AA = /* @__PURE__ */ CA(function(t, n, i) {
  var s = t.css;
  typeof s == "string" && n.registered[s] !== void 0 && (s = n.registered[s]);
  var o = t[wc], u = [s], l = "";
  typeof t.className == "string" ? l = dA(n.registered, u, t.className) : t.className != null && (l = t.className + " ");
  var d = vA(u, void 0, fn.useContext(vc));
  l += n.key + "-" + d.name;
  var f = {};
  for (var m in t)
    Kc.call(t, m) && m !== "css" && m !== wc && (f[m] = t[m]);
  return f.className = l, i && (f.ref = i), /* @__PURE__ */ fn.createElement(fn.Fragment, null, /* @__PURE__ */ fn.createElement(IA, {
    cache: n,
    serialized: d,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ fn.createElement(o, f));
}), OA = AA, da = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Wu, Gh;
function kA() {
  if (Gh) return Wu;
  Gh = 1;
  var t = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function s(u) {
    if (u == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(u);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var u = new String("abc");
      if (u[5] = "de", Object.getOwnPropertyNames(u)[0] === "5")
        return !1;
      for (var l = {}, d = 0; d < 10; d++)
        l["_" + String.fromCharCode(d)] = d;
      var f = Object.getOwnPropertyNames(l).map(function(T) {
        return l[T];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var m = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(T) {
        m[T] = T;
      }), Object.keys(Object.assign({}, m)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Wu = o() ? Object.assign : function(u, l) {
    for (var d, f = s(u), m, T = 1; T < arguments.length; T++) {
      d = Object(arguments[T]);
      for (var v in d)
        n.call(d, v) && (f[v] = d[v]);
      if (t) {
        m = t(d);
        for (var x = 0; x < m.length; x++)
          i.call(d, m[x]) && (f[m[x]] = d[m[x]]);
      }
    }
    return f;
  }, Wu;
}
var Uu, Yh;
function Qc() {
  if (Yh) return Uu;
  Yh = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Uu = t, Uu;
}
var qu, Zh;
function Rm() {
  return Zh || (Zh = 1, qu = Function.call.bind(Object.prototype.hasOwnProperty)), qu;
}
var zu, Kh;
function $A() {
  if (Kh) return zu;
  Kh = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = /* @__PURE__ */ Qc(), i = {}, s = /* @__PURE__ */ Rm();
    t = function(u) {
      var l = "Warning: " + u;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function o(u, l, d, f, m) {
    if (process.env.NODE_ENV !== "production") {
      for (var T in u)
        if (s(u, T)) {
          var v;
          try {
            if (typeof u[T] != "function") {
              var x = Error(
                (f || "React class") + ": " + d + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw x.name = "Invariant Violation", x;
            }
            v = u[T](l, T, f, d, null, n);
          } catch (A) {
            v = A;
          }
          if (v && !(v instanceof Error) && t(
            (f || "React class") + ": type specification of " + d + " `" + T + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof v + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), v instanceof Error && !(v.message in i)) {
            i[v.message] = !0;
            var C = m ? m() : "";
            t(
              "Failed " + d + " type: " + v.message + (C ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (i = {});
  }, zu = o, zu;
}
var Bu, Qh;
function NA() {
  if (Qh) return Bu;
  Qh = 1;
  var t = Zc(), n = kA(), i = /* @__PURE__ */ Qc(), s = /* @__PURE__ */ Rm(), o = /* @__PURE__ */ $A(), u = function() {
  };
  process.env.NODE_ENV !== "production" && (u = function(d) {
    var f = "Warning: " + d;
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return Bu = function(d, f) {
    var m = typeof Symbol == "function" && Symbol.iterator, T = "@@iterator";
    function v(B) {
      var V = B && (m && B[m] || B[T]);
      if (typeof V == "function")
        return V;
    }
    var x = "<<anonymous>>", C = {
      array: L("array"),
      bigint: L("bigint"),
      bool: L("boolean"),
      func: L("function"),
      number: L("number"),
      object: L("object"),
      string: L("string"),
      symbol: L("symbol"),
      any: U(),
      arrayOf: q,
      element: P(),
      elementType: O(),
      instanceOf: M,
      node: ke(),
      objectOf: H,
      oneOf: $,
      oneOfType: re,
      shape: ue,
      exact: xe
    };
    function A(B, V) {
      return B === V ? B !== 0 || 1 / B === 1 / V : B !== B && V !== V;
    }
    function _(B, V) {
      this.message = B, this.data = V && typeof V == "object" ? V : {}, this.stack = "";
    }
    _.prototype = Error.prototype;
    function R(B) {
      if (process.env.NODE_ENV !== "production")
        var V = {}, Y = 0;
      function ne(pe, ce, le, me, ve, he, Ke) {
        if (me = me || x, he = he || le, Ke !== i) {
          if (f) {
            var G = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw G.name = "Invariant Violation", G;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Xe = me + ":" + le;
            !V[Xe] && // Avoid spamming the console because they are often not actionable except for lib authors
            Y < 3 && (u(
              "You are manually calling a React.PropTypes validation function for the `" + he + "` prop on `" + me + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), V[Xe] = !0, Y++);
          }
        }
        return ce[le] == null ? pe ? ce[le] === null ? new _("The " + ve + " `" + he + "` is marked as required " + ("in `" + me + "`, but its value is `null`.")) : new _("The " + ve + " `" + he + "` is marked as required in " + ("`" + me + "`, but its value is `undefined`.")) : null : B(ce, le, me, ve, he);
      }
      var te = ne.bind(null, !1);
      return te.isRequired = ne.bind(null, !0), te;
    }
    function L(B) {
      function V(Y, ne, te, pe, ce, le) {
        var me = Y[ne], ve = st(me);
        if (ve !== B) {
          var he = X(me);
          return new _(
            "Invalid " + pe + " `" + ce + "` of type " + ("`" + he + "` supplied to `" + te + "`, expected ") + ("`" + B + "`."),
            { expectedType: B }
          );
        }
        return null;
      }
      return R(V);
    }
    function U() {
      return R(l);
    }
    function q(B) {
      function V(Y, ne, te, pe, ce) {
        if (typeof B != "function")
          return new _("Property `" + ce + "` of component `" + te + "` has invalid PropType notation inside arrayOf.");
        var le = Y[ne];
        if (!Array.isArray(le)) {
          var me = st(le);
          return new _("Invalid " + pe + " `" + ce + "` of type " + ("`" + me + "` supplied to `" + te + "`, expected an array."));
        }
        for (var ve = 0; ve < le.length; ve++) {
          var he = B(le, ve, te, pe, ce + "[" + ve + "]", i);
          if (he instanceof Error)
            return he;
        }
        return null;
      }
      return R(V);
    }
    function P() {
      function B(V, Y, ne, te, pe) {
        var ce = V[Y];
        if (!d(ce)) {
          var le = st(ce);
          return new _("Invalid " + te + " `" + pe + "` of type " + ("`" + le + "` supplied to `" + ne + "`, expected a single ReactElement."));
        }
        return null;
      }
      return R(B);
    }
    function O() {
      function B(V, Y, ne, te, pe) {
        var ce = V[Y];
        if (!t.isValidElementType(ce)) {
          var le = st(ce);
          return new _("Invalid " + te + " `" + pe + "` of type " + ("`" + le + "` supplied to `" + ne + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return R(B);
    }
    function M(B) {
      function V(Y, ne, te, pe, ce) {
        if (!(Y[ne] instanceof B)) {
          var le = B.name || x, me = je(Y[ne]);
          return new _("Invalid " + pe + " `" + ce + "` of type " + ("`" + me + "` supplied to `" + te + "`, expected ") + ("instance of `" + le + "`."));
        }
        return null;
      }
      return R(V);
    }
    function $(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? u(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : u("Invalid argument supplied to oneOf, expected an array.")), l;
      function V(Y, ne, te, pe, ce) {
        for (var le = Y[ne], me = 0; me < B.length; me++)
          if (A(le, B[me]))
            return null;
        var ve = JSON.stringify(B, function(Ke, G) {
          var Xe = X(G);
          return Xe === "symbol" ? String(G) : G;
        });
        return new _("Invalid " + pe + " `" + ce + "` of value `" + String(le) + "` " + ("supplied to `" + te + "`, expected one of " + ve + "."));
      }
      return R(V);
    }
    function H(B) {
      function V(Y, ne, te, pe, ce) {
        if (typeof B != "function")
          return new _("Property `" + ce + "` of component `" + te + "` has invalid PropType notation inside objectOf.");
        var le = Y[ne], me = st(le);
        if (me !== "object")
          return new _("Invalid " + pe + " `" + ce + "` of type " + ("`" + me + "` supplied to `" + te + "`, expected an object."));
        for (var ve in le)
          if (s(le, ve)) {
            var he = B(le, ve, te, pe, ce + "." + ve, i);
            if (he instanceof Error)
              return he;
          }
        return null;
      }
      return R(V);
    }
    function re(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && u("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var V = 0; V < B.length; V++) {
        var Y = B[V];
        if (typeof Y != "function")
          return u(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ze(Y) + " at index " + V + "."
          ), l;
      }
      function ne(te, pe, ce, le, me) {
        for (var ve = [], he = 0; he < B.length; he++) {
          var Ke = B[he], G = Ke(te, pe, ce, le, me, i);
          if (G == null)
            return null;
          G.data && s(G.data, "expectedType") && ve.push(G.data.expectedType);
        }
        var Xe = ve.length > 0 ? ", expected one of type [" + ve.join(", ") + "]" : "";
        return new _("Invalid " + le + " `" + me + "` supplied to " + ("`" + ce + "`" + Xe + "."));
      }
      return R(ne);
    }
    function ke() {
      function B(V, Y, ne, te, pe) {
        return He(V[Y]) ? null : new _("Invalid " + te + " `" + pe + "` supplied to " + ("`" + ne + "`, expected a ReactNode."));
      }
      return R(B);
    }
    function oe(B, V, Y, ne, te) {
      return new _(
        (B || "React class") + ": " + V + " type `" + Y + "." + ne + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + te + "`."
      );
    }
    function ue(B) {
      function V(Y, ne, te, pe, ce) {
        var le = Y[ne], me = st(le);
        if (me !== "object")
          return new _("Invalid " + pe + " `" + ce + "` of type `" + me + "` " + ("supplied to `" + te + "`, expected `object`."));
        for (var ve in B) {
          var he = B[ve];
          if (typeof he != "function")
            return oe(te, pe, ce, ve, X(he));
          var Ke = he(le, ve, te, pe, ce + "." + ve, i);
          if (Ke)
            return Ke;
        }
        return null;
      }
      return R(V);
    }
    function xe(B) {
      function V(Y, ne, te, pe, ce) {
        var le = Y[ne], me = st(le);
        if (me !== "object")
          return new _("Invalid " + pe + " `" + ce + "` of type `" + me + "` " + ("supplied to `" + te + "`, expected `object`."));
        var ve = n({}, Y[ne], B);
        for (var he in ve) {
          var Ke = B[he];
          if (s(B, he) && typeof Ke != "function")
            return oe(te, pe, ce, he, X(Ke));
          if (!Ke)
            return new _(
              "Invalid " + pe + " `" + ce + "` key `" + he + "` supplied to `" + te + "`.\nBad object: " + JSON.stringify(Y[ne], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(B), null, "  ")
            );
          var G = Ke(le, he, te, pe, ce + "." + he, i);
          if (G)
            return G;
        }
        return null;
      }
      return R(V);
    }
    function He(B) {
      switch (typeof B) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !B;
        case "object":
          if (Array.isArray(B))
            return B.every(He);
          if (B === null || d(B))
            return !0;
          var V = v(B);
          if (V) {
            var Y = V.call(B), ne;
            if (V !== B.entries) {
              for (; !(ne = Y.next()).done; )
                if (!He(ne.value))
                  return !1;
            } else
              for (; !(ne = Y.next()).done; ) {
                var te = ne.value;
                if (te && !He(te[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function $e(B, V) {
      return B === "symbol" ? !0 : V ? V["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && V instanceof Symbol : !1;
    }
    function st(B) {
      var V = typeof B;
      return Array.isArray(B) ? "array" : B instanceof RegExp ? "object" : $e(V, B) ? "symbol" : V;
    }
    function X(B) {
      if (typeof B > "u" || B === null)
        return "" + B;
      var V = st(B);
      if (V === "object") {
        if (B instanceof Date)
          return "date";
        if (B instanceof RegExp)
          return "regexp";
      }
      return V;
    }
    function ze(B) {
      var V = X(B);
      switch (V) {
        case "array":
        case "object":
          return "an " + V;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + V;
        default:
          return V;
      }
    }
    function je(B) {
      return !B.constructor || !B.constructor.name ? x : B.constructor.name;
    }
    return C.checkPropTypes = o, C.resetWarningCache = o.resetWarningCache, C.PropTypes = C, C;
  }, Bu;
}
var Vu, Jh;
function RA() {
  if (Jh) return Vu;
  Jh = 1;
  var t = /* @__PURE__ */ Qc();
  function n() {
  }
  function i() {
  }
  return i.resetWarningCache = n, Vu = function() {
    function s(l, d, f, m, T, v) {
      if (v !== t) {
        var x = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw x.name = "Invariant Violation", x;
      }
    }
    s.isRequired = s;
    function o() {
      return s;
    }
    var u = {
      array: s,
      bigint: s,
      bool: s,
      func: s,
      number: s,
      object: s,
      string: s,
      symbol: s,
      any: s,
      arrayOf: o,
      element: s,
      elementType: s,
      instanceOf: o,
      node: s,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: i,
      resetWarningCache: n
    };
    return u.PropTypes = u, u;
  }, Vu;
}
var jh;
function MA() {
  if (jh) return da.exports;
  if (jh = 1, process.env.NODE_ENV !== "production") {
    var t = Zc(), n = !0;
    da.exports = /* @__PURE__ */ NA()(t.isElement, n);
  } else
    da.exports = /* @__PURE__ */ RA()();
  return da.exports;
}
var PA = /* @__PURE__ */ MA();
const Sr = /* @__PURE__ */ oA(PA);
function DA(t, n) {
  if (t == null) return {};
  var i = {};
  for (var s in t) if ({}.hasOwnProperty.call(t, s)) {
    if (n.indexOf(s) !== -1) continue;
    i[s] = t[s];
  }
  return i;
}
function Xh(t, n) {
  if (t == null) return {};
  var i, s, o = DA(t, n);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    for (s = 0; s < u.length; s++) i = u[s], n.indexOf(i) === -1 && {}.propertyIsEnumerable.call(t, i) && (o[i] = t[i]);
  }
  return o;
}
function LA() {
  let t = "";
  try {
    t = N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactDebugCurrentFrame.getStackAddendum();
  } catch {
  }
  return t;
}
function FA(t, n, i, s, ...o) {
  if (process.env.NODE_ENV !== "production" && !i)
    if (typeof console[t] == "function") {
      const u = LA();
      console[t](`Warning: ${s}`, ...o, u);
    } else
      throw new Error(`'${t}' is not a valid console method!`);
}
const Jc = (t, n, ...i) => FA("error", !0, t, n, ...i), WA = ["key", "description"], UA = ["key", "description", "use"], qA = "@@themeRegistryDefaultTheme", Da = "__GLOBAL_THEME_REGISTRY__";
globalThis[Da] ? jc(zA(globalThis[Da])) : Pm();
function Mm() {
  return {
    currentThemeKey: null,
    themes: {},
    registered: []
    // the theme keys in the order they are registered,
  };
}
function zA(t) {
  const n = Mm();
  if (typeof t > "u")
    return n;
  let i = !0;
  return Object.keys(n).forEach((s) => {
    typeof t[s] > "u" && (i = !1);
  }), Jc(i, "[theme-registry] Invalid global theme registry!"), t;
}
function eo() {
  return globalThis[Da];
}
function jc(t) {
  globalThis[Da] = t;
}
function Pm() {
  jc(Mm());
}
function BA() {
  const t = eo(), n = t.currentThemeKey;
  if (n)
    return t.themes[n];
}
function VA(t, n) {
  const i = eo(), s = i.themes[t];
  s || t !== qA && Jc(s, `[theme-registry] Could not find theme: '${t}' in the registry.`), i.currentThemeKey = t;
  const o = dg(s, n);
  return i.themes[t] = o, o;
}
function HA(t) {
  const n = t.key, i = t.description, s = Xh(t, WA), o = {
    key: n,
    description: i,
    ...s,
    /**
     * Activate a global theme with the given overrides.
     * @deprecated since version 10
     * @param arg
     */
    use(u) {
      VA(n, (u == null ? void 0 : u.overrides) || {});
    }
  };
  return new Proxy(o, {
    get(u, l) {
      u.key, u.description, u.use;
      const d = Xh(u, UA);
      return l === "variables" ? d : Reflect.get(u, l);
    }
  });
}
function GA(t) {
  const n = eo();
  if (t.key && n.themes[t.key])
    return n.themes[t.key];
  {
    if (!fg(t))
      throw Jc(!1, `[theme-registry] The theme provided to 'registerTheme' is not a valid theme object!
For it to be valid some properties have to be present, check out https://instructure.design/#canvas as a reference.`), new Error();
    const i = HA(t);
    return n.themes[i.key] = i, n.registered.push(i.key), i;
  }
}
const YA = {
  getRegistry: eo,
  clearRegistry: Pm,
  setRegistry: jc,
  registerTheme: GA,
  getCurrentTheme: BA
}, ZA = (t) => (n = {}) => {
  var i;
  let s;
  if (Object.keys(n).length === 0) {
    const f = YA.getCurrentTheme();
    process.env.NODE_ENV, s = f || b;
  } else
    s = n;
  let o = t;
  typeof o == "function" && (o = o(s));
  try {
    if (fg(o))
      return o;
  } catch {
    process.env.NODE_ENV, o = {};
  }
  const u = s.key, l = (i = o) === null || i === void 0 ? void 0 : i.themeOverrides, d = (l == null ? void 0 : l[u]) || l || {};
  return dg(s, o, d);
};
var ha = function(n, i, s) {
  return Kc.call(i, "css") ? $d.jsx(OA, EA(n, i), s) : $d.jsx(n, i, s);
};
function Dm({
  children: t,
  theme: n = {},
  dir: i,
  instanceCounterMap: s,
  as: o
}) {
  const u = i || sg(Rd);
  process.env.NODE_ENV;
  let l = ha(qC, {
    instanceCounterMap: s,
    children: ha(bA, {
      theme: ZA(n),
      children: ha(Rd.Provider, {
        value: u,
        children: t
      })
    })
  });
  return i ? l = ha(o || "span", {
    dir: u,
    children: l
  }) : o && process.env.NODE_ENV, l;
}
Dm.propTypes = {
  /* eslint-disable react/require-default-props */
  children: Sr.node,
  theme: Sr.oneOfType([Sr.object, Sr.func]),
  dir: Sr.oneOf(["ltr", "rtl"]),
  instanceCounterMap: Sr.instanceOf(Map),
  as: Sr.string
  /* eslint-enable react/require-default-props */
};
const Xc = ["inst-tagging-sr-polite-0", "inst-tagging-sr-polite-1"], Lm = [
  "inst-tagging-sr-assertive-0",
  "inst-tagging-sr-assertive-1"
];
function KA() {
  return document.getElementById(Xc[0]) ?? document.body;
}
const QA = () => UC(
  /* @__PURE__ */ J(La, { children: [
    Xc.map((t) => /* @__PURE__ */ y("span", { id: t, role: "alert", "aria-atomic": !0, "aria-live": "polite" }, t)),
    Lm.map((t) => /* @__PURE__ */ y("span", { id: t, role: "alert", "aria-atomic": !0, "aria-live": "assertive" }, t))
  ] }),
  document.body
), JA = Q.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9999;
`, jA = Q.div`
  width: 50%;
  margin: 0 auto;
    
  @container (max-width: ${Zi.Small}px) {
    width: 66%;
  }
`, eg = { polite: 0, assertive: 0 }, XA = (t, n) => {
  const i = n ? Lm : Xc, s = n ? "assertive" : "polite", o = eg[s], u = 1 - o;
  eg[s] = u;
  const l = document.getElementById(i[o]), d = document.getElementById(i[u]);
  d && (d.textContent = ""), l && (l.textContent = t);
}, eO = ({ children: t }) => {
  const [n, i] = N.useState([]), s = N.useRef(0), { translations: o } = Ae(), u = N.useCallback((d) => {
    const f = ++s.current, m = d.assertive || d.variant === "error" || d.variant === "warning";
    XA(d.message, m), i((T) => [...T, { ...d, id: f }]);
  }, []), l = N.useCallback((d) => {
    i((f) => f.filter((m) => m.id !== d));
  }, []);
  return /* @__PURE__ */ J(dm.Provider, { value: { showAlert: u }, children: [
    /* @__PURE__ */ y(QA, {}),
    t,
    n.length > 0 && /* @__PURE__ */ y(JA, { children: n.map((d) => /* @__PURE__ */ y(jA, { children: /* @__PURE__ */ y(
      Tc,
      {
        variant: d.variant,
        timeout: d.timeout ?? 5e3,
        onDismiss: () => l(d.id),
        renderCloseButtonLabel: o.close,
        children: d.message
      }
    ) }, d.id)) })
  ] });
};
var Hi = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var tO = Hi.exports, tg;
function nO() {
  return tg || (tg = 1, function(t, n) {
    (function() {
      var i, s = "4.17.23", o = 200, u = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", d = "Invalid `variable` option passed into `_.template`", f = "__lodash_hash_undefined__", m = 500, T = "__lodash_placeholder__", v = 1, x = 2, C = 4, A = 1, _ = 2, R = 1, L = 2, U = 4, q = 8, P = 16, O = 32, M = 64, $ = 128, H = 256, re = 512, ke = 30, oe = "...", ue = 800, xe = 16, He = 1, $e = 2, st = 3, X = 1 / 0, ze = 9007199254740991, je = 17976931348623157e292, B = NaN, V = 4294967295, Y = V - 1, ne = V >>> 1, te = [
        ["ary", $],
        ["bind", R],
        ["bindKey", L],
        ["curry", q],
        ["curryRight", P],
        ["flip", re],
        ["partial", O],
        ["partialRight", M],
        ["rearg", H]
      ], pe = "[object Arguments]", ce = "[object Array]", le = "[object AsyncFunction]", me = "[object Boolean]", ve = "[object Date]", he = "[object DOMException]", Ke = "[object Error]", G = "[object Function]", Xe = "[object GeneratorFunction]", yt = "[object Map]", Hn = "[object Number]", Fm = "[object Null]", In = "[object Object]", el = "[object Promise]", Wm = "[object Proxy]", wi = "[object RegExp]", nn = "[object Set]", Ti = "[object String]", ds = "[object Symbol]", Um = "[object Undefined]", Si = "[object WeakMap]", qm = "[object WeakSet]", Ci = "[object ArrayBuffer]", Mr = "[object DataView]", to = "[object Float32Array]", no = "[object Float64Array]", ro = "[object Int8Array]", io = "[object Int16Array]", so = "[object Int32Array]", ao = "[object Uint8Array]", oo = "[object Uint8ClampedArray]", uo = "[object Uint16Array]", co = "[object Uint32Array]", zm = /\b__p \+= '';/g, Bm = /\b(__p \+=) '' \+/g, Vm = /(__e\(.*?\)|\b__t\)) \+\n'';/g, tl = /&(?:amp|lt|gt|quot|#39);/g, nl = /[&<>"']/g, Hm = RegExp(tl.source), Gm = RegExp(nl.source), Ym = /<%-([\s\S]+?)%>/g, Zm = /<%([\s\S]+?)%>/g, rl = /<%=([\s\S]+?)%>/g, Km = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Qm = /^\w*$/, Jm = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, lo = /[\\^$.*+?()[\]{}|]/g, jm = RegExp(lo.source), fo = /^\s+/, Xm = /\s/, ey = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ty = /\{\n\/\* \[wrapped with (.+)\] \*/, ny = /,? & /, ry = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, iy = /[()=,{}\[\]\/\s]/, sy = /\\(\\)?/g, ay = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, il = /\w*$/, oy = /^[-+]0x[0-9a-f]+$/i, uy = /^0b[01]+$/i, cy = /^\[object .+?Constructor\]$/, ly = /^0o[0-7]+$/i, fy = /^(?:0|[1-9]\d*)$/, dy = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, hs = /($^)/, hy = /['\n\r\u2028\u2029\\]/g, gs = "\\ud800-\\udfff", gy = "\\u0300-\\u036f", py = "\\ufe20-\\ufe2f", my = "\\u20d0-\\u20ff", sl = gy + py + my, al = "\\u2700-\\u27bf", ol = "a-z\\xdf-\\xf6\\xf8-\\xff", yy = "\\xac\\xb1\\xd7\\xf7", vy = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", wy = "\\u2000-\\u206f", Ty = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ul = "A-Z\\xc0-\\xd6\\xd8-\\xde", cl = "\\ufe0e\\ufe0f", ll = yy + vy + wy + Ty, ho = "['’]", Sy = "[" + gs + "]", fl = "[" + ll + "]", ps = "[" + sl + "]", dl = "\\d+", Cy = "[" + al + "]", hl = "[" + ol + "]", gl = "[^" + gs + ll + dl + al + ol + ul + "]", go = "\\ud83c[\\udffb-\\udfff]", xy = "(?:" + ps + "|" + go + ")", pl = "[^" + gs + "]", po = "(?:\\ud83c[\\udde6-\\uddff]){2}", mo = "[\\ud800-\\udbff][\\udc00-\\udfff]", Pr = "[" + ul + "]", ml = "\\u200d", yl = "(?:" + hl + "|" + gl + ")", _y = "(?:" + Pr + "|" + gl + ")", vl = "(?:" + ho + "(?:d|ll|m|re|s|t|ve))?", wl = "(?:" + ho + "(?:D|LL|M|RE|S|T|VE))?", Tl = xy + "?", Sl = "[" + cl + "]?", by = "(?:" + ml + "(?:" + [pl, po, mo].join("|") + ")" + Sl + Tl + ")*", Ey = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Iy = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Cl = Sl + Tl + by, Ay = "(?:" + [Cy, po, mo].join("|") + ")" + Cl, Oy = "(?:" + [pl + ps + "?", ps, po, mo, Sy].join("|") + ")", ky = RegExp(ho, "g"), $y = RegExp(ps, "g"), yo = RegExp(go + "(?=" + go + ")|" + Oy + Cl, "g"), Ny = RegExp([
        Pr + "?" + hl + "+" + vl + "(?=" + [fl, Pr, "$"].join("|") + ")",
        _y + "+" + wl + "(?=" + [fl, Pr + yl, "$"].join("|") + ")",
        Pr + "?" + yl + "+" + vl,
        Pr + "+" + wl,
        Iy,
        Ey,
        dl,
        Ay
      ].join("|"), "g"), Ry = RegExp("[" + ml + gs + sl + cl + "]"), My = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Py = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], Dy = -1, Ge = {};
      Ge[to] = Ge[no] = Ge[ro] = Ge[io] = Ge[so] = Ge[ao] = Ge[oo] = Ge[uo] = Ge[co] = !0, Ge[pe] = Ge[ce] = Ge[Ci] = Ge[me] = Ge[Mr] = Ge[ve] = Ge[Ke] = Ge[G] = Ge[yt] = Ge[Hn] = Ge[In] = Ge[wi] = Ge[nn] = Ge[Ti] = Ge[Si] = !1;
      var Ve = {};
      Ve[pe] = Ve[ce] = Ve[Ci] = Ve[Mr] = Ve[me] = Ve[ve] = Ve[to] = Ve[no] = Ve[ro] = Ve[io] = Ve[so] = Ve[yt] = Ve[Hn] = Ve[In] = Ve[wi] = Ve[nn] = Ve[Ti] = Ve[ds] = Ve[ao] = Ve[oo] = Ve[uo] = Ve[co] = !0, Ve[Ke] = Ve[G] = Ve[Si] = !1;
      var Ly = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, Fy = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Wy = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Uy = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, qy = parseFloat, zy = parseInt, xl = typeof la == "object" && la && la.Object === Object && la, By = typeof self == "object" && self && self.Object === Object && self, gt = xl || By || Function("return this")(), vo = n && !n.nodeType && n, lr = vo && !0 && t && !t.nodeType && t, _l = lr && lr.exports === vo, wo = _l && xl.process, Bt = function() {
        try {
          var E = lr && lr.require && lr.require("util").types;
          return E || wo && wo.binding && wo.binding("util");
        } catch {
        }
      }(), bl = Bt && Bt.isArrayBuffer, El = Bt && Bt.isDate, Il = Bt && Bt.isMap, Al = Bt && Bt.isRegExp, Ol = Bt && Bt.isSet, kl = Bt && Bt.isTypedArray;
      function Pt(E, D, k) {
        switch (k.length) {
          case 0:
            return E.call(D);
          case 1:
            return E.call(D, k[0]);
          case 2:
            return E.call(D, k[0], k[1]);
          case 3:
            return E.call(D, k[0], k[1], k[2]);
        }
        return E.apply(D, k);
      }
      function Vy(E, D, k, j) {
        for (var ge = -1, Ne = E == null ? 0 : E.length; ++ge < Ne; ) {
          var ct = E[ge];
          D(j, ct, k(ct), E);
        }
        return j;
      }
      function Vt(E, D) {
        for (var k = -1, j = E == null ? 0 : E.length; ++k < j && D(E[k], k, E) !== !1; )
          ;
        return E;
      }
      function Hy(E, D) {
        for (var k = E == null ? 0 : E.length; k-- && D(E[k], k, E) !== !1; )
          ;
        return E;
      }
      function $l(E, D) {
        for (var k = -1, j = E == null ? 0 : E.length; ++k < j; )
          if (!D(E[k], k, E))
            return !1;
        return !0;
      }
      function Gn(E, D) {
        for (var k = -1, j = E == null ? 0 : E.length, ge = 0, Ne = []; ++k < j; ) {
          var ct = E[k];
          D(ct, k, E) && (Ne[ge++] = ct);
        }
        return Ne;
      }
      function ms(E, D) {
        var k = E == null ? 0 : E.length;
        return !!k && Dr(E, D, 0) > -1;
      }
      function To(E, D, k) {
        for (var j = -1, ge = E == null ? 0 : E.length; ++j < ge; )
          if (k(D, E[j]))
            return !0;
        return !1;
      }
      function Ze(E, D) {
        for (var k = -1, j = E == null ? 0 : E.length, ge = Array(j); ++k < j; )
          ge[k] = D(E[k], k, E);
        return ge;
      }
      function Yn(E, D) {
        for (var k = -1, j = D.length, ge = E.length; ++k < j; )
          E[ge + k] = D[k];
        return E;
      }
      function So(E, D, k, j) {
        var ge = -1, Ne = E == null ? 0 : E.length;
        for (j && Ne && (k = E[++ge]); ++ge < Ne; )
          k = D(k, E[ge], ge, E);
        return k;
      }
      function Gy(E, D, k, j) {
        var ge = E == null ? 0 : E.length;
        for (j && ge && (k = E[--ge]); ge--; )
          k = D(k, E[ge], ge, E);
        return k;
      }
      function Co(E, D) {
        for (var k = -1, j = E == null ? 0 : E.length; ++k < j; )
          if (D(E[k], k, E))
            return !0;
        return !1;
      }
      var Yy = xo("length");
      function Zy(E) {
        return E.split("");
      }
      function Ky(E) {
        return E.match(ry) || [];
      }
      function Nl(E, D, k) {
        var j;
        return k(E, function(ge, Ne, ct) {
          if (D(ge, Ne, ct))
            return j = Ne, !1;
        }), j;
      }
      function ys(E, D, k, j) {
        for (var ge = E.length, Ne = k + (j ? 1 : -1); j ? Ne-- : ++Ne < ge; )
          if (D(E[Ne], Ne, E))
            return Ne;
        return -1;
      }
      function Dr(E, D, k) {
        return D === D ? ov(E, D, k) : ys(E, Rl, k);
      }
      function Qy(E, D, k, j) {
        for (var ge = k - 1, Ne = E.length; ++ge < Ne; )
          if (j(E[ge], D))
            return ge;
        return -1;
      }
      function Rl(E) {
        return E !== E;
      }
      function Ml(E, D) {
        var k = E == null ? 0 : E.length;
        return k ? bo(E, D) / k : B;
      }
      function xo(E) {
        return function(D) {
          return D == null ? i : D[E];
        };
      }
      function _o(E) {
        return function(D) {
          return E == null ? i : E[D];
        };
      }
      function Pl(E, D, k, j, ge) {
        return ge(E, function(Ne, ct, Be) {
          k = j ? (j = !1, Ne) : D(k, Ne, ct, Be);
        }), k;
      }
      function Jy(E, D) {
        var k = E.length;
        for (E.sort(D); k--; )
          E[k] = E[k].value;
        return E;
      }
      function bo(E, D) {
        for (var k, j = -1, ge = E.length; ++j < ge; ) {
          var Ne = D(E[j]);
          Ne !== i && (k = k === i ? Ne : k + Ne);
        }
        return k;
      }
      function Eo(E, D) {
        for (var k = -1, j = Array(E); ++k < E; )
          j[k] = D(k);
        return j;
      }
      function jy(E, D) {
        return Ze(D, function(k) {
          return [k, E[k]];
        });
      }
      function Dl(E) {
        return E && E.slice(0, Ul(E) + 1).replace(fo, "");
      }
      function Dt(E) {
        return function(D) {
          return E(D);
        };
      }
      function Io(E, D) {
        return Ze(D, function(k) {
          return E[k];
        });
      }
      function xi(E, D) {
        return E.has(D);
      }
      function Ll(E, D) {
        for (var k = -1, j = E.length; ++k < j && Dr(D, E[k], 0) > -1; )
          ;
        return k;
      }
      function Fl(E, D) {
        for (var k = E.length; k-- && Dr(D, E[k], 0) > -1; )
          ;
        return k;
      }
      function Xy(E, D) {
        for (var k = E.length, j = 0; k--; )
          E[k] === D && ++j;
        return j;
      }
      var ev = _o(Ly), tv = _o(Fy);
      function nv(E) {
        return "\\" + Uy[E];
      }
      function rv(E, D) {
        return E == null ? i : E[D];
      }
      function Lr(E) {
        return Ry.test(E);
      }
      function iv(E) {
        return My.test(E);
      }
      function sv(E) {
        for (var D, k = []; !(D = E.next()).done; )
          k.push(D.value);
        return k;
      }
      function Ao(E) {
        var D = -1, k = Array(E.size);
        return E.forEach(function(j, ge) {
          k[++D] = [ge, j];
        }), k;
      }
      function Wl(E, D) {
        return function(k) {
          return E(D(k));
        };
      }
      function Zn(E, D) {
        for (var k = -1, j = E.length, ge = 0, Ne = []; ++k < j; ) {
          var ct = E[k];
          (ct === D || ct === T) && (E[k] = T, Ne[ge++] = k);
        }
        return Ne;
      }
      function vs(E) {
        var D = -1, k = Array(E.size);
        return E.forEach(function(j) {
          k[++D] = j;
        }), k;
      }
      function av(E) {
        var D = -1, k = Array(E.size);
        return E.forEach(function(j) {
          k[++D] = [j, j];
        }), k;
      }
      function ov(E, D, k) {
        for (var j = k - 1, ge = E.length; ++j < ge; )
          if (E[j] === D)
            return j;
        return -1;
      }
      function uv(E, D, k) {
        for (var j = k + 1; j--; )
          if (E[j] === D)
            return j;
        return j;
      }
      function Fr(E) {
        return Lr(E) ? lv(E) : Yy(E);
      }
      function rn(E) {
        return Lr(E) ? fv(E) : Zy(E);
      }
      function Ul(E) {
        for (var D = E.length; D-- && Xm.test(E.charAt(D)); )
          ;
        return D;
      }
      var cv = _o(Wy);
      function lv(E) {
        for (var D = yo.lastIndex = 0; yo.test(E); )
          ++D;
        return D;
      }
      function fv(E) {
        return E.match(yo) || [];
      }
      function dv(E) {
        return E.match(Ny) || [];
      }
      var hv = function E(D) {
        D = D == null ? gt : Wr.defaults(gt.Object(), D, Wr.pick(gt, Py));
        var k = D.Array, j = D.Date, ge = D.Error, Ne = D.Function, ct = D.Math, Be = D.Object, Oo = D.RegExp, gv = D.String, Ht = D.TypeError, ws = k.prototype, pv = Ne.prototype, Ur = Be.prototype, Ts = D["__core-js_shared__"], Ss = pv.toString, Le = Ur.hasOwnProperty, mv = 0, ql = function() {
          var e = /[^.]+$/.exec(Ts && Ts.keys && Ts.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        }(), Cs = Ur.toString, yv = Ss.call(Be), vv = gt._, wv = Oo(
          "^" + Ss.call(Le).replace(lo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), xs = _l ? D.Buffer : i, Kn = D.Symbol, _s = D.Uint8Array, zl = xs ? xs.allocUnsafe : i, bs = Wl(Be.getPrototypeOf, Be), Bl = Be.create, Vl = Ur.propertyIsEnumerable, Es = ws.splice, Hl = Kn ? Kn.isConcatSpreadable : i, _i = Kn ? Kn.iterator : i, fr = Kn ? Kn.toStringTag : i, Is = function() {
          try {
            var e = mr(Be, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        }(), Tv = D.clearTimeout !== gt.clearTimeout && D.clearTimeout, Sv = j && j.now !== gt.Date.now && j.now, Cv = D.setTimeout !== gt.setTimeout && D.setTimeout, As = ct.ceil, Os = ct.floor, ko = Be.getOwnPropertySymbols, xv = xs ? xs.isBuffer : i, Gl = D.isFinite, _v = ws.join, bv = Wl(Be.keys, Be), lt = ct.max, vt = ct.min, Ev = j.now, Iv = D.parseInt, Yl = ct.random, Av = ws.reverse, $o = mr(D, "DataView"), bi = mr(D, "Map"), No = mr(D, "Promise"), qr = mr(D, "Set"), Ei = mr(D, "WeakMap"), Ii = mr(Be, "create"), ks = Ei && new Ei(), zr = {}, Ov = yr($o), kv = yr(bi), $v = yr(No), Nv = yr(qr), Rv = yr(Ei), $s = Kn ? Kn.prototype : i, Ai = $s ? $s.valueOf : i, Zl = $s ? $s.toString : i;
        function g(e) {
          if (et(e) && !ye(e) && !(e instanceof be)) {
            if (e instanceof Gt)
              return e;
            if (Le.call(e, "__wrapped__"))
              return Qf(e);
          }
          return new Gt(e);
        }
        var Br = /* @__PURE__ */ function() {
          function e() {
          }
          return function(r) {
            if (!Qe(r))
              return {};
            if (Bl)
              return Bl(r);
            e.prototype = r;
            var a = new e();
            return e.prototype = i, a;
          };
        }();
        function Ns() {
        }
        function Gt(e, r) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!r, this.__index__ = 0, this.__values__ = i;
        }
        g.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Ym,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Zm,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: rl,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: g
          }
        }, g.prototype = Ns.prototype, g.prototype.constructor = g, Gt.prototype = Br(Ns.prototype), Gt.prototype.constructor = Gt;
        function be(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = V, this.__views__ = [];
        }
        function Mv() {
          var e = new be(this.__wrapped__);
          return e.__actions__ = Ot(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Ot(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Ot(this.__views__), e;
        }
        function Pv() {
          if (this.__filtered__) {
            var e = new be(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function Dv() {
          var e = this.__wrapped__.value(), r = this.__dir__, a = ye(e), c = r < 0, h = a ? e.length : 0, p = Z0(0, h, this.__views__), w = p.start, S = p.end, I = S - w, F = c ? S : w - 1, W = this.__iteratees__, z = W.length, Z = 0, ee = vt(I, this.__takeCount__);
          if (!a || !c && h == I && ee == I)
            return wf(e, this.__actions__);
          var se = [];
          e:
            for (; I-- && Z < ee; ) {
              F += r;
              for (var Te = -1, ae = e[F]; ++Te < z; ) {
                var _e = W[Te], Ee = _e.iteratee, Wt = _e.type, bt = Ee(ae);
                if (Wt == $e)
                  ae = bt;
                else if (!bt) {
                  if (Wt == He)
                    continue e;
                  break e;
                }
              }
              se[Z++] = ae;
            }
          return se;
        }
        be.prototype = Br(Ns.prototype), be.prototype.constructor = be;
        function dr(e) {
          var r = -1, a = e == null ? 0 : e.length;
          for (this.clear(); ++r < a; ) {
            var c = e[r];
            this.set(c[0], c[1]);
          }
        }
        function Lv() {
          this.__data__ = Ii ? Ii(null) : {}, this.size = 0;
        }
        function Fv(e) {
          var r = this.has(e) && delete this.__data__[e];
          return this.size -= r ? 1 : 0, r;
        }
        function Wv(e) {
          var r = this.__data__;
          if (Ii) {
            var a = r[e];
            return a === f ? i : a;
          }
          return Le.call(r, e) ? r[e] : i;
        }
        function Uv(e) {
          var r = this.__data__;
          return Ii ? r[e] !== i : Le.call(r, e);
        }
        function qv(e, r) {
          var a = this.__data__;
          return this.size += this.has(e) ? 0 : 1, a[e] = Ii && r === i ? f : r, this;
        }
        dr.prototype.clear = Lv, dr.prototype.delete = Fv, dr.prototype.get = Wv, dr.prototype.has = Uv, dr.prototype.set = qv;
        function An(e) {
          var r = -1, a = e == null ? 0 : e.length;
          for (this.clear(); ++r < a; ) {
            var c = e[r];
            this.set(c[0], c[1]);
          }
        }
        function zv() {
          this.__data__ = [], this.size = 0;
        }
        function Bv(e) {
          var r = this.__data__, a = Rs(r, e);
          if (a < 0)
            return !1;
          var c = r.length - 1;
          return a == c ? r.pop() : Es.call(r, a, 1), --this.size, !0;
        }
        function Vv(e) {
          var r = this.__data__, a = Rs(r, e);
          return a < 0 ? i : r[a][1];
        }
        function Hv(e) {
          return Rs(this.__data__, e) > -1;
        }
        function Gv(e, r) {
          var a = this.__data__, c = Rs(a, e);
          return c < 0 ? (++this.size, a.push([e, r])) : a[c][1] = r, this;
        }
        An.prototype.clear = zv, An.prototype.delete = Bv, An.prototype.get = Vv, An.prototype.has = Hv, An.prototype.set = Gv;
        function On(e) {
          var r = -1, a = e == null ? 0 : e.length;
          for (this.clear(); ++r < a; ) {
            var c = e[r];
            this.set(c[0], c[1]);
          }
        }
        function Yv() {
          this.size = 0, this.__data__ = {
            hash: new dr(),
            map: new (bi || An)(),
            string: new dr()
          };
        }
        function Zv(e) {
          var r = Hs(this, e).delete(e);
          return this.size -= r ? 1 : 0, r;
        }
        function Kv(e) {
          return Hs(this, e).get(e);
        }
        function Qv(e) {
          return Hs(this, e).has(e);
        }
        function Jv(e, r) {
          var a = Hs(this, e), c = a.size;
          return a.set(e, r), this.size += a.size == c ? 0 : 1, this;
        }
        On.prototype.clear = Yv, On.prototype.delete = Zv, On.prototype.get = Kv, On.prototype.has = Qv, On.prototype.set = Jv;
        function hr(e) {
          var r = -1, a = e == null ? 0 : e.length;
          for (this.__data__ = new On(); ++r < a; )
            this.add(e[r]);
        }
        function jv(e) {
          return this.__data__.set(e, f), this;
        }
        function Xv(e) {
          return this.__data__.has(e);
        }
        hr.prototype.add = hr.prototype.push = jv, hr.prototype.has = Xv;
        function sn(e) {
          var r = this.__data__ = new An(e);
          this.size = r.size;
        }
        function e0() {
          this.__data__ = new An(), this.size = 0;
        }
        function t0(e) {
          var r = this.__data__, a = r.delete(e);
          return this.size = r.size, a;
        }
        function n0(e) {
          return this.__data__.get(e);
        }
        function r0(e) {
          return this.__data__.has(e);
        }
        function i0(e, r) {
          var a = this.__data__;
          if (a instanceof An) {
            var c = a.__data__;
            if (!bi || c.length < o - 1)
              return c.push([e, r]), this.size = ++a.size, this;
            a = this.__data__ = new On(c);
          }
          return a.set(e, r), this.size = a.size, this;
        }
        sn.prototype.clear = e0, sn.prototype.delete = t0, sn.prototype.get = n0, sn.prototype.has = r0, sn.prototype.set = i0;
        function Kl(e, r) {
          var a = ye(e), c = !a && vr(e), h = !a && !c && er(e), p = !a && !c && !h && Yr(e), w = a || c || h || p, S = w ? Eo(e.length, gv) : [], I = S.length;
          for (var F in e)
            (r || Le.call(e, F)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
            (F == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            h && (F == "offset" || F == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            p && (F == "buffer" || F == "byteLength" || F == "byteOffset") || // Skip index properties.
            Rn(F, I))) && S.push(F);
          return S;
        }
        function Ql(e) {
          var r = e.length;
          return r ? e[Bo(0, r - 1)] : i;
        }
        function s0(e, r) {
          return Gs(Ot(e), gr(r, 0, e.length));
        }
        function a0(e) {
          return Gs(Ot(e));
        }
        function Ro(e, r, a) {
          (a !== i && !an(e[r], a) || a === i && !(r in e)) && kn(e, r, a);
        }
        function Oi(e, r, a) {
          var c = e[r];
          (!(Le.call(e, r) && an(c, a)) || a === i && !(r in e)) && kn(e, r, a);
        }
        function Rs(e, r) {
          for (var a = e.length; a--; )
            if (an(e[a][0], r))
              return a;
          return -1;
        }
        function o0(e, r, a, c) {
          return Qn(e, function(h, p, w) {
            r(c, h, a(h), w);
          }), c;
        }
        function Jl(e, r) {
          return e && yn(r, dt(r), e);
        }
        function u0(e, r) {
          return e && yn(r, $t(r), e);
        }
        function kn(e, r, a) {
          r == "__proto__" && Is ? Is(e, r, {
            configurable: !0,
            enumerable: !0,
            value: a,
            writable: !0
          }) : e[r] = a;
        }
        function Mo(e, r) {
          for (var a = -1, c = r.length, h = k(c), p = e == null; ++a < c; )
            h[a] = p ? i : gu(e, r[a]);
          return h;
        }
        function gr(e, r, a) {
          return e === e && (a !== i && (e = e <= a ? e : a), r !== i && (e = e >= r ? e : r)), e;
        }
        function Yt(e, r, a, c, h, p) {
          var w, S = r & v, I = r & x, F = r & C;
          if (a && (w = h ? a(e, c, h, p) : a(e)), w !== i)
            return w;
          if (!Qe(e))
            return e;
          var W = ye(e);
          if (W) {
            if (w = Q0(e), !S)
              return Ot(e, w);
          } else {
            var z = wt(e), Z = z == G || z == Xe;
            if (er(e))
              return Cf(e, S);
            if (z == In || z == pe || Z && !h) {
              if (w = I || Z ? {} : qf(e), !S)
                return I ? W0(e, u0(w, e)) : F0(e, Jl(w, e));
            } else {
              if (!Ve[z])
                return h ? e : {};
              w = J0(e, z, S);
            }
          }
          p || (p = new sn());
          var ee = p.get(e);
          if (ee)
            return ee;
          p.set(e, w), md(e) ? e.forEach(function(ae) {
            w.add(Yt(ae, r, a, ae, e, p));
          }) : gd(e) && e.forEach(function(ae, _e) {
            w.set(_e, Yt(ae, r, a, _e, e, p));
          });
          var se = F ? I ? eu : Xo : I ? $t : dt, Te = W ? i : se(e);
          return Vt(Te || e, function(ae, _e) {
            Te && (_e = ae, ae = e[_e]), Oi(w, _e, Yt(ae, r, a, _e, e, p));
          }), w;
        }
        function c0(e) {
          var r = dt(e);
          return function(a) {
            return jl(a, e, r);
          };
        }
        function jl(e, r, a) {
          var c = a.length;
          if (e == null)
            return !c;
          for (e = Be(e); c--; ) {
            var h = a[c], p = r[h], w = e[h];
            if (w === i && !(h in e) || !p(w))
              return !1;
          }
          return !0;
        }
        function Xl(e, r, a) {
          if (typeof e != "function")
            throw new Ht(l);
          return Di(function() {
            e.apply(i, a);
          }, r);
        }
        function ki(e, r, a, c) {
          var h = -1, p = ms, w = !0, S = e.length, I = [], F = r.length;
          if (!S)
            return I;
          a && (r = Ze(r, Dt(a))), c ? (p = To, w = !1) : r.length >= o && (p = xi, w = !1, r = new hr(r));
          e:
            for (; ++h < S; ) {
              var W = e[h], z = a == null ? W : a(W);
              if (W = c || W !== 0 ? W : 0, w && z === z) {
                for (var Z = F; Z--; )
                  if (r[Z] === z)
                    continue e;
                I.push(W);
              } else p(r, z, c) || I.push(W);
            }
          return I;
        }
        var Qn = If(mn), ef = If(Do, !0);
        function l0(e, r) {
          var a = !0;
          return Qn(e, function(c, h, p) {
            return a = !!r(c, h, p), a;
          }), a;
        }
        function Ms(e, r, a) {
          for (var c = -1, h = e.length; ++c < h; ) {
            var p = e[c], w = r(p);
            if (w != null && (S === i ? w === w && !Ft(w) : a(w, S)))
              var S = w, I = p;
          }
          return I;
        }
        function f0(e, r, a, c) {
          var h = e.length;
          for (a = we(a), a < 0 && (a = -a > h ? 0 : h + a), c = c === i || c > h ? h : we(c), c < 0 && (c += h), c = a > c ? 0 : vd(c); a < c; )
            e[a++] = r;
          return e;
        }
        function tf(e, r) {
          var a = [];
          return Qn(e, function(c, h, p) {
            r(c, h, p) && a.push(c);
          }), a;
        }
        function pt(e, r, a, c, h) {
          var p = -1, w = e.length;
          for (a || (a = X0), h || (h = []); ++p < w; ) {
            var S = e[p];
            r > 0 && a(S) ? r > 1 ? pt(S, r - 1, a, c, h) : Yn(h, S) : c || (h[h.length] = S);
          }
          return h;
        }
        var Po = Af(), nf = Af(!0);
        function mn(e, r) {
          return e && Po(e, r, dt);
        }
        function Do(e, r) {
          return e && nf(e, r, dt);
        }
        function Ps(e, r) {
          return Gn(r, function(a) {
            return Mn(e[a]);
          });
        }
        function pr(e, r) {
          r = jn(r, e);
          for (var a = 0, c = r.length; e != null && a < c; )
            e = e[vn(r[a++])];
          return a && a == c ? e : i;
        }
        function rf(e, r, a) {
          var c = r(e);
          return ye(e) ? c : Yn(c, a(e));
        }
        function xt(e) {
          return e == null ? e === i ? Um : Fm : fr && fr in Be(e) ? Y0(e) : a1(e);
        }
        function Lo(e, r) {
          return e > r;
        }
        function d0(e, r) {
          return e != null && Le.call(e, r);
        }
        function h0(e, r) {
          return e != null && r in Be(e);
        }
        function g0(e, r, a) {
          return e >= vt(r, a) && e < lt(r, a);
        }
        function Fo(e, r, a) {
          for (var c = a ? To : ms, h = e[0].length, p = e.length, w = p, S = k(p), I = 1 / 0, F = []; w--; ) {
            var W = e[w];
            w && r && (W = Ze(W, Dt(r))), I = vt(W.length, I), S[w] = !a && (r || h >= 120 && W.length >= 120) ? new hr(w && W) : i;
          }
          W = e[0];
          var z = -1, Z = S[0];
          e:
            for (; ++z < h && F.length < I; ) {
              var ee = W[z], se = r ? r(ee) : ee;
              if (ee = a || ee !== 0 ? ee : 0, !(Z ? xi(Z, se) : c(F, se, a))) {
                for (w = p; --w; ) {
                  var Te = S[w];
                  if (!(Te ? xi(Te, se) : c(e[w], se, a)))
                    continue e;
                }
                Z && Z.push(se), F.push(ee);
              }
            }
          return F;
        }
        function p0(e, r, a, c) {
          return mn(e, function(h, p, w) {
            r(c, a(h), p, w);
          }), c;
        }
        function $i(e, r, a) {
          r = jn(r, e), e = Hf(e, r);
          var c = e == null ? e : e[vn(Kt(r))];
          return c == null ? i : Pt(c, e, a);
        }
        function sf(e) {
          return et(e) && xt(e) == pe;
        }
        function m0(e) {
          return et(e) && xt(e) == Ci;
        }
        function y0(e) {
          return et(e) && xt(e) == ve;
        }
        function Ni(e, r, a, c, h) {
          return e === r ? !0 : e == null || r == null || !et(e) && !et(r) ? e !== e && r !== r : v0(e, r, a, c, Ni, h);
        }
        function v0(e, r, a, c, h, p) {
          var w = ye(e), S = ye(r), I = w ? ce : wt(e), F = S ? ce : wt(r);
          I = I == pe ? In : I, F = F == pe ? In : F;
          var W = I == In, z = F == In, Z = I == F;
          if (Z && er(e)) {
            if (!er(r))
              return !1;
            w = !0, W = !1;
          }
          if (Z && !W)
            return p || (p = new sn()), w || Yr(e) ? Ff(e, r, a, c, h, p) : H0(e, r, I, a, c, h, p);
          if (!(a & A)) {
            var ee = W && Le.call(e, "__wrapped__"), se = z && Le.call(r, "__wrapped__");
            if (ee || se) {
              var Te = ee ? e.value() : e, ae = se ? r.value() : r;
              return p || (p = new sn()), h(Te, ae, a, c, p);
            }
          }
          return Z ? (p || (p = new sn()), G0(e, r, a, c, h, p)) : !1;
        }
        function w0(e) {
          return et(e) && wt(e) == yt;
        }
        function Wo(e, r, a, c) {
          var h = a.length, p = h, w = !c;
          if (e == null)
            return !p;
          for (e = Be(e); h--; ) {
            var S = a[h];
            if (w && S[2] ? S[1] !== e[S[0]] : !(S[0] in e))
              return !1;
          }
          for (; ++h < p; ) {
            S = a[h];
            var I = S[0], F = e[I], W = S[1];
            if (w && S[2]) {
              if (F === i && !(I in e))
                return !1;
            } else {
              var z = new sn();
              if (c)
                var Z = c(F, W, I, e, r, z);
              if (!(Z === i ? Ni(W, F, A | _, c, z) : Z))
                return !1;
            }
          }
          return !0;
        }
        function af(e) {
          if (!Qe(e) || t1(e))
            return !1;
          var r = Mn(e) ? wv : cy;
          return r.test(yr(e));
        }
        function T0(e) {
          return et(e) && xt(e) == wi;
        }
        function S0(e) {
          return et(e) && wt(e) == nn;
        }
        function C0(e) {
          return et(e) && js(e.length) && !!Ge[xt(e)];
        }
        function of(e) {
          return typeof e == "function" ? e : e == null ? Nt : typeof e == "object" ? ye(e) ? lf(e[0], e[1]) : cf(e) : Od(e);
        }
        function Uo(e) {
          if (!Pi(e))
            return bv(e);
          var r = [];
          for (var a in Be(e))
            Le.call(e, a) && a != "constructor" && r.push(a);
          return r;
        }
        function x0(e) {
          if (!Qe(e))
            return s1(e);
          var r = Pi(e), a = [];
          for (var c in e)
            c == "constructor" && (r || !Le.call(e, c)) || a.push(c);
          return a;
        }
        function qo(e, r) {
          return e < r;
        }
        function uf(e, r) {
          var a = -1, c = kt(e) ? k(e.length) : [];
          return Qn(e, function(h, p, w) {
            c[++a] = r(h, p, w);
          }), c;
        }
        function cf(e) {
          var r = nu(e);
          return r.length == 1 && r[0][2] ? Bf(r[0][0], r[0][1]) : function(a) {
            return a === e || Wo(a, e, r);
          };
        }
        function lf(e, r) {
          return iu(e) && zf(r) ? Bf(vn(e), r) : function(a) {
            var c = gu(a, e);
            return c === i && c === r ? pu(a, e) : Ni(r, c, A | _);
          };
        }
        function Ds(e, r, a, c, h) {
          e !== r && Po(r, function(p, w) {
            if (h || (h = new sn()), Qe(p))
              _0(e, r, w, a, Ds, c, h);
            else {
              var S = c ? c(au(e, w), p, w + "", e, r, h) : i;
              S === i && (S = p), Ro(e, w, S);
            }
          }, $t);
        }
        function _0(e, r, a, c, h, p, w) {
          var S = au(e, a), I = au(r, a), F = w.get(I);
          if (F) {
            Ro(e, a, F);
            return;
          }
          var W = p ? p(S, I, a + "", e, r, w) : i, z = W === i;
          if (z) {
            var Z = ye(I), ee = !Z && er(I), se = !Z && !ee && Yr(I);
            W = I, Z || ee || se ? ye(S) ? W = S : rt(S) ? W = Ot(S) : ee ? (z = !1, W = Cf(I, !0)) : se ? (z = !1, W = xf(I, !0)) : W = [] : Li(I) || vr(I) ? (W = S, vr(S) ? W = wd(S) : (!Qe(S) || Mn(S)) && (W = qf(I))) : z = !1;
          }
          z && (w.set(I, W), h(W, I, c, p, w), w.delete(I)), Ro(e, a, W);
        }
        function ff(e, r) {
          var a = e.length;
          if (a)
            return r += r < 0 ? a : 0, Rn(r, a) ? e[r] : i;
        }
        function df(e, r, a) {
          r.length ? r = Ze(r, function(p) {
            return ye(p) ? function(w) {
              return pr(w, p.length === 1 ? p[0] : p);
            } : p;
          }) : r = [Nt];
          var c = -1;
          r = Ze(r, Dt(ie()));
          var h = uf(e, function(p, w, S) {
            var I = Ze(r, function(F) {
              return F(p);
            });
            return { criteria: I, index: ++c, value: p };
          });
          return Jy(h, function(p, w) {
            return L0(p, w, a);
          });
        }
        function b0(e, r) {
          return hf(e, r, function(a, c) {
            return pu(e, c);
          });
        }
        function hf(e, r, a) {
          for (var c = -1, h = r.length, p = {}; ++c < h; ) {
            var w = r[c], S = pr(e, w);
            a(S, w) && Ri(p, jn(w, e), S);
          }
          return p;
        }
        function E0(e) {
          return function(r) {
            return pr(r, e);
          };
        }
        function zo(e, r, a, c) {
          var h = c ? Qy : Dr, p = -1, w = r.length, S = e;
          for (e === r && (r = Ot(r)), a && (S = Ze(e, Dt(a))); ++p < w; )
            for (var I = 0, F = r[p], W = a ? a(F) : F; (I = h(S, W, I, c)) > -1; )
              S !== e && Es.call(S, I, 1), Es.call(e, I, 1);
          return e;
        }
        function gf(e, r) {
          for (var a = e ? r.length : 0, c = a - 1; a--; ) {
            var h = r[a];
            if (a == c || h !== p) {
              var p = h;
              Rn(h) ? Es.call(e, h, 1) : Go(e, h);
            }
          }
          return e;
        }
        function Bo(e, r) {
          return e + Os(Yl() * (r - e + 1));
        }
        function I0(e, r, a, c) {
          for (var h = -1, p = lt(As((r - e) / (a || 1)), 0), w = k(p); p--; )
            w[c ? p : ++h] = e, e += a;
          return w;
        }
        function Vo(e, r) {
          var a = "";
          if (!e || r < 1 || r > ze)
            return a;
          do
            r % 2 && (a += e), r = Os(r / 2), r && (e += e);
          while (r);
          return a;
        }
        function Ce(e, r) {
          return ou(Vf(e, r, Nt), e + "");
        }
        function A0(e) {
          return Ql(Zr(e));
        }
        function O0(e, r) {
          var a = Zr(e);
          return Gs(a, gr(r, 0, a.length));
        }
        function Ri(e, r, a, c) {
          if (!Qe(e))
            return e;
          r = jn(r, e);
          for (var h = -1, p = r.length, w = p - 1, S = e; S != null && ++h < p; ) {
            var I = vn(r[h]), F = a;
            if (I === "__proto__" || I === "constructor" || I === "prototype")
              return e;
            if (h != w) {
              var W = S[I];
              F = c ? c(W, I, S) : i, F === i && (F = Qe(W) ? W : Rn(r[h + 1]) ? [] : {});
            }
            Oi(S, I, F), S = S[I];
          }
          return e;
        }
        var pf = ks ? function(e, r) {
          return ks.set(e, r), e;
        } : Nt, k0 = Is ? function(e, r) {
          return Is(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: yu(r),
            writable: !0
          });
        } : Nt;
        function $0(e) {
          return Gs(Zr(e));
        }
        function Zt(e, r, a) {
          var c = -1, h = e.length;
          r < 0 && (r = -r > h ? 0 : h + r), a = a > h ? h : a, a < 0 && (a += h), h = r > a ? 0 : a - r >>> 0, r >>>= 0;
          for (var p = k(h); ++c < h; )
            p[c] = e[c + r];
          return p;
        }
        function N0(e, r) {
          var a;
          return Qn(e, function(c, h, p) {
            return a = r(c, h, p), !a;
          }), !!a;
        }
        function Ls(e, r, a) {
          var c = 0, h = e == null ? c : e.length;
          if (typeof r == "number" && r === r && h <= ne) {
            for (; c < h; ) {
              var p = c + h >>> 1, w = e[p];
              w !== null && !Ft(w) && (a ? w <= r : w < r) ? c = p + 1 : h = p;
            }
            return h;
          }
          return Ho(e, r, Nt, a);
        }
        function Ho(e, r, a, c) {
          var h = 0, p = e == null ? 0 : e.length;
          if (p === 0)
            return 0;
          r = a(r);
          for (var w = r !== r, S = r === null, I = Ft(r), F = r === i; h < p; ) {
            var W = Os((h + p) / 2), z = a(e[W]), Z = z !== i, ee = z === null, se = z === z, Te = Ft(z);
            if (w)
              var ae = c || se;
            else F ? ae = se && (c || Z) : S ? ae = se && Z && (c || !ee) : I ? ae = se && Z && !ee && (c || !Te) : ee || Te ? ae = !1 : ae = c ? z <= r : z < r;
            ae ? h = W + 1 : p = W;
          }
          return vt(p, Y);
        }
        function mf(e, r) {
          for (var a = -1, c = e.length, h = 0, p = []; ++a < c; ) {
            var w = e[a], S = r ? r(w) : w;
            if (!a || !an(S, I)) {
              var I = S;
              p[h++] = w === 0 ? 0 : w;
            }
          }
          return p;
        }
        function yf(e) {
          return typeof e == "number" ? e : Ft(e) ? B : +e;
        }
        function Lt(e) {
          if (typeof e == "string")
            return e;
          if (ye(e))
            return Ze(e, Lt) + "";
          if (Ft(e))
            return Zl ? Zl.call(e) : "";
          var r = e + "";
          return r == "0" && 1 / e == -X ? "-0" : r;
        }
        function Jn(e, r, a) {
          var c = -1, h = ms, p = e.length, w = !0, S = [], I = S;
          if (a)
            w = !1, h = To;
          else if (p >= o) {
            var F = r ? null : B0(e);
            if (F)
              return vs(F);
            w = !1, h = xi, I = new hr();
          } else
            I = r ? [] : S;
          e:
            for (; ++c < p; ) {
              var W = e[c], z = r ? r(W) : W;
              if (W = a || W !== 0 ? W : 0, w && z === z) {
                for (var Z = I.length; Z--; )
                  if (I[Z] === z)
                    continue e;
                r && I.push(z), S.push(W);
              } else h(I, z, a) || (I !== S && I.push(z), S.push(W));
            }
          return S;
        }
        function Go(e, r) {
          r = jn(r, e);
          var a = -1, c = r.length;
          if (!c)
            return !0;
          for (var h = e == null || typeof e != "object" && typeof e != "function"; ++a < c; ) {
            var p = r[a];
            if (typeof p == "string") {
              if (p === "__proto__" && !Le.call(e, "__proto__"))
                return !1;
              if (p === "constructor" && a + 1 < c && typeof r[a + 1] == "string" && r[a + 1] === "prototype") {
                if (h && a === 0)
                  continue;
                return !1;
              }
            }
          }
          var w = Hf(e, r);
          return w == null || delete w[vn(Kt(r))];
        }
        function vf(e, r, a, c) {
          return Ri(e, r, a(pr(e, r)), c);
        }
        function Fs(e, r, a, c) {
          for (var h = e.length, p = c ? h : -1; (c ? p-- : ++p < h) && r(e[p], p, e); )
            ;
          return a ? Zt(e, c ? 0 : p, c ? p + 1 : h) : Zt(e, c ? p + 1 : 0, c ? h : p);
        }
        function wf(e, r) {
          var a = e;
          return a instanceof be && (a = a.value()), So(r, function(c, h) {
            return h.func.apply(h.thisArg, Yn([c], h.args));
          }, a);
        }
        function Yo(e, r, a) {
          var c = e.length;
          if (c < 2)
            return c ? Jn(e[0]) : [];
          for (var h = -1, p = k(c); ++h < c; )
            for (var w = e[h], S = -1; ++S < c; )
              S != h && (p[h] = ki(p[h] || w, e[S], r, a));
          return Jn(pt(p, 1), r, a);
        }
        function Tf(e, r, a) {
          for (var c = -1, h = e.length, p = r.length, w = {}; ++c < h; ) {
            var S = c < p ? r[c] : i;
            a(w, e[c], S);
          }
          return w;
        }
        function Zo(e) {
          return rt(e) ? e : [];
        }
        function Ko(e) {
          return typeof e == "function" ? e : Nt;
        }
        function jn(e, r) {
          return ye(e) ? e : iu(e, r) ? [e] : Kf(Fe(e));
        }
        var R0 = Ce;
        function Xn(e, r, a) {
          var c = e.length;
          return a = a === i ? c : a, !r && a >= c ? e : Zt(e, r, a);
        }
        var Sf = Tv || function(e) {
          return gt.clearTimeout(e);
        };
        function Cf(e, r) {
          if (r)
            return e.slice();
          var a = e.length, c = zl ? zl(a) : new e.constructor(a);
          return e.copy(c), c;
        }
        function Qo(e) {
          var r = new e.constructor(e.byteLength);
          return new _s(r).set(new _s(e)), r;
        }
        function M0(e, r) {
          var a = r ? Qo(e.buffer) : e.buffer;
          return new e.constructor(a, e.byteOffset, e.byteLength);
        }
        function P0(e) {
          var r = new e.constructor(e.source, il.exec(e));
          return r.lastIndex = e.lastIndex, r;
        }
        function D0(e) {
          return Ai ? Be(Ai.call(e)) : {};
        }
        function xf(e, r) {
          var a = r ? Qo(e.buffer) : e.buffer;
          return new e.constructor(a, e.byteOffset, e.length);
        }
        function _f(e, r) {
          if (e !== r) {
            var a = e !== i, c = e === null, h = e === e, p = Ft(e), w = r !== i, S = r === null, I = r === r, F = Ft(r);
            if (!S && !F && !p && e > r || p && w && I && !S && !F || c && w && I || !a && I || !h)
              return 1;
            if (!c && !p && !F && e < r || F && a && h && !c && !p || S && a && h || !w && h || !I)
              return -1;
          }
          return 0;
        }
        function L0(e, r, a) {
          for (var c = -1, h = e.criteria, p = r.criteria, w = h.length, S = a.length; ++c < w; ) {
            var I = _f(h[c], p[c]);
            if (I) {
              if (c >= S)
                return I;
              var F = a[c];
              return I * (F == "desc" ? -1 : 1);
            }
          }
          return e.index - r.index;
        }
        function bf(e, r, a, c) {
          for (var h = -1, p = e.length, w = a.length, S = -1, I = r.length, F = lt(p - w, 0), W = k(I + F), z = !c; ++S < I; )
            W[S] = r[S];
          for (; ++h < w; )
            (z || h < p) && (W[a[h]] = e[h]);
          for (; F--; )
            W[S++] = e[h++];
          return W;
        }
        function Ef(e, r, a, c) {
          for (var h = -1, p = e.length, w = -1, S = a.length, I = -1, F = r.length, W = lt(p - S, 0), z = k(W + F), Z = !c; ++h < W; )
            z[h] = e[h];
          for (var ee = h; ++I < F; )
            z[ee + I] = r[I];
          for (; ++w < S; )
            (Z || h < p) && (z[ee + a[w]] = e[h++]);
          return z;
        }
        function Ot(e, r) {
          var a = -1, c = e.length;
          for (r || (r = k(c)); ++a < c; )
            r[a] = e[a];
          return r;
        }
        function yn(e, r, a, c) {
          var h = !a;
          a || (a = {});
          for (var p = -1, w = r.length; ++p < w; ) {
            var S = r[p], I = c ? c(a[S], e[S], S, a, e) : i;
            I === i && (I = e[S]), h ? kn(a, S, I) : Oi(a, S, I);
          }
          return a;
        }
        function F0(e, r) {
          return yn(e, ru(e), r);
        }
        function W0(e, r) {
          return yn(e, Wf(e), r);
        }
        function Ws(e, r) {
          return function(a, c) {
            var h = ye(a) ? Vy : o0, p = r ? r() : {};
            return h(a, e, ie(c, 2), p);
          };
        }
        function Vr(e) {
          return Ce(function(r, a) {
            var c = -1, h = a.length, p = h > 1 ? a[h - 1] : i, w = h > 2 ? a[2] : i;
            for (p = e.length > 3 && typeof p == "function" ? (h--, p) : i, w && _t(a[0], a[1], w) && (p = h < 3 ? i : p, h = 1), r = Be(r); ++c < h; ) {
              var S = a[c];
              S && e(r, S, c, p);
            }
            return r;
          });
        }
        function If(e, r) {
          return function(a, c) {
            if (a == null)
              return a;
            if (!kt(a))
              return e(a, c);
            for (var h = a.length, p = r ? h : -1, w = Be(a); (r ? p-- : ++p < h) && c(w[p], p, w) !== !1; )
              ;
            return a;
          };
        }
        function Af(e) {
          return function(r, a, c) {
            for (var h = -1, p = Be(r), w = c(r), S = w.length; S--; ) {
              var I = w[e ? S : ++h];
              if (a(p[I], I, p) === !1)
                break;
            }
            return r;
          };
        }
        function U0(e, r, a) {
          var c = r & R, h = Mi(e);
          function p() {
            var w = this && this !== gt && this instanceof p ? h : e;
            return w.apply(c ? a : this, arguments);
          }
          return p;
        }
        function Of(e) {
          return function(r) {
            r = Fe(r);
            var a = Lr(r) ? rn(r) : i, c = a ? a[0] : r.charAt(0), h = a ? Xn(a, 1).join("") : r.slice(1);
            return c[e]() + h;
          };
        }
        function Hr(e) {
          return function(r) {
            return So(Id(Ed(r).replace(ky, "")), e, "");
          };
        }
        function Mi(e) {
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return new e();
              case 1:
                return new e(r[0]);
              case 2:
                return new e(r[0], r[1]);
              case 3:
                return new e(r[0], r[1], r[2]);
              case 4:
                return new e(r[0], r[1], r[2], r[3]);
              case 5:
                return new e(r[0], r[1], r[2], r[3], r[4]);
              case 6:
                return new e(r[0], r[1], r[2], r[3], r[4], r[5]);
              case 7:
                return new e(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
            }
            var a = Br(e.prototype), c = e.apply(a, r);
            return Qe(c) ? c : a;
          };
        }
        function q0(e, r, a) {
          var c = Mi(e);
          function h() {
            for (var p = arguments.length, w = k(p), S = p, I = Gr(h); S--; )
              w[S] = arguments[S];
            var F = p < 3 && w[0] !== I && w[p - 1] !== I ? [] : Zn(w, I);
            if (p -= F.length, p < a)
              return Mf(
                e,
                r,
                Us,
                h.placeholder,
                i,
                w,
                F,
                i,
                i,
                a - p
              );
            var W = this && this !== gt && this instanceof h ? c : e;
            return Pt(W, this, w);
          }
          return h;
        }
        function kf(e) {
          return function(r, a, c) {
            var h = Be(r);
            if (!kt(r)) {
              var p = ie(a, 3);
              r = dt(r), a = function(S) {
                return p(h[S], S, h);
              };
            }
            var w = e(r, a, c);
            return w > -1 ? h[p ? r[w] : w] : i;
          };
        }
        function $f(e) {
          return Nn(function(r) {
            var a = r.length, c = a, h = Gt.prototype.thru;
            for (e && r.reverse(); c--; ) {
              var p = r[c];
              if (typeof p != "function")
                throw new Ht(l);
              if (h && !w && Vs(p) == "wrapper")
                var w = new Gt([], !0);
            }
            for (c = w ? c : a; ++c < a; ) {
              p = r[c];
              var S = Vs(p), I = S == "wrapper" ? tu(p) : i;
              I && su(I[0]) && I[1] == ($ | q | O | H) && !I[4].length && I[9] == 1 ? w = w[Vs(I[0])].apply(w, I[3]) : w = p.length == 1 && su(p) ? w[S]() : w.thru(p);
            }
            return function() {
              var F = arguments, W = F[0];
              if (w && F.length == 1 && ye(W))
                return w.plant(W).value();
              for (var z = 0, Z = a ? r[z].apply(this, F) : W; ++z < a; )
                Z = r[z].call(this, Z);
              return Z;
            };
          });
        }
        function Us(e, r, a, c, h, p, w, S, I, F) {
          var W = r & $, z = r & R, Z = r & L, ee = r & (q | P), se = r & re, Te = Z ? i : Mi(e);
          function ae() {
            for (var _e = arguments.length, Ee = k(_e), Wt = _e; Wt--; )
              Ee[Wt] = arguments[Wt];
            if (ee)
              var bt = Gr(ae), Ut = Xy(Ee, bt);
            if (c && (Ee = bf(Ee, c, h, ee)), p && (Ee = Ef(Ee, p, w, ee)), _e -= Ut, ee && _e < F) {
              var it = Zn(Ee, bt);
              return Mf(
                e,
                r,
                Us,
                ae.placeholder,
                a,
                Ee,
                it,
                S,
                I,
                F - _e
              );
            }
            var on = z ? a : this, Dn = Z ? on[e] : e;
            return _e = Ee.length, S ? Ee = o1(Ee, S) : se && _e > 1 && Ee.reverse(), W && I < _e && (Ee.length = I), this && this !== gt && this instanceof ae && (Dn = Te || Mi(Dn)), Dn.apply(on, Ee);
          }
          return ae;
        }
        function Nf(e, r) {
          return function(a, c) {
            return p0(a, e, r(c), {});
          };
        }
        function qs(e, r) {
          return function(a, c) {
            var h;
            if (a === i && c === i)
              return r;
            if (a !== i && (h = a), c !== i) {
              if (h === i)
                return c;
              typeof a == "string" || typeof c == "string" ? (a = Lt(a), c = Lt(c)) : (a = yf(a), c = yf(c)), h = e(a, c);
            }
            return h;
          };
        }
        function Jo(e) {
          return Nn(function(r) {
            return r = Ze(r, Dt(ie())), Ce(function(a) {
              var c = this;
              return e(r, function(h) {
                return Pt(h, c, a);
              });
            });
          });
        }
        function zs(e, r) {
          r = r === i ? " " : Lt(r);
          var a = r.length;
          if (a < 2)
            return a ? Vo(r, e) : r;
          var c = Vo(r, As(e / Fr(r)));
          return Lr(r) ? Xn(rn(c), 0, e).join("") : c.slice(0, e);
        }
        function z0(e, r, a, c) {
          var h = r & R, p = Mi(e);
          function w() {
            for (var S = -1, I = arguments.length, F = -1, W = c.length, z = k(W + I), Z = this && this !== gt && this instanceof w ? p : e; ++F < W; )
              z[F] = c[F];
            for (; I--; )
              z[F++] = arguments[++S];
            return Pt(Z, h ? a : this, z);
          }
          return w;
        }
        function Rf(e) {
          return function(r, a, c) {
            return c && typeof c != "number" && _t(r, a, c) && (a = c = i), r = Pn(r), a === i ? (a = r, r = 0) : a = Pn(a), c = c === i ? r < a ? 1 : -1 : Pn(c), I0(r, a, c, e);
          };
        }
        function Bs(e) {
          return function(r, a) {
            return typeof r == "string" && typeof a == "string" || (r = Qt(r), a = Qt(a)), e(r, a);
          };
        }
        function Mf(e, r, a, c, h, p, w, S, I, F) {
          var W = r & q, z = W ? w : i, Z = W ? i : w, ee = W ? p : i, se = W ? i : p;
          r |= W ? O : M, r &= ~(W ? M : O), r & U || (r &= -4);
          var Te = [
            e,
            r,
            h,
            ee,
            z,
            se,
            Z,
            S,
            I,
            F
          ], ae = a.apply(i, Te);
          return su(e) && Gf(ae, Te), ae.placeholder = c, Yf(ae, e, r);
        }
        function jo(e) {
          var r = ct[e];
          return function(a, c) {
            if (a = Qt(a), c = c == null ? 0 : vt(we(c), 292), c && Gl(a)) {
              var h = (Fe(a) + "e").split("e"), p = r(h[0] + "e" + (+h[1] + c));
              return h = (Fe(p) + "e").split("e"), +(h[0] + "e" + (+h[1] - c));
            }
            return r(a);
          };
        }
        var B0 = qr && 1 / vs(new qr([, -0]))[1] == X ? function(e) {
          return new qr(e);
        } : Tu;
        function Pf(e) {
          return function(r) {
            var a = wt(r);
            return a == yt ? Ao(r) : a == nn ? av(r) : jy(r, e(r));
          };
        }
        function $n(e, r, a, c, h, p, w, S) {
          var I = r & L;
          if (!I && typeof e != "function")
            throw new Ht(l);
          var F = c ? c.length : 0;
          if (F || (r &= -97, c = h = i), w = w === i ? w : lt(we(w), 0), S = S === i ? S : we(S), F -= h ? h.length : 0, r & M) {
            var W = c, z = h;
            c = h = i;
          }
          var Z = I ? i : tu(e), ee = [
            e,
            r,
            a,
            c,
            h,
            W,
            z,
            p,
            w,
            S
          ];
          if (Z && i1(ee, Z), e = ee[0], r = ee[1], a = ee[2], c = ee[3], h = ee[4], S = ee[9] = ee[9] === i ? I ? 0 : e.length : lt(ee[9] - F, 0), !S && r & (q | P) && (r &= -25), !r || r == R)
            var se = U0(e, r, a);
          else r == q || r == P ? se = q0(e, r, S) : (r == O || r == (R | O)) && !h.length ? se = z0(e, r, a, c) : se = Us.apply(i, ee);
          var Te = Z ? pf : Gf;
          return Yf(Te(se, ee), e, r);
        }
        function Df(e, r, a, c) {
          return e === i || an(e, Ur[a]) && !Le.call(c, a) ? r : e;
        }
        function Lf(e, r, a, c, h, p) {
          return Qe(e) && Qe(r) && (p.set(r, e), Ds(e, r, i, Lf, p), p.delete(r)), e;
        }
        function V0(e) {
          return Li(e) ? i : e;
        }
        function Ff(e, r, a, c, h, p) {
          var w = a & A, S = e.length, I = r.length;
          if (S != I && !(w && I > S))
            return !1;
          var F = p.get(e), W = p.get(r);
          if (F && W)
            return F == r && W == e;
          var z = -1, Z = !0, ee = a & _ ? new hr() : i;
          for (p.set(e, r), p.set(r, e); ++z < S; ) {
            var se = e[z], Te = r[z];
            if (c)
              var ae = w ? c(Te, se, z, r, e, p) : c(se, Te, z, e, r, p);
            if (ae !== i) {
              if (ae)
                continue;
              Z = !1;
              break;
            }
            if (ee) {
              if (!Co(r, function(_e, Ee) {
                if (!xi(ee, Ee) && (se === _e || h(se, _e, a, c, p)))
                  return ee.push(Ee);
              })) {
                Z = !1;
                break;
              }
            } else if (!(se === Te || h(se, Te, a, c, p))) {
              Z = !1;
              break;
            }
          }
          return p.delete(e), p.delete(r), Z;
        }
        function H0(e, r, a, c, h, p, w) {
          switch (a) {
            case Mr:
              if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
                return !1;
              e = e.buffer, r = r.buffer;
            case Ci:
              return !(e.byteLength != r.byteLength || !p(new _s(e), new _s(r)));
            case me:
            case ve:
            case Hn:
              return an(+e, +r);
            case Ke:
              return e.name == r.name && e.message == r.message;
            case wi:
            case Ti:
              return e == r + "";
            case yt:
              var S = Ao;
            case nn:
              var I = c & A;
              if (S || (S = vs), e.size != r.size && !I)
                return !1;
              var F = w.get(e);
              if (F)
                return F == r;
              c |= _, w.set(e, r);
              var W = Ff(S(e), S(r), c, h, p, w);
              return w.delete(e), W;
            case ds:
              if (Ai)
                return Ai.call(e) == Ai.call(r);
          }
          return !1;
        }
        function G0(e, r, a, c, h, p) {
          var w = a & A, S = Xo(e), I = S.length, F = Xo(r), W = F.length;
          if (I != W && !w)
            return !1;
          for (var z = I; z--; ) {
            var Z = S[z];
            if (!(w ? Z in r : Le.call(r, Z)))
              return !1;
          }
          var ee = p.get(e), se = p.get(r);
          if (ee && se)
            return ee == r && se == e;
          var Te = !0;
          p.set(e, r), p.set(r, e);
          for (var ae = w; ++z < I; ) {
            Z = S[z];
            var _e = e[Z], Ee = r[Z];
            if (c)
              var Wt = w ? c(Ee, _e, Z, r, e, p) : c(_e, Ee, Z, e, r, p);
            if (!(Wt === i ? _e === Ee || h(_e, Ee, a, c, p) : Wt)) {
              Te = !1;
              break;
            }
            ae || (ae = Z == "constructor");
          }
          if (Te && !ae) {
            var bt = e.constructor, Ut = r.constructor;
            bt != Ut && "constructor" in e && "constructor" in r && !(typeof bt == "function" && bt instanceof bt && typeof Ut == "function" && Ut instanceof Ut) && (Te = !1);
          }
          return p.delete(e), p.delete(r), Te;
        }
        function Nn(e) {
          return ou(Vf(e, i, Xf), e + "");
        }
        function Xo(e) {
          return rf(e, dt, ru);
        }
        function eu(e) {
          return rf(e, $t, Wf);
        }
        var tu = ks ? function(e) {
          return ks.get(e);
        } : Tu;
        function Vs(e) {
          for (var r = e.name + "", a = zr[r], c = Le.call(zr, r) ? a.length : 0; c--; ) {
            var h = a[c], p = h.func;
            if (p == null || p == e)
              return h.name;
          }
          return r;
        }
        function Gr(e) {
          var r = Le.call(g, "placeholder") ? g : e;
          return r.placeholder;
        }
        function ie() {
          var e = g.iteratee || vu;
          return e = e === vu ? of : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function Hs(e, r) {
          var a = e.__data__;
          return e1(r) ? a[typeof r == "string" ? "string" : "hash"] : a.map;
        }
        function nu(e) {
          for (var r = dt(e), a = r.length; a--; ) {
            var c = r[a], h = e[c];
            r[a] = [c, h, zf(h)];
          }
          return r;
        }
        function mr(e, r) {
          var a = rv(e, r);
          return af(a) ? a : i;
        }
        function Y0(e) {
          var r = Le.call(e, fr), a = e[fr];
          try {
            e[fr] = i;
            var c = !0;
          } catch {
          }
          var h = Cs.call(e);
          return c && (r ? e[fr] = a : delete e[fr]), h;
        }
        var ru = ko ? function(e) {
          return e == null ? [] : (e = Be(e), Gn(ko(e), function(r) {
            return Vl.call(e, r);
          }));
        } : Su, Wf = ko ? function(e) {
          for (var r = []; e; )
            Yn(r, ru(e)), e = bs(e);
          return r;
        } : Su, wt = xt;
        ($o && wt(new $o(new ArrayBuffer(1))) != Mr || bi && wt(new bi()) != yt || No && wt(No.resolve()) != el || qr && wt(new qr()) != nn || Ei && wt(new Ei()) != Si) && (wt = function(e) {
          var r = xt(e), a = r == In ? e.constructor : i, c = a ? yr(a) : "";
          if (c)
            switch (c) {
              case Ov:
                return Mr;
              case kv:
                return yt;
              case $v:
                return el;
              case Nv:
                return nn;
              case Rv:
                return Si;
            }
          return r;
        });
        function Z0(e, r, a) {
          for (var c = -1, h = a.length; ++c < h; ) {
            var p = a[c], w = p.size;
            switch (p.type) {
              case "drop":
                e += w;
                break;
              case "dropRight":
                r -= w;
                break;
              case "take":
                r = vt(r, e + w);
                break;
              case "takeRight":
                e = lt(e, r - w);
                break;
            }
          }
          return { start: e, end: r };
        }
        function K0(e) {
          var r = e.match(ty);
          return r ? r[1].split(ny) : [];
        }
        function Uf(e, r, a) {
          r = jn(r, e);
          for (var c = -1, h = r.length, p = !1; ++c < h; ) {
            var w = vn(r[c]);
            if (!(p = e != null && a(e, w)))
              break;
            e = e[w];
          }
          return p || ++c != h ? p : (h = e == null ? 0 : e.length, !!h && js(h) && Rn(w, h) && (ye(e) || vr(e)));
        }
        function Q0(e) {
          var r = e.length, a = new e.constructor(r);
          return r && typeof e[0] == "string" && Le.call(e, "index") && (a.index = e.index, a.input = e.input), a;
        }
        function qf(e) {
          return typeof e.constructor == "function" && !Pi(e) ? Br(bs(e)) : {};
        }
        function J0(e, r, a) {
          var c = e.constructor;
          switch (r) {
            case Ci:
              return Qo(e);
            case me:
            case ve:
              return new c(+e);
            case Mr:
              return M0(e, a);
            case to:
            case no:
            case ro:
            case io:
            case so:
            case ao:
            case oo:
            case uo:
            case co:
              return xf(e, a);
            case yt:
              return new c();
            case Hn:
            case Ti:
              return new c(e);
            case wi:
              return P0(e);
            case nn:
              return new c();
            case ds:
              return D0(e);
          }
        }
        function j0(e, r) {
          var a = r.length;
          if (!a)
            return e;
          var c = a - 1;
          return r[c] = (a > 1 ? "& " : "") + r[c], r = r.join(a > 2 ? ", " : " "), e.replace(ey, `{
/* [wrapped with ` + r + `] */
`);
        }
        function X0(e) {
          return ye(e) || vr(e) || !!(Hl && e && e[Hl]);
        }
        function Rn(e, r) {
          var a = typeof e;
          return r = r ?? ze, !!r && (a == "number" || a != "symbol" && fy.test(e)) && e > -1 && e % 1 == 0 && e < r;
        }
        function _t(e, r, a) {
          if (!Qe(a))
            return !1;
          var c = typeof r;
          return (c == "number" ? kt(a) && Rn(r, a.length) : c == "string" && r in a) ? an(a[r], e) : !1;
        }
        function iu(e, r) {
          if (ye(e))
            return !1;
          var a = typeof e;
          return a == "number" || a == "symbol" || a == "boolean" || e == null || Ft(e) ? !0 : Qm.test(e) || !Km.test(e) || r != null && e in Be(r);
        }
        function e1(e) {
          var r = typeof e;
          return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
        }
        function su(e) {
          var r = Vs(e), a = g[r];
          if (typeof a != "function" || !(r in be.prototype))
            return !1;
          if (e === a)
            return !0;
          var c = tu(a);
          return !!c && e === c[0];
        }
        function t1(e) {
          return !!ql && ql in e;
        }
        var n1 = Ts ? Mn : Cu;
        function Pi(e) {
          var r = e && e.constructor, a = typeof r == "function" && r.prototype || Ur;
          return e === a;
        }
        function zf(e) {
          return e === e && !Qe(e);
        }
        function Bf(e, r) {
          return function(a) {
            return a == null ? !1 : a[e] === r && (r !== i || e in Be(a));
          };
        }
        function r1(e) {
          var r = Qs(e, function(c) {
            return a.size === m && a.clear(), c;
          }), a = r.cache;
          return r;
        }
        function i1(e, r) {
          var a = e[1], c = r[1], h = a | c, p = h < (R | L | $), w = c == $ && a == q || c == $ && a == H && e[7].length <= r[8] || c == ($ | H) && r[7].length <= r[8] && a == q;
          if (!(p || w))
            return e;
          c & R && (e[2] = r[2], h |= a & R ? 0 : U);
          var S = r[3];
          if (S) {
            var I = e[3];
            e[3] = I ? bf(I, S, r[4]) : S, e[4] = I ? Zn(e[3], T) : r[4];
          }
          return S = r[5], S && (I = e[5], e[5] = I ? Ef(I, S, r[6]) : S, e[6] = I ? Zn(e[5], T) : r[6]), S = r[7], S && (e[7] = S), c & $ && (e[8] = e[8] == null ? r[8] : vt(e[8], r[8])), e[9] == null && (e[9] = r[9]), e[0] = r[0], e[1] = h, e;
        }
        function s1(e) {
          var r = [];
          if (e != null)
            for (var a in Be(e))
              r.push(a);
          return r;
        }
        function a1(e) {
          return Cs.call(e);
        }
        function Vf(e, r, a) {
          return r = lt(r === i ? e.length - 1 : r, 0), function() {
            for (var c = arguments, h = -1, p = lt(c.length - r, 0), w = k(p); ++h < p; )
              w[h] = c[r + h];
            h = -1;
            for (var S = k(r + 1); ++h < r; )
              S[h] = c[h];
            return S[r] = a(w), Pt(e, this, S);
          };
        }
        function Hf(e, r) {
          return r.length < 2 ? e : pr(e, Zt(r, 0, -1));
        }
        function o1(e, r) {
          for (var a = e.length, c = vt(r.length, a), h = Ot(e); c--; ) {
            var p = r[c];
            e[c] = Rn(p, a) ? h[p] : i;
          }
          return e;
        }
        function au(e, r) {
          if (!(r === "constructor" && typeof e[r] == "function") && r != "__proto__")
            return e[r];
        }
        var Gf = Zf(pf), Di = Cv || function(e, r) {
          return gt.setTimeout(e, r);
        }, ou = Zf(k0);
        function Yf(e, r, a) {
          var c = r + "";
          return ou(e, j0(c, u1(K0(c), a)));
        }
        function Zf(e) {
          var r = 0, a = 0;
          return function() {
            var c = Ev(), h = xe - (c - a);
            if (a = c, h > 0) {
              if (++r >= ue)
                return arguments[0];
            } else
              r = 0;
            return e.apply(i, arguments);
          };
        }
        function Gs(e, r) {
          var a = -1, c = e.length, h = c - 1;
          for (r = r === i ? c : r; ++a < r; ) {
            var p = Bo(a, h), w = e[p];
            e[p] = e[a], e[a] = w;
          }
          return e.length = r, e;
        }
        var Kf = r1(function(e) {
          var r = [];
          return e.charCodeAt(0) === 46 && r.push(""), e.replace(Jm, function(a, c, h, p) {
            r.push(h ? p.replace(sy, "$1") : c || a);
          }), r;
        });
        function vn(e) {
          if (typeof e == "string" || Ft(e))
            return e;
          var r = e + "";
          return r == "0" && 1 / e == -X ? "-0" : r;
        }
        function yr(e) {
          if (e != null) {
            try {
              return Ss.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function u1(e, r) {
          return Vt(te, function(a) {
            var c = "_." + a[0];
            r & a[1] && !ms(e, c) && e.push(c);
          }), e.sort();
        }
        function Qf(e) {
          if (e instanceof be)
            return e.clone();
          var r = new Gt(e.__wrapped__, e.__chain__);
          return r.__actions__ = Ot(e.__actions__), r.__index__ = e.__index__, r.__values__ = e.__values__, r;
        }
        function c1(e, r, a) {
          (a ? _t(e, r, a) : r === i) ? r = 1 : r = lt(we(r), 0);
          var c = e == null ? 0 : e.length;
          if (!c || r < 1)
            return [];
          for (var h = 0, p = 0, w = k(As(c / r)); h < c; )
            w[p++] = Zt(e, h, h += r);
          return w;
        }
        function l1(e) {
          for (var r = -1, a = e == null ? 0 : e.length, c = 0, h = []; ++r < a; ) {
            var p = e[r];
            p && (h[c++] = p);
          }
          return h;
        }
        function f1() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var r = k(e - 1), a = arguments[0], c = e; c--; )
            r[c - 1] = arguments[c];
          return Yn(ye(a) ? Ot(a) : [a], pt(r, 1));
        }
        var d1 = Ce(function(e, r) {
          return rt(e) ? ki(e, pt(r, 1, rt, !0)) : [];
        }), h1 = Ce(function(e, r) {
          var a = Kt(r);
          return rt(a) && (a = i), rt(e) ? ki(e, pt(r, 1, rt, !0), ie(a, 2)) : [];
        }), g1 = Ce(function(e, r) {
          var a = Kt(r);
          return rt(a) && (a = i), rt(e) ? ki(e, pt(r, 1, rt, !0), i, a) : [];
        });
        function p1(e, r, a) {
          var c = e == null ? 0 : e.length;
          return c ? (r = a || r === i ? 1 : we(r), Zt(e, r < 0 ? 0 : r, c)) : [];
        }
        function m1(e, r, a) {
          var c = e == null ? 0 : e.length;
          return c ? (r = a || r === i ? 1 : we(r), r = c - r, Zt(e, 0, r < 0 ? 0 : r)) : [];
        }
        function y1(e, r) {
          return e && e.length ? Fs(e, ie(r, 3), !0, !0) : [];
        }
        function v1(e, r) {
          return e && e.length ? Fs(e, ie(r, 3), !0) : [];
        }
        function w1(e, r, a, c) {
          var h = e == null ? 0 : e.length;
          return h ? (a && typeof a != "number" && _t(e, r, a) && (a = 0, c = h), f0(e, r, a, c)) : [];
        }
        function Jf(e, r, a) {
          var c = e == null ? 0 : e.length;
          if (!c)
            return -1;
          var h = a == null ? 0 : we(a);
          return h < 0 && (h = lt(c + h, 0)), ys(e, ie(r, 3), h);
        }
        function jf(e, r, a) {
          var c = e == null ? 0 : e.length;
          if (!c)
            return -1;
          var h = c - 1;
          return a !== i && (h = we(a), h = a < 0 ? lt(c + h, 0) : vt(h, c - 1)), ys(e, ie(r, 3), h, !0);
        }
        function Xf(e) {
          var r = e == null ? 0 : e.length;
          return r ? pt(e, 1) : [];
        }
        function T1(e) {
          var r = e == null ? 0 : e.length;
          return r ? pt(e, X) : [];
        }
        function S1(e, r) {
          var a = e == null ? 0 : e.length;
          return a ? (r = r === i ? 1 : we(r), pt(e, r)) : [];
        }
        function C1(e) {
          for (var r = -1, a = e == null ? 0 : e.length, c = {}; ++r < a; ) {
            var h = e[r];
            c[h[0]] = h[1];
          }
          return c;
        }
        function ed(e) {
          return e && e.length ? e[0] : i;
        }
        function x1(e, r, a) {
          var c = e == null ? 0 : e.length;
          if (!c)
            return -1;
          var h = a == null ? 0 : we(a);
          return h < 0 && (h = lt(c + h, 0)), Dr(e, r, h);
        }
        function _1(e) {
          var r = e == null ? 0 : e.length;
          return r ? Zt(e, 0, -1) : [];
        }
        var b1 = Ce(function(e) {
          var r = Ze(e, Zo);
          return r.length && r[0] === e[0] ? Fo(r) : [];
        }), E1 = Ce(function(e) {
          var r = Kt(e), a = Ze(e, Zo);
          return r === Kt(a) ? r = i : a.pop(), a.length && a[0] === e[0] ? Fo(a, ie(r, 2)) : [];
        }), I1 = Ce(function(e) {
          var r = Kt(e), a = Ze(e, Zo);
          return r = typeof r == "function" ? r : i, r && a.pop(), a.length && a[0] === e[0] ? Fo(a, i, r) : [];
        });
        function A1(e, r) {
          return e == null ? "" : _v.call(e, r);
        }
        function Kt(e) {
          var r = e == null ? 0 : e.length;
          return r ? e[r - 1] : i;
        }
        function O1(e, r, a) {
          var c = e == null ? 0 : e.length;
          if (!c)
            return -1;
          var h = c;
          return a !== i && (h = we(a), h = h < 0 ? lt(c + h, 0) : vt(h, c - 1)), r === r ? uv(e, r, h) : ys(e, Rl, h, !0);
        }
        function k1(e, r) {
          return e && e.length ? ff(e, we(r)) : i;
        }
        var $1 = Ce(td);
        function td(e, r) {
          return e && e.length && r && r.length ? zo(e, r) : e;
        }
        function N1(e, r, a) {
          return e && e.length && r && r.length ? zo(e, r, ie(a, 2)) : e;
        }
        function R1(e, r, a) {
          return e && e.length && r && r.length ? zo(e, r, i, a) : e;
        }
        var M1 = Nn(function(e, r) {
          var a = e == null ? 0 : e.length, c = Mo(e, r);
          return gf(e, Ze(r, function(h) {
            return Rn(h, a) ? +h : h;
          }).sort(_f)), c;
        });
        function P1(e, r) {
          var a = [];
          if (!(e && e.length))
            return a;
          var c = -1, h = [], p = e.length;
          for (r = ie(r, 3); ++c < p; ) {
            var w = e[c];
            r(w, c, e) && (a.push(w), h.push(c));
          }
          return gf(e, h), a;
        }
        function uu(e) {
          return e == null ? e : Av.call(e);
        }
        function D1(e, r, a) {
          var c = e == null ? 0 : e.length;
          return c ? (a && typeof a != "number" && _t(e, r, a) ? (r = 0, a = c) : (r = r == null ? 0 : we(r), a = a === i ? c : we(a)), Zt(e, r, a)) : [];
        }
        function L1(e, r) {
          return Ls(e, r);
        }
        function F1(e, r, a) {
          return Ho(e, r, ie(a, 2));
        }
        function W1(e, r) {
          var a = e == null ? 0 : e.length;
          if (a) {
            var c = Ls(e, r);
            if (c < a && an(e[c], r))
              return c;
          }
          return -1;
        }
        function U1(e, r) {
          return Ls(e, r, !0);
        }
        function q1(e, r, a) {
          return Ho(e, r, ie(a, 2), !0);
        }
        function z1(e, r) {
          var a = e == null ? 0 : e.length;
          if (a) {
            var c = Ls(e, r, !0) - 1;
            if (an(e[c], r))
              return c;
          }
          return -1;
        }
        function B1(e) {
          return e && e.length ? mf(e) : [];
        }
        function V1(e, r) {
          return e && e.length ? mf(e, ie(r, 2)) : [];
        }
        function H1(e) {
          var r = e == null ? 0 : e.length;
          return r ? Zt(e, 1, r) : [];
        }
        function G1(e, r, a) {
          return e && e.length ? (r = a || r === i ? 1 : we(r), Zt(e, 0, r < 0 ? 0 : r)) : [];
        }
        function Y1(e, r, a) {
          var c = e == null ? 0 : e.length;
          return c ? (r = a || r === i ? 1 : we(r), r = c - r, Zt(e, r < 0 ? 0 : r, c)) : [];
        }
        function Z1(e, r) {
          return e && e.length ? Fs(e, ie(r, 3), !1, !0) : [];
        }
        function K1(e, r) {
          return e && e.length ? Fs(e, ie(r, 3)) : [];
        }
        var Q1 = Ce(function(e) {
          return Jn(pt(e, 1, rt, !0));
        }), J1 = Ce(function(e) {
          var r = Kt(e);
          return rt(r) && (r = i), Jn(pt(e, 1, rt, !0), ie(r, 2));
        }), j1 = Ce(function(e) {
          var r = Kt(e);
          return r = typeof r == "function" ? r : i, Jn(pt(e, 1, rt, !0), i, r);
        });
        function X1(e) {
          return e && e.length ? Jn(e) : [];
        }
        function ew(e, r) {
          return e && e.length ? Jn(e, ie(r, 2)) : [];
        }
        function tw(e, r) {
          return r = typeof r == "function" ? r : i, e && e.length ? Jn(e, i, r) : [];
        }
        function cu(e) {
          if (!(e && e.length))
            return [];
          var r = 0;
          return e = Gn(e, function(a) {
            if (rt(a))
              return r = lt(a.length, r), !0;
          }), Eo(r, function(a) {
            return Ze(e, xo(a));
          });
        }
        function nd(e, r) {
          if (!(e && e.length))
            return [];
          var a = cu(e);
          return r == null ? a : Ze(a, function(c) {
            return Pt(r, i, c);
          });
        }
        var nw = Ce(function(e, r) {
          return rt(e) ? ki(e, r) : [];
        }), rw = Ce(function(e) {
          return Yo(Gn(e, rt));
        }), iw = Ce(function(e) {
          var r = Kt(e);
          return rt(r) && (r = i), Yo(Gn(e, rt), ie(r, 2));
        }), sw = Ce(function(e) {
          var r = Kt(e);
          return r = typeof r == "function" ? r : i, Yo(Gn(e, rt), i, r);
        }), aw = Ce(cu);
        function ow(e, r) {
          return Tf(e || [], r || [], Oi);
        }
        function uw(e, r) {
          return Tf(e || [], r || [], Ri);
        }
        var cw = Ce(function(e) {
          var r = e.length, a = r > 1 ? e[r - 1] : i;
          return a = typeof a == "function" ? (e.pop(), a) : i, nd(e, a);
        });
        function rd(e) {
          var r = g(e);
          return r.__chain__ = !0, r;
        }
        function lw(e, r) {
          return r(e), e;
        }
        function Ys(e, r) {
          return r(e);
        }
        var fw = Nn(function(e) {
          var r = e.length, a = r ? e[0] : 0, c = this.__wrapped__, h = function(p) {
            return Mo(p, e);
          };
          return r > 1 || this.__actions__.length || !(c instanceof be) || !Rn(a) ? this.thru(h) : (c = c.slice(a, +a + (r ? 1 : 0)), c.__actions__.push({
            func: Ys,
            args: [h],
            thisArg: i
          }), new Gt(c, this.__chain__).thru(function(p) {
            return r && !p.length && p.push(i), p;
          }));
        });
        function dw() {
          return rd(this);
        }
        function hw() {
          return new Gt(this.value(), this.__chain__);
        }
        function gw() {
          this.__values__ === i && (this.__values__ = yd(this.value()));
          var e = this.__index__ >= this.__values__.length, r = e ? i : this.__values__[this.__index__++];
          return { done: e, value: r };
        }
        function pw() {
          return this;
        }
        function mw(e) {
          for (var r, a = this; a instanceof Ns; ) {
            var c = Qf(a);
            c.__index__ = 0, c.__values__ = i, r ? h.__wrapped__ = c : r = c;
            var h = c;
            a = a.__wrapped__;
          }
          return h.__wrapped__ = e, r;
        }
        function yw() {
          var e = this.__wrapped__;
          if (e instanceof be) {
            var r = e;
            return this.__actions__.length && (r = new be(this)), r = r.reverse(), r.__actions__.push({
              func: Ys,
              args: [uu],
              thisArg: i
            }), new Gt(r, this.__chain__);
          }
          return this.thru(uu);
        }
        function vw() {
          return wf(this.__wrapped__, this.__actions__);
        }
        var ww = Ws(function(e, r, a) {
          Le.call(e, a) ? ++e[a] : kn(e, a, 1);
        });
        function Tw(e, r, a) {
          var c = ye(e) ? $l : l0;
          return a && _t(e, r, a) && (r = i), c(e, ie(r, 3));
        }
        function Sw(e, r) {
          var a = ye(e) ? Gn : tf;
          return a(e, ie(r, 3));
        }
        var Cw = kf(Jf), xw = kf(jf);
        function _w(e, r) {
          return pt(Zs(e, r), 1);
        }
        function bw(e, r) {
          return pt(Zs(e, r), X);
        }
        function Ew(e, r, a) {
          return a = a === i ? 1 : we(a), pt(Zs(e, r), a);
        }
        function id(e, r) {
          var a = ye(e) ? Vt : Qn;
          return a(e, ie(r, 3));
        }
        function sd(e, r) {
          var a = ye(e) ? Hy : ef;
          return a(e, ie(r, 3));
        }
        var Iw = Ws(function(e, r, a) {
          Le.call(e, a) ? e[a].push(r) : kn(e, a, [r]);
        });
        function Aw(e, r, a, c) {
          e = kt(e) ? e : Zr(e), a = a && !c ? we(a) : 0;
          var h = e.length;
          return a < 0 && (a = lt(h + a, 0)), Xs(e) ? a <= h && e.indexOf(r, a) > -1 : !!h && Dr(e, r, a) > -1;
        }
        var Ow = Ce(function(e, r, a) {
          var c = -1, h = typeof r == "function", p = kt(e) ? k(e.length) : [];
          return Qn(e, function(w) {
            p[++c] = h ? Pt(r, w, a) : $i(w, r, a);
          }), p;
        }), kw = Ws(function(e, r, a) {
          kn(e, a, r);
        });
        function Zs(e, r) {
          var a = ye(e) ? Ze : uf;
          return a(e, ie(r, 3));
        }
        function $w(e, r, a, c) {
          return e == null ? [] : (ye(r) || (r = r == null ? [] : [r]), a = c ? i : a, ye(a) || (a = a == null ? [] : [a]), df(e, r, a));
        }
        var Nw = Ws(function(e, r, a) {
          e[a ? 0 : 1].push(r);
        }, function() {
          return [[], []];
        });
        function Rw(e, r, a) {
          var c = ye(e) ? So : Pl, h = arguments.length < 3;
          return c(e, ie(r, 4), a, h, Qn);
        }
        function Mw(e, r, a) {
          var c = ye(e) ? Gy : Pl, h = arguments.length < 3;
          return c(e, ie(r, 4), a, h, ef);
        }
        function Pw(e, r) {
          var a = ye(e) ? Gn : tf;
          return a(e, Js(ie(r, 3)));
        }
        function Dw(e) {
          var r = ye(e) ? Ql : A0;
          return r(e);
        }
        function Lw(e, r, a) {
          (a ? _t(e, r, a) : r === i) ? r = 1 : r = we(r);
          var c = ye(e) ? s0 : O0;
          return c(e, r);
        }
        function Fw(e) {
          var r = ye(e) ? a0 : $0;
          return r(e);
        }
        function Ww(e) {
          if (e == null)
            return 0;
          if (kt(e))
            return Xs(e) ? Fr(e) : e.length;
          var r = wt(e);
          return r == yt || r == nn ? e.size : Uo(e).length;
        }
        function Uw(e, r, a) {
          var c = ye(e) ? Co : N0;
          return a && _t(e, r, a) && (r = i), c(e, ie(r, 3));
        }
        var qw = Ce(function(e, r) {
          if (e == null)
            return [];
          var a = r.length;
          return a > 1 && _t(e, r[0], r[1]) ? r = [] : a > 2 && _t(r[0], r[1], r[2]) && (r = [r[0]]), df(e, pt(r, 1), []);
        }), Ks = Sv || function() {
          return gt.Date.now();
        };
        function zw(e, r) {
          if (typeof r != "function")
            throw new Ht(l);
          return e = we(e), function() {
            if (--e < 1)
              return r.apply(this, arguments);
          };
        }
        function ad(e, r, a) {
          return r = a ? i : r, r = e && r == null ? e.length : r, $n(e, $, i, i, i, i, r);
        }
        function od(e, r) {
          var a;
          if (typeof r != "function")
            throw new Ht(l);
          return e = we(e), function() {
            return --e > 0 && (a = r.apply(this, arguments)), e <= 1 && (r = i), a;
          };
        }
        var lu = Ce(function(e, r, a) {
          var c = R;
          if (a.length) {
            var h = Zn(a, Gr(lu));
            c |= O;
          }
          return $n(e, c, r, a, h);
        }), ud = Ce(function(e, r, a) {
          var c = R | L;
          if (a.length) {
            var h = Zn(a, Gr(ud));
            c |= O;
          }
          return $n(r, c, e, a, h);
        });
        function cd(e, r, a) {
          r = a ? i : r;
          var c = $n(e, q, i, i, i, i, i, r);
          return c.placeholder = cd.placeholder, c;
        }
        function ld(e, r, a) {
          r = a ? i : r;
          var c = $n(e, P, i, i, i, i, i, r);
          return c.placeholder = ld.placeholder, c;
        }
        function fd(e, r, a) {
          var c, h, p, w, S, I, F = 0, W = !1, z = !1, Z = !0;
          if (typeof e != "function")
            throw new Ht(l);
          r = Qt(r) || 0, Qe(a) && (W = !!a.leading, z = "maxWait" in a, p = z ? lt(Qt(a.maxWait) || 0, r) : p, Z = "trailing" in a ? !!a.trailing : Z);
          function ee(it) {
            var on = c, Dn = h;
            return c = h = i, F = it, w = e.apply(Dn, on), w;
          }
          function se(it) {
            return F = it, S = Di(_e, r), W ? ee(it) : w;
          }
          function Te(it) {
            var on = it - I, Dn = it - F, kd = r - on;
            return z ? vt(kd, p - Dn) : kd;
          }
          function ae(it) {
            var on = it - I, Dn = it - F;
            return I === i || on >= r || on < 0 || z && Dn >= p;
          }
          function _e() {
            var it = Ks();
            if (ae(it))
              return Ee(it);
            S = Di(_e, Te(it));
          }
          function Ee(it) {
            return S = i, Z && c ? ee(it) : (c = h = i, w);
          }
          function Wt() {
            S !== i && Sf(S), F = 0, c = I = h = S = i;
          }
          function bt() {
            return S === i ? w : Ee(Ks());
          }
          function Ut() {
            var it = Ks(), on = ae(it);
            if (c = arguments, h = this, I = it, on) {
              if (S === i)
                return se(I);
              if (z)
                return Sf(S), S = Di(_e, r), ee(I);
            }
            return S === i && (S = Di(_e, r)), w;
          }
          return Ut.cancel = Wt, Ut.flush = bt, Ut;
        }
        var Bw = Ce(function(e, r) {
          return Xl(e, 1, r);
        }), Vw = Ce(function(e, r, a) {
          return Xl(e, Qt(r) || 0, a);
        });
        function Hw(e) {
          return $n(e, re);
        }
        function Qs(e, r) {
          if (typeof e != "function" || r != null && typeof r != "function")
            throw new Ht(l);
          var a = function() {
            var c = arguments, h = r ? r.apply(this, c) : c[0], p = a.cache;
            if (p.has(h))
              return p.get(h);
            var w = e.apply(this, c);
            return a.cache = p.set(h, w) || p, w;
          };
          return a.cache = new (Qs.Cache || On)(), a;
        }
        Qs.Cache = On;
        function Js(e) {
          if (typeof e != "function")
            throw new Ht(l);
          return function() {
            var r = arguments;
            switch (r.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, r[0]);
              case 2:
                return !e.call(this, r[0], r[1]);
              case 3:
                return !e.call(this, r[0], r[1], r[2]);
            }
            return !e.apply(this, r);
          };
        }
        function Gw(e) {
          return od(2, e);
        }
        var Yw = R0(function(e, r) {
          r = r.length == 1 && ye(r[0]) ? Ze(r[0], Dt(ie())) : Ze(pt(r, 1), Dt(ie()));
          var a = r.length;
          return Ce(function(c) {
            for (var h = -1, p = vt(c.length, a); ++h < p; )
              c[h] = r[h].call(this, c[h]);
            return Pt(e, this, c);
          });
        }), fu = Ce(function(e, r) {
          var a = Zn(r, Gr(fu));
          return $n(e, O, i, r, a);
        }), dd = Ce(function(e, r) {
          var a = Zn(r, Gr(dd));
          return $n(e, M, i, r, a);
        }), Zw = Nn(function(e, r) {
          return $n(e, H, i, i, i, r);
        });
        function Kw(e, r) {
          if (typeof e != "function")
            throw new Ht(l);
          return r = r === i ? r : we(r), Ce(e, r);
        }
        function Qw(e, r) {
          if (typeof e != "function")
            throw new Ht(l);
          return r = r == null ? 0 : lt(we(r), 0), Ce(function(a) {
            var c = a[r], h = Xn(a, 0, r);
            return c && Yn(h, c), Pt(e, this, h);
          });
        }
        function Jw(e, r, a) {
          var c = !0, h = !0;
          if (typeof e != "function")
            throw new Ht(l);
          return Qe(a) && (c = "leading" in a ? !!a.leading : c, h = "trailing" in a ? !!a.trailing : h), fd(e, r, {
            leading: c,
            maxWait: r,
            trailing: h
          });
        }
        function jw(e) {
          return ad(e, 1);
        }
        function Xw(e, r) {
          return fu(Ko(r), e);
        }
        function eT() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return ye(e) ? e : [e];
        }
        function tT(e) {
          return Yt(e, C);
        }
        function nT(e, r) {
          return r = typeof r == "function" ? r : i, Yt(e, C, r);
        }
        function rT(e) {
          return Yt(e, v | C);
        }
        function iT(e, r) {
          return r = typeof r == "function" ? r : i, Yt(e, v | C, r);
        }
        function sT(e, r) {
          return r == null || jl(e, r, dt(r));
        }
        function an(e, r) {
          return e === r || e !== e && r !== r;
        }
        var aT = Bs(Lo), oT = Bs(function(e, r) {
          return e >= r;
        }), vr = sf(/* @__PURE__ */ function() {
          return arguments;
        }()) ? sf : function(e) {
          return et(e) && Le.call(e, "callee") && !Vl.call(e, "callee");
        }, ye = k.isArray, uT = bl ? Dt(bl) : m0;
        function kt(e) {
          return e != null && js(e.length) && !Mn(e);
        }
        function rt(e) {
          return et(e) && kt(e);
        }
        function cT(e) {
          return e === !0 || e === !1 || et(e) && xt(e) == me;
        }
        var er = xv || Cu, lT = El ? Dt(El) : y0;
        function fT(e) {
          return et(e) && e.nodeType === 1 && !Li(e);
        }
        function dT(e) {
          if (e == null)
            return !0;
          if (kt(e) && (ye(e) || typeof e == "string" || typeof e.splice == "function" || er(e) || Yr(e) || vr(e)))
            return !e.length;
          var r = wt(e);
          if (r == yt || r == nn)
            return !e.size;
          if (Pi(e))
            return !Uo(e).length;
          for (var a in e)
            if (Le.call(e, a))
              return !1;
          return !0;
        }
        function hT(e, r) {
          return Ni(e, r);
        }
        function gT(e, r, a) {
          a = typeof a == "function" ? a : i;
          var c = a ? a(e, r) : i;
          return c === i ? Ni(e, r, i, a) : !!c;
        }
        function du(e) {
          if (!et(e))
            return !1;
          var r = xt(e);
          return r == Ke || r == he || typeof e.message == "string" && typeof e.name == "string" && !Li(e);
        }
        function pT(e) {
          return typeof e == "number" && Gl(e);
        }
        function Mn(e) {
          if (!Qe(e))
            return !1;
          var r = xt(e);
          return r == G || r == Xe || r == le || r == Wm;
        }
        function hd(e) {
          return typeof e == "number" && e == we(e);
        }
        function js(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ze;
        }
        function Qe(e) {
          var r = typeof e;
          return e != null && (r == "object" || r == "function");
        }
        function et(e) {
          return e != null && typeof e == "object";
        }
        var gd = Il ? Dt(Il) : w0;
        function mT(e, r) {
          return e === r || Wo(e, r, nu(r));
        }
        function yT(e, r, a) {
          return a = typeof a == "function" ? a : i, Wo(e, r, nu(r), a);
        }
        function vT(e) {
          return pd(e) && e != +e;
        }
        function wT(e) {
          if (n1(e))
            throw new ge(u);
          return af(e);
        }
        function TT(e) {
          return e === null;
        }
        function ST(e) {
          return e == null;
        }
        function pd(e) {
          return typeof e == "number" || et(e) && xt(e) == Hn;
        }
        function Li(e) {
          if (!et(e) || xt(e) != In)
            return !1;
          var r = bs(e);
          if (r === null)
            return !0;
          var a = Le.call(r, "constructor") && r.constructor;
          return typeof a == "function" && a instanceof a && Ss.call(a) == yv;
        }
        var hu = Al ? Dt(Al) : T0;
        function CT(e) {
          return hd(e) && e >= -ze && e <= ze;
        }
        var md = Ol ? Dt(Ol) : S0;
        function Xs(e) {
          return typeof e == "string" || !ye(e) && et(e) && xt(e) == Ti;
        }
        function Ft(e) {
          return typeof e == "symbol" || et(e) && xt(e) == ds;
        }
        var Yr = kl ? Dt(kl) : C0;
        function xT(e) {
          return e === i;
        }
        function _T(e) {
          return et(e) && wt(e) == Si;
        }
        function bT(e) {
          return et(e) && xt(e) == qm;
        }
        var ET = Bs(qo), IT = Bs(function(e, r) {
          return e <= r;
        });
        function yd(e) {
          if (!e)
            return [];
          if (kt(e))
            return Xs(e) ? rn(e) : Ot(e);
          if (_i && e[_i])
            return sv(e[_i]());
          var r = wt(e), a = r == yt ? Ao : r == nn ? vs : Zr;
          return a(e);
        }
        function Pn(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = Qt(e), e === X || e === -X) {
            var r = e < 0 ? -1 : 1;
            return r * je;
          }
          return e === e ? e : 0;
        }
        function we(e) {
          var r = Pn(e), a = r % 1;
          return r === r ? a ? r - a : r : 0;
        }
        function vd(e) {
          return e ? gr(we(e), 0, V) : 0;
        }
        function Qt(e) {
          if (typeof e == "number")
            return e;
          if (Ft(e))
            return B;
          if (Qe(e)) {
            var r = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = Qe(r) ? r + "" : r;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = Dl(e);
          var a = uy.test(e);
          return a || ly.test(e) ? zy(e.slice(2), a ? 2 : 8) : oy.test(e) ? B : +e;
        }
        function wd(e) {
          return yn(e, $t(e));
        }
        function AT(e) {
          return e ? gr(we(e), -ze, ze) : e === 0 ? e : 0;
        }
        function Fe(e) {
          return e == null ? "" : Lt(e);
        }
        var OT = Vr(function(e, r) {
          if (Pi(r) || kt(r)) {
            yn(r, dt(r), e);
            return;
          }
          for (var a in r)
            Le.call(r, a) && Oi(e, a, r[a]);
        }), Td = Vr(function(e, r) {
          yn(r, $t(r), e);
        }), ea = Vr(function(e, r, a, c) {
          yn(r, $t(r), e, c);
        }), kT = Vr(function(e, r, a, c) {
          yn(r, dt(r), e, c);
        }), $T = Nn(Mo);
        function NT(e, r) {
          var a = Br(e);
          return r == null ? a : Jl(a, r);
        }
        var RT = Ce(function(e, r) {
          e = Be(e);
          var a = -1, c = r.length, h = c > 2 ? r[2] : i;
          for (h && _t(r[0], r[1], h) && (c = 1); ++a < c; )
            for (var p = r[a], w = $t(p), S = -1, I = w.length; ++S < I; ) {
              var F = w[S], W = e[F];
              (W === i || an(W, Ur[F]) && !Le.call(e, F)) && (e[F] = p[F]);
            }
          return e;
        }), MT = Ce(function(e) {
          return e.push(i, Lf), Pt(Sd, i, e);
        });
        function PT(e, r) {
          return Nl(e, ie(r, 3), mn);
        }
        function DT(e, r) {
          return Nl(e, ie(r, 3), Do);
        }
        function LT(e, r) {
          return e == null ? e : Po(e, ie(r, 3), $t);
        }
        function FT(e, r) {
          return e == null ? e : nf(e, ie(r, 3), $t);
        }
        function WT(e, r) {
          return e && mn(e, ie(r, 3));
        }
        function UT(e, r) {
          return e && Do(e, ie(r, 3));
        }
        function qT(e) {
          return e == null ? [] : Ps(e, dt(e));
        }
        function zT(e) {
          return e == null ? [] : Ps(e, $t(e));
        }
        function gu(e, r, a) {
          var c = e == null ? i : pr(e, r);
          return c === i ? a : c;
        }
        function BT(e, r) {
          return e != null && Uf(e, r, d0);
        }
        function pu(e, r) {
          return e != null && Uf(e, r, h0);
        }
        var VT = Nf(function(e, r, a) {
          r != null && typeof r.toString != "function" && (r = Cs.call(r)), e[r] = a;
        }, yu(Nt)), HT = Nf(function(e, r, a) {
          r != null && typeof r.toString != "function" && (r = Cs.call(r)), Le.call(e, r) ? e[r].push(a) : e[r] = [a];
        }, ie), GT = Ce($i);
        function dt(e) {
          return kt(e) ? Kl(e) : Uo(e);
        }
        function $t(e) {
          return kt(e) ? Kl(e, !0) : x0(e);
        }
        function YT(e, r) {
          var a = {};
          return r = ie(r, 3), mn(e, function(c, h, p) {
            kn(a, r(c, h, p), c);
          }), a;
        }
        function ZT(e, r) {
          var a = {};
          return r = ie(r, 3), mn(e, function(c, h, p) {
            kn(a, h, r(c, h, p));
          }), a;
        }
        var KT = Vr(function(e, r, a) {
          Ds(e, r, a);
        }), Sd = Vr(function(e, r, a, c) {
          Ds(e, r, a, c);
        }), QT = Nn(function(e, r) {
          var a = {};
          if (e == null)
            return a;
          var c = !1;
          r = Ze(r, function(p) {
            return p = jn(p, e), c || (c = p.length > 1), p;
          }), yn(e, eu(e), a), c && (a = Yt(a, v | x | C, V0));
          for (var h = r.length; h--; )
            Go(a, r[h]);
          return a;
        });
        function JT(e, r) {
          return Cd(e, Js(ie(r)));
        }
        var jT = Nn(function(e, r) {
          return e == null ? {} : b0(e, r);
        });
        function Cd(e, r) {
          if (e == null)
            return {};
          var a = Ze(eu(e), function(c) {
            return [c];
          });
          return r = ie(r), hf(e, a, function(c, h) {
            return r(c, h[0]);
          });
        }
        function XT(e, r, a) {
          r = jn(r, e);
          var c = -1, h = r.length;
          for (h || (h = 1, e = i); ++c < h; ) {
            var p = e == null ? i : e[vn(r[c])];
            p === i && (c = h, p = a), e = Mn(p) ? p.call(e) : p;
          }
          return e;
        }
        function eS(e, r, a) {
          return e == null ? e : Ri(e, r, a);
        }
        function tS(e, r, a, c) {
          return c = typeof c == "function" ? c : i, e == null ? e : Ri(e, r, a, c);
        }
        var xd = Pf(dt), _d = Pf($t);
        function nS(e, r, a) {
          var c = ye(e), h = c || er(e) || Yr(e);
          if (r = ie(r, 4), a == null) {
            var p = e && e.constructor;
            h ? a = c ? new p() : [] : Qe(e) ? a = Mn(p) ? Br(bs(e)) : {} : a = {};
          }
          return (h ? Vt : mn)(e, function(w, S, I) {
            return r(a, w, S, I);
          }), a;
        }
        function rS(e, r) {
          return e == null ? !0 : Go(e, r);
        }
        function iS(e, r, a) {
          return e == null ? e : vf(e, r, Ko(a));
        }
        function sS(e, r, a, c) {
          return c = typeof c == "function" ? c : i, e == null ? e : vf(e, r, Ko(a), c);
        }
        function Zr(e) {
          return e == null ? [] : Io(e, dt(e));
        }
        function aS(e) {
          return e == null ? [] : Io(e, $t(e));
        }
        function oS(e, r, a) {
          return a === i && (a = r, r = i), a !== i && (a = Qt(a), a = a === a ? a : 0), r !== i && (r = Qt(r), r = r === r ? r : 0), gr(Qt(e), r, a);
        }
        function uS(e, r, a) {
          return r = Pn(r), a === i ? (a = r, r = 0) : a = Pn(a), e = Qt(e), g0(e, r, a);
        }
        function cS(e, r, a) {
          if (a && typeof a != "boolean" && _t(e, r, a) && (r = a = i), a === i && (typeof r == "boolean" ? (a = r, r = i) : typeof e == "boolean" && (a = e, e = i)), e === i && r === i ? (e = 0, r = 1) : (e = Pn(e), r === i ? (r = e, e = 0) : r = Pn(r)), e > r) {
            var c = e;
            e = r, r = c;
          }
          if (a || e % 1 || r % 1) {
            var h = Yl();
            return vt(e + h * (r - e + qy("1e-" + ((h + "").length - 1))), r);
          }
          return Bo(e, r);
        }
        var lS = Hr(function(e, r, a) {
          return r = r.toLowerCase(), e + (a ? bd(r) : r);
        });
        function bd(e) {
          return mu(Fe(e).toLowerCase());
        }
        function Ed(e) {
          return e = Fe(e), e && e.replace(dy, ev).replace($y, "");
        }
        function fS(e, r, a) {
          e = Fe(e), r = Lt(r);
          var c = e.length;
          a = a === i ? c : gr(we(a), 0, c);
          var h = a;
          return a -= r.length, a >= 0 && e.slice(a, h) == r;
        }
        function dS(e) {
          return e = Fe(e), e && Gm.test(e) ? e.replace(nl, tv) : e;
        }
        function hS(e) {
          return e = Fe(e), e && jm.test(e) ? e.replace(lo, "\\$&") : e;
        }
        var gS = Hr(function(e, r, a) {
          return e + (a ? "-" : "") + r.toLowerCase();
        }), pS = Hr(function(e, r, a) {
          return e + (a ? " " : "") + r.toLowerCase();
        }), mS = Of("toLowerCase");
        function yS(e, r, a) {
          e = Fe(e), r = we(r);
          var c = r ? Fr(e) : 0;
          if (!r || c >= r)
            return e;
          var h = (r - c) / 2;
          return zs(Os(h), a) + e + zs(As(h), a);
        }
        function vS(e, r, a) {
          e = Fe(e), r = we(r);
          var c = r ? Fr(e) : 0;
          return r && c < r ? e + zs(r - c, a) : e;
        }
        function wS(e, r, a) {
          e = Fe(e), r = we(r);
          var c = r ? Fr(e) : 0;
          return r && c < r ? zs(r - c, a) + e : e;
        }
        function TS(e, r, a) {
          return a || r == null ? r = 0 : r && (r = +r), Iv(Fe(e).replace(fo, ""), r || 0);
        }
        function SS(e, r, a) {
          return (a ? _t(e, r, a) : r === i) ? r = 1 : r = we(r), Vo(Fe(e), r);
        }
        function CS() {
          var e = arguments, r = Fe(e[0]);
          return e.length < 3 ? r : r.replace(e[1], e[2]);
        }
        var xS = Hr(function(e, r, a) {
          return e + (a ? "_" : "") + r.toLowerCase();
        });
        function _S(e, r, a) {
          return a && typeof a != "number" && _t(e, r, a) && (r = a = i), a = a === i ? V : a >>> 0, a ? (e = Fe(e), e && (typeof r == "string" || r != null && !hu(r)) && (r = Lt(r), !r && Lr(e)) ? Xn(rn(e), 0, a) : e.split(r, a)) : [];
        }
        var bS = Hr(function(e, r, a) {
          return e + (a ? " " : "") + mu(r);
        });
        function ES(e, r, a) {
          return e = Fe(e), a = a == null ? 0 : gr(we(a), 0, e.length), r = Lt(r), e.slice(a, a + r.length) == r;
        }
        function IS(e, r, a) {
          var c = g.templateSettings;
          a && _t(e, r, a) && (r = i), e = Fe(e), r = ea({}, r, c, Df);
          var h = ea({}, r.imports, c.imports, Df), p = dt(h), w = Io(h, p), S, I, F = 0, W = r.interpolate || hs, z = "__p += '", Z = Oo(
            (r.escape || hs).source + "|" + W.source + "|" + (W === rl ? ay : hs).source + "|" + (r.evaluate || hs).source + "|$",
            "g"
          ), ee = "//# sourceURL=" + (Le.call(r, "sourceURL") ? (r.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Dy + "]") + `
`;
          e.replace(Z, function(ae, _e, Ee, Wt, bt, Ut) {
            return Ee || (Ee = Wt), z += e.slice(F, Ut).replace(hy, nv), _e && (S = !0, z += `' +
__e(` + _e + `) +
'`), bt && (I = !0, z += `';
` + bt + `;
__p += '`), Ee && (z += `' +
((__t = (` + Ee + `)) == null ? '' : __t) +
'`), F = Ut + ae.length, ae;
          }), z += `';
`;
          var se = Le.call(r, "variable") && r.variable;
          if (!se)
            z = `with (obj) {
` + z + `
}
`;
          else if (iy.test(se))
            throw new ge(d);
          z = (I ? z.replace(zm, "") : z).replace(Bm, "$1").replace(Vm, "$1;"), z = "function(" + (se || "obj") + `) {
` + (se ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (S ? ", __e = _.escape" : "") + (I ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + z + `return __p
}`;
          var Te = Ad(function() {
            return Ne(p, ee + "return " + z).apply(i, w);
          });
          if (Te.source = z, du(Te))
            throw Te;
          return Te;
        }
        function AS(e) {
          return Fe(e).toLowerCase();
        }
        function OS(e) {
          return Fe(e).toUpperCase();
        }
        function kS(e, r, a) {
          if (e = Fe(e), e && (a || r === i))
            return Dl(e);
          if (!e || !(r = Lt(r)))
            return e;
          var c = rn(e), h = rn(r), p = Ll(c, h), w = Fl(c, h) + 1;
          return Xn(c, p, w).join("");
        }
        function $S(e, r, a) {
          if (e = Fe(e), e && (a || r === i))
            return e.slice(0, Ul(e) + 1);
          if (!e || !(r = Lt(r)))
            return e;
          var c = rn(e), h = Fl(c, rn(r)) + 1;
          return Xn(c, 0, h).join("");
        }
        function NS(e, r, a) {
          if (e = Fe(e), e && (a || r === i))
            return e.replace(fo, "");
          if (!e || !(r = Lt(r)))
            return e;
          var c = rn(e), h = Ll(c, rn(r));
          return Xn(c, h).join("");
        }
        function RS(e, r) {
          var a = ke, c = oe;
          if (Qe(r)) {
            var h = "separator" in r ? r.separator : h;
            a = "length" in r ? we(r.length) : a, c = "omission" in r ? Lt(r.omission) : c;
          }
          e = Fe(e);
          var p = e.length;
          if (Lr(e)) {
            var w = rn(e);
            p = w.length;
          }
          if (a >= p)
            return e;
          var S = a - Fr(c);
          if (S < 1)
            return c;
          var I = w ? Xn(w, 0, S).join("") : e.slice(0, S);
          if (h === i)
            return I + c;
          if (w && (S += I.length - S), hu(h)) {
            if (e.slice(S).search(h)) {
              var F, W = I;
              for (h.global || (h = Oo(h.source, Fe(il.exec(h)) + "g")), h.lastIndex = 0; F = h.exec(W); )
                var z = F.index;
              I = I.slice(0, z === i ? S : z);
            }
          } else if (e.indexOf(Lt(h), S) != S) {
            var Z = I.lastIndexOf(h);
            Z > -1 && (I = I.slice(0, Z));
          }
          return I + c;
        }
        function MS(e) {
          return e = Fe(e), e && Hm.test(e) ? e.replace(tl, cv) : e;
        }
        var PS = Hr(function(e, r, a) {
          return e + (a ? " " : "") + r.toUpperCase();
        }), mu = Of("toUpperCase");
        function Id(e, r, a) {
          return e = Fe(e), r = a ? i : r, r === i ? iv(e) ? dv(e) : Ky(e) : e.match(r) || [];
        }
        var Ad = Ce(function(e, r) {
          try {
            return Pt(e, i, r);
          } catch (a) {
            return du(a) ? a : new ge(a);
          }
        }), DS = Nn(function(e, r) {
          return Vt(r, function(a) {
            a = vn(a), kn(e, a, lu(e[a], e));
          }), e;
        });
        function LS(e) {
          var r = e == null ? 0 : e.length, a = ie();
          return e = r ? Ze(e, function(c) {
            if (typeof c[1] != "function")
              throw new Ht(l);
            return [a(c[0]), c[1]];
          }) : [], Ce(function(c) {
            for (var h = -1; ++h < r; ) {
              var p = e[h];
              if (Pt(p[0], this, c))
                return Pt(p[1], this, c);
            }
          });
        }
        function FS(e) {
          return c0(Yt(e, v));
        }
        function yu(e) {
          return function() {
            return e;
          };
        }
        function WS(e, r) {
          return e == null || e !== e ? r : e;
        }
        var US = $f(), qS = $f(!0);
        function Nt(e) {
          return e;
        }
        function vu(e) {
          return of(typeof e == "function" ? e : Yt(e, v));
        }
        function zS(e) {
          return cf(Yt(e, v));
        }
        function BS(e, r) {
          return lf(e, Yt(r, v));
        }
        var VS = Ce(function(e, r) {
          return function(a) {
            return $i(a, e, r);
          };
        }), HS = Ce(function(e, r) {
          return function(a) {
            return $i(e, a, r);
          };
        });
        function wu(e, r, a) {
          var c = dt(r), h = Ps(r, c);
          a == null && !(Qe(r) && (h.length || !c.length)) && (a = r, r = e, e = this, h = Ps(r, dt(r)));
          var p = !(Qe(a) && "chain" in a) || !!a.chain, w = Mn(e);
          return Vt(h, function(S) {
            var I = r[S];
            e[S] = I, w && (e.prototype[S] = function() {
              var F = this.__chain__;
              if (p || F) {
                var W = e(this.__wrapped__), z = W.__actions__ = Ot(this.__actions__);
                return z.push({ func: I, args: arguments, thisArg: e }), W.__chain__ = F, W;
              }
              return I.apply(e, Yn([this.value()], arguments));
            });
          }), e;
        }
        function GS() {
          return gt._ === this && (gt._ = vv), this;
        }
        function Tu() {
        }
        function YS(e) {
          return e = we(e), Ce(function(r) {
            return ff(r, e);
          });
        }
        var ZS = Jo(Ze), KS = Jo($l), QS = Jo(Co);
        function Od(e) {
          return iu(e) ? xo(vn(e)) : E0(e);
        }
        function JS(e) {
          return function(r) {
            return e == null ? i : pr(e, r);
          };
        }
        var jS = Rf(), XS = Rf(!0);
        function Su() {
          return [];
        }
        function Cu() {
          return !1;
        }
        function eC() {
          return {};
        }
        function tC() {
          return "";
        }
        function nC() {
          return !0;
        }
        function rC(e, r) {
          if (e = we(e), e < 1 || e > ze)
            return [];
          var a = V, c = vt(e, V);
          r = ie(r), e -= V;
          for (var h = Eo(c, r); ++a < e; )
            r(a);
          return h;
        }
        function iC(e) {
          return ye(e) ? Ze(e, vn) : Ft(e) ? [e] : Ot(Kf(Fe(e)));
        }
        function sC(e) {
          var r = ++mv;
          return Fe(e) + r;
        }
        var aC = qs(function(e, r) {
          return e + r;
        }, 0), oC = jo("ceil"), uC = qs(function(e, r) {
          return e / r;
        }, 1), cC = jo("floor");
        function lC(e) {
          return e && e.length ? Ms(e, Nt, Lo) : i;
        }
        function fC(e, r) {
          return e && e.length ? Ms(e, ie(r, 2), Lo) : i;
        }
        function dC(e) {
          return Ml(e, Nt);
        }
        function hC(e, r) {
          return Ml(e, ie(r, 2));
        }
        function gC(e) {
          return e && e.length ? Ms(e, Nt, qo) : i;
        }
        function pC(e, r) {
          return e && e.length ? Ms(e, ie(r, 2), qo) : i;
        }
        var mC = qs(function(e, r) {
          return e * r;
        }, 1), yC = jo("round"), vC = qs(function(e, r) {
          return e - r;
        }, 0);
        function wC(e) {
          return e && e.length ? bo(e, Nt) : 0;
        }
        function TC(e, r) {
          return e && e.length ? bo(e, ie(r, 2)) : 0;
        }
        return g.after = zw, g.ary = ad, g.assign = OT, g.assignIn = Td, g.assignInWith = ea, g.assignWith = kT, g.at = $T, g.before = od, g.bind = lu, g.bindAll = DS, g.bindKey = ud, g.castArray = eT, g.chain = rd, g.chunk = c1, g.compact = l1, g.concat = f1, g.cond = LS, g.conforms = FS, g.constant = yu, g.countBy = ww, g.create = NT, g.curry = cd, g.curryRight = ld, g.debounce = fd, g.defaults = RT, g.defaultsDeep = MT, g.defer = Bw, g.delay = Vw, g.difference = d1, g.differenceBy = h1, g.differenceWith = g1, g.drop = p1, g.dropRight = m1, g.dropRightWhile = y1, g.dropWhile = v1, g.fill = w1, g.filter = Sw, g.flatMap = _w, g.flatMapDeep = bw, g.flatMapDepth = Ew, g.flatten = Xf, g.flattenDeep = T1, g.flattenDepth = S1, g.flip = Hw, g.flow = US, g.flowRight = qS, g.fromPairs = C1, g.functions = qT, g.functionsIn = zT, g.groupBy = Iw, g.initial = _1, g.intersection = b1, g.intersectionBy = E1, g.intersectionWith = I1, g.invert = VT, g.invertBy = HT, g.invokeMap = Ow, g.iteratee = vu, g.keyBy = kw, g.keys = dt, g.keysIn = $t, g.map = Zs, g.mapKeys = YT, g.mapValues = ZT, g.matches = zS, g.matchesProperty = BS, g.memoize = Qs, g.merge = KT, g.mergeWith = Sd, g.method = VS, g.methodOf = HS, g.mixin = wu, g.negate = Js, g.nthArg = YS, g.omit = QT, g.omitBy = JT, g.once = Gw, g.orderBy = $w, g.over = ZS, g.overArgs = Yw, g.overEvery = KS, g.overSome = QS, g.partial = fu, g.partialRight = dd, g.partition = Nw, g.pick = jT, g.pickBy = Cd, g.property = Od, g.propertyOf = JS, g.pull = $1, g.pullAll = td, g.pullAllBy = N1, g.pullAllWith = R1, g.pullAt = M1, g.range = jS, g.rangeRight = XS, g.rearg = Zw, g.reject = Pw, g.remove = P1, g.rest = Kw, g.reverse = uu, g.sampleSize = Lw, g.set = eS, g.setWith = tS, g.shuffle = Fw, g.slice = D1, g.sortBy = qw, g.sortedUniq = B1, g.sortedUniqBy = V1, g.split = _S, g.spread = Qw, g.tail = H1, g.take = G1, g.takeRight = Y1, g.takeRightWhile = Z1, g.takeWhile = K1, g.tap = lw, g.throttle = Jw, g.thru = Ys, g.toArray = yd, g.toPairs = xd, g.toPairsIn = _d, g.toPath = iC, g.toPlainObject = wd, g.transform = nS, g.unary = jw, g.union = Q1, g.unionBy = J1, g.unionWith = j1, g.uniq = X1, g.uniqBy = ew, g.uniqWith = tw, g.unset = rS, g.unzip = cu, g.unzipWith = nd, g.update = iS, g.updateWith = sS, g.values = Zr, g.valuesIn = aS, g.without = nw, g.words = Id, g.wrap = Xw, g.xor = rw, g.xorBy = iw, g.xorWith = sw, g.zip = aw, g.zipObject = ow, g.zipObjectDeep = uw, g.zipWith = cw, g.entries = xd, g.entriesIn = _d, g.extend = Td, g.extendWith = ea, wu(g, g), g.add = aC, g.attempt = Ad, g.camelCase = lS, g.capitalize = bd, g.ceil = oC, g.clamp = oS, g.clone = tT, g.cloneDeep = rT, g.cloneDeepWith = iT, g.cloneWith = nT, g.conformsTo = sT, g.deburr = Ed, g.defaultTo = WS, g.divide = uC, g.endsWith = fS, g.eq = an, g.escape = dS, g.escapeRegExp = hS, g.every = Tw, g.find = Cw, g.findIndex = Jf, g.findKey = PT, g.findLast = xw, g.findLastIndex = jf, g.findLastKey = DT, g.floor = cC, g.forEach = id, g.forEachRight = sd, g.forIn = LT, g.forInRight = FT, g.forOwn = WT, g.forOwnRight = UT, g.get = gu, g.gt = aT, g.gte = oT, g.has = BT, g.hasIn = pu, g.head = ed, g.identity = Nt, g.includes = Aw, g.indexOf = x1, g.inRange = uS, g.invoke = GT, g.isArguments = vr, g.isArray = ye, g.isArrayBuffer = uT, g.isArrayLike = kt, g.isArrayLikeObject = rt, g.isBoolean = cT, g.isBuffer = er, g.isDate = lT, g.isElement = fT, g.isEmpty = dT, g.isEqual = hT, g.isEqualWith = gT, g.isError = du, g.isFinite = pT, g.isFunction = Mn, g.isInteger = hd, g.isLength = js, g.isMap = gd, g.isMatch = mT, g.isMatchWith = yT, g.isNaN = vT, g.isNative = wT, g.isNil = ST, g.isNull = TT, g.isNumber = pd, g.isObject = Qe, g.isObjectLike = et, g.isPlainObject = Li, g.isRegExp = hu, g.isSafeInteger = CT, g.isSet = md, g.isString = Xs, g.isSymbol = Ft, g.isTypedArray = Yr, g.isUndefined = xT, g.isWeakMap = _T, g.isWeakSet = bT, g.join = A1, g.kebabCase = gS, g.last = Kt, g.lastIndexOf = O1, g.lowerCase = pS, g.lowerFirst = mS, g.lt = ET, g.lte = IT, g.max = lC, g.maxBy = fC, g.mean = dC, g.meanBy = hC, g.min = gC, g.minBy = pC, g.stubArray = Su, g.stubFalse = Cu, g.stubObject = eC, g.stubString = tC, g.stubTrue = nC, g.multiply = mC, g.nth = k1, g.noConflict = GS, g.noop = Tu, g.now = Ks, g.pad = yS, g.padEnd = vS, g.padStart = wS, g.parseInt = TS, g.random = cS, g.reduce = Rw, g.reduceRight = Mw, g.repeat = SS, g.replace = CS, g.result = XT, g.round = yC, g.runInContext = E, g.sample = Dw, g.size = Ww, g.snakeCase = xS, g.some = Uw, g.sortedIndex = L1, g.sortedIndexBy = F1, g.sortedIndexOf = W1, g.sortedLastIndex = U1, g.sortedLastIndexBy = q1, g.sortedLastIndexOf = z1, g.startCase = bS, g.startsWith = ES, g.subtract = vC, g.sum = wC, g.sumBy = TC, g.template = IS, g.times = rC, g.toFinite = Pn, g.toInteger = we, g.toLength = vd, g.toLower = AS, g.toNumber = Qt, g.toSafeInteger = AT, g.toString = Fe, g.toUpper = OS, g.trim = kS, g.trimEnd = $S, g.trimStart = NS, g.truncate = RS, g.unescape = MS, g.uniqueId = sC, g.upperCase = PS, g.upperFirst = mu, g.each = id, g.eachRight = sd, g.first = ed, wu(g, function() {
          var e = {};
          return mn(g, function(r, a) {
            Le.call(g.prototype, a) || (e[a] = r);
          }), e;
        }(), { chain: !1 }), g.VERSION = s, Vt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          g[e].placeholder = g;
        }), Vt(["drop", "take"], function(e, r) {
          be.prototype[e] = function(a) {
            a = a === i ? 1 : lt(we(a), 0);
            var c = this.__filtered__ && !r ? new be(this) : this.clone();
            return c.__filtered__ ? c.__takeCount__ = vt(a, c.__takeCount__) : c.__views__.push({
              size: vt(a, V),
              type: e + (c.__dir__ < 0 ? "Right" : "")
            }), c;
          }, be.prototype[e + "Right"] = function(a) {
            return this.reverse()[e](a).reverse();
          };
        }), Vt(["filter", "map", "takeWhile"], function(e, r) {
          var a = r + 1, c = a == He || a == st;
          be.prototype[e] = function(h) {
            var p = this.clone();
            return p.__iteratees__.push({
              iteratee: ie(h, 3),
              type: a
            }), p.__filtered__ = p.__filtered__ || c, p;
          };
        }), Vt(["head", "last"], function(e, r) {
          var a = "take" + (r ? "Right" : "");
          be.prototype[e] = function() {
            return this[a](1).value()[0];
          };
        }), Vt(["initial", "tail"], function(e, r) {
          var a = "drop" + (r ? "" : "Right");
          be.prototype[e] = function() {
            return this.__filtered__ ? new be(this) : this[a](1);
          };
        }), be.prototype.compact = function() {
          return this.filter(Nt);
        }, be.prototype.find = function(e) {
          return this.filter(e).head();
        }, be.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, be.prototype.invokeMap = Ce(function(e, r) {
          return typeof e == "function" ? new be(this) : this.map(function(a) {
            return $i(a, e, r);
          });
        }), be.prototype.reject = function(e) {
          return this.filter(Js(ie(e)));
        }, be.prototype.slice = function(e, r) {
          e = we(e);
          var a = this;
          return a.__filtered__ && (e > 0 || r < 0) ? new be(a) : (e < 0 ? a = a.takeRight(-e) : e && (a = a.drop(e)), r !== i && (r = we(r), a = r < 0 ? a.dropRight(-r) : a.take(r - e)), a);
        }, be.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, be.prototype.toArray = function() {
          return this.take(V);
        }, mn(be.prototype, function(e, r) {
          var a = /^(?:filter|find|map|reject)|While$/.test(r), c = /^(?:head|last)$/.test(r), h = g[c ? "take" + (r == "last" ? "Right" : "") : r], p = c || /^find/.test(r);
          h && (g.prototype[r] = function() {
            var w = this.__wrapped__, S = c ? [1] : arguments, I = w instanceof be, F = S[0], W = I || ye(w), z = function(_e) {
              var Ee = h.apply(g, Yn([_e], S));
              return c && Z ? Ee[0] : Ee;
            };
            W && a && typeof F == "function" && F.length != 1 && (I = W = !1);
            var Z = this.__chain__, ee = !!this.__actions__.length, se = p && !Z, Te = I && !ee;
            if (!p && W) {
              w = Te ? w : new be(this);
              var ae = e.apply(w, S);
              return ae.__actions__.push({ func: Ys, args: [z], thisArg: i }), new Gt(ae, Z);
            }
            return se && Te ? e.apply(this, S) : (ae = this.thru(z), se ? c ? ae.value()[0] : ae.value() : ae);
          });
        }), Vt(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var r = ws[e], a = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", c = /^(?:pop|shift)$/.test(e);
          g.prototype[e] = function() {
            var h = arguments;
            if (c && !this.__chain__) {
              var p = this.value();
              return r.apply(ye(p) ? p : [], h);
            }
            return this[a](function(w) {
              return r.apply(ye(w) ? w : [], h);
            });
          };
        }), mn(be.prototype, function(e, r) {
          var a = g[r];
          if (a) {
            var c = a.name + "";
            Le.call(zr, c) || (zr[c] = []), zr[c].push({ name: r, func: a });
          }
        }), zr[Us(i, L).name] = [{
          name: "wrapper",
          func: i
        }], be.prototype.clone = Mv, be.prototype.reverse = Pv, be.prototype.value = Dv, g.prototype.at = fw, g.prototype.chain = dw, g.prototype.commit = hw, g.prototype.next = gw, g.prototype.plant = mw, g.prototype.reverse = yw, g.prototype.toJSON = g.prototype.valueOf = g.prototype.value = vw, g.prototype.first = g.prototype.head, _i && (g.prototype[_i] = pw), g;
      }, Wr = hv();
      lr ? ((lr.exports = Wr)._ = Wr, vo._ = Wr) : gt._ = Wr;
    }).call(tO);
  }(Hi, Hi.exports)), Hi.exports;
}
var rO = nO();
const ng = Q.div`
	container-type: inline-size;
	container-name: ${Ma};
`, iO = ({
  ignoreContainerSize: t = !1,
  children: n
}) => {
  const i = N.useRef(null), [s, o] = N.useState(Qg.width), u = N.useMemo(
    () => rO.debounce((d) => {
      o((f) => f !== d ? d : f);
    }, 40),
    []
  );
  N.useEffect(() => {
    if (t || !i.current) return;
    const d = new ResizeObserver(([f]) => {
      f && u(f.contentRect.width);
    });
    return d.observe(i.current), () => {
      d.disconnect(), u.cancel();
    };
  }, [t, u]);
  const l = N.useMemo(
    () => ({
      width: s,
      isMobile: s < Xr[Sn.Small],
      isTablet: s >= Xr[Sn.Small] && s < Xr[Sn.Medium],
      isTabletOrMobile: s < Xr[Sn.Medium],
      isLargeScreen: s >= Xr[Sn.Large]
    }),
    [s]
  );
  return t ? /* @__PURE__ */ y(ng, { id: Ma, children: n }) : /* @__PURE__ */ y(ng, { id: Ma, ref: i, children: /* @__PURE__ */ y(Jg.Provider, { value: l, children: n }) });
}, sO = Q.div`
    display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

`, aO = Q.div`
    display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	gap: ${b.spacing.small};
	padding: ${b.spacing.small};
`, oO = ({
  onPrimaryClick: t,
  primaryButton: n,
  primaryButtonLabel: i,
  secondaryButton: s,
  secondaryButtonLabel: o,
  handleClose: u,
  heading: l,
  headerProps: d,
  bodyProps: f,
  footerProps: m,
  ...T
}) => {
  const { translations: v, resolveToken: x } = Ae(), C = x(l), A = () => "simpleBodyText" in T ? /* @__PURE__ */ y(Je, { ...T.simpleBodyTextProps, children: x(T.simpleBodyText) }) : "body" in T ? T.body : null;
  return /* @__PURE__ */ J(
    ta,
    {
      open: !0,
      onDismiss: u,
      label: C,
      size: T.size ?? "large",
      ...T,
      children: [
        /* @__PURE__ */ y(ta.Header, { ...d, children: /* @__PURE__ */ J(sO, { children: [
          /* @__PURE__ */ y(Ji, { children: C }),
          /* @__PURE__ */ y(
            xC,
            {
              screenReaderLabel: v.close,
              placement: "static",
              size: "medium",
              onClick: u
            }
          )
        ] }) }),
        /* @__PURE__ */ y(ta.Body, { ...f, children: A() }),
        /* @__PURE__ */ y(ta.Footer, { ...m, children: /* @__PURE__ */ J(aO, { children: [
          /* @__PURE__ */ y(
            Er,
            {
              color: "secondary",
              onClick: (s == null ? void 0 : s.onClick) ?? u,
              ...s,
              children: x(o ?? "cancel")
            }
          ),
          /* @__PURE__ */ y(Er, { color: "primary", ...n, onClick: t, children: x(i ?? "save") })
        ] }) })
      ]
    }
  );
}, uO = ({ children: t }) => {
  const [n, i] = N.useState(null), s = N.useCallback((u) => {
    i(u);
  }, []), o = N.useCallback((u) => {
    i(null), u && setTimeout(() => u.focus(), 0);
  }, []);
  return /* @__PURE__ */ J(em.Provider, { value: { openModal: s, closeModal: o }, children: [
    t,
    n && /* @__PURE__ */ y(oO, { ...n })
  ] });
}, cO = (t) => /* @__PURE__ */ y(Dm, { theme: { ...b }, children: /* @__PURE__ */ y(v_, { translations: Vg, translate: T_, children: /* @__PURE__ */ y($E, { children: /* @__PURE__ */ y(iO, { children: /* @__PURE__ */ y(eO, { children: /* @__PURE__ */ y(uO, { children: t.children }) }) }) }) }) }), lO = Q.div`
  padding: ${b.spacing.mediumSmall};
  border-radius: ${b.borders.radiusLarge};
  overflow: hidden;
`, fO = Q.div`
  display: flex;
  flex-direction: column;
  gap: ${b.spacing.mediumSmall};
`, dO = Q.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${b.spacing.xSmall};
`, hO = ({ onSuccess: t, onError: n }) => {
  const i = bn(), { showAlert: s } = pn(), { translations: o } = Ae(), { executeQuery: u } = ht(), { mutate: l, isPending: d } = En({
    mutationFn: (f) => u(cm, { input: f }),
    onSuccess: (f) => {
      if (tn(f.createInstitutionalTagCategory)) {
        n(f.createInstitutionalTagCategory ?? {});
        return;
      }
      i.invalidateQueries({ queryKey: ["categories"] }), i.invalidateQueries({ queryKey: ["allCategories"] }), s({ message: o.categoryCreated, variant: "success" }), t();
    },
    onError: () => {
      n({ errors: [{ message: "Request failed" }] });
    }
  });
  return { create: l, isPending: d };
}, Hu = [], gO = [], pO = () => {
  const { categoryAutocomplete: t } = Fa(), { data: n = [] } = yi({ enabled: t }), i = N.useMemo(
    () => Un(n),
    [n]
  ), { translations: s } = Ae(), { showAlert: o } = pn(), [u, l] = N.useState(!1), [d, f] = N.useState(""), [m, T] = N.useState(""), [v, x] = N.useState(Hu), C = () => {
    l(!1), f(""), T(""), x(Hu);
  }, { create: A, isPending: _ } = hO({
    onSuccess: C,
    onError: (P) => {
      cs(P) ? x([{ text: s.categoryNameAlreadyExists, type: "error" }]) : o({ message: s.saveCategoryFailed, variant: "error" });
    }
  }), R = (P) => i.some((O) => O.label.trim().toLowerCase() === P.trim().toLowerCase()), L = (P) => {
    f(P), P.trim() && R(P) ? x([{ type: "error", text: s.categoryNameAlreadyExists }]) : x(Hu);
  }, U = N.useMemo(() => {
    if (!t) return gO;
    const P = d.trim().toLowerCase();
    return P ? i.filter((O) => O.label.toLowerCase().includes(P)) : i;
  }, [t, i, d]);
  return {
    isOpen: u,
    name: d,
    description: m,
    nameErrors: v,
    filteredSuggestions: U,
    onOpen: () => l(!0),
    onClose: C,
    onNameChange: L,
    onDescriptionChange: T,
    onSave: () => {
      if (!_) {
        if (!d.trim()) {
          x([{ text: s.categoryNameRequired, type: "error" }]);
          return;
        }
        if (R(d.trim())) {
          x([{ type: "error", text: s.categoryNameAlreadyExists }]);
          return;
        }
        A({
          name: d.trim(),
          ...m.trim() ? { description: m.trim() } : {}
        });
      }
    },
    isPending: _
  };
}, mO = () => {
  const { translations: t } = Ae(), {
    isOpen: n,
    name: i,
    description: s,
    nameErrors: o,
    filteredSuggestions: u,
    onOpen: l,
    onClose: d,
    onNameChange: f,
    onDescriptionChange: m,
    onSave: T,
    isPending: v
  } = pO();
  return /* @__PURE__ */ y(
    zC,
    {
      renderTrigger: /* @__PURE__ */ y(
        Er,
        {
          color: "primary",
          size: "small",
          renderIcon: /* @__PURE__ */ y(NC, {}),
          onClick: l,
          display: "block",
          children: t.newCategory
        }
      ),
      isShowingContent: n,
      onShowContent: l,
      onHideContent: d,
      on: "click",
      placement: "bottom end",
      shouldContainFocus: !0,
      children: /* @__PURE__ */ y(lO, { children: /* @__PURE__ */ J(fO, { children: [
        /* @__PURE__ */ y(
          Bc,
          {
            inputValue: i,
            filteredSuggestions: u,
            messages: o,
            onInputChange: f
          }
        ),
        /* @__PURE__ */ y(
          BC,
          {
            label: t.newCategoryDescriptionLabel,
            placeholder: t.categoryDescriptionPlaceholder,
            value: s,
            onChange: (x) => m(x.target.value)
          }
        ),
        /* @__PURE__ */ J(dO, { children: [
          /* @__PURE__ */ y(
            Er,
            {
              color: "secondary",
              size: "small",
              withBackground: !1,
              onClick: d,
              display: "inline-block",
              children: t.cancel
            }
          ),
          /* @__PURE__ */ y(
            Er,
            {
              color: "primary",
              size: "small",
              onClick: T,
              display: "inline-block",
              interaction: v ? "disabled" : "enabled",
              children: t.save
            }
          )
        ] })
      ] }) })
    }
  );
}, yO = Q.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: ${b.spacing.xSmall};
	padding: ${b.spacing.mediumSmall};
    border: ${b.borders.widthSmall} solid ${b.colors.contrasts.grey1214};
    border-radius: ${b.borders.radiusLarge};
    box-shadow: ${b.shadows.resting};

    @container (max-width: ${b.breakpoints.medium}) {
		flex-direction: column;
    }
`;
Q.div`
	display: flex;
	flex-direction: row;
	flex: 2;

    @container (max-width: ${b.breakpoints.medium}) {
		width: 100%;
		flex: 1;
        display: inline;
	}
	
	span[class*='-formFieldLayout__label'] {
		padding: 0;
	}
`;
const vO = Q.div`
    display: flex;
	flex-direction: row;
	flex: 3;
	flex-grow: 8;
	gap: ${b.spacing.xSmall};
	align-items: center;

    @container (max-width: ${b.breakpoints.medium}) {
		width: 100%;
		flex: 1;
		text-align: center;
	}
`, wO = Q.hr`
	border: none;
	border-top: ${b.borders.widthSmall} solid ${b.colors.contrasts.grey1214};
	width: 100%;
`, TO = Q.div`
	display: flex;
	flex-direction: row;
	gap: ${b.spacing.xSmall};
	
	@container (max-width: ${b.breakpoints.medium}) {
		justify-content: space-between;
		width: 100%;
	}
`, SO = (t) => {
  const { translations: n, resolveToken: i } = Ae(), { isTabletOrMobile: s } = Va(), { allExpanded: o, handleExpandAllToggle: u } = Kg(), { canCreate: l } = mi(), [d, f] = N.useState("");
  return /* @__PURE__ */ J(yO, { role: "group", "aria-label": n.searchAndFilter, children: [
    /* @__PURE__ */ J(vO, { children: [
      d && /* @__PURE__ */ y(Tc, { screenReaderOnly: !0, liveRegion: KA, children: t.isFetching ? n.loadingData : i({
        key: "searchResults",
        vars: { resultCount: t.searchResultCount }
      }) }),
      /* @__PURE__ */ y(
        Ar,
        {
          placeholder: n.search,
          renderBeforeInput: () => /* @__PURE__ */ y(ug, { inline: !1 }),
          value: d,
          onChange: (m, T) => {
            f(T), t.handleSearchQueryChange(T);
          }
        }
      ),
      /* @__PURE__ */ y(
        _n,
        {
          size: "small",
          renderIcon: t.sortOrder === sr.Asc ? /* @__PURE__ */ y(RC, {}) : /* @__PURE__ */ y(MC, {}),
          screenReaderLabel: t.sortOrder === sr.Asc ? n.sortCategoriesAscending : n.sortCategoriesDescending,
          onClick: t.handleSortToggle
        }
      )
    ] }),
    s && /* @__PURE__ */ y(wO, {}),
    /* @__PURE__ */ J(TO, { children: [
      /* @__PURE__ */ y(Er, { size: "small", onClick: u, children: o ? n.collapseAll : n.expendAll }),
      l && /* @__PURE__ */ y(mO, {})
    ] })
  ] });
}, CO = {
  [Oa.Active]: zn.Active,
  [Oa.Archive]: zn.Deleted
}, xO = () => {
  const [t, n] = N.useState(""), [i, s] = N.useState(""), [o, u] = N.useState(Oa.Active), l = N.useRef(void 0), [d, f] = N.useState(sr.Asc), { accountId: m, executeQuery: T } = ht();
  N.useEffect(() => {
    const ue = setTimeout(() => {
      s(t);
    }, wm);
    return () => clearTimeout(ue);
  }, [t]);
  const v = (ue) => {
    N.startTransition(() => n(ue));
  }, x = (ue) => {
    u(ue);
  }, C = () => {
    f((ue) => ue === sr.Asc ? sr.Desc : sr.Asc);
  }, A = CO[o], { cursor: _, currentPage: R, handlePageChange: L, getTotalPages: U } = Qa({
    endCursorRef: l,
    resetKey: `${i}:${A}`
  }), { data: q, isPending: P, isFetching: O, isError: M, error: $ } = Nr({
    queryKey: ["categories", _, i, A],
    queryFn: () => T(
      nm,
      {
        accountId: m,
        first: qn,
        after: _ ?? void 0,
        searchTerm: i || void 0,
        workflowState: A,
        tagsFirst: qn
      }
    ).then((ue) => {
      var xe;
      return (xe = ue.account) == null ? void 0 : xe.institutionalTagCategoriesConnection;
    })
  });
  l.current = q == null ? void 0 : q.pageInfo.endCursor;
  const H = ((q == null ? void 0 : q.nodes) ?? []).filter(cr), re = A === zn.Active ? Object.fromEntries(H.map((ue) => [ue._id, PE(ue)])) : {};
  return {
    shownCategories: [...((q == null ? void 0 : q.nodes) ?? []).filter(
      (ue) => ue != null
    )].sort((ue, xe) => {
      const He = ue.name.localeCompare(xe.name);
      return d === sr.Asc ? He : -He;
    }),
    categoryTagsMap: re,
    isPending: P,
    isFetching: O,
    isError: M,
    error: $,
    currentPage: R,
    totalPages: U(q == null ? void 0 : q.pageInfo.totalCount),
    handlePageChange: L,
    handleSearchQueryChange: v,
    handleViewTypeChange: x,
    selectedView: o,
    searchResultCount: (q == null ? void 0 : q.pageInfo.totalCount) ?? 0,
    sortOrder: d,
    handleSortToggle: C
  };
}, _O = (t, n) => {
  var _, R, L;
  const { executeQuery: i } = ht(), s = N.useRef(void 0), { cursor: o, currentPage: u, handlePageChange: l, getTotalPages: d } = Qa({
    endCursorRef: s,
    resetKey: `${t}-${(n == null ? void 0 : n.field) ?? "none"}-${(n == null ? void 0 : n.direction) ?? "none"}`
  }), { data: f, isPending: m, isFetching: T, isError: v } = Nr({
    queryKey: ["tagUsers", t, o, n],
    queryFn: () => i(
      im,
      {
        id: t,
        first: qn,
        after: o ?? void 0,
        sort: n
      }
    ).then((U) => U.institutionalTag)
  });
  s.current = (_ = f == null ? void 0 : f.usersConnection) == null ? void 0 : _.pageInfo.endCursor;
  const x = f ? ME(f) : void 0, C = N.useRef(x);
  x && (C.current = x);
  const A = (((R = f == null ? void 0 : f.usersConnection) == null ? void 0 : R.nodes) ?? []).filter(cr).map(am);
  return {
    tag: C.current,
    users: A,
    isPending: m && !C.current,
    isFetching: T,
    isError: v,
    currentPage: u,
    totalPages: d((L = f == null ? void 0 : f.usersConnection) == null ? void 0 : L.pageInfo.totalCount),
    handlePageChange: l
  };
}, bO = (t) => {
  const n = bn(), { showAlert: i } = pn(), { translations: s } = Ae(), { executeQuery: o } = ht(), { mutate: u } = En({
    mutationFn: (l) => o(
      HE,
      { input: { tagId: t, userId: l } }
    ),
    onSuccess: (l) => {
      if (tn(l.removeInstitutionalTag)) {
        i({ message: s.removeUserFromTagFailed, variant: "error" });
        return;
      }
      n.invalidateQueries({ queryKey: ["tagUsers", t] }), n.invalidateQueries({ queryKey: ["categories"] }), n.invalidateQueries({ queryKey: ["tags"] }), n.invalidateQueries({ queryKey: ["allCategories"] }), n.invalidateQueries({ queryKey: ["allTagNames"] }), i({ message: s.userRemovedFromTag, variant: "success" });
    },
    onError: () => {
      i({ message: s.removeUserFromTagFailed, variant: "error" });
    }
  });
  return { removeUser: u };
}, EO = () => /* @__PURE__ */ J("div", { "aria-hidden": !0, children: [
  /* @__PURE__ */ J(i_, { children: [
    /* @__PURE__ */ J(s_, { children: [
      /* @__PURE__ */ J(a_, { children: [
        /* @__PURE__ */ y(
          Ie,
          {
            $width: b.typography.fontSizeLarge,
            $height: b.typography.fontSizeLarge,
            $radius: b.borders.radiusSmall
          }
        ),
        /* @__PURE__ */ y(Ie, { $width: "180px", $height: b.typography.fontSizeMedium }),
        /* @__PURE__ */ y(
          Ie,
          {
            $width: b.breakpoints.xxSmall,
            $height: b.spacing.medium,
            $radius: "999px"
          }
        ),
        /* @__PURE__ */ y(
          Ie,
          {
            $width: b.spacing.space48,
            $height: b.spacing.medium,
            $radius: "999px"
          }
        )
      ] }),
      /* @__PURE__ */ y(o_, { children: Xi(3).map((t) => /* @__PURE__ */ y(
        Ie,
        {
          $width: b.spacing.large,
          $height: b.spacing.large,
          $radius: b.borders.radiusMedium
        },
        t.id
      )) })
    ] }),
    /* @__PURE__ */ y(Ie, { $width: "60%", $height: b.typography.fontSizeSmall })
  ] }),
  /* @__PURE__ */ J(u_, { style: { marginTop: b.spacing.medium }, children: [
    /* @__PURE__ */ y(Ie, { $height: b.spacing.xLarge }),
    /* @__PURE__ */ y(
      Ie,
      {
        $width: "130px",
        $height: b.spacing.xLarge,
        $radius: b.borders.radiusMedium
      }
    )
  ] }),
  /* @__PURE__ */ J(c_, { style: { marginTop: b.spacing.medium }, children: [
    /* @__PURE__ */ J(jd, { children: [
      /* @__PURE__ */ y(Ie, { $height: b.typography.fontSizeMedium, $width: "40px" }),
      /* @__PURE__ */ y(Ie, { $height: b.typography.fontSizeMedium, $width: "120px" }),
      /* @__PURE__ */ y(Ie, { $height: b.typography.fontSizeMedium, $width: "16px" })
    ] }),
    Xi(4).map((t) => /* @__PURE__ */ J(jd, { children: [
      /* @__PURE__ */ y(Ie, { $height: b.typography.fontSizeSmall, $width: "60px" }),
      /* @__PURE__ */ y(Ie, { $height: b.typography.fontSizeSmall, $width: "140px" }),
      /* @__PURE__ */ y(
        Ie,
        {
          $height: b.spacing.medium,
          $width: b.spacing.medium,
          $radius: b.borders.radiusSmall
        }
      )
    ] }, t.id))
  ] })
] }), IO = Q.div`
  display: flex;
  flex-direction: column;
  gap: ${b.spacing.medium};
`, AO = Q.div`
  border: ${b.borders.widthSmall} solid ${b.colors.contrasts.grey1214};
  border-radius: ${b.borders.radiusLarge};
  padding: ${b.spacing.small} ${b.spacing.medium};
`, OO = Q.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${b.spacing.small};
  justify-content: space-between;
`, kO = Q.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${b.spacing.small};
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
`, $O = Q.div`
  display: flex;
  flex-direction: row;
  gap: ${b.spacing.xSmall};
  flex-shrink: 0;
`, NO = Q.div`
  display: flex;
  flex-direction: row;
  gap: ${b.spacing.small};
  align-items: flex-end;
`, RO = Q.div`
  flex: 1;
`, rg = Q.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${b.spacing.small};
`, ig = Q.div`
  display: flex;
  flex-direction: column;
  gap: ${b.spacing.xxxSmall};
`, MO = ({
  tag: t,
  onEdit: n,
  onArchive: i,
  onClose: s
}) => {
  const { translations: o, resolveToken: u } = Ae(), { canEdit: l } = mi(), d = () => l ? /* @__PURE__ */ y(La, { children: /* @__PURE__ */ y(ba, { renderTip: o.edit, children: /* @__PURE__ */ y(
    _n,
    {
      renderIcon: DC,
      screenReaderLabel: o.edit,
      withBackground: !1,
      withBorder: !0,
      onClick: n
    }
  ) }) }) : null;
  return /* @__PURE__ */ J(AO, { children: [
    /* @__PURE__ */ J(OO, { children: [
      /* @__PURE__ */ J(kO, { children: [
        /* @__PURE__ */ y(ag, {}),
        /* @__PURE__ */ y(Ji, { variant: "titleCardMini", children: t.name }),
        t.createdAt && /* @__PURE__ */ y(xr, { color: "info", children: /* @__PURE__ */ y(Je, { weight: "bold", children: u({ key: "createdAt", vars: { date: Xp(t.createdAt) } }) }) }),
        t.associationsCount != null && /* @__PURE__ */ y(xr, { renderIcon: /* @__PURE__ */ y(og, {}), children: /* @__PURE__ */ y(Je, { weight: "bold", children: t.associationsCount }) })
      ] }),
      /* @__PURE__ */ J($O, { children: [
        d(),
        /* @__PURE__ */ y(ba, { renderTip: o.close, children: /* @__PURE__ */ y(
          _n,
          {
            renderIcon: PC,
            screenReaderLabel: o.close,
            withBackground: !1,
            withBorder: !0,
            onClick: s
          }
        ) })
      ] })
    ] }),
    t.description && /* @__PURE__ */ y(Je, { size: "medium", children: t.description })
  ] });
}, PO = ({
  users: t,
  isLoading: n,
  currentPage: i,
  totalPages: s,
  sortDirection: o,
  onPageChange: u,
  onSort: l,
  removeUser: d,
  onAddPeople: f
}) => {
  const { translations: m } = Ae(), { canEdit: T } = mi(), [v, x] = N.useState(""), C = (_, { id: R }) => {
    R === "name" && l(o === "ascending" ? "descending" : "ascending");
  }, A = N.useMemo(() => t.filter(
    (_) => !v || _.sortableName.toLowerCase().includes(v.toLowerCase())
  ), [t, v]);
  return /* @__PURE__ */ J(La, { children: [
    /* @__PURE__ */ J(NO, { children: [
      /* @__PURE__ */ y(RO, { children: /* @__PURE__ */ y(
        Ar,
        {
          placeholder: m.search,
          renderBeforeInput: () => /* @__PURE__ */ y(ug, { inline: !1 }),
          value: v,
          onChange: (_, R) => x(R)
        }
      ) }),
      T && /* @__PURE__ */ y(Er, { color: "primary", renderIcon: /* @__PURE__ */ y(Cc, {}), onClick: f, children: m.addPeople })
    ] }),
    /* @__PURE__ */ J(Et, { caption: m.tagActions, hover: !0, children: [
      /* @__PURE__ */ y(Et.Head, { renderSortLabel: m.sortPeople, children: /* @__PURE__ */ J(Et.Row, { children: [
        /* @__PURE__ */ y(Et.ColHeader, { id: "name", sortDirection: o, onRequestSort: C, children: m.name }),
        /* @__PURE__ */ y(Et.ColHeader, { id: "sisId", children: m.sisId }),
        T && /* @__PURE__ */ y(Et.ColHeader, { id: "actions", children: m.moreOptions })
      ] }) }),
      /* @__PURE__ */ y(Et.Body, { children: n ? Xi(qn).map((_) => /* @__PURE__ */ J(Et.Row, { children: [
        /* @__PURE__ */ y(Et.Cell, { children: /* @__PURE__ */ J(rg, { children: [
          /* @__PURE__ */ y(Ie, { $width: "2rem", $height: "2rem", $radius: "50%" }),
          /* @__PURE__ */ J(ig, { children: [
            /* @__PURE__ */ y(Ie, { $width: "140px", $height: "1rem" }),
            /* @__PURE__ */ y(Ie, { $width: "180px", $height: "0.75rem" })
          ] })
        ] }) }),
        /* @__PURE__ */ y(Et.Cell, { children: /* @__PURE__ */ y(Ie, { $width: "80px", $height: "1rem" }) }),
        /* @__PURE__ */ y(Et.Cell, { children: /* @__PURE__ */ y(Ie, { $width: "1.5rem", $height: "1.5rem", $radius: "50%" }) })
      ] }, _.id)) : A.map((_) => /* @__PURE__ */ J(Et.Row, { children: [
        /* @__PURE__ */ y(Et.Cell, { children: /* @__PURE__ */ J(rg, { children: [
          /* @__PURE__ */ y(lg, { name: _.name, src: _.avatarUrl, size: "x-small" }),
          /* @__PURE__ */ J(ig, { children: [
            /* @__PURE__ */ y(Je, { weight: "bold", children: _.sortableName }),
            _.email && /* @__PURE__ */ y(Je, { size: "small", children: _.email })
          ] })
        ] }) }),
        /* @__PURE__ */ y(Et.Cell, { children: _.sisId ?? "—" }),
        T && /* @__PURE__ */ y(Et.Cell, { children: /* @__PURE__ */ y(
          ji,
          {
            trigger: /* @__PURE__ */ y(
              _n,
              {
                renderIcon: xc,
                screenReaderLabel: m.moreOptions,
                withBackground: !1,
                withBorder: !1,
                size: "small"
              }
            ),
            children: /* @__PURE__ */ y(ji.Item, { onClick: () => d(_._id), children: m.removeUserFromTag })
          }
        ) })
      ] }, _._id)) })
    ] }),
    s > 1 && /* @__PURE__ */ y(
      Sc,
      {
        as: "nav",
        variant: "compact",
        labelNext: m.nextPage,
        labelPrev: m.previousPage,
        currentPage: i,
        totalPageNumber: s,
        onPageChange: u
      }
    )
  ] });
}, DO = (t) => {
  if (t !== "none")
    return { field: "username", direction: t === "ascending" ? "asc" : "desc" };
}, LO = ({ tagId: t, onClose: n }) => {
  const { openModal: i, closeModal: s } = Vn(), { data: o = [] } = yi({ enabled: !0 }), { data: u = [] } = Uc(), l = N.useRef(void 0), [d, f] = N.useState("none"), { handleAddPeople: m } = Tm(l), { tag: T, users: v, isPending: x, isFetching: C, currentPage: A, totalPages: _, handlePageChange: R } = _O(t, DO(d)), { archive: L } = Sm((T == null ? void 0 : T.category._id) ?? ""), { removeUser: U } = bO(t), q = () => {
    T && i({
      heading: "editTag",
      body: /* @__PURE__ */ y(
        Cm,
        {
          tag: T,
          categories: Un(o),
          submitRef: l,
          existingTagNames: u
        }
      ),
      handleClose: s,
      onPrimaryClick: () => {
        var O;
        return (O = l.current) == null ? void 0 : O.call(l);
      }
    });
  }, P = () => {
    i({
      heading: "archiveTag",
      simpleBodyText: "archiveTagConfirmation",
      handleClose: s,
      primaryButtonLabel: "archiveTag",
      size: "small",
      onPrimaryClick: () => {
        L(t), s(), n();
      }
    });
  };
  return x || !T ? /* @__PURE__ */ y(EO, {}) : /* @__PURE__ */ J(IO, { children: [
    /* @__PURE__ */ y(
      MO,
      {
        tag: T,
        onEdit: q,
        onArchive: P,
        onClose: n
      }
    ),
    /* @__PURE__ */ y(
      PO,
      {
        users: v,
        isLoading: C,
        currentPage: A,
        totalPages: _,
        sortDirection: d,
        onPageChange: R,
        onSort: f,
        removeUser: U,
        onAddPeople: () => m(t)
      }
    )
  ] });
}, FO = Q.div`
	display: flex;
	flex-direction: column;
	padding-block-start: ${b.spacing.mediumSmall};
	gap: ${b.spacing.mediumSmall};
`, vk = ({ initialTagId: t, onTagSelect: n }) => {
  const [i, s] = N.useState(t ?? null), o = N.useCallback(
    (P) => {
      s(P), n == null || n(P);
    },
    [n]
  ), {
    shownCategories: u,
    categoryTagsMap: l,
    isPending: d,
    isFetching: f,
    isError: m,
    error: T,
    currentPage: v,
    totalPages: x,
    handlePageChange: C,
    handleSearchQueryChange: A,
    handleViewTypeChange: _,
    selectedView: R,
    searchResultCount: L,
    sortOrder: U,
    handleSortToggle: q
  } = xO();
  return /* @__PURE__ */ y(cO, { children: /* @__PURE__ */ y(FO, { children: i ? /* @__PURE__ */ y(LO, { tagId: i, onClose: () => o(null) }) : /* @__PURE__ */ J(C_, { children: [
    /* @__PURE__ */ y(
      SO,
      {
        handleSearchQueryChange: A,
        handleViewTypeChange: _,
        selectedView: R,
        searchResultCount: L,
        isFetching: f,
        sortOrder: U,
        handleSortToggle: q
      }
    ),
    /* @__PURE__ */ y(
      $I,
      {
        categories: u,
        categoryTagsMap: l,
        isPending: d,
        isFetching: f,
        isError: m,
        error: T,
        currentPage: v,
        totalPages: x,
        onPageChange: C,
        viewTagAssociationsHandler: o
      }
    )
  ] }) }) });
};
export {
  vk as AccountTags,
  yk as FeatureFlagsProvider
};
